// React
import React, {
  useState,
  useContext,
  useEffect,
  useMemo,
  createContext,
  useRef,
} from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
// Assets
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCcVisa,
  faCcMastercard,
  faCcAmex,
  faCcDiscover,
  faCcDinersClub,
  faCcJcb,
} from "@fortawesome/free-brands-svg-icons";
// import { loadStripe } from "@stripe/stripe-js";
import {
  PaymentRequestButtonElement,
  useElements,
  useStripe,
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement,
} from "@stripe/react-stripe-js";

import { Container, Row, Col, Image, Card } from "react-bootstrap";
import "./css/checkoutV2.scss";
import "./css/popup.scss";

import Spinner from "react-bootstrap/Spinner";
import Form from "react-bootstrap/Form";
import Accordion from "react-bootstrap/Accordion";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Helmet } from "react-helmet-async";
// Components
import PreOrder from "../preorder/preorder";
import { PaymentFaild } from "./popup";
import { PaymentSuccess } from "./popup";
import { MinOrderPopup } from "./popup";
import { PaymentComponent } from "./popup";

import { MdOutlineCancel } from "react-icons/md";
import { OrderFlow } from "../../App";
import ThemeContext from "../../common/theme/components/contexts/themecontexts";
// CSS
import "./css/checkout.scss";
import "./css/address-formV2.scss";
import "./css/popup.scss";
// Images

import CardImgWhite from "./img/cardNew.png";
import CashImgWhite from "./img/cash.svg";
import CashImgDark from "./img/dark.jpg";
import Gpay from "./img/Google__G__logo.svg.png";

// checkout images
import Paypallogo from "./img/paypal2.svg";
import applepays from "./img/applecheckout.svg";
import applepaydark from "./img/apple-dark.png";
import applepayNewmobile from "./img/appleiconmobilenewfinal.png";
import applepaynewdark from "./img/mobileapplepayicon.png";
import klarnapay from "./img/klarnamobilepay.png";
import threeplus from "./img/3 +.svg";
import Deliveryiconcheckout from "./img/deliverynicon.png";
// import Deliveryiconcheckout from "./img/deliverycheckouticon.svg"
import Pickupiconcheckout from "./img/pickupcheckouticon.svg";
//back icon Img
import { FaLock } from "react-icons/fa";
import BackIcon from "./img/backNew.png";
import BackWhiteIcon from "./img/backNewWhite.png";
import user from "./img/fa_profile.png";
import time from "./img/fa_calender.png";
import Clock from "./img/fa_Clock.png";
import Map from "./img/bxs_map.png";
import OK from "./img/Group - Copy.png";
import Privacy from "./img/privacy_tip.png";
import closeiconnew from "./img/closebuttonimage.png";
import { FaRegCircleCheck } from "react-icons/fa6";

//white
import creditcarddebitcart from "./img/cardcreditdebitcard.png";
import usercommon from "./img/usericonnew.png";
import lockimgkey from "./img/lockimgkey.png";
import userWhite from "./img/fi_user_white.png";
import ClockWhite from "./img/fi_clock_white.png";
import clockcommon from "./img/Asapiconnew.png";
import timeWhite from "./img/fi_calender_white.png";
import MapWhite from "./img/bxs_map_white.png";
import timecommon from "./img/schedulecommon.png";
import popupimgpayment from "./img/popupimgnew.png";
import OkWhite from "./img/Group_white.png";
import PrivacyWhite from "./img/fi_tip_security_white.png";
import notesWhite from "./img/notes-white.png";
import notesBlack from "./img/notes-black.png";
import notecommon from "./img/addinstruction.png";
import notemobilenew from "./img/notemobilenew.png";
import Mapcommon from "./img/locationcheckout.png";
import Voucherimg from "./img/voucherimg.png";
import EditaddressHome from "./img/editaddresshomeicon.png";
import EditadressPlus from "./img/editaddressplusicon.png";
import EditadressLocation from "./img/editiconlocation.png";
import Secureimgone from "./img/secureimageonw.png";
import Secureimgtwo from "./img/secureimgtwo.png";
import Secureimgthree from "./img/secureimgthree.png";
import Cvvbgimage from "./img/cvvimagenew.png";
import { PiPlusCircle } from "react-icons/pi";
import { BiSolidDiscount } from "react-icons/bi";
import { FaQrcode } from "react-icons/fa";
import { FiCreditCard } from "react-icons/fi";
//
import PayPal from "./img/paypalmobileicon.png";
import Clarna from "./img/klarnaNew.png";
import AfterPay from "./img/afterpay.png";
import AfterPayWhite from "./img/afterpaywhite.png";
import NewwalletImg from "./img/waleetWhiteNew.png";
import walletimgicon from "./img/walletimgpay.png";
import Cashimgicondesktop from "./img/cashpaymentimg.png";
import CashimgiconFinalMobile from "./img/cashimageiconfinalmobile.png";
import cardimgicon from "./img/cardimgvisa.png";
import kalarnaimgicon from "./img/klarnaimgpay.png";
import paypalimgicon from "./img/paypalimgpay.png";
import CardIcon from "./img/waleetWhiteNew.png";
import { IoCloseSharp } from "react-icons/io5";
import CardIconDark from "./img/walletNew.png";
import { IoIosArrowForward } from "react-icons/io";
import { GrLocation } from "react-icons/gr";
import { TfiTimer } from "react-icons/tfi";
import CreditdebitCardImg from "./img/cardnewmobilefinal.png";
import CreditCardImg from "./img/cardmobileicon.png";
// Icons
import { MdDone } from "react-icons/md";
import { RiArrowRightSLine } from "react-icons/ri";
import { FiCalendar } from "react-icons/fi";
import { FaRegClock } from "react-icons/fa6";
import { FaRegUser } from "react-icons/fa6";
import { TbNotes } from "react-icons/tb";
import { GoHome } from "react-icons/go";
import { PiBuildingOfficeLight } from "react-icons/pi";

import { MdOutlineArrowBackIos } from "react-icons/md";
import { BsNutFill } from "react-icons/bs";
// *******~ Import ~******** //

// accordian
import PlaceOrderJson from "../../components/placeorderdetails.json";
import axios from "axios";

import { updateAddressApi } from "../../api/checkout/updateAddress";
import { postcodeDetailApi } from "../../api/menu/postcodeDetailApi";
import { googleAddressApi } from "../../api/checkout/googleAddress";
import { getProfileApi } from "../../api/myaccount/profile/getProfileApi";

// Redux wallet history
import { connect } from "react-redux";
import { getAddress } from "../../actions/myaccount/address/getAddressActions";
import { getchargesDetail } from "../../actions/checkout/getChargesDetailActions";
import { getStripePayment } from "../../actions/checkout/getStripePaymentDetailActions";
import {
  postPlaceOrder,
  clearPlaceOrder,
} from "../../actions/checkout/placeorderActions";
import { afterPlaceOrder } from "../../actions/checkout/afterPlaceOrderAction";
import { getLoyaltyPoints } from "../../actions/checkout/getLoyaltyAction";
import {
  postPlaceOrderStatus,
  PlaceCardStatus,
} from "../../actions/checkout/placeorderStatusAction";
import { useSelector, useDispatch } from "react-redux";
import {
  isIOS,
  isAndroid,
  isWindows,
  isMacOs,
  isTablet,
} from "react-device-detect";
// import Checkoutpage2 from "./Checkoutpageskeleton";
import Checkoutpageskeleton from "./Checkoutpageskeleton";

import jwtEncode from "jwt-encode";
//swiper
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper";
import { orderTimingApi } from "../../api/menu/orderTimingApi";
import { checkVoucherApi } from "../../api/menu/checkVoucherApi";
import {
  applyVoucher,
  autoDiscount,
  applySubcriptionCouponCode,
} from "../../actions/menu/offerAction";
import { itemAvailableApi } from "../../api/checkout/getItemAvailable";
import { getSubcribeCoupon } from "../../actions/subscribe/subcribeCouponAction";
import TextField from "@mui/material/TextField";

import { cartPrice, cartRemoveAllItem } from "../../actions/menu/cartAction";
import { applyDiscount } from "../../actions/menu/offerAction";
import moment from "moment/moment";
// import required modules
// lazy


// lazy
// const SubmitButton = Loadable(lazy(() => import("../preorder/submitButton")));

export const getOrderTimingDetail = async (formData) => {
  try {
    const response = await orderTimingApi(formData);
    return response.data; // Assuming the response has a 'data' property
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const itemAvailableCheck = async (data) => {
  try {
    const response = await itemAvailableApi(data);
    return response.data; // Assuming the response has a 'data' property
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const CheckoutContext = createContext({});
export const CheckoutData = () => useContext(CheckoutContext);

const CheckoutPagev2 = ({
  getchargesDetail,
  getStripePayment,
  error,
  userData,
  postPlaceOrder,
  chargesdetail,
  stripepayment,
  getAddress,
  addressDetail,
  placeorder,
  getLoyaltyPoints,
  getLoyalty,
  applyDiscount,
}) => {
  const navigate = useNavigate();
  const sectionRef = useRef(null);
  // console.log('userDatauserData',userData);

  const { path } = useParams();
  const { theme } = useContext(ThemeContext);
  const stripe = useStripe();
  const elements = useElements();
  const [paysaveCard, setPaySaveCard] = useState(null);
  const [saveCardError, setSaveCardError] = useState(null);
  const [cardStatus, setCardStatus] = useState(false);
  const [paymentRequest, setPaymentRequest] = useState(null);
  const [applepayGpayBtnStatus, setApplepayGpayBtnStatus] = useState(0);
  const [payType, setPayType] = useState("");
  const [paymentSva, setPaymentSva] = useState(0);
  const [paymentMId, setPaymentMId] = useState("");
  const [paymentIntentId, setPaymentIntentId] = useState("");
  const [paymentType, setPaymentType] = useState(1); // payment type 1,7,8,9
  const [paySubmit, setPaySubmit] = useState(0); // validate pay button submitted or not
  const [preOrderTimeTable, setPreOrderTimeTable] = useState(null);
  const { getOrderMode, setStuartStatus, stuartStatus, setLastOrder } =
    OrderFlow();
  const breakpoint = 767;
  const [AddressPopupshow, setAddressPopupshow] = useState(false);
  const [postCodePopupshow, setPostCodePopupshow] = useState(false);
  const [newAddresShow, setNewAddressShow] = useState(false);
  const orderType = getOrderMode === "Collection" ? 1 : 0;
  const preorderTime = localStorage.getItem("preOrder");
  const preorder = preorderTime || "";
  const [instruction, setInstruction] = useState("");
  const localCutlery = localStorage.getItem("cutlery") || "";
  const gift = localStorage.getItem("gift") || "";
  const bagCharge = chargesdetail?.message?.baggageCharge || 0;
  const serviceCharge = chargesdetail?.message?.serviceCharge || 0;
  const clientFkCharge = chargesdetail?.message?.serviceCharge || 0;
  // const clientFkCharge = chargesdetail?.message?.clientFkCharge || 0;
  const [gpaySubmit, setGpaySubmit] = useState(0);
  const [svpaySubmit, setSvpaySubmit] = useState(0);
  const [apaySubmit, setApaySubmit] = useState(0);
  const [svclientSecret, setSvclientSecret] = useState(0);
  const [clientSecret, setClientSecret] = useState(0);
  const [payPalClientSecret, setPayPalClientSecret] = useState(0);
  const [walletstatus, setWalletstatus] = useState(0);
  const [walletamount, setWalletamount] = useState(0);
  const [cardErrorMessage, setCardErrorMessage] = useState(null);
  const [PaypalErrorMessage, setPayPalErrorMessage] = useState(null);
  const [faildshow, setFaildShow] = useState(false); //order status warning
  const [buttonstatus, setButtonstatus] = useState(false); //order button loading
  const discountJSON = localStorage.getItem("discount");
  const parsedDiscount = discountJSON ? JSON.parse(discountJSON) : 0;
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const [localCustomerId, setCustomerId] = useState("");
  const [localAddressId, setAddressId] = useState("");
  const [localOrderPostcode, setOrderPostcode] = useState("");
  const loginAddress = localStorage.getItem("loginAddress") || "";
  const guestAddress = localStorage.getItem("guestAddress") || "";
  const [localGuestMode, setGuestMode] = useState(false);
  const [tabStatus, setTabStatus] = useState(null);
  //selectime status
  const [selectimeStatus, setSelectimeStatus] = useState(false);
  //
  const [itemAvailableData, setItemAvailableData] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);

  //selectEstimateTime
  const preOrderTimePart1 = localStorage.getItem("orderTime");

  const preOrderTimePart = preOrderTimePart1?.trim();
  const exitOrderTimePart = preOrderTimePart?.split(" ")[1];
  const exitOrderDatePart1 = preOrderTimePart?.split(" ")[0];
  //old date format check
  const dateParts = exitOrderDatePart1?.includes("-")
    ? exitOrderDatePart1
    : exitOrderDatePart1?.split("/");

  const exitOrderDatePart = dateParts
    ? dateParts?.includes("-")
      ? dateParts
      : `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`
    : "";

  // Check if the date is valid and parse it.

  const dateZone = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  let formatToday = new Date()
    ?.toLocaleString("en-GB", dateZone)
    .replace(",", "");
  const dateString = formatToday?.replaceAll("/", "-");
  const parts = dateString?.split("-"); // Split the string by '-'
  const formattedDateE = `${parts[2]}-${parts[1]}-${parts[0]}`;
  const [selectEstimateTime, setSelectEstimateTime] = useState(
    exitOrderDatePart
      ? exitOrderDatePart == formattedDateE
        ? "today"
        : exitOrderDatePart
      : "today"
  );
  //tab status estimate
  //order button disable & enable
  const [footerBtn, setFooterBtn] = useState(true);
  const [paymentMethodId, setPaymentMethodId] = useState(null); // Add state for payment method ID
  const [jsonData, setJsonData] = useState(PlaceOrderJson);
  // Function to update the JSON data with the new paymentMethodId
  const updateJsonData = (newPaymentMethodId) => {
    // Create a copy of the JSON data
    const updatedData = [...jsonData];

    // Find the specific item you want to update (for example, the first item)
    const itemToUpdate = updatedData[0];

    // Update the "paymentMethodId" property within the "paymentDetail" object
    itemToUpdate.paymentDetail.paymentMethodId = newPaymentMethodId;

    // Update the state with the modified JSON data
    setJsonData(updatedData);

    // postPlaceOrder(jsonData[0]); // post the latest PM ID
  };

  //setMinOrderModal
  const [minOrderModal, setMinOrderModal] = useState(false);
  const [minOrderMessage, setMinOrderMessage] = useState(null);
  const [minOrderStatus, setMinOrderStatus] = useState(false);
  const dispatch = useDispatch();
  const [width, setWidth] = useState(window.innerWidth);
  const [cardtype, setCardtype] = useState(0);
  const [cashtype, setCashtype] = useState(0);
  const [applepaytype, setApplepaytype] = useState(0);
  const [googlepaytype, setGooglepaytype] = useState(0);
  const [klarnaType, setKlarnaType] = useState(0);
  const [paypalType, setPaypalType] = useState(1);
  // type 1 - mobile view only, 2- all device, 3 - future use

  const [gpaydeviceInfo, setGpaydeviceInfo] = useState(null);
  const [appledeviceInfo, setAppledeviceInfo] = useState(null);
  const [selectedValue, setSelectedValue] = useState(null);
  const [scrollelement, setScrollelement] = useState(false);
  const [paymentSuccessShow, setPaymentSuccessShow] = useState(false);
  const [paymentSuccessMsg, setPaymentSuccessMsg] = useState("");
  const [paySpinner, setPaySpinner] = useState(false);
  const [duplicatHeight, setDuplicatHeight] = useState(136);
  //estimate section
  const [getorderType, setGetOrderType] = useState("ASAP");
  //extra Amount
  const [extraAmountModal, setExtraAmountModal] = useState(false);
  const [useWalletBalance, setUseWalletBalance] = useState(false);
  const [extraLessAmount, setExtraLessAmount] = useState(null);
  const [extraPayment, setExtraPayment] = useState(false);
  const [extraPayStatus, setExtraPayStatus] = useState(0);
  const [extraStatus, setExtraStatus] = useState(false);
  const [showModalAddressEdit, setShowModalAddressEdit] = useState(false);
  const unTrimmedPromotionType =
    localStorage.getItem("promotion_type") || "/website";
  const promotionType =
    typeof unTrimmedPromotionType === "string"
      ? unTrimmedPromotionType.replace("/", "")
      : "website";

  const deviceDetect = () => {
    let width = window.innerWidth;
    const paymentStatus = stripepayment?.message?.paymentStatus;
    const orderModeCheck = localStorage.getItem("orderMode");
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (width < 1199) {
      if (stripepayment) {
        if (isIOS) {
          //check apple pay
          if (stripepayment) {
            if (isLoggedIn === "true") {
              if (orderModeCheck === "Delivery") {
                //delivery Check
                if (paymentStatus.applePay) {
                  setSelectedValue("apple-pay");
                  setPaymentType(7);
                  setApplepaytype(1);
                  setAppledeviceInfo(1);

                } else {
                  if (paymentStatus.cash) {
                    setSelectedValue("cashimg");
                    setPaymentType(0);
                  }
                }
              } else {
                if (paymentStatus.coll_applePay) {
                  setSelectedValue("apple-pay");
                  setPaymentType(7);
                  setApplepaytype(1);
                  setAppledeviceInfo(1);
                } else {
                  if (paymentStatus.coll_cash) {
                    setSelectedValue("cashimg");
                    setPaymentType(0);
                  }
                }
              }
            } else {
              if (paymentStatus.coll_applePay) {
                setSelectedValue("apple-pay");
                setPaymentType(7);
                setApplepaytype(1);
                setAppledeviceInfo(1);
              } else {
                if (paymentStatus.guest_cash) {
                  setSelectedValue("cashimg");
                  setPaymentType(0);
                }
              }
            }
          }
        } else if (isAndroid || isTablet) {
          if (stripepayment) {
            if (isLoggedIn === "true") {
              if (orderModeCheck === "Delivery") {
                //delivery Check
                if (paymentStatus.googlePay) {
                  setGpaydeviceInfo(1);
                  setPaymentType(8);
                  setSelectedValue("google-pay");
                  setGooglepaytype(1);
                } else {
                  if (paymentStatus.cash) {
                    setSelectedValue("cashimg");
                    setPaymentType(0);
                  }
                }
              } else {
                if (paymentStatus.coll_googlePay) {
                  setGpaydeviceInfo(1);
                  setPaymentType(8);
                  setSelectedValue("google-pay");
                  setGooglepaytype(1);
                } else {
                  if (paymentStatus.coll_cash) {
                    setSelectedValue("cashimg");
                    setPaymentType(0);
                  }
                }
              }
            } else {
              if (paymentStatus.coll_googlePay) {
                setGpaydeviceInfo(1);
                setPaymentType(8);
                setSelectedValue("google-pay");
                setGooglepaytype(1);
              } else {
                if (paymentStatus.guest_cash) {
                  setSelectedValue("cashimg");
                  setPaymentType(0);
                }
              }
            }
          }
        } else {
          if (cardtype) {
            setSelectedValue("cardimg");
          } else if (cashtype) {
            setSelectedValue("cashimg");
          }
        }
      } else {
        if (cardtype) {
          setSelectedValue("cardimg");
          setCardtype(1);
        } else if (cashtype) {
          setSelectedValue("cashimg");
          setCashtype(1);
        }
      }
    }
  };
  //client title
  const [clientName, setClientName] = useState("");
  const [clientImages, setClientIamges] = useState("");
  const [clientLogo, setClientLogo] = useState("");
  const [scrolled, setScrolled] = useState(false);
  const [topScolled, setTopScolled] = useState(false);
  //itemAvilable
  const [effectStatus, setEffectStatus] = useState(true);
  //autoRefresh
  const [autoshowPopup, setAutoShowPopup] = useState(false);

  // restaurant Details
  // const deliveryDiscount = localStorage.getItem("deliveryDiscount", deliveryDiscount);
  // const collectionDiscount = localStorage.getItem("collectionDiscount", collectionDiscount);

  // if (deliveryDiscount || collectionDiscount) {
  //   console.log("deliveryDiscount =>", deliveryDiscount);
  //   console.log("collectionDiscount =>", collectionDiscount);
  // }

  useEffect(() => {
    // Retrieve data from localStorage for the key 'clientName'
    const storedClientName = localStorage.getItem("clientName");
    const storedClientImage1 = localStorage.getItem("menuData");
    const storedClientImage = storedClientImage1
      ? JSON.parse(storedClientImage1)
      : "";
    if (storedClientName) {
      setClientName(storedClientName);
    }
    if (storedClientImage) {
      setClientIamges(storedClientImage?.backgroundImage);
    }
    if (storedClientImage) {
      setClientLogo(storedClientImage?.logo);
    }
  }, []);
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const klarnaRedirectStatus = urlParams.get("redirect_status");
    const checkPaypalklarna = localStorage.getItem("isPaypalKlarna");
    if (klarnaRedirectStatus === "succeeded" && checkPaypalklarna === "1") {
      setPaymentType(10);
    } else if (
      klarnaRedirectStatus === "succeeded" &&
      checkPaypalklarna === "0"
    ) {
      setPaymentType(14);
    } else {
      deviceDetect();
    }
    setLastOrder(false);
  }, []); // Empty dependency array ensures that this effect runs once on mount
  useEffect(() => {
    // Check payment status on component mount
    const paymentStatus = localStorage.getItem("paymentStatus");

    if (paymentStatus === "processing") {
      setAutoShowPopup(true);
    }
  }, []);
  // const handlePaypalRedirection = () => {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const paypalRedirectionStatus = urlParams.get("redirect_status");
  //   const checkPaypalklarnas = localStorage.getItem("isPaypalKlarna");
  //   switch (paypalRedirectionStatus && checkPaypalklarnas==="0") {
  //     case "succeeded":
  //       setPaymentType(14);
  //     default:
  //       deviceDetect();
  //   }
  // };

  // useEffect(() => {
  //   handlePaypalRedirection();
  // }, []);

  const PayOptions = [
    {
      value: "wallet",
      icon: walletimgicon,
      darkicon: NewwalletImg,
      type: 2,
      status: extraPayStatus,
      device: 1,
      para: "Wallet",
    },
    // {
    //   value: "cashimg",
    //   icon: Cashimgicondesktop,
    //   darkicon: CashImgDark,
    //   type: 2,
    //   status: cashtype,
    //   device: 1,
    //   para: "Cash",
    // },
    {
      value: "cardimg",
      icon: cardimgicon,
      darkicon: CardImgWhite,
      type: 2,
      status: cardtype,
      device: 1,
      para: "Card",
    },
    {
      value: "paypal",
      icon: paypalimgicon,
      darkicon: PayPal,
      type: 3,
      status: paypalType,
      device: 1,
      para: "Paypal",
    },
    {
      value: "klarna",
      icon: kalarnaimgicon,
      darkicon: Clarna,
      type: 2,
      status: klarnaType,
      device: 1,
      para: "Klarna",
    },
    {
      value: "savedcard",
      icon: Clarna,
      darkicon: Clarna,
      type: 3,
      status: 12,
      device: 1,
      para: "SavedCard",
    },
    {
      value: "afterpay",
      icon: AfterPay,
      darkicon: AfterPayWhite,
      type: 3,
      status: 0,
      device: 1,
      para: "afterpay",
    },
    // {
    //   value: "apple-pay",
    //   icon: ApplyPayNew,
    //   darkicon: ApplyPayNewWhite,
    //   type: 2,
    //   status: paymentType === 7 ? 1 : 0,
    //   device: applepaytype,
    // },
    // {
    //   value: "google-pay",
    //   icon: Gpay,
    //   darkicon: GooglePayNew,
    //   type: 2,
    //   status: paymentType === 8 ? 1 : 0,
    //   device: googlepaytype,
    // },
    //  {
    //   value: "wallet",
    //   icon: NewwalletImg,
    //   darkicon: NewwalletImg,
    //   type: 2,
    //   status: 1,
    //   device: 1,
    //   para: "Wallet",
    // }
  ];
  const [paymentOptions, setPaymentOptions] = useState(null);

  useEffect(() => {
    const guestusered = localStorage.getItem("guestAddress");
    const filteredOptions = PayOptions.filter((option) => {
      if (!guestusered && option.value === "wallet") {
        return false;
      }
      return true;
    });

    setPaymentOptions(PayOptions);
  }, [
    gpaydeviceInfo,
    appledeviceInfo,
    cardtype,
    applepayGpayBtnStatus,
    applepaytype,
    googlepaytype,
    paypalType,
    cashtype,
  ]);

  // type 1 - mobile view only, 2- all device, 3 - future use

  // const breakpoint = 767;
  useEffect(() => {
    const handleResizeWindow = () => setWidth(window.innerWidth);
    // subscribe to window resize event "onComponentDidMount"
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      // unsubscribe "onComponentDestroy"
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, []);

  // adjust the time once cross the selected time with every minutes
  const [showPreorder, setShowPreorder] = useState(false);

  // ! page width
  useEffect(() => {
    // let addressData = null;
    if (isLoggedIn === "true") {
      if (loginAddress) {
        const address = JSON.parse(loginAddress);
        setOrderPostcode(address.postcode || "");
        setCustomerId(address.customerId);
        setAddressId(address.addressId);
      } else {
        setAddressPopupshow(true);
      }
      // addressData = loginAddress;
    } else {
      if (guestAddress) {
        const address = JSON.parse(guestAddress);
        setOrderPostcode(address.postcode || "");
        setCustomerId(address.customerId);
        setAddressId(address.addressId);
        setGuestMode(true);
      } else {
        setAddressPopupshow(true);
      }
      // addressData = guestAddress;
    }

    // if (addressData) {
    //   const address = JSON.parse(addressData);
    //   setOrderPostcode(address.postcode || "");
    //   setCustomerId(address.customerId);
    //   setAddressId(address.addressId);
    // } else {
    //   setAddressPopupshow(true);
    // }
  }, [isLoggedIn, loginAddress, guestAddress]);

  const [promo, setPromo] = useState(0);
  const [promoDesc, setPromoDesc] = useState("");
  const [discount, setDiscount] = useState(0);
  const [discountDesc, setDiscountDesc] = useState("");
  const [voucher, setVoucher] = useState(0);
  const [voucherDesc, setVoucherDesc] = useState("");
  const SummaryOrderType = getOrderMode === "Collection" ? 1 : 0;
  useEffect(() => {
    if (parsedDiscount) {
      if (parsedDiscount.source === "promoDiscount") {
        setVoucher(0);
        setVoucherDesc("");
        setDiscount(0);
        setDiscountDesc("");
        setPromo(parsedDiscount.appliedDiscount);
        setPromoDesc(parsedDiscount.discount);
      } else if (parsedDiscount.source === "voucherDiscount") {
        setPromo(0);
        setPromoDesc("");
        setDiscount(0);
        setDiscountDesc("");
        setVoucher(parsedDiscount.appliedDiscount);
        setVoucherDesc(parsedDiscount.discount);
      } else {
        setPromo(0);
        setPromoDesc("");
        setVoucher(0);
        setVoucherDesc("");
        if (
          parsedDiscount?.orderType === SummaryOrderType ||
          parsedDiscount?.orderType === 2 ||
          parsedDiscount?.orderType === "2"
        ) {
          setDiscount(parsedDiscount.appliedDiscount);
          setDiscountDesc(parsedDiscount.discount);
        } else {
          setDiscount(0);
          setDiscountDesc("");
        }
      }
    } else {
      setDiscount(0);
      setDiscountDesc("");
      setPromo(0);
      setPromoDesc("");
      setVoucher(0);
      setVoucherDesc("");
    }
  }, [
    setPromo,
    setPromoDesc,
    setDiscount,
    setDiscountDesc,
    setVoucher,
    setVoucherDesc,
    parsedDiscount,
  ]);

  // round off and donation
  const roundOffPrice = localStorage.getItem("roundOffPrice") || 0;
  const [roundedValue, setRoundedValue] = useState(roundOffPrice);
  const subTotal = parseFloat(localStorage.getItem("totalPrice"));
  const driverTipValue = localStorage.getItem("driverTipValue") || 0;
  const [driverTip, setDriverTip] = useState(driverTipValue);
  const localFinalTotal = localStorage.getItem("finalTotal") || 0;
  const [finalTotal, setFinalTotal] = useState(localFinalTotal);
  const [finalTotalValue, setFinalTotalValue] = useState("");
  const [paymentModalShow, setPaymentModalShow] = useState(false);
  const [ukRailwayTime, setUkRailwayTime] = useState(new Date());
  // get ip address
  const [ipAddress, setIpAddress] = useState(localStorage.getItem("ip") || "");

  //Undelivery postcode Status
  const [deliverPostCodeStatus,setDeliverPostCodeStatus]=useState(false);

  // axios
  //   .get("https://api.ipify.org?format=json")
  //   .then((response) => {
  //     setIpAddress(response.data.ip);
  //     localStorage.setItem("ip", response.data.ip);
  //   })
  //   .catch((error) => {
  //     console.error("Error fetching IP address:", error);
  //   });

  // polling Method
  const [polling, setPolling] = useState(false);
  useEffect(() => {
    const fetchPriceTotal = async () => {
      try {
        const cartData = typeof localStorage.getItem('cart') !== "undefined" && localStorage.getItem('cart') !== "undefined" ? JSON.parse(localStorage.getItem('cart')) : '';
        const clientId = localStorage.getItem('clientId');
        const orderTime = localStorage.getItem('orderTime');
        const order_Mode = localStorage.getItem('orderMode');
        const post_code = localStorage.getItem("orderPostcode");
        const orderMode = order_Mode === "Collection" ? 1 : 0;
        const orderTimeNew = orderTime.includes("/")
          ? convertDateTime(orderTime)
          : orderTime;
        function convertDateTime(input) {
          const [datePart, timePart] = input.split(" ");
          const [d, m, y] = datePart.split("/");

          return `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")} ${timePart}`;
        }
        const totalData = {
          "cart": cartData,
          "order_mode": orderMode,
          "orderTime": orderTimeNew,
          'client_id': clientId,
          'post_code': post_code,

        }
        const response = await axios.post('https://api-new.fusionkitchen.co.uk/liveCartData', totalData);
        if (response?.data?.message) {
          console.log(response?.data?.message?.cart, "pollingData");
          const newCartData = response?.data?.message?.cart;
          const newDeliveryDetail = response?.data?.message?.postCode;
          const coData = JSON.stringify(newCartData);
          localStorage.setItem('cart', coData);
          const newTotalPrice = newCartData.reduce(
            (priceAccumulator, currentItem) => {
              return priceAccumulator + parseFloat(currentItem.price);
            },
            0
          );
          if (order_Mode === "Delivery") {
            if (newDeliveryDetail.status === true) {
              const coDeliveryDetail = JSON.stringify(newDeliveryDetail?.message);
              localStorage.setItem("postcodeDetail", coDeliveryDetail);
              setDeliverPostCodeStatus(false);
            }
            else {
              if(newDeliveryDetail.status === false){
                setAddressPopupshow(true);
                setDeliverPostCodeStatus(true);
              }
            }
          }
          localStorage.setItem("totalPrice", newTotalPrice.toFixed(2));
          const polResponse = response.data.message;
          const discountJSON = localStorage.getItem("discount");
          const discount = discountJSON ? JSON.parse(discountJSON) : "";
          const discountType = localStorage.getItem("discountType");

          console.log("discount", "pooling");
          if (discount.source === "autoDiscount" || discountType === "autoDiscount") {
            console.log("000", "pooling");
            const discountCondition = order_Mode === "Delivery"
              ? polResponse?.deliveryDiscount
              : order_Mode === "Collection" && polResponse?.collectionDiscount;
            console.log(discountCondition);
            if (discountCondition) {
              applyDiscount(discountCondition, order_Mode, "autoDiscount");
            }
          }
          setPolling(true);
        }
      } catch (error) {
        console.error("Error fetching price total:", error);
      }
    };

    // Initial fetch
    fetchPriceTotal();

    // Polling every 8 seconds
    const interval = setInterval(fetchPriceTotal, 8000);

    // Cleanup on unmount
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const clientId = localStorage.getItem("clientId");
    // console.log(clientId);
    const formData = { client_id: clientId };
    getOrderTimingDetail(formData)
      .then((response) => {
        // console.log(response);
        if (response.status === true) {
          // console.log(response.status);
          setPreOrderTimeTable(response?.message);
        } else {
          // Handle the case where response.status is false
          console.log(response);
        }
      })
      .catch((error) => {
        // Handle the case where response.status is false
        console.log("Error: " + error);
      });
  }, []);

  useEffect(() => {
    const storedInstruction = localStorage.getItem("instruction") || "";
    setInstruction(storedInstruction);
  }, []);

  const postcodeDetail = localStorage.getItem("postcodeDetail") || "";
  const parsedPostcode = postcodeDetail ? JSON.parse(postcodeDetail) : "";
  const [deliveryCharge, setDeliveryCharge] = useState(0);
  const [stuartCharge, setStuartCharge] = useState(0);
  const sessionalOfferStatus = localStorage.getItem("sessionalOffer") || 0;
  const sessionalOfferTotal = localStorage.getItem("seasonalDiscount") || 0;
  const platform = 1;

  useEffect(() => {
    setStuartStatus(stripepayment?.message?.stuart || false);
    deviceDetect();
  }, [stripepayment]);

  useEffect(() => {
    if (getOrderMode === "Delivery") {
      const freeAbove = parseFloat(parsedPostcode?.freeAbove || 0);
      const lessThanAmount = parseFloat(parsedPostcode?.lessThenAmount || 0);
      const deliveryCharge = parseFloat(parsedPostcode?.deliveryCharge || 0);
      const extraDeliveryCharge = parseFloat(
        parsedPostcode?.extraDeliveryCharge || 0
      );
      const subtotal = parseFloat(subTotal);

      let newDeliveryCharge = "0.00";
      let newDeliveryChargeSet = 0.0;
      if (freeAbove == "0.00" || freeAbove == "0") {
        if (subtotal < lessThanAmount) {
          newDeliveryChargeSet = extraDeliveryCharge;
        }
        newDeliveryCharge = newDeliveryChargeSet + deliveryCharge;
      } else {
        if (subtotal < lessThanAmount) {
          newDeliveryChargeSet = extraDeliveryCharge;
          newDeliveryCharge = newDeliveryChargeSet;
        }
        if (freeAbove > subtotal) {
          newDeliveryCharge = newDeliveryChargeSet + deliveryCharge;
        }
      }

      // if (freeAbove <= subtotal) {
      //   setDeliveryCharge(
      //     parseFloat(
      //       lessThanAmount <= subtotal ? 0 : extraDeliveryCharge
      //     ).toFixed(2)
      //   );
      // } else {
      //   setDeliveryCharge(
      //     parseFloat(
      //       lessThanAmount <= subtotal
      //         ? deliveryCharge
      //         : deliveryCharge + extraDeliveryCharge
      //     ).toFixed(2)
      //   );
      // }

      setDeliveryCharge(parseFloat(newDeliveryCharge).toFixed(2));

      if (stuartStatus !== false) {
        setStuartCharge(
          parsedPostcode?.stuartDeliveryCharge?.deliveryCharge || 0
        );
      } else {
        setStuartCharge(0);
      }
    } else {
      setDeliveryCharge(0);
      setStuartCharge(0);
    }
  }, [getOrderMode]);
  useEffect(() => {
    if (getOrderMode === "Delivery") {
      const freeAbove = parseFloat(parsedPostcode?.freeAbove || 0);
      const lessThanAmount = parseFloat(parsedPostcode?.lessThenAmount || 0);
      const deliveryCharge = parseFloat(parsedPostcode?.deliveryCharge || 0);
      const extraDeliveryCharge = parseFloat(
        parsedPostcode?.extraDeliveryCharge || 0
      );
      const subtotal = parseFloat(subTotal);

      let newDeliveryCharge = "0.00";
      let newDeliveryChargeSet = 0.0;
      if (freeAbove == "0.00" || freeAbove == "0") {
        if (subtotal < lessThanAmount) {
          newDeliveryChargeSet = extraDeliveryCharge;
        }
        newDeliveryCharge = newDeliveryChargeSet + deliveryCharge;
      } else {
        if (subtotal < lessThanAmount) {
          newDeliveryChargeSet = extraDeliveryCharge;
          newDeliveryCharge = newDeliveryChargeSet;
        }
        if (freeAbove > subtotal) {
          newDeliveryCharge = newDeliveryChargeSet + deliveryCharge;
        }
      }

      // if (freeAbove <= subtotal) {
      //   setDeliveryCharge(
      //     parseFloat(
      //       lessThanAmount <= subtotal ? 0 : extraDeliveryCharge
      //     ).toFixed(2)
      //   );
      // } else {
      //   setDeliveryCharge(
      //     parseFloat(
      //       lessThanAmount <= subtotal
      //         ? deliveryCharge
      //         : deliveryCharge + extraDeliveryCharge
      //     ).toFixed(2)
      //   );
      // }

      setDeliveryCharge(parseFloat(newDeliveryCharge).toFixed(2));

      if (stuartStatus !== false) {
        setStuartCharge(
          parsedPostcode?.stuartDeliveryCharge?.deliveryCharge || 0
        );
      } else {
        setStuartCharge(0);
      }
    } else {
      setDeliveryCharge(0);
      setStuartCharge(0);
    }
  }, [parsedPostcode, getOrderMode]);

  useEffect(() => {
    if (
      isLoggedIn === "true" &&
      !isNaN(finalTotalValue) &&
      finalTotalValue > 0
    ) {
      getLoyaltyPoints({
        ordered_amount: finalTotalValue,
      });
    }
  }, [isLoggedIn, finalTotalValue]);

  const customerId = userData ? userData.customerId : "";

  //subcription
  useEffect(() => {
    if (isLoggedIn === "true" && customerId) {
      const customer_Id = {
        customer_id: customerId,
        domain: window.location.hostname,
      };
      getProfile(customer_Id)
        .then((response) => {
          if (response.status === false) {
          } else {
            if (response?.data?.profile?.email) {
              const Subcription_Data = {
                client_path: path,
                user_name: response?.data?.profile?.email,
              };
              dispatch(getSubcribeCoupon(Subcription_Data));
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [isLoggedIn, customerId]);

  const subcriptionCouponGet = useSelector(
    (state) => state.subscribeCouponReducer?.Plan?.message?.coupons
  );
  useMemo(() => {
    const CusSubscribeCoupon =
      getOrderMode == "Delivery"
        ? JSON.stringify(subcriptionCouponGet?.delivery_coupons)
        : JSON.stringify(subcriptionCouponGet?.delivery_coupons);
    localStorage.setItem("SubcripeCoupon", CusSubscribeCoupon);
  }, [subcriptionCouponGet]);

  useEffect(() => {
    // Ensure finalTotalValue and walletamount are valid and positive numbers
    if (!isNaN(finalTotalValue) && finalTotalValue > 0) {
      const oAmount = parseFloat(finalTotalValue); // Convert to float
      const walletAmount = parseFloat(walletamount); // Ensure walletamount is parsed correctly
      const isButtonEnabled = walletAmount <= oAmount;
      // Set the extra payment status based on the button status
      if (isButtonEnabled) {
        setExtraPayStatus(0);
      } else {
        setExtraPayStatus(1);
      }
    }
  }, [finalTotalValue, walletamount]); // Track changes for finalTotalValue and walletamount

  //subscription end

  // paymentDetail memo
  const paymentDetail = useMemo(() => {
    if (svpaySubmit > 0 || paySubmit > 0) {
      if (svpaySubmit === 1 || paySubmit === 1) {
        return {
          type: payType,
          paymentMethodId: paymentMId,
          sva: paymentSva,
        };
      }

      if (svpaySubmit === 3 || paySubmit === 2 || paySubmit === 3) {
        // alert(JSON.stringify("paymentMethodId", paymentMethodId))
        return {
          type: payType,
          sva: paymentSva,
          paymentIntentId: paymentIntentId,
        };
      }
    } else if (svpaySubmit === 0 || paySubmit === 0) {
      return {
        type: payType,
        paymentMethodId: paymentMId,
        sva: paymentSva,
      };
    }

    if (paySubmit === 14) {
      // console.log(payType);
      // console.log(payType);
      if (payType !== "PaypalIntent") {
        return {
          type: "PaypalMethodId",
          paymentMethodId: paymentMId,
        };
      } else {
        return {
          type: "paymentIntentId",
          paymentIntentId: paymentIntentId,
        };
      }
    }

    if (paySubmit === 10) {
      if (payType !== "klarnaOrderPlaced") {
        return {
          type: payType,
        };
      } else {
        return {
          type: payType,
          paymentIntentId: paymentIntentId,
        };
    }
    }
  }, [
    paymentType,
    paymentMId,
    paymentSva,
    paymentIntentId,
    svpaySubmit,
    paySubmit,
    payType,
  ]);

  // // old orderDetail memo
  // const orderDetail = useMemo(() => {
  //   // with and without time fieldsCheckoutPage
  //   let dateParts = "";
  //   let timePart = "";
  //   let formattedDate = "";

  //   if (preorder && preorder !== "0") {
  //     const inputDate = preorder;
  //     dateParts = inputDate.split(" ")[0].split("/"); // Split the date into parts
  //     timePart = inputDate.split(" ")[1]; // Get the time part
  //     // Create a Date object with the parts
  //     const dateObject = new Date(
  //       `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}T${timePart}`
  //     );

  //     // Format the date in the desired format
  //     const year = dateObject.getFullYear();
  //     const month = String(dateObject.getMonth() + 1).padStart(2, "0");
  //     const day = String(dateObject.getDate()).padStart(2, "0");
  //     const hour = String(dateObject.getHours()).padStart(2, "0");
  //     const minute = String(dateObject.getMinutes()).padStart(2, "0");
  //     formattedDate = `${year}-${month}-${day} ${hour}:${minute}`;
  //   }

  //   let login_type = 5;
  //   if (userData) {
  //     if (userData.login_type || userData.login_type === 0) {
  //       login_type = userData.login_type;
  //     }
  //   }
  //   const paymentType1 =
  //     selectedValue === "google-pay"
  //       ? "8"
  //       : selectedValue === "apple-pay"
  //         ? "7"
  //         : paymentType;
  //   return {
  //     loginType: login_type,
  //     orderType: orderType,
  //     paymentType: paymentType1,
  //     instruction: instruction,
  //     preOrder: formattedDate,
  //     cutlery: localCutlery,
  //     gift: gift,
  //     giftQty: gift === "" ? "" : "1",
  //   };
  // }, [
  //   paymentType,
  //   orderType,
  //   preorder,
  //   instruction,
  //   localCutlery,
  //   userData,
  //   gift,
  //   selectedValue,
  // ]);

  const parseDateString = (dateTimeString) => {
    // console.log("dateTimeString");
    // console.log(dateTimeString);
    if (dateTimeString && dateTimeString != 0) {
      const [date, time] = dateTimeString.split(" ");
      let day, month, year;
      if (date.includes("/")) {
        [day, month, year] = date.split("/");
      } else if (date.includes("-")) {
        [year, month, day] = date.split("-");
      }
      const [hour, minute] = time.split(":");
      return new Date(year, month - 1, day, hour, minute);
    } else {
      return 0;
    }
  };
  const [estimateShow, setEstimateShow] = useState(false);

  // orderDetail memo
  const isTableOrderCheck = localStorage.getItem("isTableQr");
  const orderDetail = useMemo(() => {
    // with and without time fieldsCheckoutPage
    let dateParts = "";
    let timePart = "";
    let formattedDate = "";

    const isTableOrder = localStorage.getItem("isTableQr");
    const tableName = localStorage.getItem("tableName");

    if (preorder && preorder !== "0") {
      let inputDate = preorder;
      if (inputDate.includes("/")) {
        dateParts = inputDate.split(" ")[0].split("/"); // Split the date into parts
        timePart = inputDate.split(" ")[1]; // Get the time part
        // Create a Date object with the parts
        const dateObject = new Date(
          `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}T${timePart}`
        );

        // Format the date in the desired format
        const year = dateObject.getFullYear();
        const month = String(dateObject.getMonth() + 1).padStart(2, "0");
        const day = String(dateObject.getDate()).padStart(2, "0");
        const hour = String(dateObject.getHours()).padStart(2, "0");
        const minute = String(dateObject.getMinutes()).padStart(2, "0");
        formattedDate = `${year}-${month}-${day} ${hour}:${minute}`;
      } else {
        formattedDate = preorder;
      }

      if (formattedDate != "") {
        const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const currentTime = new Date().toLocaleString("en", {
          timeZone: userTimezone,
          hour12: false,
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        });
        const [datePart, timePart] = currentTime.split(", ");
        const [month, day, year] = datePart.split("/");
        const [hour, minute] = timePart.split(":");
        const formattedDay = day.padStart(2, "0");
        const formattedMonth = month.padStart(2, "0");
        const formattedHours = parseInt(hour, 10);
        const formattedMinutes = parseInt(minute, 10);
        const formattedTime = `${formattedHours
          .toString()
          .padStart(2, "0")}:${formattedMinutes.toString().padStart(2, "0")}`;
        const changedDate = `${year}-${formattedMonth}-${formattedDay}`;
        const date1 = parseDateString(changedDate + " " + formattedTime);
        const date2 = parseDateString(localStorage.getItem("orderTime"));
        const date3 = parseDateString(localStorage.getItem("preOrder"));

        if (date1 > date2 || date1 > date3) {
          setEstimateShow(true);
        }
      }
    }

    let login_type = 5;
    if (userData) {
      if (userData.login_type || userData.login_type === 0) {
        login_type = userData.login_type;
      }
    }
    const paymentType1 =
      selectedValue === "google-pay"
        ? "8"
        : selectedValue === "apple-pay"
        ? "7"
        : paymentType;
    return {
      loginType: login_type,
      orderType: orderType,
      paymentType: paymentType1,
      instruction: instruction,
      preOrder: formattedDate,
      cutlery: localCutlery,
      gift: gift,
      giftQty: gift === "" ? "" : "1",
      isTableOrder: isTableOrder ? 1 : 0,
      tableName: tableName,
      useWalletBalance: useWalletBalance,
    };
  }, [
    paymentType,
    orderType,
    preorder,
    instruction,
    localCutlery,
    userData,
    gift,
    selectedValue,
    isTableOrderCheck,
    useWalletBalance,
  ]);

  // chargesDetail memo
  const placeOrderChargesDetail = useMemo(() => {
    return {
      subTotal: subTotal,
      deliveryCharge: deliveryCharge,
      driverTip: driverTip,
      roundAmount: roundedValue,
      extraDonate: "0.00",
      clientStuartCharge: stuartCharge,
      discount: discount,
      discountDescription: discountDesc ? "Discount" : "",
      promo: promo,
      promoDescription: promoDesc,
      voucher: voucher,
      voucherDescription: voucherDesc,
      sessionalOffer: sessionalOfferStatus,
      sessionalOfferTotal: sessionalOfferTotal,
      platform: platform,
    };
  }, [
    promo,
    promoDesc,
    voucher,
    voucherDesc,
    discount,
    discountDesc,
    deliveryCharge,
    stuartCharge,
    roundedValue,
    subTotal,
    driverTip,
    sessionalOfferStatus,
    sessionalOfferTotal,
    platform,
  ]);

  // itemsDetail memo
  const cartJSON = localStorage.getItem("cart") || "";
  const parsedCart =
    cartJSON && cartJSON !== "undefined" ? JSON.parse(cartJSON) : [];
  const menuLayoutType = localStorage.getItem("menuType") || "";
  useEffect(() => {
    if (Array.isArray(parsedCart) && parsedCart.length === 0) {
      // alert("hii")
      // navigate("/" + path + "/menu");
    }
  }, [parsedCart]);

  const itemsDetail = parsedCart
    ?.filter((item) => item.gift === 0)
    ?.map((item) => ({
      id: item.itemId.toString(),
      qty: item.count.toString(),
      loyalty: item.loyalty.toString(),
      instruction: item.instruction.toString(),
      addon: menuLayoutType === "1" ? "" : item.addon,
    }));

  
  // userDetail memo
  const userDetail = useMemo(() => {
    return {
      customerId: localCustomerId,
      addressId: localAddressId,
      postcode: localOrderPostcode,
      userAgent: navigator.userAgent,
      ip: ipAddress,
    };
  }, [
    navigator,
    paymentType,
    ipAddress,
    localCustomerId,
    localAddressId,
    localOrderPostcode,
  ]);

  const platforms =
    localStorage.getItem("isApp") == "true" ? "mobile_app" : "browser";

  const devices = isIOS
    ? "ios"
    : isAndroid
    ? "android"
    : isWindows
    ? "windows"
    : isMacOs
    ? "macOs"
    : "others";

  const deviceDetails = {
    device: devices ?? "",
    platform: platforms ?? "",
  };
  // alert(JSON.stringify(deviceDetails))
  // console.log('deviceDetailssdsfsf',deviceDetails)

  // final place order api memo
  const placeOrderApiJson = useMemo(() => {
    return {
      clientPath: path,
      orderDetail: orderDetail,
      paymentDetail: paymentDetail,
      userDetail: userDetail,
      chargesDetail: placeOrderChargesDetail,
      itemsDetail: itemsDetail,
      deviceDetail: deviceDetails,
    };
  }, [
    path,
    orderDetail,
    paymentDetail,
    placeOrderChargesDetail,
    userDetail,
    itemsDetail,
    paymentMId,
  ]);

  useEffect(() => {
    if (orderDetail) {
      localStorage.setItem("orderDetail", JSON.stringify(orderDetail));
    }
  }, [orderDetail]);
  const [orderApiStatus, setOrderApiStatus] = useState(false);

  useEffect(() => {
    if (gpaySubmit == 0) {
      return;
    }
    if (gpaySubmit === 1) {
      placeOrderApiJson.paymentDetail.paymentMethodId = paymentMId;

      localStorage.setItem(
        "placeOrderApiData",
        JSON.stringify(placeOrderApiJson)
      );
      postPlaceOrder(placeOrderApiJson);

      setPaymentSuccessShow(true);
      setPaymentSuccessMsg("loading");
    } // google pay/ apple pay order submit
  }, [gpaySubmit, paymentMId]);

  useEffect(() => {
    if (svpaySubmit == 0) {
      return;
    }
    localStorage.setItem(
      "placeOrderApiData",
      JSON.stringify(placeOrderApiJson)
    );
    console.log("placeOrderApiJson =>", placeOrderApiJson);
    postPlaceOrder(placeOrderApiJson); // savecard payment submit
  }, [svpaySubmit]);

  useEffect(() => {
    if (paySubmit == 0) {
      return;
    }
    if (
      paySubmit === 1 ||
      paySubmit === 3 ||
      paySubmit === 9 ||
      paySubmit === 10 ||
      paySubmit === 14
    ) {
      localStorage.setItem(
        "placeOrderApiData",
        JSON.stringify(placeOrderApiJson)
      );
      postPlaceOrder(placeOrderApiJson); // card payment and wallet payment submit
      afterPlaceOrder(placeOrderApiJson);
    }
  }, [paySubmit]);

  useEffect(() => {
    if (
      placeorder &&
      placeorder.status &&
      placeorder.type == "orderPlaced" &&
      gpaySubmit == 1
    ) {
      setPaymentSuccessShow(true);
      setPaymentSuccessMsg("loading");
    }
  }, [placeorder, gpaySubmit]);

  useEffect(() => {
    if (placeorder?.response_code === 500) {
      navigate("/" + path + "/menu");
    }
    // Gp and Ap payment code
    if (
      placeorder &&
      placeorder.status &&
      placeorder.type == "orderPlaced" &&
      gpaySubmit == 1
    ) {
      // console.log("orderstatus1");
      setLastOrder(placeorder.message);
      setPaymentSuccessShow(true);
      setPaymentSuccessMsg("success");
      setGpaySubmit(0);
      setPaySubmit(0);
      localStorage.removeItem("paymentStatus");
      if (width > breakpoint) {
        navigate("/myaccount/orderstatus", {
          state: { promotion_type: promotionType },
        });
      } else {
        navigate("/orderstatus", { state: { promotion_type: promotionType } });
      }
      setOrderApiStatus(false);
      removeSession();
    }

    // wallet payment code
    if (
      placeorder &&
      placeorder.status &&
      placeorder.type == "orderPlaced" &&
      paySubmit == 9
    ) {
      // console.log("orderstatus9");
      setLastOrder(placeorder.message);
      setGpaySubmit(0);
      setPaySubmit(0);
      setSvpaySubmit(0);
      localStorage.removeItem("paymentStatus");
      if (width > breakpoint) {
        navigate("/myaccount/orderstatus", {
          state: { promotion_type: promotionType },
        });
      } else {
        navigate("/orderstatus", { state: { promotion_type: promotionType } });
      }
      setOrderApiStatus(false);
      removeSession();
    }

    if (
      placeorder &&
      placeorder.status &&
      placeorder.type == "orderPlaced" &&
      paySubmit == 1
    ) {
      // console.log("orderstatus0");
      setLastOrder(placeorder.message);
      setGpaySubmit(0);
      setPaySubmit(0);
      setSvpaySubmit(0);
      localStorage.removeItem("paymentStatus");
      if (width > breakpoint) {
        navigate("/myaccount/orderstatus", {
          state: { promotion_type: promotionType },
        });
      } else {
        navigate("/orderstatus", { state: { promotion_type: promotionType } });
      }
      setOrderApiStatus(false);
      removeSession();
    }

    // savecard payment code
    if (
      placeorder &&
      placeorder.status &&
      placeorder.type == "orderPlaced" &&
      svpaySubmit == 3
    ) {
      // console.log("orderstatus3");
      setLastOrder(placeorder.message);
      setGpaySubmit(0);
      setPaySubmit(0);
      setSvpaySubmit(0);
      localStorage.removeItem("paymentStatus");
      if (width > breakpoint) {
        navigate("/myaccount/orderstatus", {
          state: { promotion_type: promotionType },
        });
      } else {
        navigate("/orderstatus", { state: { promotion_type: promotionType } });
      }
      setOrderApiStatus(false);
      removeSession();
    }

    // card payment code
    if (
      placeorder &&
      placeorder.status &&
      placeorder.type == "orderPlaced" &&
      paySubmit == 3
    ) {
      setLastOrder(placeorder.message);
      setGpaySubmit(0);
      setPaySubmit(0);
      setSvpaySubmit(0);
      setButtonstatus(false);
      localStorage.removeItem("paymentStatus");
      if (width > breakpoint) {
        navigate("/myaccount/orderstatus", {
          state: { promotion_type: promotionType },
        });
      } else {
        navigate("/orderstatus", { state: { promotion_type: promotionType } });
      }
      setOrderApiStatus(false);
      removeSession();
    }

    // cash
    // if (
    //   placeorder &&
    //   placeorder.status &&
    //   placeorder.type == "orderPlaced" &&
    //   paySubmit == 1
    // ) {
    //   // console.log("orderstatus33");
    //   // setGpaySubmit(0);
    //   // setPaySubmit(0);
    //   // setSvpaySubmit(0);
    //   // setButtonstatus(false);
    //   // navigate("/orderstatus");
    //   // setOrderApiStatus(false);
    //   // removeSession();
    // }

    // save card payment code
    if (
      placeorder &&
      placeorder.status &&
      placeorder.type == "3dSecure" &&
      svpaySubmit == 1
    ) {
      if (placeorder?.message?.clientSecret) {
        const svclientSecret = placeorder.message.clientSecret;
        setSvclientSecret(svclientSecret);
        setSvpaySubmit(2);
      } else {
        setSvpaySubmit(0);
      }
      setOrderApiStatus(true);
    }

    // card payment code
    if (
      placeorder &&
      placeorder.status &&
      placeorder.type == "3dSecure" &&
      paySubmit == 1
    ) {
      if (placeorder?.message?.clientSecret) {
        const clientSecret = placeorder.message.clientSecret;
        setClientSecret(clientSecret);
        setPayType("paymentIntentId");
        setPaymentIntentId(placeorder.message.id);
        setPaySubmit(2);
        console.log("placeorder 1", placeorder.message.id);
        // console.log(placeorder.message.id);
      } else {
        setPaySubmit(0);
      }
      setOrderApiStatus(true);
    }

    if (
      placeorder &&
      placeorder.status &&
      placeorder.type == "orderPlaced" &&
      paySubmit == 1 &&
      orderApiStatus === true
    ) {
      setLastOrder(placeorder.message);
      console.log("placeorder 2", placeorder.message.id);
      setGpaySubmit(0);
      setPaySubmit(0);
      setSvpaySubmit(0);
      setPaySpinner(true);
      localStorage.removeItem("paymentStatus");
      if (width > breakpoint) {
        navigate("/myaccount/orderstatus", {
          state: { promotion_type: promotionType },
        });
      } else {
        navigate("/orderstatus", { state: { promotion_type: promotionType } });
      }
      setOrderApiStatus(false);
      removeSession();
    }
    if (placeorder && placeorder.status && paySubmit === 14) {
      if (placeorder.type === "PayPalIntent") {
        if (placeorder?.message?.clientSecret) {
          const clientSecret = placeorder.message.clientSecret;
          setPaySpinner(true);
          setPayPalClientSecret(clientSecret);
          setPaySubmit(14);
        }
      } else if (placeorder.type === "orderPlaced") {
        setLastOrder(placeorder.message);
        setGpaySubmit(0);
        setPaySubmit(14);
        setSvpaySubmit(0);
        setPaySpinner(true);
        if (width > breakpoint) {
          navigate("/myaccount/orderstatus", {
            state: { promotion_type: promotionType },
          });
        } else {
          navigate("/orderstatus", {
            state: { promotion_type: promotionType },
          });
        }
        setOrderApiStatus(false);
        removeSession();
      }
    }

    if (placeorder && placeorder.status && paySubmit === 10) {
      if (placeorder.type === "klarnaIntent") {
        if (placeorder?.message?.clientSecret) {
          const clientSecret = placeorder.message.clientSecret;
          // console.log("klranaIntent");
          setPaySpinner(true);
          setClientSecret(clientSecret);
          setPaySubmit(10);
        }
      } else if (placeorder.type === "orderPlaced") {
        // console.log("klranaPlaced");
        setLastOrder(placeorder.message);
        setGpaySubmit(0);
        setPaySubmit(10);
        setSvpaySubmit(0);
        setPaySpinner(true);
        if (width > breakpoint) {
          navigate("/myaccount/orderstatus", {
            state: { promotion_type: promotionType },
          });
        } else {
          navigate("/orderstatus", {
            state: { promotion_type: promotionType },
          });
        }
        setOrderApiStatus(false);
        removeSession();
      }
    }
  }, [placeorder, paySubmit, gpaySubmit]);

  function removeSession() {
    localStorage.removeItem("cart");
    localStorage.removeItem("totalPrice");
    localStorage.removeItem("cartQty");
    localStorage.removeItem("discount");
    localStorage.removeItem("gift");
    localStorage.removeItem("orderType");
    localStorage.removeItem("cutlery");
    localStorage.removeItem("preOrder");
    localStorage.removeItem("postcodeDetail");
    localStorage.removeItem("checkRoundEnable");
    localStorage.removeItem("roundOffPrice");
    // localStorage.removeItem("guestAddress");
    localStorage.removeItem("driverTipValue");
    localStorage.removeItem("orderMode");
    localStorage.removeItem("itemNotes");
    localStorage.removeItem("orderTime");
    localStorage.removeItem("instruction");
    localStorage.removeItem("checkRepeatAddon");
    localStorage.removeItem("sessionalOffer");
    localStorage.removeItem("seasonalDiscount");
    dispatch(clearPlaceOrder());
  }

  const orderModeChecked = localStorage.getItem("orderMode");
  const isLoggedInChecked = localStorage.getItem("isLoggedIn");
  useEffect(() => {
    getStripePayment({
      client_path: path,
      customer_id: customerId,
      platform: 1,
    });
  }, [getStripePayment, path, orderModeChecked, isLoggedInChecked]);

  useEffect(() => {
    getchargesDetail({
      client_path: path,
      platform: 1,
    });
  }, [getchargesDetail, path]);

  const [customer, setCustomer] = useState("");
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));

    if (userData !== null && isLoggedIn === "true") {
      setCustomer(userData);
    } else {
      setCustomer("");
    }
  }, [isLoggedIn]);

  const addressFormData = useMemo(() => {
    return customer ? { customer_id: customer.customerId } : null;
  }, [customer]);

  useEffect(() => {
    if (!addressFormData) {
      return;
    }
    getAddress(addressFormData);
  }, [addressFormData, getAddress]);
  //preOrder Check
  useEffect(() => {
    const interval = setInterval(() => {
      setUkRailwayTime(new Date());
    }, 1000); // Update every second

    return () => clearInterval(interval); // Clean up interval on component unmount
  }, []);
  const convertDateFormat = (dateString) => {
    // Split the date string assuming it's in "DD/MM/YYYY" format
    const [datePart, timePart] = dateString.split(" ");

    // Split the date into day, month, and year
    const [day, month, year] = datePart.split("/");

    // Return in "YYYY-MM-DD" format
    return `${year}-${month}-${day} ${timePart}`;
  };
  const effectRan = useRef(false); // Ref to keep track if the effect has run

  useEffect(() => {
    if (effectRan.current === false) {
      console.log("111");
      fetchItemAvailability();
      effectRan.current = true; // Mark the effect as having run
    }
  }, []); // Empty dependency array to run only once

  const fetchItemAvailability = async () => {
    let orderTiming = localStorage.getItem("orderTime");
    setEffectStatus(false);
    try {
      let timingModeCheck =
        typeof orderTiming === "string" && orderTiming.includes("/");
      let timingMode = timingModeCheck
        ? convertDateFormat(orderTiming)
        : orderTiming;
      const localStorageItems = JSON.parse(localStorage.getItem("cart"));
      const path = localStorage.getItem("clientPath");
      const data = {
        client_path: path,
        order_time: timingMode,
      };
      console.log("444");
      const res = await itemAvailableCheck(data);

      if (res && res.data && res.data.items) {
        console.log("555");
        console.log(res.data.items);
        setItemAvailableData(res.data.items);
        const resetItem = localStorageItems?.filter((itemA) => {
          if (Array.isArray(res?.data?.items)) {
            return !res.data.items.some(
              (itemB) => itemB.itemId === itemA.itemId
            );
          }
          return true;
        });

        if (resetItem?.length > 0) {
          console.log("666");
          resetItem.forEach((reset, i) => {
            const discountJSON = localStorage.getItem("discount");
            const parsedDiscount = discountJSON ? JSON.parse(discountJSON) : 0;
            cartRemoveAllItem(reset, parsedDiscount, getOrderMode);
          });
        }
      } else {
        console.log("No items available.");
      }
    } catch (error) {
      console.error("Error checking item availability:", error);
    }
  };

  // const currentTime = ukRailwayTime.toLocaleTimeString('en-GB');
  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  };

  const formatter = new Intl.DateTimeFormat("en-GB", options);

  const currentDateTime1 = formatter.format(ukRailwayTime);
  const currentDateTime = currentDateTime1?.replace(",", "");

  if (!addressDetail && !chargesdetail && !stripepayment) {
    return <Checkoutpageskeleton />;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  const scrollToSection = () => {
    // Use the current property of the ref to access the DOM node
    sectionRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const checkOrderTime = () => {
    const preorderTime = localStorage.getItem("preOrder");
    const preorder = preorderTime || "";
    if (preorder && preorder !== "0") {
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const currentTime = new Date().toLocaleString("en", {
        timeZone: userTimezone,
        hour12: false,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
      const [datePart, timePart] = currentTime.split(", ");
      const [month, day, year] = datePart.split("/");
      const [hour, minute] = timePart.split(":");
      const formattedDay = day.padStart(2, "0");
      const formattedMonth = month.padStart(2, "0");
      const formattedHours = parseInt(hour, 10);
      const formattedMinutes = parseInt(minute, 10);
      const formattedTime = `${formattedHours
        .toString()
        .padStart(2, "0")}:${formattedMinutes.toString().padStart(2, "0")}`;
      const changedDate = `${formattedDay}/${formattedMonth}/${year}`;
      const date1 = parseDateString(changedDate + " " + formattedTime);
      const date2 = parseDateString(localStorage.getItem("orderTime"));
      const date3 = parseDateString(localStorage.getItem("preOrder"));
      if (date1 > date2 || date1 > date3) {
        return true;
      }
    }
  };

  //save card function
  const handlesavecardPayment = async (paymentMethodId) => {
    const checkTime = checkOrderTime();

    if (checkTime) {
      setEstimateShow(true);
    } else {
      setPaymentMId(paymentMethodId);
      setPayType("saveCardPaymentIntent");
      setSvpaySubmit(1); // for create payment Intent id
      setPaymentType(1); // payment type 1,8,7,9
      setButtonstatus(true);
    }
  };
  const CARD_OPTIONS1 = {
    iconStyle: "solid",
    style: {
      base: {
        iconColor: "#c4f0ff",
        color: theme === "dark" ? "#fff" : "#000",
        fontWeight: "400",
        fontFamily: "Segoe UI",
        fontSize: "16px",
        fontSmoothing: "antialiased",
        backgroundColor: theme === "dark" ? "#1a1a1a" : "#fff",
        "::placeholder": {
          color: "#aab7c4",
        },
        ":-webkit-autofill": {
          color: theme === "dark" ? "#fff" : "#000",
          backgroundColor: theme === "dark" ? "#1a1a1a" : "#fff",
        },
      },
      invalid: {
        color: "#e5424d",
        iconColor: "#e5424d",
      },
    },
  };

  const containerStyle = {
    borderRadius: "8px",
    padding: "20px",
    border: theme === "dark" ? "1px solid #fff" : "1px solid #ebedf0",
    backgroundColor: theme === "dark" ? "#1a1a1a" : "#fff",
  };

  const currency_symbol = localStorage.getItem("currencySymbol");
  return (
    <>
      <CheckoutContext.Provider
        value={{
          addressDetail,
          payType,
          setPayType,
          paymentSva,
          setPaymentSva,
          paymentMId,
          setPaymentMId,
          paymentIntentId,
          setPaymentIntentId,
          paymentType,
          setPaymentType,
          stripepayment,
          placeOrderApiJson,
          chargesdetail,
          applepayGpayBtnStatus,
          setApplepayGpayBtnStatus,
          paymentRequest,
          PlaceOrderJson,
          stripe,
          elements,
          setPaySubmit,
          paySubmit,
          setGpaySubmit,
          gpaySubmit,
          setSvpaySubmit,
          svpaySubmit,
          setApaySubmit,
          clientSecret,
          setClientSecret,
          setPayPalClientSecret,
          payPalClientSecret,
          svclientSecret,
          setSvclientSecret,
          apaySubmit,
          placeorder,
          instruction,
          setInstruction,
          AddressPopupshow,
          walletstatus,
          setWalletstatus,
          localGuestMode,
          walletamount,
          setWalletamount,
          setAddressPopupshow,
          setCardErrorMessage,
          setPayPalErrorMessage,
          setFinalTotal,
          cardErrorMessage,
          PaypalErrorMessage,
          deliveryCharge,
          bagCharge,
          clientFkCharge,
          serviceCharge,
          setRoundedValue,
          roundedValue,
          setDriverTip,
          driverTip,
          subTotal,
          finalTotal,
          faildshow,
          setFaildShow,
          buttonstatus,
          setButtonstatus,
          finalTotalValue,
          setFinalTotalValue,
          getLoyalty,
          updateJsonData,
          setPaymentMethodId,
          jsonData,
          setPaymentRequest,
          selectedValue,
          setSelectedValue,
          paymentOptions,
          cardtype,
          setCardtype,
          paypalType,
          setPaypalType,
          cashtype,
          setCashtype,
          applepaytype,
          setApplepaytype,
          googlepaytype,
          setGooglepaytype,
          klarnaType,
          setKlarnaType,
          footerBtn,
          setFooterBtn,
          scrollelement,
          setScrollelement,
          sectionRef,
          scrollToSection,
          paymentSuccessShow,
          setPaymentSuccessShow,
          paymentSuccessMsg,
          setPaymentSuccessMsg,
          paymentModalShow,
          setPaymentModalShow,
          gpaydeviceInfo,
          appledeviceInfo,
          paysaveCard,
          setPaySaveCard,
          handlesavecardPayment,
          CARD_OPTIONS1,
          containerStyle,
          saveCardError,
          setSaveCardError,
          cardStatus,
          setCardStatus,
          paySpinner,
          setPaySpinner,
          currentDateTime,
          preorder,
          duplicatHeight,
          setDuplicatHeight,
          preOrderTimeTable,
          setPreOrderTimeTable,
          getorderType,
          setGetOrderType,
          postCodePopupshow,
          setPostCodePopupshow,
          newAddresShow,
          setNewAddressShow,
          tabStatus,
          setTabStatus,
          selectimeStatus,
          setSelectimeStatus,
          selectedTime,
          setSelectedTime,
          selectEstimateTime,
          setSelectEstimateTime,
          exitOrderDatePart,
          exitOrderTimePart,
          formattedDateE,
          formatToday,
          estimateShow,
          setEstimateShow,
          clientName,
          setClientName,
          clientImages,
          setClientIamges,
          clientLogo,
          setClientLogo,
          scrolled,
          setScrolled,
          topScolled,
          setTopScolled,
          setMinOrderModal,
          minOrderModal,
          minOrderMessage,
          setMinOrderMessage,
          setMinOrderStatus,
          minOrderStatus,
          itemAvailableData,
          setItemAvailableData,
          effectStatus,
          setEffectStatus,
          fetchItemAvailability,
          autoshowPopup,
          setAutoShowPopup,
          localCustomerId,
          currency_symbol,
          extraAmountModal,
          setExtraAmountModal,
          useWalletBalance,
          setUseWalletBalance,
          extraLessAmount,
          setExtraLessAmount,
          extraPayment,
          setExtraPayment,
          extraStatus,
          setExtraStatus,
          extraPayStatus,
          setExtraPayStatus,
          polling,
          applyDiscount,
          showModalAddressEdit,
          setShowModalAddressEdit,
          deliverPostCodeStatus,setDeliverPostCodeStatus
        }}
      >
        <Helmet>
          <style type="text/css">{`
        @media only screen and (min-width: 320px) and (max-width: 767px) {
          .copyright-sec {
            display:none;
          }
          .top-to-btm .icon-position {
            bottom: 80px;
            display:none;
          }
          .theme-btn{
            display:none;
          }
          nav.main-header .logo img{
              // visibility:hidden;
              display:none;
            }
                .sticky-top {
          padding-bottom: 20px !important;
          padding-top: 10px !important;
        }
        button.navbar-toggler.collapsed {
          margin-top: 12px;
        }
        .scroll-header-content {
          margin-top: 12px;
        }
          .scroll-header-content button{
          background-color: #dde0e4 !important;
            }
      .scroll-header-content button svg{
          font-size: 18px;
          fill: #000 !important;
          margin-right: 2px;
      }
        }
        footer{ 
            display:none;
          }
          .checkbox-wrapper-54 .slider {
            display:none;
      }
                #light-dark-tool {
          display: none;
      }

          
      `}</style>
          <style type="text/css">{`
      :root {
        scroll-behavior: inherit;
      }
      .top-to-btm{
        display:none;
      }
        .transform-active {
                position: absolute;
                display: flex;
                justify-content: space-between;
                align-items: center;
                background-color: var(--theme-background);
                border-radius: 50px;
                border: none;
                box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.3);
              } 
      `}</style>
        </Helmet>

        {width < 768 && <ClientNameHeader />}
        <CheckoutV2
          showPreorder={showPreorder}
          setShowPreorder={setShowPreorder}
        />
        <PaymentSuccess />
        <PaymentFaild />
        <PaymentComponent userData={userData} />
      </CheckoutContext.Provider>
    </>
  );
};

const mapStateToProps = (state) => ({
  chargesdetail: state.chargesdetail.chargesdetail, // Replace 'post' with your reducer name
  userData: state.userdata.userData,
  stripepayment: state.stripepayment.stripepayment,
  stripee: state.stripe,
  placeorder: state.placeorder.placeorder,
  addressDetail: state.address.address,
  getLoyalty: state.getLoyalty.loyaltyPoints,
});
const mapDispatchToProps = {
  getchargesDetail,
  getStripePayment,
  postPlaceOrder,
  getAddress,
  getLoyaltyPoints,
  applyDiscount,
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutPagev2);

export const updateAddress = async (formData) => {
  try {
    const response = await updateAddressApi(formData);
    // console.log(response.data);
    return response.data; // Assuming the response has a 'data' property
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const checkPostcode = async (formData) => {
  try {
     const secret = "FUSION-POSTCODE-2025"; // Your secret key
       // Encode the payload into a JWT
       const token = jwtEncode(formData, secret);
       const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      };
    const response = await postcodeDetailApi(token);
    return response.data; // Assuming the response has a 'data' property
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const googleAddress = async (formData) => {
  if (formData?.post_code) {
    try {
       const secret = "FUSION-2025"; // Your secret key
       const payload = {
        fuspcode: formData?.post_code,
       };
       // Encode the payload into a JWT
       const token = jwtEncode(payload, secret);
       const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      };
       const response = await googleAddressApi(token,config);
      return response.data; // Assuming the response has a 'data' property
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
};

export const getProfile = async (formData) => {
  try {
    const response = await getProfileApi(formData);
    return response.data; // Assuming the response has a 'data' property
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const AddressProvider = createContext({});
export const AddressPopupContext = () => useContext(AddressProvider);

const CheckoutV2 = ({
  showPreorder,
  setShowPreorder,
  setGetOrderType,
  getorderType,
}) => {
  const {
    preOrderTimeTable,
    scrolled,
    setScrolled,
    setTopScolled,
    chargesdetail,
    itemAvailableData,
  } = useContext(CheckoutContext);
  // ! page width
  const { getOrderMode, getOrderTime } = OrderFlow();
  const [width, setWidth] = useState(window.innerWidth);
  const [cartItemsData, setcartItems] = useState([]);
  const orderModeChecked = localStorage.getItem("orderMode");
  const orderpostcodechecked = localStorage.getItem("orderPostcode");
  const storeClientNamecheck = localStorage.getItem("clientName");
  const cartqtyName = localStorage.getItem("cartQty");
  const preorderTime = localStorage.getItem("preOrder");
  const TatTime = localStorage.getItem("tatTime");
  const isDesktop = window.innerWidth > 768;

  // const breakpoint = 767;
  useEffect(() => {
    const handleResizeWindow = () => setWidth(window.innerWidth);
    // subscribe to window resize event "onComponentDidMount"
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      // unsubscribe "onComponentDestroy"
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, []);
  useEffect(() => {
    if (!chargesdetail?.message?.driverTipStatus) {
      localStorage.removeItem("driverTipValue");
    }
  }, [chargesdetail]);

  const tipStatus = chargesdetail && chargesdetail?.message?.driverTipStatus;

  useEffect(() => {
    function handleScroll() {
      // console.log(window?.scrollY);
      if (window.scrollY > 2) {
        setTopScolled(true);
      } else {
        setTopScolled(false);
      }

      if (window.scrollY > 50) {
        // Change 100 to the scroll position where you want the class to be added
        setScrolled(true);
        // console.log("ttt");
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    let localStorageData =
      localStorage.getItem("cart") &&
      localStorage.getItem("cart") !== "undefined"
        ? JSON.parse(localStorage.getItem("cart"))
        : [];

    setcartItems(localStorageData);
  }, [localStorage.getItem("cart")]);
  return (
    <>
      <div className="fus-checkout-page">
        {width < 768 && <ClientNameHeader />}
        <div className={width > 575 ? "container" : ""}>
          <div className="fus-checkout">
            {/* <Container> */}
            <Row>
              {/* <div className={`fus-top-title ${topScolled ? "" : ""}`}>
                  <Col xl={7} lg={7}>
                    <div style={{ display: "flex" }}>
                      <Image
                        src={clientImages ? clientImages : clientLogo}
                        roundedCircle
                        className="fus-client-img"
                      />
                      <h5 className="fus-client-title">
                        {clientName ? clientName : ""}
                      </h5>
                    </div>
                  </Col>
                  <Col xl={5} lg={5}>
                    <div className="fus-payment-btn1">
                      <OrderButton />
                    </div>
                  </Col>
                </div> */}
              {/* firse Section */}
              <Col xl={6} lg={6} className="lg-style-1">
                <div className="fus-delivery-bar">
                  {/* delivery card */}
                  <div>
                    <PreOrderSection
                      setShowPreorder={setShowPreorder}
                      showPreorder={showPreorder}
                      preOrderTimeTable={preOrderTimeTable}
                    />
                  </div>
                  {/* estimate card */}
                  <EstimateCard />
                  <Vouchermobile />
                  {/* payment card */}
                  <VoucherCodeAdd />
                  <PaymentMethod />

                  {/* Tip card */}
                  {tipStatus && <AddTip />}

                  <DonateChange />
                  <MobilePayMentDropdown />
                  {/* <PaymentBillMobile /> */}
                  {/* end Tip card */}
                  {/* request Card */}

                  {/* <div >
                      <Card  className="requestCard">
                      <Card.Body>
                        <div className="request-detail">
                            <div className="request-text">
                              <p className="request-text-postcode">Request Invoice</p>
                              <p className="estimate-text-sub">Add Tax Details</p>
                            </div>
                            <div className="request-action-btn">
                              <button className="request-action-btn">
                                Edit
                              </button>
                            </div>
                        </div>
                      </Card.Body>
                      </Card>
                      </div> */}

                  {/* order card */}
                  {/* <div>
                      <Card className="orderCard">
                        <Card.Body>
                          <Card.Title className="order-summary-title">Order Summary
                            <div className="order-summary-btn">
                              <button className="order-summary-btn">
                                + Add Items
                              </button>
                            </div>
                          </Card.Title>

                          <div className="order-detail">
                            <div className="order-text">
                              <p className="order-text-postcode">1 Item</p>
                            </div>
                          </div>

                          <div className="border-style">
                            <div className="borders">
                            </div>
                          </div>

                          <div className="order-detail">
                            <div className="order-count">
                              1
                            </div>
                            <div className="order-text">
                              <p className="order-text-postcode">Meet at Door</p>
                              <p>add order instruction</p>
                            </div>

                            <div className="order-action-btn">
                              $3.55
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </div> */}
                </div>
              </Col>
              {/* second section */}
              <Col
                xl={6}
                lg={6}
                className={`${scrolled ? "lg-style-2" : "lg-style-2"}`}
                style={{ paddingLeft: isDesktop ? "20px" : "0px" }}
              >
                <div className="fus-payment-btn d-sm-none d-xs-none d-xl-block d-xxl-block d-lg-block d-md-none">
                  {/* Continue to Payment  */}
                </div>

                <div className="fus-payment-bar">
                  <ItemToal />
                </div>

                <MobileCart />
              </Col>
            </Row>
            {/* </Container> */}
          </div>
        </div>
      </div>
      {/* <PaymentProcessingPopup /> */}
    </>
  );
};
const PreOrderSection = (props) => {
  const { currency_symbol } = CheckoutData();
  const { getOrderMode, getOrderTime, setOrderMode } = OrderFlow();
  const [appliedDiscount, setAppliedDiscount] = useState(0);
  const SummaryOrderType = getOrderMode === "Collection" ? 1 : 0;
  const [parsedDiscount, setParsedDiscount] = useState("");

  const {
    setAddressPopupshow,
    setInstruction,
    setGetOrderType,
    preOrderTimeTable,
    setSelectimeStatus,
    setSelectedTime,
    formatToday,
    setMinOrderModal,
    minOrderModal,
    setMinOrderStatus,
    fetchItemAvailability,
  } = useContext(CheckoutContext);
  const { theme } = useContext(ThemeContext);

  const [orderModeType, setOrderModeType] = useState(null);
  //itemAvilable Check Time

  // Dynamic Discount
  const collectionDiscount = JSON.parse(
    localStorage.getItem("collectionDiscount")
  );
  const deliveryDiscount = JSON.parse(localStorage.getItem("deliveryDiscount"));

  const HandleClick = async (selectedTab) => {
    const tableCheck = localStorage.getItem("isTableQr");
    if (!tableCheck) {
      setOrderModeType(selectedTab);
      setOrderMode(selectedTab);
      setSelectimeStatus(true);
      setSelectedTime(null);

      //Delivery
      const preOrderDeliveryToday = preOrderTimeTable?.Delivery?.today;
      let preOrderDeliveryTodayTiming = preOrderDeliveryToday?.split(",")[0];
      //Delivery later
      const DeliverylaterObject = preOrderTimeTable?.Delivery?.later;
      let preOrderDeliveryLaterTiming = "";
      let preOrderDeliveryDate = "";
      if (
        DeliverylaterObject != "" &&
        DeliverylaterObject != "No Pre-order later"
      ) {
        // Get the keys of the 'later' object
        const laterKeys = Object.keys(DeliverylaterObject);
        // Sort the keys if needed (dates are usually sorted, but this ensures correct order)
        laterKeys.sort();
        // Get the first key and its corresponding value
        preOrderDeliveryDate = laterKeys[0];
        const firstValue = DeliverylaterObject[preOrderDeliveryDate];

        // If you need the first time from the first value
        preOrderDeliveryLaterTiming = firstValue.split(",")[0];

        console.log(
          `First date: ${preOrderDeliveryDate}, First time: ${preOrderDeliveryLaterTiming}`
        );
      } else {
        console.log("later object is undefined or empty");
      }

      //collection
      const preOrderCollectionToday = preOrderTimeTable?.Collection?.today;
      let preOrderCollectionTodayTiming =
        preOrderCollectionToday?.split(",")[0];
      //collection later
      const laterObject = preOrderTimeTable?.Collection?.later;
      let preOrderCollectionLateTiming;
      let preOrderCollectionDate = "";
      if (laterObject != "" && laterObject != "No Pre-order later") {
        // Get the keys of the 'later' object
        const laterKeys = Object.keys(laterObject);
        // Sort the keys if needed (dates are usually sorted, but this ensures correct order)
        laterKeys.sort();
        // Get the first key and its corresponding value
        preOrderCollectionDate = laterKeys[0];
        const firstValue = laterObject[preOrderCollectionDate];

        // If you need the first time from the first value
        preOrderCollectionLateTiming = firstValue.split(",")[0];

        console.log(
          `First date: ${preOrderCollectionDate}, First time: ${preOrderCollectionLateTiming}`
        );
      } else {
        console.log("later object is undefined or empty");
      }

      localStorage.setItem("orderMode", selectedTab);
      const orderMinOrder_Check = localStorage.getItem("orderMinOrder")
        ? JSON.parse(localStorage.getItem("orderMinOrder"))
        : "";
      const TotalPriceValue = localStorage.getItem("totalPrice")
        ? localStorage.getItem("totalPrice")
        : 0;
      if (selectedTab == "Delivery") {
        //minOrder Check
        if (orderMinOrder_Check) {
          if (
            parseFloat(TotalPriceValue) <
            parseFloat(orderMinOrder_Check.deliveryMinOrder)
          ) {
            // console.log(TotalPriceValue, orderMinOrder_Check.deliveryMinOrder);
            setMinOrderModal(true);
            setMinOrderStatus(true);
          } else {
            setMinOrderModal(false);
            setMinOrderStatus(false);
          }
        }

        if (preOrderTimeTable && preOrderTimeTable?.Delivery?.asap?.tatTime) {
          setGetOrderType("ASAP");
          localStorage.setItem("orderType", "ASAP");
          localStorage.setItem(
            "orderTime",
            preOrderTimeTable?.Delivery?.asap?.time
          );
          localStorage.setItem("preOrder", "0");
          fetchItemAvailability();
        } else {
          if (
            preOrderTimeTable &&
            preOrderTimeTable?.Delivery &&
            preOrderTimeTable.Delivery.today &&
            preOrderTimeTable.Delivery.today != "" &&
            preOrderTimeTable.Delivery.today != "No Pre-order" &&
            preOrderTimeTable.Delivery.today != "closed"
          ) {
            setGetOrderType("Today");
            // console.log(preOrderDeliveryTodayTiming);
            localStorage.setItem("orderType", "Today");
            localStorage.setItem(
              "orderTime",
              formatToday + " " + preOrderDeliveryTodayTiming
            );
            localStorage.setItem(
              "preOrder",
              formatToday + " " + preOrderDeliveryTodayTiming
            );
            fetchItemAvailability();
          } else {
            setGetOrderType("Later");
            localStorage.setItem("orderType", "Later");

            localStorage.setItem(
              "orderTime",
              preOrderCollectionDate + " " + preOrderDeliveryLaterTiming
            );
            localStorage.setItem(
              "preOrder",
              preOrderCollectionDate + " " + preOrderDeliveryLaterTiming
            );
            fetchItemAvailability();
          }
        }
        //itemAvilable Check
        //set Auto Discount
        autoDiscount(deliveryDiscount, "Delivery");
      } else {
        if (selectedTab == "Collection") {
          if (orderMinOrder_Check) {
            if (
              parseFloat(TotalPriceValue) <
              parseFloat(orderMinOrder_Check.collectionMinOrder)
            ) {
              setMinOrderModal(true);
              setMinOrderStatus(true);
            } else {
              setMinOrderModal(false);
              setMinOrderStatus(false);
            }
          }
          if (
            preOrderTimeTable &&
            preOrderTimeTable?.Collection?.asap?.tatTime
          ) {
            setGetOrderType("ASAP");
            localStorage.setItem("orderType", "ASAP");
            localStorage.setItem(
              "orderTime",
              preOrderTimeTable?.Collection?.asap?.time
            );
            localStorage.setItem("preOrder", "0");
            fetchItemAvailability();
          } else {
            if (
              preOrderTimeTable &&
              preOrderTimeTable?.Collection &&
              preOrderTimeTable.Collection.today &&
              preOrderTimeTable.Collection.today != "" &&
              preOrderTimeTable.Collection.today != "No Pre-order" &&
              preOrderTimeTable.Collection.today != "closed"
            ) {
              setGetOrderType("Today");
              localStorage.setItem("orderType", "Today");
              localStorage.setItem(
                "orderTime",
                formatToday + " " + preOrderCollectionTodayTiming
              );
              localStorage.setItem(
                "preOrder",
                formatToday + " " + preOrderCollectionTodayTiming
              );
              fetchItemAvailability();
            } else {
              setGetOrderType("Later");
              localStorage.setItem("orderType", "Later");

              localStorage.setItem(
                "orderTime",
                preOrderCollectionDate + " " + preOrderCollectionLateTiming
              );
              localStorage.setItem(
                "preOrder",
                preOrderCollectionDate + " " + preOrderCollectionLateTiming
              );
              fetchItemAvailability();
            }
          }
          //set Auto Discount
          autoDiscount(collectionDiscount, "Collection");
        }
      }
      cartPrice();
    }
    // props.setShowPreorder(true);
  };
  const postcodeDetail = localStorage.getItem("postcodeDetail") || "";
  const loginAddress = localStorage.getItem("loginAddress") || "";
  const guestAddress = localStorage.getItem("guestAddress") || "";
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const [deliveryUnavailableStatus, setDeliveryUnavailableStatus] =
    useState(false);
  const [collectionUnavailableStatus, setCollectionUnavailableStatus] =
    useState(false);
  const isTableCheck = localStorage.getItem("isTableQr");

  useEffect(() => {
    // console.log(props.preOrderTimeTable);
    if (preOrderTimeTable && preOrderTimeTable?.Collection?.asap?.tatTime) {
      setCollectionUnavailableStatus(false);
    } else if (
      preOrderTimeTable &&
      preOrderTimeTable?.Collection &&
      preOrderTimeTable.Collection.today &&
      preOrderTimeTable.Collection.today != "" &&
      preOrderTimeTable.Collection.today != "No Pre-order" &&
      preOrderTimeTable.Collection.today != "closed"
    ) {
      setCollectionUnavailableStatus(false);
    } else if (
      preOrderTimeTable &&
      preOrderTimeTable?.Collection &&
      preOrderTimeTable.Collection.later &&
      preOrderTimeTable.Collection.later !== ""
    ) {
      setCollectionUnavailableStatus(false);
    } else {
      setCollectionUnavailableStatus(true);
    }

    if (preOrderTimeTable && preOrderTimeTable?.Delivery?.asap?.tatTime) {
      setDeliveryUnavailableStatus(false);
    } else if (
      preOrderTimeTable &&
      preOrderTimeTable?.Delivery &&
      preOrderTimeTable.Delivery.today &&
      preOrderTimeTable.Delivery.today != "" &&
      preOrderTimeTable.Delivery.today != "No Pre-order" &&
      preOrderTimeTable.Delivery.today != "closed"
    ) {
      setDeliveryUnavailableStatus(false);
    } else if (
      preOrderTimeTable &&
      preOrderTimeTable?.Delivery &&
      preOrderTimeTable.Delivery.later &&
      preOrderTimeTable.Delivery.later !== ""
    ) {
      setDeliveryUnavailableStatus(false);
    } else {
      setDeliveryUnavailableStatus(true);
    }
  }, [props.preOrderTimeTable]);

  useEffect(() => {
    let address = "";
    if (isLoggedIn === "true") {
      address = loginAddress ? JSON.parse(loginAddress) : "";
    } else {
      address = guestAddress ? JSON.parse(guestAddress) : "";
    }
    const parsedPostcode = postcodeDetail ? JSON.parse(postcodeDetail) : "";
    if (getOrderMode === "Delivery" && parsedPostcode && !address.postcode) {
      setAddressPopupshow(true);
    }
  }, [getOrderMode, postcodeDetail, loginAddress, guestAddress, isLoggedIn]);

  const HandleClickClose = () => {
    props.setShowPreorder(false);
  };
  // responsive script
  const [width, setWidth] = useState(window.innerWidth);
  const breakpoint = 767;
  useEffect(() => {
    const handleResizeWindow = () => setWidth(window.innerWidth);
    // subscribe to window resize event "onComponentDidMount"
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      // unsubscribe "onComponentDestroy"
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, []);
  // responsive script
  const instructionToOptionMap = {
    "Need Double Bags": "doublebag",
    "Food is ready? Please Call me": "call",
    "Leave at door": "door",
    "Leave with guard": "guard",
  };

  const [showOrderNote, setShowOrderNote] = useState(false);
  const instruction = localStorage.getItem("instruction");
  const inst = instructionToOptionMap[instruction] || "other";

  const [selectedOption, setSelectedOption] = useState(inst);

  const handleOptionChange = (option) => {
    setSelectedOption(option);
    const instructionsMap = {
      doublebag: "Need Double Bags",
      call: "Food is ready? Please Call me",
      door: "Leave at door",
      guard: "Leave with guard",
    };

    const instruction = instructionsMap[option];
    if (instruction) {
      localStorage.setItem("instruction", instruction);
    }
    setInstruction(instruction);
  };

  function otherInstruction(event) {
    const value = event.target.value;
    // console.log(value);
    setInstruction(value);
    localStorage.setItem("instruction", value);
  }

  const handleOrderNotes = () => {
    setShowOrderNote(true); // Always open modal when clicked
  };

  const handleDoneClick = () => {
    setShowOrderNote(false);
  };
  const isTableQr = localStorage.getItem("isTableQr");
  const discount = JSON.parse(localStorage.getItem("discount") || "{}");
  const AppliedDisocunttop = parseFloat(discount?.appliedDiscount) || 0;

  const cardPadding =
    width > breakpoint
      ? { padding: "15px 15px 15px 15px" }
      : { padding: "10px 15px 15px 15px" };

  return (
    <>
      <div>
        {/* {parsedDiscount !== "" &&
          (parsedDiscount?.orderType === SummaryOrderType || parsedDiscount?.orderType === "2") &&
          appliedDiscount !== 0 ? ( */}
        {AppliedDisocunttop > 0 ? (
          <div className="savingstopdiscount d-block d-sm-none">
            <p>
              You saved{" "}
              <span style={{ fontWeight: "600" }}>
                {" "}
                {currency_symbol} {AppliedDisocunttop}{" "}
              </span>{" "}
              on this order
            </p>
          </div>
        ) : null}
        {/* ) : null} */}
      </div>

      <Card className="deliveryCard">
        <Card.Body style={cardPadding}>
          <div className="preorder-box">
            <Card.Title
              style={{
                cursor: "pointer",
                width:
                  props.width > props.breakpoint ||
                  deliveryUnavailableStatus ||
                  collectionUnavailableStatus
                    ? "100%"
                    : "50%",
              }}
            >
              {" "}
              {getOrderMode === "Delivery"
                ? "Order details"
                : isTableCheck
                ? "Dine-in Details"
                : "Order details"}
            </Card.Title>
            {(!isTableQr && deliveryUnavailableStatus) ||
            collectionUnavailableStatus ? (
              <Tabs
                fill
                style={{ display: "none" }}
                onSelect={HandleClick}
                defaultActiveKey={getOrderMode ? getOrderMode : "Delivery"}
                activeKey={getOrderMode}
              ></Tabs>
            ) : (
              !isTableQr && (
                <Tabs
                  fill
                  style={{ height: "100%", border: "none", width: "50%" }}
                  onSelect={HandleClick}
                  defaultActiveKey={getOrderMode ? getOrderMode : "Delivery"}
                  activeKey={getOrderMode}
                >
                  <Tab
                    eventKey="Delivery"
                    title={
                      <span>
                        <img
                          src={Deliveryiconcheckout}
                          alt="delivery"
                          style={{
                            width: "24px",
                            height: "24px",
                            marginRight: "5px",
                          }}
                        />
                        Delivery
                      </span>
                    }
                    className="delivery"
                    disabled={deliveryUnavailableStatus}
                  ></Tab>
                  <Tab
                    eventKey="Collection"
                    title={
                      <span>
                        <img
                          src={Pickupiconcheckout}
                          alt="Pickup"
                          style={{
                            width: "18px",
                            height: "18px",
                            marginRight: "8px",
                          }}
                        />
                        Pickup
                      </span>
                    }
                    className="collection"
                    disabled={collectionUnavailableStatus}
                  ></Tab>
                </Tabs>
              )
            )}
          </div>

          {getOrderMode === "Delivery" ? (
            <>
              <DeliveryData
                theme={theme}
                width={width}
                breakpoint={breakpoint}
                selectedOption={selectedOption}
                handleOptionChange={handleOptionChange}
                otherInstruction={otherInstruction}
              ></DeliveryData>
            </>
          ) : (
            <>
              <CollectionData
                theme={theme}
                width={width}
                breakpoint={breakpoint}
                selectedOption={selectedOption}
                handleOptionChange={handleOptionChange}
                otherInstruction={otherInstruction}
              ></CollectionData>
            </>
          )}

          {/* <div className="border-style">
              <div className="borders">
              </div>
            </div> */}
          <div className="borderbottomdiv"></div>
          {width > breakpoint ? (
            <>
              <div>
                <div className="delivery-detail" onClick={handleOrderNotes}>
                  {/* <img
                    
                    src={notecommon}
                    alt="notewhite"
                    style={{ height: "20px !important" }}
                    className="notes-icon"
                  /> */}
                  <TbNotes />
                  <div className="delivery-text">
                    <p className="delivery-text-postcode">Add order notes</p>
                    <span>
                      {" "}
                      {instruction && instruction.trim() !== ""
                        ? instruction
                        : null}
                    </span>
                  </div>

                  <div className="delivery-action-btn">
                    <button
                      className="delivery-action-btn"
                      onClick={handleOrderNotes}
                    >
                      <RiArrowRightSLine />
                      {/* {showOrderNote ? "Remove" : "Add"} */}
                    </button>
                  </div>
                </div>
                {/* {showOrderNote && (
              <div className="input-textarea">
                <Form>
                  <Form.Control
                    as="textarea"
                    placeholder="Eg: Add extra choose and spices"
                    rows={3}
                    value={instruction}
                    onChange={otherInstruction}
                  />
                </Form>
              </div>
            )} */}
              </div>
              <Modal
                show={showOrderNote}
                onHide={() => setShowOrderNote(false)}
                id="checkout-postcodenew"
                centered
              >
                <Modal.Body className="order-note-modal">
                  <h2 className="order-note-title">
                    Order notes{" "}
                    <img
                      src={closeiconnew}
                      alt="closeicon"
                      className="closeiconnew"
                      onClick={handleDoneClick}
                    />
                  </h2>
                  <div className="order-modal-bodycontent">
                    <p className="order-note-description">
                      Leave a note about your order. If you (or someone you're
                      ordering for) have a food allergy, please contact the
                      place directly. Do not include details about any allergens
                      or tolerance in note.
                    </p>

                    <h3 className="order-note-subtitle">
                      Add your note{" "}
                      <span className="optional-text">Optional</span>
                    </h3>

                    <Form className="formnoteinput" style={{ padding: "4px" }}>
                      <Form.Control
                        as="textarea"
                        placeholder={`For example "Extra hot please", or "please leave order on the porch"`}
                        rows={4}
                        value={instruction}
                        onChange={otherInstruction}
                        className="textarea-field mt-2"
                      />
                    </Form>

                    <button
                      onClick={handleDoneClick}
                      className="done-button mt-2 w-100"
                    >
                      Update
                    </button>
                  </div>
                </Modal.Body>
              </Modal>
            </>
          ) : (
            <>
              <div>
                <div className="delivery-detail" onClick={handleOrderNotes}>
                  {/* <img
                    
                    src={notemobilenew}
                    alt="notewhite"
                    style={{ height: "20px !important" }}
                    className="notes-icon"
                  /> */}
                  <TbNotes />
                  <div className="delivery-text">
                    <p className="delivery-text-postcode">Add order notes</p>
                    <span>
                      {" "}
                      {instruction && instruction.trim() !== ""
                        ? instruction
                        : null}
                    </span>
                  </div>

                  <div className="delivery-action-btn">
                    <button
                      className="delivery-action-btn"
                      onClick={handleOrderNotes}
                    >
                      <RiArrowRightSLine />
                      {/* {showOrderNote ? "Remove" : "Add"} */}
                    </button>
                  </div>
                </div>
                {/* {showOrderNote && (
              <div className="input-textarea">
                <Form>
                  <Form.Control
                    as="textarea"
                    placeholder="Eg: Add extra choose and spices"
                    rows={3}
                    value={instruction}
                    onChange={otherInstruction}
                  />
                </Form>
              </div>
            )} */}
              </div>
              <Modal
                show={showOrderNote}
                onHide={() => setShowOrderNote(false)}
                id="checkoutcustomModal"
                centered
              >
                <Modal.Body className="order-note-modal ">
                  <h2 className="order-note-title">
                    Add instruction{" "}
                    <img
                      src={closeiconnew}
                      alt="closeicon"
                      className="closeiconnew"
                      onClick={handleDoneClick}
                    />
                  </h2>
                  <div className="order-modal-bodycontent">
                    <Form className="forminstruction">
                      <Form.Control
                        as="textarea"
                        placeholder="Add instruction"
                        // rows={4}
                        value={instruction}
                        onChange={otherInstruction}
                        className="textarea-fieldmobile mt-3 w-100"
                      />
                    </Form>

                    <button
                      onClick={handleDoneClick}
                      className="done-button mt-3 w-100"
                    >
                      Submit
                    </button>
                  </div>
                </Modal.Body>
              </Modal>
            </>
          )}
        </Card.Body>
      </Card>
      <ChangeOrder
        theme={theme}
        selectedOrderMode={orderModeType}
        setSelectedOrderModeValue={setOrderMode}
        showPreorder={props.showPreorder}
        setShowPreorder={props.setShowPreorder}
        HandleClickClose={HandleClickClose}
      ></ChangeOrder>
      {minOrderModal && <MinOrderPopup HandleClick={HandleClick} />}
    </>
  );
};
//deliveryData
const DeliveryData = (props) => {
  // Map integer type values to corresponding string values
  const getTypeString = (type) => {
    switch (type) {
      case 1:
        return "Home";
      case 2:
        return "Office";
      case 3:
        return "Other";
      default:
        return "";
    }
  };
  const { getOrderMode } = OrderFlow();

  const { addressDetail } = useContext(CheckoutContext);

  const [getAddress, setAddress] = useState([]);
  const [getDefaultAddress, setDefaultAddress] = useState("Home");
  const [getAddressField, setAddressField] = useState([]);

  const { setAddressPopupshow } = useContext(CheckoutContext);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    postcode: "",
    phone: "",
    email: "",
    door: "",
    street: "",
    city: "",
    orderMode: getOrderMode === "Delivery" ? "0" : "1",
    customerId: "",
    addressId: "",
  });

  const [newAddressData, setNewAddressData] = useState({
    firstName: "",
    lastName: "",
    postcode: "",
    phone: "",
    email: "",
    door: "",
    street: "",
    city: "",
    orderMode: getOrderMode === "Delivery" ? "0" : "1",
    customerId: "",
    addressId: "",
  });

  useEffect(() => {
    if (addressDetail?.status === true) {
      // console.log(addressDetail);
      const checkAddressPopup =
        addressDetail.data.find(
          (item) => item.postcode === localStorage.getItem("orderPostcode")
        ) || "";
      if (!checkAddressPopup) {
        setAddressPopupshow(true);
      } else {
        setAddressPopupshow(false);
      }

      const updatedData = addressDetail.data.map((item) => {
        const type = getTypeString(item.type);
        if (item.postcode === localStorage.getItem("orderPostcode")) {
          setDefaultAddress(type);
          const deliveryData = {
            firstName: item.fname || "",
            lastName: item.lname || "",
            postcode: item.postcode || "",
            phone: item.phone || "",
            email: item.email || "",
            door: item.no || "",
            street: item.address1 || "",
            city: item.address2 || "",
            customerId: item.cid || "",
            addressId: item.id || "",
            type: type,
          };
          setAddressField(deliveryData);
        } else {
          setDefaultAddress(type);
          const deliveryData = {
            firstName: item.fname || "",
            lastName: item.lname || "",
            postcode: item.postcode || "",
            phone: item.phone || "",
            email: item.email || "",
            door: item.no || "",
            street: item.address1 || "",
            city: item.address2 || "",
            customerId: item.cid || "",
            addressId: item.id || "",
            type: type,
          };
          setAddressField(deliveryData);
        }
        return { ...item, type };
      });
      setAddress(updatedData);

    }
  }, [addressDetail, setAddressField, setAddressPopupshow]);

  return (
    <>
      <AddressProvider.Provider
        value={{
          getAddressField,
          formData,
          setFormData,
          newAddressData,
          setNewAddressData,
        }}
      >
        <div className="delivery-detail">
          <DeliveryAddressField getAddressField={getAddressField} />
          {props.width < 768 && (
            <AddressPopup
              getAddress={getAddress}
              setAddressField={setAddressField}
              getDefaultAddress={getDefaultAddress}
              setDefaultAddress={setDefaultAddress}
              label={<RiArrowRightSLine />}
            />
          )}
          {props.width > props.breakpoint && (
            <AddressPopup
              getAddress={getAddress}
              setAddressField={setAddressField}
              getDefaultAddress={getDefaultAddress}
              setDefaultAddress={setDefaultAddress}
              label={<RiArrowRightSLine />}
            />
          )}
        </div>
        <div className="borderbottomdiv"></div>
        <div className="delivery-detail">
          <DeliverypostCodeField />
          {props.width < 768 && (
            <PostCodePopup
              getAddress={getAddress}
              setAddressField={setAddressField}
              getDefaultAddress={getDefaultAddress}
              setDefaultAddress={setDefaultAddress}
              label={<RiArrowRightSLine />}
            />
          )}
          {props.width > props.breakpoint && (
            <PostCodePopup
              getAddress={getAddress}
              setAddressField={setAddressField}
              getDefaultAddress={getDefaultAddress}
              setDefaultAddress={setDefaultAddress}
              label={<RiArrowRightSLine />}
            />
          )}
        </div>
      </AddressProvider.Provider>
    </>
  );
};
function DeliveryAddressField() {
  const isLoggedIn = JSON.parse(localStorage.getItem("isLoggedIn"));
  const { AddressPopupshow, setAddressPopupshow } = useContext(CheckoutContext);
  const { theme } = useContext(ThemeContext);

  let getAddressField = [];
  if (isLoggedIn === true) {
    const data = AddressPopupContext();
    getAddressField = data.getAddressField;
  } else {
    const guestAddress = localStorage.getItem("guestAddress");
    getAddressField = guestAddress ? JSON.parse(guestAddress) : "";
    // console.log(getAddressField.postcode);
    if (getAddressField.postcode !== localStorage.getItem("orderPostcode")) {
      setAddressPopupshow(true);
    }
  }

  const handleShow = () => setAddressPopupshow(true);

  return (
    <>
      {getAddressField ? (
        <>
          {/* <img
            src={usercommon}
         
          /> */}
          <FaRegUser />
          <div className="delivery-text" onClick={handleShow}>
            {getAddressField.firstName &&
            getAddressField.lastName &&
            getAddressField.phone ? (
              <>
                <p className="delivery-text-postcode">
                  {" "}
                  {getAddressField.firstName} {getAddressField.lastName}
                </p>
                <p
                  className="delivery-sub-text-postcode"
                  style={{ color: "#868686 !important" }}
                >
                  {getAddressField.phone}
                </p>
              </>
            ) : (
              <>
                <p className="delivery-text-postcode">Add Address</p>
              </>
            )}
          </div>
        </>
      ) : (
        <>
          {/* <img
            src={usercommon}
          
          /> */}
          <FaRegUser />
          <div className="delivery-text">
            <p className="delivery-text-postcode">Add Address</p>
          </div>
        </>
      )}
    </>
  );
}
function DeliverypostCodeField() {
  const { theme } = useContext(ThemeContext);
  const isLoggedIn = JSON.parse(localStorage.getItem("isLoggedIn"));
  const { setAddressPopupshow, setShowModalAddressEdit, showModalAddressEdit } =
    useContext(CheckoutContext);
  // const [showModalAddressEdit, setShowModalAddressEdit] = useState(false);
  const selectedAddressType = localStorage.getItem("selectedAddressType");
  let getAddressField = [];
  if (isLoggedIn === true) {
    const data = AddressPopupContext();
    getAddressField = data.getAddressField;
  } else {
    const guestAddress = localStorage.getItem("guestAddress");
    getAddressField = guestAddress ? JSON.parse(guestAddress) : "";
    // console.log(getAddressField.postcode);
    if (getAddressField.postcode !== localStorage.getItem("orderPostcode")) {
      setAddressPopupshow(true);
    }
  }
  const getAddressIcon = (type) => {
    switch (type) {
      case "home":
        return <GoHome style={{ alignSelf: "flex-start" }} />;
      case "office":
        return <PiBuildingOfficeLight style={{ alignSelf: "flex-start" }} />;
      default:
        return <GrLocation style={{ alignSelf: "flex-start" }} />;
    }
  };
  const handleShowAddressEdit = () => setShowModalAddressEdit(true);

  return (
    <>
      {getAddressField ? (
        <>
          {/* <img
           
            src={Mapcommon}
          /> */}
          {getAddressIcon(selectedAddressType)}
          <div className="delivery-text" onClick={handleShowAddressEdit}>
            {getAddressField.postcode &&
            getAddressField.door &&
            getAddressField.street &&
            getAddressField.city ? (
              <>
                <p className="delivery-text-postcode">
                  {/* {getAddressIcon(selectedAddressType)}{" "} */}
                  Delivery to {selectedAddressType}
                </p>
                <p
                  className="delivery-sub-text-postcode"
                  style={{ color: "#868686 !important" }}
                >
                  {getAddressField.door},{getAddressField.street},
                  {getAddressField.city}
                </p>
                <p className="deliverypostcode-text">
                  {getAddressField.postcode}
                </p>
              </>
            ) : (
              <>
                <p className="delivery-text-postcode">Add Postcode</p>
              </>
            )}
          </div>
        </>
      ) : (
        <>
          {/* <img
           
            src={Mapcommon}
          /> */}
          {getAddressIcon(selectedAddressType)}
          <div className="delivery-text">
            <p className="delivery-text-postcode">Add Postcode</p>
          </div>
        </>
      )}
    </>
  );
}
//collection Data
function CollectionData(props) {
  const { theme } = useContext(ThemeContext);
  const [collectionData, setCollectionData] = useState([]);
  const guestAddress = localStorage.getItem("guestAddress") || "";
  let getAddressField;
  if (guestAddress) {
    getAddressField = JSON.parse(guestAddress);
  }
  const loginAddress = localStorage.getItem("loginAddress") || "";
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  let loginAddressField = "";
  if (isLoggedIn === "true") {
    if (loginAddress) {
      loginAddressField = JSON.parse(loginAddress);
    }
  }
  // console.log(loginAddress);
  const checkTableOrder = localStorage.getItem("isTableQr");
  const checkTableName = localStorage.getItem("tableName");
  const { stripepayment } = useContext(CheckoutContext);

  useEffect(() => {
    if (stripepayment?.message?.clientDetail) {
      setCollectionData(stripepayment.message.clientDetail);
    }
  }, [stripepayment]);

  const Addressone = localStorage.getItem("address1");
  const Addresstwo = localStorage.getItem("address2");
  const Citycollection = localStorage.getItem("city");
  const Pincodecollection = localStorage.getItem("pincode");

  return (
    <>
      {/* collection by */}
      <div className="delivery-detail">
        <div className="detailsusericon">
          {/* <img
            src={usercommon}
          
          /> */}
          <FaRegUser />
        </div>
        <div className="delivery-text">
          {/* <p className="delivery-text-postcode">Pickup By</p> */}
          <p className="delivery-text-postcode">
            {getAddressField?.firstName} {getAddressField?.lastName}
          </p>
          {getAddressField ? (
            <>
              <p
                className="delivery-sub-text-postcode"
                style={{ color: "#868686 !important" }}
              >
                {getAddressField?.phone}
              </p>
            </>
          ) : loginAddressField && loginAddressField != "" ? (
            <>
              <p className="delivery-text-postcode">
                {loginAddressField?.firstName} {loginAddressField?.lastName}
              </p>

              {loginAddressField?.phone && (
                <p
                  className="delivery-sub-text-postcode"
                  style={{ color: "#868686 !important" }}
                >
                  {loginAddressField?.phone}
                </p>
              )}
            </>
          ) : null}
        </div>

        <div className="delivery-action-btn">
          {props.width > props.breakpoint && (
            <ConfirmDetails label={<RiArrowRightSLine />} />
          )}
          {props.width < 768 && (
            <ConfirmDetails label={<RiArrowRightSLine />} />
          )}
        </div>
      </div>
      <div className="borderbottomdiv"></div>
      {/* pick up from */}
      <div className="delivery-detail">
        <div className="detailsusericon">
          {/* <img
           
            src={Mapcommon}
          /> */}
          <GrLocation />
        </div>
        <div className="delivery-text">
          <p className="delivery-text-postcode">
            {checkTableOrder ? "Dine-in" : "Pickup from"}
          </p>
          {/* {collectionData ? ( */}
          <>
            <p
              className="delivery-sub-text-postcode"
              style={{ color: "#FFFADE" }}
            >
              {/* {checkTableOrder ? checkTableName : collectionData?.name} */}
              {Addresstwo}, {Citycollection},{Pincodecollection}
            </p>

            {/* {collectionData?.address1 &&
                  // collectionData?.address2 &&
                  collectionData?.pincode &&
                  collectionData?.city &&
                  <p className="delivery-sub-text-postcode">{collectionData?.address1},{collectionData?.address2 ? collectionData?.address2 : ""},{collectionData?.pincode},{collectionData?.city}</p>} */}
          </>
          {/* ) : null} */}
        </div>

        <div className="delivery-action-btn">
          {/* {props.width > props.breakpoint && <ConfirmDetails label="Edit" />} */}
        </div>
      </div>
    </>
  );
}
function AddressPopup(props) {
  const isLoggedIn = JSON.parse(localStorage.getItem("isLoggedIn"));
  const path = localStorage.getItem("clientPath");
  const {
    AddressPopupshow,
    setAddressPopupshow,
    SuccessShow,
    setSuccessShow,
    localGuestMode,
    setMinOrderModal, setMinOrderStatus,
    setMinOrderMessage,
    deliverPostCodeStatus,setDeliverPostCodeStatus
  } = useContext(CheckoutContext);
  const { getOrderMode } = OrderFlow();
  const { theme } = useContext(ThemeContext);
  const { formData, setFormData } = AddressPopupContext();
  const { newAddressData, setNewAddressData } = AddressPopupContext();
  const [apiPostCode, setApiPostCode] = useState(null);

  const [Data, setData] = useState(null);

  const SSOuserData = JSON.parse(localStorage.getItem("userData"));

  const SSOCustomerId = useMemo(() => {
    return SSOuserData ? SSOuserData.customerId : null;
  }, [SSOuserData])

  useEffect(()=>{
   if(deliverPostCodeStatus === true){
     setFormErrors({
            postcode: "The restaurant doesn't deliver to " + formData.postcode,
      });
   }
  },[deliverPostCodeStatus])


  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const isLoggedIn = JSON.parse(localStorage.getItem("isLoggedIn"));
    const postcode = localStorage.getItem("orderPostcode") || "";
    if (userData && isLoggedIn === true) {
      // Fetch and set newData
      const newData =
        props.getAddress.find(
          (data) => data.type === props.getDefaultAddress
        ) || "";
      // console.log(newData);
      setData(newData);
      setFormData((prevFormData) => ({
        ...prevFormData,
        firstName: newData.fname || "",
        lastName: newData.lname || "",
        postcode: newData.postcode || "",
        phone: newData.phone || "",
        email: newData.email || "",
        door: newData.no || "",
        street: newData.address1 || "",
        city: newData.address2 || "",
        orderMode: getOrderMode === "Delivery" ? "0" : "1",
        customerId: newData.cid || "",
        addressId: newData.id || "",
        type: newData.type,
      }));
      const LoginAddress = localStorage.getItem("loginAddress");
      if (LoginAddress && LoginAddress !== "") {
        const address = JSON.parse(LoginAddress);
        setData((prevFormData) => ({
          ...prevFormData,
          firstName: address.firstName || "",
          lastName: address.lastName || "",
          postcode: address.postcode || "",
          phone: address.phone || "",
          email: address.email || "",
          door: address.door || "",
          street: address.street || "",
          city: address.city || "",
          orderMode: getOrderMode === "Delivery" ? "0" : "1",
          customerId: address.customerId || "",
          addressId: address.addressId || "",
          type: "Default",
        }));
        setFormData((prevFormData) => ({
          ...prevFormData,
          firstName: address.firstName || "",
          lastName: address.lastName || "",
          postcode: address.postcode || "",
          phone: address.phone || "",
          email: address.email || "",
          door: address.door || "",
          street: address.street || "",
          city: address.city || "",
          orderMode: getOrderMode === "Delivery" ? "0" : "1",
          customerId: address.customerId || "",
          addressId: address.addressId || "",
          type: "Home",
        }));
      } else {
        const customerId = {
          customer_id: userData.customerId,
        };
        getProfile(customerId)
          .then((response) => {
            if (response.status === false) {
            } else {
              setData((prevFormData) => ({
                ...prevFormData,
                email: response?.data?.profile?.email || "",
                type: "",
              }));
              setFormData((prevFormData) => ({
                ...prevFormData,
                email: response?.data?.profile?.email || "",
                type: "",
              }));
            }
          })
          .catch((error) => {
            console.log(error);
          });
        googleAddress({ post_code: postcode })
          .then((response) => {
            // console.log(response);
            if (response?.status === false) {
              console.log(response?.message);
            } else {
              setData((prevFormData) => ({
                ...prevFormData,
              }));
              setFormData((prevFormData) => ({
                ...prevFormData,
                postcode: postcode,
                street: response?.message?.street,
                city: response?.message?.city,
                orderMode: getOrderMode === "Delivery" ? "0" : "1",
              }));
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      // Fetch and set guest address data
      const guestAddress = localStorage.getItem("guestAddress");
      // console.log(guestAddress);
      if (guestAddress) {
        const address = JSON.parse(guestAddress);
        setFormData((prevFormData) => ({
          ...prevFormData,
          firstName: address.firstName || "",
          lastName: address.lastName || "",
          postcode: address.postcode || "",
          phone: address.phone || "",
          email: address.email || "",
          door: address.door || "",
          street: address.street || "",
          city: address.city || "",
          orderMode: getOrderMode === "Delivery" ? "0" : "1",
          customerId: address.customerId || "",
          addressId: address.addressId || "",
        }));
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          postcode: postcode,
          orderMode: getOrderMode === "Delivery" ? "0" : "1",
        }));
        googleAddress({ post_code: postcode })
          .then((response) => {
            console.log("");
            if (response.status === false) {
              console.log(response.message);
            } else {
              setFormData((prevFormData) => ({
                ...prevFormData,
                postcode: postcode,
                street: response?.message?.street,
                city: response?.message?.city,
                orderMode: getOrderMode === "Delivery" ? "0" : "1",
              }));
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }, [props.getAddress, SSOCustomerId]);

  useEffect(() => {
    let guest_postcode; // Define guest_postcode variable outside the if block

    const guestAddress = localStorage.getItem("guestAddress");

    if (guestAddress) {
      const address = JSON.parse(guestAddress);
      guest_postcode = address.postcode;
    }

    const guestdeliveryFormData = {
      client_path: path,
      order_mode: getOrderMode === "Delivery" ? "0" : "1",
      post_code: guest_postcode,
    };

    if (localGuestMode) {
      checkPostcode(guestdeliveryFormData)
        .then((response) => {
          console.log("");

          if (response.status === true) {
            localStorage.setItem("orderPostcode", guest_postcode);
            localStorage.setItem(
              "postcodeDetail",
              JSON.stringify(response?.message || "")
            );
            // console.log(response?.message?.minAmount);
            const minAmount = response?.message?.minAmount || 0;
            const TotalPriceValue = localStorage.getItem("totalPrice")
              ? localStorage.getItem("totalPrice")
              : 0;
            localStorage.setItem("deliverRadiousAmount", minAmount.toString());
            if (parseFloat(TotalPriceValue) < parseFloat(minAmount)) {
              setMinOrderModal(true);
              setMinOrderStatus(true);
              let difference = minAmount - TotalPriceValue;
              let roundedDifference = difference.toFixed(2);
              const minMsg = `Need More £${roundedDifference} for delivery`;
              setMinOrderMessage(minMsg);
            }
          } else {
            console.log("");

            localStorage.setItem("postcodeDetail", "");
          }
        })

        .catch((error) => {
          setFormErrors({
            postcode: "The restaurant doesn't deliver to " + formData.postcode,
          });
          localStorage.setItem("postcodeDetail", "");

          console.log(error);
        });
    }
  }, [localGuestMode, getOrderMode]);

  useEffect(() => {
    let loginuser_postcode; // Define guest_postcode variable outside the if block

    const userData = JSON.parse(localStorage.getItem("userData"));
    const isLoggedIn = JSON.parse(localStorage.getItem("isLoggedIn"));
    if (userData && isLoggedIn === true) {
      const loginAddress = localStorage.getItem("loginAddress");

      if (loginAddress) {
        const address = JSON.parse(loginAddress);
        loginuser_postcode = address.postcode;
      }

      const logindeliveryFormData = {
        client_path: path,
        order_mode: getOrderMode === "Delivery" ? "0" : "1",
        post_code: loginuser_postcode,
      };

      if (loginAddress) {
        checkPostcode(logindeliveryFormData)
          .then((response) => {
            console.log("");

            if (response.status === true) {
              localStorage.setItem(
                "postcodeDetail",
                JSON.stringify(response.message)
              );
              // deliverRadiousMethod(response, loginuser_postcode);
              localStorage.setItem("orderPostcode", loginuser_postcode);
              localStorage.setItem(
                "postcodeDetail",
                JSON.stringify(response?.message || "")
              );
              console.log(response?.message?.minAmount);
              const minAmount = response?.message?.minAmount || 0;
              const TotalPriceValue = localStorage.getItem("totalPrice")
                ? localStorage.getItem("totalPrice")
                : 0;
              localStorage.setItem(
                "deliverRadiousAmount",
                minAmount.toString()
              );
              if (parseFloat(TotalPriceValue) < parseFloat(minAmount)) {
                setMinOrderModal(true);
                setMinOrderStatus(true);
                let difference = minAmount - TotalPriceValue;
                let roundedDifference = difference.toFixed(2);
                const minMsg = `Need More £${roundedDifference} for delivery`;
                setMinOrderMessage(minMsg);
              }
              console.log("data check");
            } else {
              console.log("");

              localStorage.setItem("postcodeDetail", "");
            }
          })

          .catch((error) => {
            setFormErrors({
              postcode:
                "The restaurant doesn't deliver to " + formData.postcode,
              //  "The restaurant doesn't deliver to " + newAddressData.postcode,
            });
            localStorage.setItem("postcodeDetail", "");

            console.log(error);
          });
      }
    }
  }, [isLoggedIn, getOrderMode]);

  const handleClose = () => setAddressPopupshow(false);
  const handleShow = () => setAddressPopupshow(true);
  const handleSuccessClose = () => setSuccessShow(false);

  const [newData, setNewData] = useState([]);
  const handleRadioChange = (type) => {
    props.setDefaultAddress(type);
    localStorage.setItem("selectedAddressType", type);
    setFormErrors({});
    const getAdd = props.getAddress.find((data) => data.type === type) || {};
    console.log(getAdd);
    setNewData(getAdd);
    if (Object.keys(getAdd).length > 0) {
      console.log("datadata");
      setData((prevFormData) => ({
        ...prevFormData,
        type: type,
      }));
      setNewData(getAdd);
    } else {
      console.log("dfdgsdsf");
      const userData = JSON.parse(localStorage.getItem("userData"));
      const isLoggedIn = JSON.parse(localStorage.getItem("isLoggedIn"));
      if (userData && isLoggedIn === true) {
        const customerId = {
          customer_id: userData.customerId,
        };
        getProfile(customerId)
          .then((response) => {
            if (response.status === false) {
              setData((prevFormData) => ({
                ...prevFormData,
                type: type,
                email: "",
              }));
            } else {
              setData((prevFormData) => ({
                ...prevFormData,
                type: type,
                email: response?.data?.profile?.email || "",
              }));
              setNewData((prevFormData) => ({
                ...prevFormData,
                email: response?.data?.profile?.email || "",
              }));
            }
          })
          .catch((error) => {
            setData((prevFormData) => ({
              ...prevFormData,
              type: type,
              email: "",
            }));
            console.log(error);
          });
      } else {
        setData((prevFormData) => ({
          ...prevFormData,
          type: type,
          email: "",
        }));
      }
    }
    const updatedFormData = {
      firstName: newData.fname || "",
      lastName: newData.lname || "",
      postcode: newData.postcode || "",
      phone: newData.phone || "",
      email: newData.email || "",
      door: newData.no || "",
      street: newData.address1 || "",
      city: newData.address2 || "",
      customerId: newData.cid || "",
      addressId: newData.id || "",
    };
    setFormData((prevFormData) => ({ ...prevFormData, ...updatedFormData }));
  };

  useEffect(() => {
    if (Object.keys(newData).length !== 0) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        firstName: newData?.fname || "",
        lastName: newData?.lname || "",
        postcode: newData?.postcode || "",
        phone: newData?.phone || "",
        email: newData?.email || "",
        door: newData?.no || "",
        street: newData?.address1 || "",
        city: newData?.address2 || "",
        orderMode: getOrderMode === "Delivery" ? "0" : "1",
        customerId: newData?.cid || "",
        addressId: newData?.id || "",
      }));
    }
  }, [newData]);

  const formatPostcode = (postcode) => {
    // Remove all non-alphanumeric characters from the postcode
    const alphanumericPostcode = postcode.replace(/\W/g, "");
    // Insert a space before the last three characters
    const formattedPostcode = alphanumericPostcode.replace(
      /^(.*)(\w{3})$/,
      "$1 $2"
    );
    // Convert the formatted postcode to uppercase
    return formattedPostcode.toUpperCase();
  };

  const [formErrors, setFormErrors] = useState({});
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleInputChange = async (event) => {
    const { name, value } = event.target;
    console.log(value);
    console.log(formData);
    // Define validation rules for each field
    const validationRules = {
      firstName: "First name is required",
      lastName: "Last name is required",
      phone: "Telephone is required",
      email: "Email is required",
      door: "Door number is required",
      street: "Street is required",
      city: "City is required",
    };

    // Check if the field is required and update errors accordingly
    const sanitizedValue = value.trim().replace(/'/g, "");
    const errors = {
      ...formErrors,
      [name]: sanitizedValue === "" ? validationRules[name] : "",
    };
    console.log(errors);

    if (name === "firstName") {
      if (value === "" || value === null) {
        errors.firstName = "First name is required";
      }
    }

    if (name === "lastName") {
      if (value === "" || value === null) {
        errors.lastName = "Last name is required";
      }
    }

    if (name === "email") {
      if (value === "" || value === null) {
        errors.email = "Email is required";
      } else if (!isValidEmail(value)) {
        errors.email = "Invalid email format";
      }
    }

    if (name === "phone") {
      if (value === "" || value === null) {
        errors.phone = "Telephone is required";
      } else if (value.replace(/\D/g, "").length < 11) {
        errors.phone = "Telephone must be at least 11 digits";
      }
    }

    if (name === "postcode") {
      if (value === "" || value === null) {
        errors.postcode = "Postcode is required";
      }
    }

    if (name === "door") {
      if (value === "" || value === null) {
        errors.door = "Door / Flat / Build.. Number is required";
      }
    }
    // Update form data
    setFormErrors(errors);
    setFormData({ ...formData, [name]: sanitizedValue });
    setIsButtonDisabled(false);
  };

  const getGoogleAddress = (event) => {
    const { name, value } = event.target;
    // console.log(name, value);
    setApiPostCode(value);
    setFormData({ ...formData, [name]: value });
    const validationRules = {
      postcode: "Post Code is required",
    };

    const errors = {
      ...formErrors,
      [name]: value.trim() === "" ? validationRules[name] : "",
    };
    const formattedPostcode =
      name === "postcode" ? formatPostcode(value) : formData.postcode;

    if (name === "postcode" && !valid_postcode(value)) {
      errors.postcode = "Invalid Post Code";
      setFormErrors(errors);
      setIsButtonDisabled(true);
      return;
    }

    const postcodeAddress = {
      post_code: value,
    };
    // console.log(postcodeAddress);
    googleAddress(postcodeAddress)
      .then((response) => {
        if (response.status === false) {
          console.log(response.message);
        } else {
          console.log("");
          const updatedFormData = {
            ...formData,
            postcode: formattedPostcode,
            street: response?.message?.street,
            city: response?.message?.city,
          };
          if (updatedFormData.street) {
            errors.street = "";
          }
          if (updatedFormData.city) {
            errors.city = "";
          }
          console.log(updatedFormData);
          setFormData(updatedFormData);
          setIsButtonDisabled(false);

          // Update form data
          // setFormData(updatedFormData);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    // Update form data
    setFormErrors(errors);
  };

  const valid_postcode = (postcode) => {
    const postcodeRegex = /^[A-Z]{1,2}[0-9R][0-9A-Z]?[0-9][A-Z]{2}$/i;
    const formattedPostcode = postcode.replace(/\s/g, "");
    return postcodeRegex.test(formattedPostcode);
  };

  const isValidEmail = (email) => {
    // Regular expression for a basic email format validation
    const emailRegex = /^[A-Za-z0-9._%-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
    return emailRegex.test(email);
  };

  const isFormValid = () => {
    return Object.values(formErrors).every((error) => error === "");
  };
  //delivery Details validationSchema

  const validationSchema = {
    firstName: (value) => {
      if (!value || value.trim() === "") {
        return "First name is required";
      }
      return "";
    },
    lastName: (value) => {
      if (!value || value.trim() === "") {
        return "Last name is required";
      }
      return "";
    },
    phone: (value) => {
      if (!value || value.trim() === "") {
        return "Phone number is required";
      }
      return "";
    },
    email: (value) => {
      if (!value || value.trim() === "") {
        return "Email is required";
      } else if (!isValidEmail(value)) {
        return "Invalid email format";
      }
      return "";
    },
    postcode: (value) => {
      if (!value || value.trim() === "") {
        return "Postcode is required";
      }
      return "";
    },
    door: (value) => {
      if (!value || value.trim() === "") {
        return "Door number is required";
      }
      return "";
    },
    street: (value) => {
      if (!value || value.trim() === "") {
        return "Street is required";
      }
      return "";
    },
    city: (value) => {
      if (!value || value.trim() === "") {
        return "City is required";
      }
      return "";
    },
  };

  const validateForm = () => {
    let errors = {};

    Object.keys(validationSchema).forEach((key) => {
      const error = validationSchema[key](formData[key]);
      if (error) {
        errors[key] = error;
      }
    });

    setFormErrors(errors);

    // Return true if no errors, false otherwise
    return Object.keys(errors).length === 0;
  };

  const deliveryFormData = {
    client_path: path,
    order_mode: getOrderMode === "Delivery" ? "0" : "1",
    post_code: formData.postcode,
  };

  const SubmitForm = () => {
    const isValid = validateForm();
    if (isValid) {
      setIsButtonDisabled(true);
      checkPostcode(deliveryFormData)
        .then((response) => {
          console.log("");
          if (response.status === true) {
            localStorage.setItem("orderPostcode", formData.postcode);
            localStorage.setItem(
              "postcodeDetail",
              JSON.stringify(response?.message || "")
            );
            console.log(response?.message?.minAmount);
            const minAmount = response?.message?.minAmount || 0;
            const TotalPriceValue = localStorage.getItem("totalPrice")
              ? localStorage.getItem("totalPrice")
              : 0;
            localStorage.setItem("deliverRadiousAmount", minAmount.toString());
            if (parseFloat(TotalPriceValue) < parseFloat(minAmount)) {
              setMinOrderModal(true);
              setMinOrderStatus(true);
            }
            if (formData) {
              if (formData.city) {
                formData.city = formData?.city?.replace(/[@#$'"&]/g, "");
              }
              if (formData.street) {
                formData.street = formData?.street?.replace(/[@#$'"&]/g, "");
              }
            }
            updateAddress(formData)
              .then((response) => {
                console.log(response);
                if (response?.status === true) {
                  formData.addressId = response.message.addressId;
                  formData.customerId = response.message.customerId;
                  props.setAddressField(formData);
                  if (isLoggedIn !== true) {
                    localStorage.setItem(
                      "guestAddress",
                      JSON.stringify(formData)
                    );
                    localStorage.setItem("orderPostcode", formData.postcode);
                    localStorage.setItem("loginAddress", "");
                  } else {
                    localStorage.setItem(
                      "loginAddress",
                      JSON.stringify(formData)
                    );
                    localStorage.setItem("guestAddress", "");
                  }
                  setAddressPopupshow(false);
                  setSuccessShow(true);
                  setIsButtonDisabled(false);
                  setTimeout(() => {
                    setSuccessShow(false);
                  }, 2000);
                } else {
                  console.log(response);
                }
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            setIsButtonDisabled(false);
            setFormErrors({
              postcode:
                "The restaurant doesn't deliver to " + formData.postcode,
            });
            console.log(response);
            localStorage.setItem("postcodeDetail", "");
          }
        })
        .catch((error) => {
          setFormErrors({
            postcode: "The restaurant doesn't deliver to " + formData.postcode,
          });
          localStorage.setItem("postcodeDetail", "");
          console.log(error);
        });
    }
  };

  return (
    <>
      <div className="delivery-action-btn">
        <button className="delivery-action-btn" onClick={handleShow}>
          {props.label}
        </button>
      </div>
      <Modal
        show={AddressPopupshow}
        onHide={handleClose}
        id="checkout-address"
        centered
        className={theme === "dark" ? "dark-popup" : null}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="header-div">
            <h3>
              {isLoggedIn === true
                ? `Change ${Data ? Data.type : ""} address`
                : "Confirm address"}
            </h3>
            {/* <span className="close-btn" onClick={handleClose} data-fus="fus-test-closebtn">
              <MdOutlineCancel />
            </span> */}
            <img
              src={closeiconnew}
              alt="closeicon"
              className="closeiconnew"
              onClick={handleClose}
            />
          </div>
          <Form>
            <Row className="align-items-start">
              <Col xxl={6} xs={6} md={6}>
                <div className="input-div first-input">
                  <Form.Control
                    name="customerId"
                    type="text"
                    placeholder="Customer Id"
                    value={formData.customerId}
                    style={{ display: "none" }}
                  />
                  <Form.Control
                    name="addressId"
                    type="text"
                    placeholder="Address Id"
                    value={formData.addressId}
                    style={{ display: "none" }}
                  />
                  <Form.Control
                    name="orderMode"
                    type="text"
                    placeholder="OrderMode"
                    value={formData.orderMode}
                    style={{ display: "none" }}
                  />
                  {/* <Form.Control
                      name="firstName"
                      type="text"
                      placeholder="First Name"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      isInvalid={!!formErrors.firstName}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.firstName}
                    </Form.Control.Feedback> */}
                </div>
                <TextField
                  required
                  className="mb-4"
                  id="outlined-basic1"
                  label="First name"
                  name="firstName"
                  variant="outlined"
                  placeholder={
                    formErrors.firstName ? formErrors.firstName : "First name"
                  }
                  type="text"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  error={!!formErrors.firstName}
                  helperText={formErrors.firstName || ""}
                  data-fus="fus-test-firstnameinput"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                    },
                  }}
                />
              </Col>
              <Col xxl={6} xs={6} md={6}>
                {/* <div className="input-div second-input">
                    <Form.Control
                      name="lastName"
                      type="text"
                      placeholder="Last Name"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      isInvalid={!!formErrors.lastName}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.lastName}
                    </Form.Control.Feedback>
                  </div> */}
                <TextField
                  required
                  className="mb-4"
                  id="outlined-basic2"
                  label="Last name"
                  name="lastName"
                  type="text"
                  placeholder="Last name"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  isInvalid={!!formErrors.lastName}
                  error={!!formErrors.lastName}
                  helperText={formErrors.lastName || ""}
                  data-fus="fus-test-lastnameinput"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                    },
                  }}
                />
              </Col>
              <Col xxl={6} xs={6} md={6}>
                {/* <div className="input-div">
                    <Form.Control
                      name="phone"
                      type="text"
                      placeholder="Telephone"
                      value={formData.phone} // Corrected this line
                      onChange={handleInputChange}
                      isInvalid={!!formErrors.phone}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.phone}
                    </Form.Control.Feedback>
                  </div> */}
                <TextField
                  required
                  className="mb-4"
                  id="outlined-basic3"
                  label="Phone number"
                  name="phone"
                  type="text"
                  placeholder="Telephone"
                  value={formData.phone} // Corrected this line
                  onChange={handleInputChange}
                  isInvalid={!!formErrors.phone}
                  error={!!formErrors.phone}
                  helperText={formErrors.phone || ""}
                  data-fus="fus-test-phonenumberinput"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                    },
                  }}
                />
              </Col>
              <Col xxl={6} xs={6} md={6}>
                {/* <div className="input-div">
                    <Form.Control
                      name="email"
                      type="text"
                      placeholder="email"
                      value={formData.email} // Corrected this line
                      onChange={handleInputChange}
                      isInvalid={!!formErrors.email}
                      disabled={Data?.email ? true : false}
                      readOnly={Data?.email ? true : false}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.email}
                    </Form.Control.Feedback>
                  </div> */}
                <TextField
                  required
                  className="mb-4"
                  id="outlined-basic4"
                  label="Email"
                  name="email"
                  type="text"
                  placeholder="email"
                  value={formData.email} // Corrected this line
                  onChange={handleInputChange}
                  isInvalid={!!formErrors.email}
                  disabled={Data?.email ? true : false}
                  readOnly={Data?.email ? true : false}
                  error={!!formErrors.email}
                  helperText={formErrors.email || ""}
                  data-fus="fus-test-emailidinput"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                    },
                  }}
                />
              </Col>
              <Col xxl={6} xs={6} md={6}>
                {/* <div className="input-div">
                    <Form.Control
                      name="postcode"
                      type="text"
                      placeholder="Post Code"
                      value={formData.postcode}
                      onChange={getGoogleAddress}
                      isInvalid={!!formErrors.postcode}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.postcode}
                    </Form.Control.Feedback>
                  </div> */}
                <TextField
                  required
                  className="mb-4"
                  id="outlined-basic5"
                  label="Postcode"
                  name="postcode"
                  type="text"
                  placeholder="Post Code"
                  value={formData.postcode}
                  onChange={getGoogleAddress}
                  isInvalid={!!formErrors.postcode}
                  error={!!formErrors.postcode}
                  helperText={formErrors.postcode || ""}
                  data-fus="fus-test-postcodeinput"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                    },
                  }}
                />
              </Col>
              <Col xxl={6} xs={6} md={6}>
                {/* <div className="input-div">
                    <Form.Control
                      name="door"
                      type="text"
                      placeholder="Door Number"
                      value={formData.door} // Corrected this line
                      onChange={handleInputChange}
                      isInvalid={!!formErrors.door}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.door}
                    </Form.Control.Feedback>
                  </div> */}
                <TextField
                  required
                  className="mb-4"
                  id="outlined-basic6"
                  label="Door / Flat / Building"
                  name="door"
                  type="text"
                  placeholder="Door / Flat / Building"
                  value={formData.door} // Corrected this line
                  onChange={handleInputChange}
                  isInvalid={!!formErrors.door}
                  error={!!formErrors.door}
                  helperText={formErrors.door || ""}
                  data-fus="fus-test-doornumberinput"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                    },
                  }}
                />
              </Col>
              <Col xxl={6} xs={6} md={6}>
                {/* <div className="input-div">
                    <Form.Control
                      name="street"
                      type="text"
                      placeholder="street"
                      value={formData.street}
                      onChange={handleInputChange}
                      isInvalid={!!formErrors.street}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.street}
                    </Form.Control.Feedback>
                  </div> */}
                <TextField
                  required
                  className="mb-4"
                  id="outlined-basic7"
                  label="Street"
                  name="street"
                  type="text"
                  placeholder="street"
                  value={formData.street}
                  onChange={handleInputChange}
                  isInvalid={!!formErrors.street}
                  error={!!formErrors.street}
                  helperText={formErrors.street || ""}
                  data-fus="fus-test-streetnameinput"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                    },
                  }}
                />
              </Col>
              <Col xxl={6} xs={6} md={6}>
                {/* <div className="input-div">
                    <Form.Control
                      name="city"
                      type="text"
                      placeholder="city"
                      value={formData.city}
                      onChange={handleInputChange}
                      isInvalid={!!formErrors.city}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.city}
                    </Form.Control.Feedback>
                  </div> */}
                <TextField
                  required
                  className="mb-4"
                  id="outlined-basic8"
                  label="City"
                  name="city"
                  type="text"
                  placeholder="city"
                  value={formData.city}
                  onChange={handleInputChange}
                  isInvalid={!!formErrors.city}
                  error={!!formErrors.city}
                  helperText={formErrors.city || ""}
                  data-fus="fus-test-citynameinput"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                    },
                  }}
                />
              </Col>
              {isLoggedIn === true ? (
                <>
                  <Col xxl={12} xs={12} md={12}>
                    <div className="radio-btn-group">
                      <label>
                        <input
                          name="selectaddtype"
                          type="radio"
                          label="Home"
                          id="Home"
                          checked={props.getDefaultAddress === "Home"}
                          onChange={() => handleRadioChange("Home")}
                          data-fus="fus-test-homeradiobtn"
                        />
                        <span>Home</span>
                      </label>
                      <label>
                        <input
                          name="selectaddtype"
                          type="radio"
                          label="Office"
                          id="Office"
                          checked={props.getDefaultAddress === "Office"}
                          onChange={() => handleRadioChange("Office")}
                          data-fus="fus-test-officeradiobtn"
                        />
                        <span>Office</span>
                      </label>
                      <label>
                        <input
                          name="selectaddtype"
                          type="radio"
                          label="Other"
                          id="Other"
                          checked={props.getDefaultAddress === "Other"}
                          onChange={() => handleRadioChange("Other")}
                          data-fus="fus-test-otherradiobtn"
                        />
                        <span>Other</span>
                      </label>
                    </div>
                  </Col>
                </>
              ) : null}
              <Col xxl={12} xs={12} md={12}>
                <Button
                  className="submit-btn"
                  onClick={SubmitForm}
                  disabled={!isFormValid() || isButtonDisabled}
                  data-fus="fus-test-submitdonebtn"
                >
                  {/* Update Details */}
                  Done
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        {/* Modal Footer */}
      </Modal>
      <Modal
        show={SuccessShow}
        onHide={handleSuccessClose}
        className={`address-success-popup  ${
          theme === "dark" ? "dark-theme" : ""
        }`}
        backdrop={true}
      >
        <Modal.Body>
          <div className="content">
            <p>Your address was updated successfully</p>
            <button onClick={handleSuccessClose} data-fus="fus-test-closebtn">
              <FaRegCircleCheck />
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
function PostCodePopup(props) {
  const isLoggedIn = JSON.parse(localStorage.getItem("isLoggedIn"));
  const path = localStorage.getItem("clientPath");
  const {
    SuccessShow,
    setSuccessShow,
    postCodePopupshow,
    setPostCodePopupshow,
    newAddresShow,
    setNewAddressShow,
    setMinOrderModal,
    setMinOrderStatus,
    showModalAddressEdit,
    setShowModalAddressEdit,
  } = useContext(CheckoutContext);

  const { getOrderMode } = OrderFlow();
  const { theme } = useContext(ThemeContext);
  const { formData, setFormData } = AddressPopupContext();
  const { newAddressData, setNewAddressData } = AddressPopupContext();
  const [apiPostCode, setApiPostCode] = useState(null);

  const [Data, setData] = useState(null);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const isLoggedIn = JSON.parse(localStorage.getItem("isLoggedIn"));
    const postcode = localStorage.getItem("orderPostcode") || "";
    if (userData && isLoggedIn === true) {
      // Fetch and set newData
      const newData =
        props.getAddress.find(
          (data) => data.type === props.getDefaultAddress
        ) || "";
      // console.log(newData);
      setData(newData);
      const LoginAddress = localStorage.getItem("loginAddress");
      if (LoginAddress) {
        const address = JSON.parse(LoginAddress);
        setFormData((prevFormData) => ({
          ...prevFormData,
          firstName: address.firstName || "",
          lastName: address.lastName || "",
          postcode: address.postcode || "",
          phone: address.phone || "",
          email: address.email || "",
          door: address.door || "",
          street: address.street || "",
          city: address.city || "",
          orderMode: address.orderMode,
          customerId: address.customerId || "",
          addressId: address.addressId || "",
        }));
      } else {
        googleAddress({ post_code: postcode })
          .then((response) => {
            console.log(response);
            if (response.status === false) {
              console.log(response.message);
            } else {
              setFormData((prevFormData) => ({
                ...prevFormData,
                postcode: postcode,
                street: response?.message?.street,
                city: response?.message?.city,
                orderMode: getOrderMode === "Delivery" ? "0" : "1",
              }));
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      // Fetch and set guest address data
      const guestAddress = localStorage.getItem("guestAddress");
      // console.log(guestAddress);
      if (guestAddress) {
        const address = JSON.parse(guestAddress);
        setFormData((prevFormData) => ({
          ...prevFormData,
          firstName: address.firstName || "",
          lastName: address.lastName || "",
          postcode: address.postcode || "",
          phone: address.phone || "",
          email: address.email || "",
          door: address.door || "",
          street: address.street || "",
          city: address.city || "",
          orderMode: getOrderMode === "Delivery" ? "0" : "1",
          customerId: address.customerId || "",
          addressId: address.addressId || "",
        }));
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          postcode: postcode,
          orderMode: getOrderMode === "Delivery" ? "0" : "1",
        }));
        googleAddress({ post_code: postcode })
          .then((response) => {
            console.log(response);
            if (response.status === false) {
              console.log(response.message);
            } else {
              setFormData((prevFormData) => ({
                ...prevFormData,
                postcode: postcode,
                street: response?.message?.street,
                city: response?.message?.city,
                orderMode: getOrderMode === "Delivery" ? "0" : "1",
              }));
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }, []);

  // useEffect(()=>{
  //   console.log(Data);
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     firstName: Data?.fname || "",
  //     lastName: Data?.lname || "",
  //     postcode: Data?.postcode || "",
  //     phone: Data?.phone || "",
  //     email: Data?.email || "",
  //     door: Data?.no || "",
  //     street: Data?.address1 || "",
  //     city: Data?.address2 || "",
  //     orderMode: getOrderMode === "Delivery" ? "0" : "1",
  //     customerId: Data?.cid || "",
  //     addressId: Data?.id || "",
  //   }));
  // },[Data]);
  // const [showModalAddressEdit, setShowModalAddressEdit] = useState(false);

  const handleClose = () => setPostCodePopupshow(false);
  const handleShow = () => {
    setPostCodePopupshow(true);
    setShowModalAddressEdit(false);
  };
  const handleSuccessClose = () => setSuccessShow(false);
  const handleShowNewAddress = () => {
    setNewAddressShow(true);
    setShowModalAddressEdit(false);
  };
  const handleCloseNewAddress = () => {
    setNewAddressShow(false);
    setShowModalAddressEdit(true);
  };

  const handleShowAddressEdit = () => setShowModalAddressEdit(true);
  const handleCloseAddressEdit = () => setShowModalAddressEdit(false);

  const handleRadioChange = (type) => {
    props.setDefaultAddress(type);
    localStorage.setItem("selectedAddressType", type);
    setFormErrors({});
    const newData =
      props.getAddress.find((data) => data.type === props.getDefaultAddress) ||
      {};
    // console.log(newData);
    setData(newData);
    const updatedFormData = {
      firstName: newData.fname || "",
      lastName: newData.lname || "",
      postcode: newData.postcode || "",
      phone: newData.phone || "",
      email: newData.email || "",
      door: newData.no || "",
      street: newData.address1 || "",
      city: newData.address2 || "",
      customerId: newData.cid || "",
      addressId: newData.id || "",
    };
    setFormData((prevFormData) => ({ ...prevFormData, ...updatedFormData }));
  };

  const formatPostcode = (postcode) => {
    // Remove all non-alphanumeric characters from the postcode
    const alphanumericPostcode = postcode.replace(/\W/g, "");
    // Insert a space before the last three characters
    const formattedPostcode = alphanumericPostcode.replace(
      /^(.*)(\w{3})$/,
      "$1 $2"
    );
    // Convert the formatted postcode to uppercase
    return formattedPostcode.toUpperCase();
  };

  const [formErrors, setFormErrors] = useState({});
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleInputChange = async (event) => {
    const { name, value } = event.target;
    console.log(value);
    console.log(formData);
    // Define validation rules for each field
    const validationRules = {
      firstName: "First name is required",
      lastName: "Last name is required",
      phone: "Telephone is required",
      email: "Email is required",
      door: "Door number is required",
      street: "Street is required",
      city: "City is required",
    };

    // Check if the field is required and update errors accordingly
    const sanitizedValue = value.trim().replace(/'/g, "");
    const errors = {
      ...formErrors,
      [name]: sanitizedValue === "" ? validationRules[name] : "",
    };
    console.log(errors);

    if (name === "email") {
      if (!isValidEmail(value)) {
        errors.email = "Invalid email format";
      }
    }
    if (name === "email") {
      if (value === "" || value === null) {
        errors.email = "Email is required";
      }
    }
    if (name === "firstName") {
      if (value === "" || value === null) {
        errors.firstName = "Firstname is required";
      }
    }
    if (name === "lastName") {
      if (value === "" || value === null) {
        errors.lastName = "Last name is required";
      }
    }
    if (name === "phone") {
      if (value === "" || value === null) {
        errors.phone = "Telephone is required";
      }
    }
    if (name === "door") {
      if (value === "" || value === null) {
        errors.door = "Door / Flat / Build.. Number is required";
      }
    }
    // Update form data
    setFormErrors(errors);
    setFormData({ ...formData, [name]: sanitizedValue });
    setIsButtonDisabled(false);
  };

  const getGoogleAddress = (event) => {
    const { name, value } = event.target;
    // console.log(name, value);
    setApiPostCode(value);
    setFormData({ ...formData, [name]: value });
    const validationRules = {
      postcode: "Post code is required",
    };

    const errors = {
      ...formErrors,
      [name]: value.trim() === "" ? validationRules[name] : "",
    };
    const formattedPostcode =
      name === "postcode" ? formatPostcode(value) : formData.postcode;

    if (name === "postcode" && !valid_postcode(value)) {
      errors.postcode = "Invalid post code";
      setFormErrors(errors);
      setIsButtonDisabled(true);
      return;
    }

    const postcodeAddress = {
      post_code: value,
    };
    // console.log(postcodeAddress);
    googleAddress(postcodeAddress)
      .then((response) => {
        if (response.status === false) {
          console.log(response.message);
        } else {
          console.log(response);
          const updatedFormData = {
            ...formData,
            postcode: formattedPostcode,
            street: response?.message?.street,
            city: response?.message?.city,
          };
          if (updatedFormData.street) {
            errors.street = "";
          }
          if (updatedFormData.city) {
            errors.city = "";
          }
          console.log(updatedFormData);
          setFormData(updatedFormData);
          setIsButtonDisabled(false);

          // Update form data
          // setFormData(updatedFormData);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    // Update form data
    setFormErrors(errors);
  };

  const getGoogleNewAddress = (event) => {
    const { name, value } = event.target;
    // console.log(name, value);
    setApiPostCode(value);
    setNewAddressData({ ...newAddressData, [name]: value });
    const validationRules = {
      postcode: "Post Code is required",
    };

    const errors = {
      ...formErrors,
      [name]: value.trim() === "" ? validationRules[name] : "",
    };
    const formattedPostcode =
      name === "postcode" ? formatPostcode(value) : newAddressData.postcode;

    if (name === "postcode" && !valid_postcode(value)) {
      errors.postcode = "Invalid Post Code";
      setFormErrors(errors);
      setIsButtonDisabled(true);
      return;
    }

    const postcodeAddress = {
      post_code: value,
    };
    // console.log(postcodeAddress);
    googleAddress(postcodeAddress)
      .then((response) => {
        if (response.status === false) {
          console.log(response.message);
        } else {
          console.log(response);
          const updatedFormData = {
            ...newAddressData,
            postcode: formattedPostcode,
            street: response.message.street,
            city: response.message.city,
          };
          if (updatedFormData.street) {
            errors.street = "";
          }
          if (updatedFormData.city) {
            errors.city = "";
          }
          console.log(updatedFormData);
          setNewAddressData(updatedFormData);
          setIsButtonDisabled(false);

          // Update form data
          // setFormData(updatedFormData);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    // Update form data
    setFormErrors(errors);
  };

  const handleNewInputChange = async (event) => {
    const { name, value } = event.target;
    console.log(value);
    console.log(newAddressData);
    // Define validation rules for each field
    const validationRules = {
      firstName: "First name is required",
      lastName: "Last name is required",
      phone: "Telephone is required",
      email: "Email is required",
      door: "Door number is required",
      street: "Street is required",
      city: "City is required",
    };

    // Check if the field is required and update errors accordingly
    const sanitizedValue = value.trim().replace(/'/g, "");
    const errors = {
      ...formErrors,
      [name]: sanitizedValue === "" ? validationRules[name] : "",
    };
    console.log(errors);

    if (name === "email") {
      if (!isValidEmail(value)) {
        errors.email = "Invalid email format";
      }
    }
    if (name === "email") {
      if (value === "" || value === null) {
        errors.email = "Email is required";
      }
    }
    if (name === "firstName") {
      if (value === "" || value === null) {
        errors.firstName = "Firstname is required";
      }
    }
    if (name === "lastName") {
      if (value === "" || value === null) {
        errors.lastName = "Lastname is required";
      }
    }
    if (name === "phone") {
      if (value === "" || value === null) {
        errors.phone = "Telephone is required";
      }
    }
    if (name === "door") {
      if (value === "" || value === null) {
        errors.door = "Door / Flat / Build.. Number is required";
      }
    }
    // Update form data
    setFormErrors(errors);
    setNewAddressData({ ...newAddressData, [name]: sanitizedValue });
    setIsButtonDisabled(false);
  };

  const valid_postcode = (postcode) => {
    const postcodeRegex = /^[A-Z]{1,2}[0-9R][0-9A-Z]?[0-9][A-Z]{2}$/i;
    const formattedPostcode = postcode.replace(/\s/g, "");
    return postcodeRegex.test(formattedPostcode);
  };

  const isValidEmail = (email) => {
    // Regular expression for a basic email format validation
    const emailRegex = /^[A-Za-z0-9._%-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
    return emailRegex.test(email);
  };

  const isFormValid = () => {
    return Object.values(formErrors).every((error) => error === "");
  };

  const deliveryFormData = {
    client_path: path,
    order_mode: getOrderMode === "Delivery" ? "0" : "1",
    post_code: formData.postcode,
  };

  const deliveryNewFormData = {
    client_path: path,
    order_mode: getOrderMode === "Delivery" ? "0" : "1",
    post_code: newAddressData.postcode,
  };

  const SubmitForm = () => {
    setIsButtonDisabled(true);
    checkPostcode(deliveryFormData)
      .then((response) => {
        console.log(response);
        if (response.status === true) {
          localStorage.setItem("orderPostcode", formData.postcode);
          localStorage.setItem(
            "postcodeDetail",
            JSON.stringify(response?.message || "")
          );
          console.log(response?.message?.minAmount);
          const minAmount = response?.message?.minAmount || 0;
          const TotalPriceValue = localStorage.getItem("totalPrice")
            ? localStorage.getItem("totalPrice")
            : 0;
          localStorage.setItem("deliverRadiousAmount", minAmount.toString());
          if (parseFloat(TotalPriceValue) < parseFloat(minAmount)) {
            setMinOrderModal(true);
            setMinOrderStatus(true);
          }
          if (formData) {
            if (formData.city) {
              formData.city = formData?.city?.replace(/[@#$'"&]/g, "");
            }
            if (formData.street) {
              formData.street = formData?.street?.replace(/[@#$'"&]/g, "");
            }
          }
          updateAddress(formData)
            .then((response) => {
              console.log(response);
              if (response.status === true) {
                formData.addressId = response.message.addressId;
                formData.customerId = response.message.customerId;
                props.setAddressField(formData);
                if (isLoggedIn !== true) {
                  localStorage.setItem(
                    "guestAddress",
                    JSON.stringify(formData)
                  );
                  localStorage.setItem("orderPostcode", formData.postcode);
                  localStorage.setItem("loginAddress", "");
                } else {
                  localStorage.setItem(
                    "loginAddress",
                    JSON.stringify(formData)
                  );
                  localStorage.setItem("guestAddress", "");
                }
                setPostCodePopupshow(false);
                setNewAddressData(false);
                setShowModalAddressEdit(false);
                setSuccessShow(true);
                setTimeout(() => {
                  setSuccessShow(false);
                }, 2000);
                setIsButtonDisabled(false);
              } else {
                console.log(response);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          setIsButtonDisabled(false);
          setFormErrors({
            postcode: "The restaurant doesn't deliver to " + formData.postcode,
          });
          console.log(response);
          localStorage.setItem("postcodeDetail", "");
        }
      })
      .catch((error) => {
        setFormErrors({
          postcode: "The restaurant doesn't deliver to " + formData.postcode,
        });
        localStorage.setItem("postcodeDetail", "");
        console.log(error);
      });
  };

  const SubmitFormNewAddress = () => {
    setIsButtonDisabled(true);
    checkPostcode(deliveryNewFormData)
      .then((response) => {
        console.log(response);
        if (response.status === true) {
          localStorage.setItem("orderPostcode", newAddressData.postcode);
          localStorage.setItem(
            "postcodeDetail",
            JSON.stringify(response?.message || "")
          );
          console.log(response?.message?.minAmount);
          const minAmount = response?.message?.minAmount || 0;
          const TotalPriceValue = localStorage.getItem("totalPrice")
            ? localStorage.getItem("totalPrice")
            : 0;
          localStorage.setItem("deliverRadiousAmount", minAmount.toString());
          if (parseFloat(TotalPriceValue) < parseFloat(minAmount)) {
            setMinOrderModal(true);
            setMinOrderStatus(true);
          }
          if (newAddressData) {
            if (newAddressData.city) {
              newAddressData.city = newAddressData?.city?.replace(
                /[@#$'"&]/g,
                ""
              );
            }
            if (newAddressData.street) {
              newAddressData.street = newAddressData?.street?.replace(
                /[@#$'"&]/g,
                ""
              );
            }
            newAddressData.firstName = formData.firstName;
            newAddressData.lastName = formData.lastName;
            newAddressData.phone = formData.phone;
            newAddressData.email = formData.email;
            newAddressData.addressId = formData.addressId;
            newAddressData.customerId = formData.customerId;
          }
          console.log(newAddressData);
          updateAddress(newAddressData)
            .then((response) => {
              console.log(response);
              if (response.status === true) {
                newAddressData.addressId = response.message.addressId;
                newAddressData.customerId = response.message.customerId;
                props.setAddressField(newAddressData);
                if (isLoggedIn !== true) {
                  localStorage.setItem(
                    "guestAddress",
                    JSON.stringify(newAddressData)
                  );
                  localStorage.setItem(
                    "orderPostcode",
                    newAddressData.postcode
                  );
                  localStorage.setItem("loginAddress", "");
                } else {
                  localStorage.setItem(
                    "loginAddress",
                    JSON.stringify(newAddressData)
                  );
                  localStorage.setItem("guestAddress", "");
                }
                setNewAddressShow(false);
                setNewAddressData({
                  firstName: "",
                  lastName: "",
                  postcode: "",
                  phone: "",
                  email: "",
                  door: "",
                  street: "",
                  city: "",
                  orderMode: getOrderMode === "Delivery" ? "0" : "1",
                  customerId: "",
                  addressId: "",
                });
                setPostCodePopupshow(false);
                setShowModalAddressEdit(false);
                setSuccessShow(true);
                setTimeout(() => {
                  setSuccessShow(false);
                }, 2000);
                setIsButtonDisabled(false);
              } else {
                console.log(response);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          setIsButtonDisabled(false);
          setFormErrors({
            postcode:
              "The restaurant doesn't deliver to " + newAddressData.postcode,
          });
          console.log(response);
          localStorage.setItem("postcodeDetail", "");
        }
      })
      .catch((error) => {
        setFormErrors({
          postcode:
            "The restaurant doesn't deliver to " + newAddressData.postcode,
        });
        localStorage.setItem("postcodeDetail", "");
        console.log(error);
      });
  };

  let getAddressField = [];
  if (isLoggedIn === true) {
    const data = AddressPopupContext();
    getAddressField = data.getAddressField;
  } else {
    const guestAddress = localStorage.getItem("guestAddress");
    getAddressField = guestAddress ? JSON.parse(guestAddress) : "";
    // console.log(getAddressField.postcode);
    if (getAddressField.postcode !== localStorage.getItem("orderPostcode")) {
      // setAddressPopupshow(true);
    }
  }

  const getAddressIcon = (type) => {
    switch (type) {
      case "home":
        return <GoHome style={{ fontSize: "25px", alignSelf: "flex-start" }} />;
      case "office":
        return (
          <PiBuildingOfficeLight
            style={{ fontSize: "25px", alignSelf: "flex-start" }}
          />
        );
      default:
        return (
          <GrLocation style={{ fontSize: "25px", alignSelf: "flex-start" }} />
        );
    }
  };

  return (
    <>
      <div className="delivery-action-btn">
        <button className="delivery-action-btn" onClick={handleShowAddressEdit}>
          {props.label}
        </button>
      </div>
      <Modal
        show={showModalAddressEdit}
        onHide={handleCloseAddressEdit}
        id="checkout-postcodenew"
        centered
        className={theme === "dark" ? "dark-popup" : null}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="address-book-modal">
            <div className="address-book-header">
              <span>Address book</span>
              <img
                src={closeiconnew}
                alt="closeicon"
                className="closeiconnew"
                onClick={handleCloseAddressEdit}
              />
            </div>
            <div className="address-book-contentbook">
              <div
                className="add-new-address-box"
                onClick={handleShowNewAddress}
              >
                <div className="add-new-left">
                  {/* <Home className="icon" /> */}
                  {/* <img
                  src={EditadressLocation}
                  className="addressiconnew" /> */}
                  <GrLocation className="addressiconnew" />

                  <span>Add a new address</span>
                </div>
                <img
                  src={EditadressPlus}
                  alt="editiconlocation"
                  className="addressiconnew"
                />
                {/* <Plus className="icon" />s */}
              </div>

              {/* Address 1 */}
              <div className="address-card">
                <div className="address-left">
                  {/* <img src={EditadressLocation} alt="editiconlocation" className="addressiconnew" /><GrLocation /> */}
                  {getAddressIcon(props.getDefaultAddress)}
                  {/* <MapPin className="icon" /> */}
                  <div className="address-info">
                    <div className="address-title">
                      {getAddressField.postcode}
                    </div>
                    <div className="address-subtitle">
                      {getAddressField.door},{getAddressField.street}
                      {getAddressField.city}
                    </div>
                    <div className="address-edit" onClick={handleShow}>
                      Edit address
                    </div>
                  </div>
                </div>
                <div className="address-radio">
                  <div className="radio-btn-group">
                    <label>
                      <input
                        name="selectaddtype"
                        type="radio"
                        label="Other"
                        id="Other"
                        // checked={props.getDefaultAddress === "Other"}
                        // onChange={() => handleRadioChange("Other")}
                        data-fus="fus-test-edithomeradiobtn"
                      />
                      {/* <span>Home</span> */}
                    </label>
                  </div>
                </div>
              </div>

              <button
                className="done-buttonaddressbook"
                // className="submit-btn"
                type="submit"
                onClick={handleCloseAddressEdit}
                disabled={!isFormValid() || isButtonDisabled}
                data-fus="fus-test-editsubmitbtn"
              >
                Update
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* // OLD Address Data popup // */}
      <Modal
        show={postCodePopupshow}
        onHide={handleClose}
        id="checkout-postcode"
        centered
        className={theme === "dark" ? "dark-popup" : null}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="header-div">
            <h3>
              {/* {isLoggedIn === true
                  ? `${Data ? Data.type : ""} To`
                  : "Change Postcode"} */}
              Address book
            </h3>
            {/* <span className="close-btn" onClick={handleClose} data-fus="fus-test-pickupeditclsebtn">
              <MdOutlineCancel />
            </span> */}
            <img
              src={closeiconnew}
              alt="closeicon"
              className="closeiconnew"
              data-fus="fus-test-pickupeditclsebtn"
              onClick={handleClose}
            />
          </div>
          <div className="checkoutaddresseditpopup">
            <Form>
              <Row className="align-items-start">
                <Col xxl={6} xs={6} md={6}>
                  <div className="input-div1 first-input">
                    <Form.Control
                      name="customerId"
                      type="text"
                      placeholder="Customer Id"
                      value={formData.customerId}
                      style={{ display: "none" }}
                    />
                    <Form.Control
                      name="addressId"
                      type="text"
                      placeholder="Address Id"
                      value={formData.addressId}
                      style={{ display: "none" }}
                    />
                    <Form.Control
                      name="orderMode"
                      type="text"
                      placeholder="OrderMode"
                      value={formData.orderMode}
                      style={{ display: "none" }}
                    />
                    <Form.Control
                      name="firstName"
                      type="text"
                      placeholder="First name"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      isInvalid={!!formErrors.firstName}
                      style={{ display: "none" }}
                      data-fus="fus-test-editfirstnameinput"
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.firstName}
                    </Form.Control.Feedback>
                  </div>
                </Col>
                <Col xxl={6} xs={6} md={6}>
                  <div className="input-div second-input">
                    <Form.Control
                      name="lastName"
                      type="text"
                      placeholder="Lastname"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      isInvalid={!!formErrors.lastName}
                      style={{ display: "none" }}
                      data-fus="fus-test-editlastnameinput"
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.lastName}
                    </Form.Control.Feedback>
                  </div>
                </Col>
                <Col xxl={6} xs={6} md={6}>
                  <div className="input-div">
                    <Form.Control
                      name="phone"
                      type="text"
                      placeholder="Telephone"
                      value={formData.phone} // Corrected this line
                      onChange={handleInputChange}
                      isInvalid={!!formErrors.phone}
                      style={{ display: "none" }}
                      data-fus="fus-test-edittelephoneinput"
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.phone}
                    </Form.Control.Feedback>
                  </div>
                </Col>
                <Col xxl={6} xs={6} md={6}>
                  <div className="input-div">
                    <Form.Control
                      name="email"
                      type="text"
                      placeholder="email"
                      value={formData.email} // Corrected this line
                      onChange={handleInputChange}
                      isInvalid={!!formErrors.email}
                      style={{ display: "none" }}
                      data-fus="fus-test-editemailinput"
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.email}
                    </Form.Control.Feedback>
                  </div>
                </Col>
                <Col xxl={6} xs={6} md={6}>
                  {/* <div
                    className="input-div1
                  "
                  >
                    <Form.Control
                      name="postcode"
                      type="text"
                      placeholder="Post Code"
                      value={formData.postcode}
                      onChange={getGoogleAddress}
                      isInvalid={!!formErrors.postcode}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.postcode}
                    </Form.Control.Feedback>
                  </div> */}
                  <TextField
                    required
                    className="mb-4"
                    id="outlined-basic5"
                    label="Postcode"
                    name="postcode"
                    type="text"
                    placeholder="Post Code"
                    value={formData.postcode}
                    onChange={getGoogleAddress}
                    isInvalid={!!formErrors.postcode}
                    error={!!formErrors.postcode}
                    helperText={formErrors.postcode || ""}
                    data-fus="fus-test-editpostcodeinput"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                      },
                    }}
                  />
                </Col>
                <Col xxl={6} xs={6} md={6}>
                  {/* <div className="input-div1">
                    <Form.Control
                      name="door"
                      type="text"
                      placeholder="Door Number"
                      value={formData.door} // Corrected this line
                      onChange={handleInputChange}
                      isInvalid={!!formErrors.door}
                    // style={{ display: "none" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.door}
                    </Form.Control.Feedback>
                  </div> */}
                  <TextField
                    required
                    className="mb-4"
                    id="outlined-basic6"
                    label="Door / Flat / Building"
                    name="door"
                    type="text"
                    placeholder="Door / Flat / Building"
                    value={formData.door} // Corrected this line
                    onChange={handleInputChange}
                    isInvalid={!!formErrors.door}
                    error={!!formErrors.door}
                    helperText={formErrors.door || ""}
                    data-fus="fus-test-editdoornumberinput"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                      },
                    }}
                  />
                </Col>
                <Col xxl={6} xs={6} md={6}></Col>
                <Col xxl={6} xs={6} md={6}></Col>
                <Col xxl={6} xs={6} md={6}>
                  {/* <div className="input-div1 mt-2">
                    <Form.Control
                      name="street"
                      type="text"
                      placeholder="street"
                      value={formData.street}
                      onChange={handleInputChange}
                      isInvalid={!!formErrors.street}
                    // style={{ display: "none" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.street}
                    </Form.Control.Feedback>
                  </div> */}
                  <TextField
                    required
                    className="mb-4"
                    id="outlined-basic7"
                    label="Street"
                    name="street"
                    type="text"
                    placeholder="street"
                    value={formData.street}
                    onChange={handleInputChange}
                    isInvalid={!!formErrors.street}
                    error={!!formErrors.street}
                    helperText={formErrors.street || ""}
                    data-fus="fus-test-editstreetnameinput"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                      },
                    }}
                  />
                </Col>
                <Col xxl={6} xs={6} md={6}>
                  {/* <div className="input-div1 mt-2">
                    <Form.Control
                      name="city"
                      type="text"
                      placeholder="city"
                      value={formData.city}
                      onChange={handleInputChange}
                      isInvalid={!!formErrors.city}
                    // style={{ display: "none" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.city}
                    </Form.Control.Feedback>
                  </div> */}
                  <TextField
                    required
                    className="mb-4"
                    id="outlined-basic8"
                    label="City"
                    name="city"
                    type="text"
                    placeholder="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    isInvalid={!!formErrors.city}
                    error={!!formErrors.city}
                    helperText={formErrors.city || ""}
                    data-fus="fus-test-editcitynameinput"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                      },
                    }}
                  />
                </Col>
                {isLoggedIn === true ? (
                  <>
                    <Col xxl={12} xs={12} md={12}>
                      <div className="radio-btn-group">
                        <label>
                          <input
                            name="selectaddtype"
                            type="radio"
                            label="Home"
                            id="Home"
                            checked={props.getDefaultAddress === "Home"}
                            onChange={() => handleRadioChange("Home")}
                            data-fus="fus-test-edithomeradiobtn"
                          />
                          <span>Home</span>
                        </label>
                        <label>
                          <input
                            name="selectaddtype"
                            type="radio"
                            label="Office"
                            id="Office"
                            checked={props.getDefaultAddress === "Office"}
                            onChange={() => handleRadioChange("Office")}
                            data-fus="fus-test-editofficeradiobtn"
                          />
                          <span>Office</span>
                        </label>
                        <label>
                          <input
                            name="selectaddtype"
                            type="radio"
                            label="Other"
                            id="Other"
                            checked={props.getDefaultAddress === "Other"}
                            onChange={() => handleRadioChange("Other")}
                            data-fus="fus-test-editothersradiobtn"
                          />
                          <span>Other</span>
                        </label>
                      </div>
                    </Col>
                  </>
                ) : null}
                <Col xxl={12} xs={12} md={12}>
                  <Button
                    className="submit-btn"
                    onClick={SubmitForm}
                    disabled={!isFormValid() || isButtonDisabled}
                    data-fus="fus-test-editsubmitbtn"
                  >
                    {/* Update Details */}
                    Save
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        </Modal.Body>
        {/* Modal Footer */}
      </Modal>

      {/* //New Address Data popup // */}

      {newAddresShow && (
        <Modal
          show={newAddresShow}
          onHide={handleClose}
          id="checkout-postcode"
          centered
          className={
            localStorage.getItem("isApp") == "true"
              ? `app-side ${theme === "dark" ? "dark-popup" : null}`
              : `${theme === "dark" ? "dark-popup" : null}`
          }
          backdrop="static"
          keyboard={false}
        >
          <Modal.Body>
            <div className="header-div">
              <h4
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                {/* {isLoggedIn === true
                  ? `${Data ? Data.type : ""} To`
                  : "Change Postcode"} */}
                <MdOutlineArrowBackIos
                  className="closeiconnew"
                  style={{ color: "#fff" }}
                  data-fus="fus-test-pickupeditclsebtn"
                  onClick={handleCloseNewAddress}
                />{" "}
                New address
              </h4>
              {/* <span className="close-btn" onClick={handleClose} data-fus="fus-test-pickupeditclsebtn">
              <MdOutlineCancel />
            </span> */}
            </div>
            <div className="checkoutaddresseditpopup">
              <Form>
                <Row className="align-items-start">
                  <Col xxl={6} xs={6} md={6}>
                    <div className="input-div1 first-input">
                      <Form.Control
                        name="customerId"
                        type="text"
                        placeholder="Customer Id"
                        value={newAddressData.customerId}
                        style={{ display: "none" }}
                      />
                      <Form.Control
                        name="addressId"
                        type="text"
                        placeholder="Address Id"
                        value={newAddressData.addressId}
                        style={{ display: "none" }}
                      />
                      <Form.Control
                        name="orderMode"
                        type="text"
                        placeholder="OrderMode"
                        value={newAddressData.orderMode}
                        style={{ display: "none" }}
                      />
                      <Form.Control
                        name="firstName"
                        type="text"
                        placeholder="First name"
                        value={newAddressData.firstName}
                        onChange={handleNewInputChange}
                        isInvalid={!!formErrors.firstName}
                        style={{ display: "none" }}
                        data-fus="fus-test-editfirstnameinput"
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.firstName}
                      </Form.Control.Feedback>
                    </div>
                  </Col>
                  <Col xxl={6} xs={6} md={6}>
                    <div className="input-div second-input">
                      <Form.Control
                        name="lastName"
                        type="text"
                        placeholder="Last name"
                        value={newAddressData.lastName}
                        onChange={handleNewInputChange}
                        isInvalid={!!formErrors.lastName}
                        style={{ display: "none" }}
                        data-fus="fus-test-editlastnameinput"
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.lastName}
                      </Form.Control.Feedback>
                    </div>
                  </Col>
                  <Col xxl={6} xs={6} md={6}>
                    <div className="input-div">
                      <Form.Control
                        name="phone"
                        type="text"
                        placeholder="Telephone"
                        value={newAddressData.phone} // Corrected this line
                        onChange={handleNewInputChange}
                        isInvalid={!!formErrors.phone}
                        style={{ display: "none" }}
                        data-fus="fus-test-edittelephoneinput"
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.phone}
                      </Form.Control.Feedback>
                    </div>
                  </Col>
                  <Col xxl={6} xs={6} md={6}>
                    <div className="input-div">
                      <Form.Control
                        name="email"
                        type="text"
                        placeholder="email"
                        value={newAddressData.email} // Corrected this line
                        onChange={handleNewInputChange}
                        isInvalid={!!formErrors.email}
                        style={{ display: "none" }}
                        data-fus="fus-test-editemailinput"
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.email}
                      </Form.Control.Feedback>
                    </div>
                  </Col>
                  <Col xxl={6} xs={6} md={6}>
                    {/* <div
                    className="input-div1
                  "
                  >
                    <Form.Control
                      name="postcode"
                      type="text"
                      placeholder="Post Code"
                      value={formData.postcode}
                      onChange={getGoogleAddress}
                      isInvalid={!!formErrors.postcode}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.postcode}
                    </Form.Control.Feedback>
                  </div> */}
                    <TextField
                      required
                      className="mb-4"
                      id="outlined-basic5"
                      label="Postcode"
                      name="postcode"
                      type="text"
                      placeholder="Post Code"
                      value={newAddressData.postcode}
                      onChange={getGoogleNewAddress}
                      isInvalid={!!formErrors.postcode}
                      error={!!formErrors.postcode}
                      helperText={formErrors.postcode || ""}
                      data-fus="fus-test-editpostcodeinput"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                        },
                      }}
                    />
                  </Col>
                  <Col xxl={6} xs={6} md={6}>
                    {/* <div className="input-div1">
                    <Form.Control
                      name="door"
                      type="text"
                      placeholder="Door Number"
                      value={formData.door} // Corrected this line
                      onChange={handleNewInputChange}
                      isInvalid={!!formErrors.door}
                    // style={{ display: "none" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.door}
                    </Form.Control.Feedback>
                  </div> */}
                    <TextField
                      required
                      className="mb-4"
                      id="outlined-basic6"
                      label="Door / Flat / Building"
                      name="door"
                      type="text"
                      placeholder="Door / Flat / Building"
                      value={newAddressData.door} // Corrected this line
                      onChange={handleNewInputChange}
                      isInvalid={!!formErrors.door}
                      error={!!formErrors.door}
                      helperText={formErrors.door || ""}
                      data-fus="fus-test-editdoornumberinput"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                        },
                      }}
                    />
                  </Col>
                  <Col xxl={6} xs={6} md={6}></Col>
                  <Col xxl={6} xs={6} md={6}></Col>
                  <Col xxl={6} xs={6} md={6}>
                    {/* <div className="input-div1 mt-2">
                    <Form.Control
                      name="street"
                      type="text"
                      placeholder="street"
                      value={formData.street}
                      onChange={handleNewInputChange}
                      isInvalid={!!formErrors.street}
                    // style={{ display: "none" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.street}
                    </Form.Control.Feedback>
                  </div> */}
                    <TextField
                      required
                      className="mb-4"
                      id="outlined-basic7"
                      label="Street"
                      name="street"
                      type="text"
                      placeholder="street"
                      value={newAddressData.street}
                      onChange={handleNewInputChange}
                      isInvalid={!!formErrors.street}
                      error={!!formErrors.street}
                      helperText={formErrors.street || ""}
                      data-fus="fus-test-editstreetnameinput"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                        },
                      }}
                    />
                  </Col>
                  <Col xxl={6} xs={6} md={6}>
                    {/* <div className="input-div1 mt-2">
                    <Form.Control
                      name="city"
                      type="text"
                      placeholder="city"
                      value={formData.city}
                      onChange={handleNewInputChange}
                      isInvalid={!!formErrors.city}
                    // style={{ display: "none" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.city}
                    </Form.Control.Feedback>
                  </div> */}
                    <TextField
                      required
                      className="mb-4"
                      id="outlined-basic8"
                      label="City"
                      name="city"
                      type="text"
                      placeholder="city"
                      value={newAddressData.city}
                      onChange={handleNewInputChange}
                      isInvalid={!!formErrors.city}
                      error={!!formErrors.city}
                      helperText={formErrors.city || ""}
                      data-fus="fus-test-editcitynameinput"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                        },
                      }}
                    />
                  </Col>
                  {isLoggedIn === true ? (
                    <>
                      <Col xxl={12} xs={12} md={12}>
                        <div className="radio-btn-group">
                          <label>
                            <input
                              name="selectaddtype"
                              type="radio"
                              label="Home"
                              id="Home"
                              checked={props.getDefaultAddress === "Home"}
                              onChange={() => handleRadioChange("Home")}
                              data-fus="fus-test-edithomeradiobtn"
                            />
                            <span>Home</span>
                          </label>
                          <label>
                            <input
                              name="selectaddtype"
                              type="radio"
                              label="Office"
                              id="Office"
                              checked={props.getDefaultAddress === "Office"}
                              onChange={() => handleRadioChange("Office")}
                              data-fus="fus-test-editofficeradiobtn"
                            />
                            <span>Office</span>
                          </label>
                          <label>
                            <input
                              name="selectaddtype"
                              type="radio"
                              label="Other"
                              id="Other"
                              checked={props.getDefaultAddress === "Other"}
                              onChange={() => handleRadioChange("Other")}
                              data-fus="fus-test-editothersradiobtn"
                            />
                            <span>Other</span>
                          </label>
                        </div>
                      </Col>
                    </>
                  ) : null}
                  <Col xxl={12} xs={12} md={12}>
                    <Button
                      className="submit-btn"
                      onClick={SubmitFormNewAddress}
                      disabled={!isFormValid() || isButtonDisabled}
                      data-fus="fus-test-editsubmitbtn"
                    >
                      {/* Update Details */}
                      Save
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </Modal.Body>
          {/* Modal Footer */}
        </Modal>
      )}

      <Modal
        show={SuccessShow}
        onHide={handleSuccessClose}
        data-fus="fus-test-editclosebtn"
        className={`address-success-popup  ${
          theme === "dark" ? "dark-theme" : ""
        }`}
        backdrop={true}
      >
        <Modal.Body>
          <div className="content">
            <p>Your address was updated successfully</p>
            <button
              onClick={handleSuccessClose}
              data-fus="fus-test-editclosebtn"
            >
              <FaRegCircleCheck />
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
function ChangeOrder(props) {
  // console.log(props);
  // default preorder tab
  const [defaultCollectionTabStatus, setDefaultCollectionTabStatus] =
    useState(null);
  const [defaultDeliveryTabStatus, setDefaultDeliveryTabStatus] =
    useState(null);

  return (
    <Modal
      show={props.showPreorder}
      onHide={props.HandleClickClose}
      centered
      className={`preorder-popup ${props.theme === "dark" ? "dark-theme" : ""}`}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body>
        <span
          className="close-btn"
          onClick={props.HandleClickClose}
          data-fus="fus-test-editclosebtn"
        >
          <MdOutlineCancel />
        </span>
        <PreOrder
          selectedOrderMode={props.selectedOrderMode}
          setSelectedOrderModeValue={props.setSelectedOrderModeValue}
          showPreorder={props.showPreorder}
          setShowPreorder={props.setShowPreorder}
          defaultCollectionTabStatus={defaultCollectionTabStatus}
          setDefaultCollectionTabStatus={setDefaultCollectionTabStatus}
          defaultDeliveryTabStatus={defaultDeliveryTabStatus}
          setDefaultDeliveryTabStatus={setDefaultDeliveryTabStatus}
        />
      </Modal.Body>
    </Modal>
  );
}

function ConfirmDetails(props) {
  const { theme } = useContext(ThemeContext);
  const [successShow, setSuccessShow] = useState(false);
  const { AddressPopupshow, setAddressPopupshow } = useContext(CheckoutContext);
  const { addressDetail } = useContext(CheckoutContext);
  const { getOrderMode } = OrderFlow();
  const [Data, setData] = useState(null);
  const isLoggedIn = JSON.parse(localStorage.getItem("isLoggedIn"));

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    orderMode: getOrderMode === "Delivery" ? "0" : "1",
    customerId: "",
    addressId: "",
  });

  // console.log('formDataformData',formData)

  // const SSOuserData = JSON.parse(localStorage.getItem("userData"));

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const isLoggedIn = JSON.parse(localStorage.getItem("isLoggedIn"));
    if (userData && isLoggedIn === true) {
      // Fetch and set newData
      const LoginAddress = localStorage.getItem("loginAddress");
      if (LoginAddress && LoginAddress !== "") {
        const address = JSON.parse(LoginAddress);
        setData(address);
        setFormData((prevFormData) => ({
          ...prevFormData,
          firstName: address.firstName || "",
          lastName: address.lastName || "",
          postcode: address.postcode || "",
          phone: address.phone || "",
          email: address.email || "",
          orderMode: getOrderMode === "Delivery" ? "0" : "1",
          customerId: address.customerId || "",
          addressId: address.addressId || "",
        }));
      } else {
        const customerId = {
          customer_id: userData.customerId,
        };
        getProfile(customerId)
          .then((response) => {
            if (response.status === false) {
            } else {
              setData((prevFormData) => ({
                ...prevFormData,
                email: response?.data?.profile?.email || "",
              }));
              setFormData((prevFormData) => ({
                ...prevFormData,
                email: response?.data?.profile?.email || "",
              }));
            }
          })
          .catch((error) => {
            console.log(error);
          });
        const newData =
          addressDetail?.data.find((data) => data.primary_address === 1) || "";
        // console.log('newDatanewData',newData);
        if (newData) {
          setFormData((prevFormData) => ({
            ...prevFormData,
            firstName: newData.fname || "",
            lastName: newData.lname || "",
            phone: newData.phone || "",
            email: newData.email || "",
            orderMode: getOrderMode === "Delivery" ? "0" : "1",
            customerId: newData.cid || "",
            addressId: newData.id || "",
          }));
          setData(newData);
        }
      }
    } else {
      // Fetch and set guest address data
      const guestAddress = localStorage.getItem("guestAddress");
      if (guestAddress) {
        const address = JSON.parse(guestAddress);
        setFormData((prevFormData) => ({
          ...prevFormData,
          firstName: address.firstName || "",
          lastName: address.lastName || "",
          phone: address.phone || "",
          email: address.email || "",
          orderMode: getOrderMode === "Delivery" ? "0" : "1",
          customerId: address.customerId || "",
          addressId: address.addressId || "",
        }));
      }
    }
  }, [getOrderMode, setFormData, addressDetail]);

  const handleClose = () => {
    const isEmpty = Object.values(formData).some((value) => value === "");
    if (!isEmpty) {
      setAddressPopupshow(false);
    }
  };

  const handleShow = () => setAddressPopupshow(true);
  const handleSuccessClose = () => setSuccessShow(false);

  const [formErrors, setFormErrors] = useState({});

  const handleInputChange = (event) => {
    setIsButtonDisabled(false);
    const { name, value } = event.target;

    // Define validation rules for each field
    const validationRules = {
      firstName: "First name is required",
      lastName: "Last name is required",
      phone: "Telephone is required",
      email: "Email is required",
    };

    // Check if the field is required and update errors accordingly
    const sanitizedValue = value.trim().replace(/'/g, "");
    const errors = {
      ...formErrors,
      [name]: sanitizedValue === "" ? validationRules[name] : "",
    };

    if (name === "email") {
      if (!isValidEmail(value)) {
        errors.email = "Invalid email format";
      }
    }

    // Update form data
    setFormErrors(errors);
    setFormData({ ...formData, [name]: sanitizedValue });
    setIsButtonDisabled(false);
  };

  const isValidEmail = (email) => {
    // Regular expression for a basic email format validation
    const emailRegex = /^[A-Za-z0-9._%-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
    return emailRegex.test(email);
  };

  const isFormValid = () => {
    return Object.values(formErrors).every((error) => error === "");
  };
  //Collection Details validationSchema
  const validationSchema = {
    firstName: (value) => {
      if (!value || value.trim() === "") {
        return "First name is required";
      }
      return "";
    },
    lastName: (value) => {
      if (!value || value.trim() === "") {
        return "Last name is required";
      }
      return "";
    },
    phone: (value) => {
      if (!value || value.trim() === "") {
        return "Phone number is required";
      } else if (value.replace(/\D/g, "").length < 11) {
        return "Phone Number must be at least 11 digits";
      }
      return "";
    },
    email: (value) => {
      if (!value || value.trim() === "") {
        return "Email is required";
      } else if (!isValidEmail(value)) {
        return "Invalid email format";
      }
      return "";
    },
  };
  const validateForm = () => {
    let errors = {};

    Object.keys(validationSchema).forEach((key) => {
      const error = validationSchema[key](formData[key]);
      if (error) {
        errors[key] = error;
      }
    });

    setFormErrors(errors);

    // Return true if no errors, false otherwise
    return Object.keys(errors).length === 0;
  };

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const SubmitForm = () => {
    const isValid = validateForm();
    if (isValid) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        firstName: formData.firstName ? "" : "FirstName-Mandatory",
        lastName: formData.lastName ? "" : "LastName-Mandatory",
        phone: formData.phone ? "" : "Phone-Mandatory",
        email: formData.email ? "" : "Email-Mandatory",
      }));
      setIsButtonDisabled(true);
      updateAddress(formData)
        .then((response) => {
          console.log(response);
          if (response.status === true) {
            formData.addressId = response.message.addressId;
            formData.customerId = response.message.customerId;
            if (isLoggedIn !== true) {
              localStorage.setItem("guestAddress", JSON.stringify(formData));
              localStorage.setItem("loginAddress", "");
            } else {
              localStorage.setItem("loginAddress", JSON.stringify(formData));
              localStorage.setItem("guestAddress", "");
            }
            setAddressPopupshow(false);
            setSuccessShow(true);
            setTimeout(() => {
              setSuccessShow(false);
            }, 2000);
            setIsButtonDisabled(false);
          } else {
            console.log(response);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
    }
  };

  return (
    <>
      <button className="delivery-action-btn" onClick={handleShow}>
        {props.label}
      </button>
      <Modal
        show={AddressPopupshow}
        onHide={handleClose}
        id="checkout-address"
        centered
        className={theme === "dark" ? "dark-popup" : null}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="header-div">
            <h3>Confirm details</h3>
            {/* <span className="close-btn" onClick={handleClose} data-fus="fus-test-editclosebtn">
              <MdOutlineCancel />
            </span> */}
            <img
              src={closeiconnew}
              alt="closeicon"
              className="closeiconnew"
              onClick={handleClose}
            />
          </div>
          <Form>
            <Row>
              <Col xs={12}>
                <div className="input-div first-input">
                  <Form.Control
                    name="customerId"
                    type="text"
                    placeholder="Customer Id"
                    value={formData.customerId}
                    style={{ display: "none" }}
                  />
                  <Form.Control
                    name="addressId"
                    type="text"
                    placeholder="Address Id"
                    value={formData.addressId}
                    style={{ display: "none" }}
                  />
                  <Form.Control
                    name="orderMode"
                    type="text"
                    placeholder="OrderMode"
                    value={formData.orderMode}
                    style={{ display: "none" }}
                  />
                </div>
                <TextField
                  className="mb-4"
                  id="outlined-basic"
                  fullWidth
                  label="First name"
                  name="firstName"
                  variant="outlined"
                  placeholder={
                    formErrors.firstName ? formErrors.firstName : "First name"
                  }
                  type="text"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  error={!!formErrors.firstName}
                  helperText={formErrors.firstName || ""}
                  data-fus="fus-test-pickupfnameinput"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      // padding:"2px" // rounded-md ≈ 6px
                    },
                  }}
                />
              </Col>
              <Col xs={12}>
                {/* <div className="input-div second-input">
                    <Form.Control
                      name="lastName"
                      type="text"
                      placeholder={
                        formErrors.lastName ? formErrors.lastName : "Last Name"
                      }
                      value={formData.lastName}
                      onChange={handleInputChange}
                      isInvalid={!!formErrors.lastName}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.LastName}
                    </Form.Control.Feedback>
                  </div> */}
                <TextField
                  className="mb-4"
                  id="outlined-basic"
                  label="Last Name"
                  variant="outlined"
                  name="lastName"
                  fullWidth
                  type="text"
                  placeholder={
                    formErrors.lastName ? formErrors.lastName : "Last Name"
                  }
                  value={formData.lastName}
                  onChange={handleInputChange}
                  error={!!formErrors.lastName}
                  helperText={formErrors.lastName || ""}
                  data-fus="fus-test-pickuplnameinput"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      // padding:"2px" // rounded-md ≈ 6px
                    },
                  }}
                />
              </Col>
              <Col xs={12}>
                {/* <div className="input-div">
                    <Form.Control
                      name="phone"
                      type="text"
                      placeholder={
                        formErrors.phone ? formErrors.phone : "Telephone"
                      }
                      value={formData.phone}
                      onChange={handleInputChange}
                      isInvalid={!!formErrors.phone}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.TelePhone}
                    </Form.Control.Feedback>
                  </div> */}
                <TextField
                  className="mb-4"
                  id="outlined-basic"
                  label="Phone Number"
                  variant="outlined"
                  name="phone"
                  type="number"
                  fullWidth
                  placeholder={
                    formErrors.phone ? formErrors.phone : "Telephone"
                  }
                  value={formData.phone}
                  onChange={handleInputChange}
                  error={!!formErrors.phone}
                  helperText={formErrors.phone || ""}
                  data-fus="fus-test-pickupphonenumberinput"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      // padding:"2px" // rounded-md ≈ 6px
                    },
                  }}
                />
              </Col>
              <Col xs={12}>
                {/* <div className="input-div">
                    <Form.Control
                      name="email"
                      type="email"
                      placeholder={formErrors.email ? formErrors.email : "Email"}
                      value={formData.email}
                      onChange={handleInputChange}
                      isInvalid={!!formErrors.email}
                      disabled={Data?.email ? true : false}
                      readOnly={Data?.email ? true : false}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.Email}
                    </Form.Control.Feedback>
                  </div> */}

                <TextField
                  className="mb-4"
                  id="outlined-basic"
                  label="Email"
                  variant="outlined"
                  name="email"
                  fullWidth
                  type="email"
                  placeholder={formErrors.email ? formErrors.email : "Email"}
                  value={formData.email}
                  onChange={handleInputChange}
                  isInvalid={!!formErrors.email}
                  disabled={Data?.email ? true : false}
                  readOnly={Data?.email ? true : false}
                  error={!!formErrors.email}
                  helperText={formErrors.email || ""}
                  data-fus="fus-test-pickupemailinput"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      // padding:"2px" // rounded-md ≈ 6px
                    },
                  }}
                />
              </Col>
              <Col xs={12}>
                <Button
                  className="submit-btn w-100"
                  onClick={SubmitForm}
                  disabled={!isFormValid() || isButtonDisabled}
                  style={{
                    width: isButtonDisabled ? "150px" : "",
                    display: "flex", // Use flexbox
                    justifyContent: "center", // Center horizontally
                    alignItems: "center", // Center vertically
                    // paddingTop:"4px"
                  }}
                  data-fus="fus-test-pickupsubmitinput"
                >
                  {isButtonDisabled ? (
                    <>
                      <span>{"        "}</span>
                      <Spinner
                        animation="border"
                        size="sm"
                        // variant="success"
                        style={{
                          display: "flex", // Use flexbox
                          justifyContent: "center", // Center horizontally
                          alignItems: "center",
                          color:'white'
                        }}
                      />
                    </>
                  ) : (
                    // "Update Details"
                    "Done"
                  )}
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal
        show={successShow}
        onHide={handleSuccessClose}
        className={`address-success-popup  ${
          theme === "dark" ? "dark-theme" : ""
        }`}
        backdrop={true}
      >
        <Modal.Body>
          <div className="content">
            <p>Your address was updated successfully</p>
            <button
              onClick={handleSuccessClose}
              data-fus="fus-test-pickupclosebtn"
            >
              <FaRegCircleCheck />
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
//end delivery details
//estimate method
const EstimateCard = () => {
  const { theme } = useContext(ThemeContext);
  const {
    preOrderTimeTable,
    getorderType,
    setGetOrderType,
    setTabStatus,
    selectimeStatus,
    selectedTime,
    setSelectedTime,
    selectEstimateTime,
    setSelectEstimateTime,
    exitOrderDatePart,
    exitOrderTimePart,
    formattedDateE,
    formatToday,
    estimateShow,
    setEstimateShow,
    AddressPopupshow,
  } = useContext(CheckoutContext);
  const { getOrderMode } = OrderFlow();

  //menu Format date today format
  const orderModetype = localStorage.getItem("orderMode");

  

  useEffect(() => {
    // if(getOrderMode === "Delivery"){
    // if(preOrderTimeTable && preOrderTimeTable?.Delivery?.asap?.tatTime){
    //   console.log(selectEstimateTime, selectedTime);
    //   localStorage.setItem("orderType", "ASAP");
    //   setGetOrderType("ASAP");
    // }
    // else{
    //   if(preOrderTimeTable && preOrderTimeTable?.Delivery && preOrderTimeTable.Delivery.today){
    //     setGetOrderType("Today");
    //   localStorage.setItem("orderType", "Today");
    //   }
    //   else{
    //     setGetOrderType("Later");
    //     localStorage.setItem("orderType", "Later");
    //   }
    // }
    // }else{
    // if(getOrderMode === "Collection" && preOrderTimeTable && preOrderTimeTable?.Collection?.asap?.tatTime){
    //   setTabStatus("ASAP");
    //   localStorage.setItem("orderType", "Today");
    // }
    // else{
    //   if(preOrderTimeTable && preOrderTimeTable?.Collection && preOrderTimeTable.Collection.today){
    //     setGetOrderType("Today");
    //   localStorage.setItem("orderType", "Today");
    //   }
    //   else{
    //     setGetOrderType("Later");
    //     localStorage.setItem("orderType", "Later");
    //   }
    // }
    // }

    setGetOrderType(localStorage.getItem("orderType"));

    // setSelectedTime(exitOrderTimePart);
  }, []);

  const handleEstimate = () => {
    setEstimateShow(true);
  };
  //tomorrow today format
  function formatDate(dateString) {
    // Helper function to get a formatted date string from a Date object
    function formatDateObject(dateObj) {
      const year = dateObj.getFullYear();
      const month = dateObj.getMonth();
      const day = dateObj.getDate();

      // Array of month names
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      // Array of day names
      const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

      // Convert month number to month name and get day of the week
      const monthName = monthNames[month];
      const dayOfWeek = dayNames[dateObj.getDay()];

      // Return formatted date with day of the week
      return `${dayOfWeek}, ${day} ${monthName} ${year}`;
    }

    // Handle special cases "today" and "tomorrow"
    if (dateString.toLowerCase() === "today") {
      const today = new Date();
      return formatDateObject(today);
    } else if (dateString.toLowerCase() === "tomorrow") {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      return formatDateObject(tomorrow);
    }

    // Split the date string into components
    const dateParts = dateString.split("-");

    // Extract year, month, and day
    const year = dateParts[0];
    const month = dateParts[1];
    const day = dateParts[2];

    // Array of month names
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Array of day names
    const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    // Convert month number to month name and get day of the week
    const monthName = monthNames[parseInt(month) - 1];
    const dayOfWeek = dayNames[new Date(year, month - 1, day).getDay()];

    // Create the estimate format
    const EstimateFormat = `${dayOfWeek}, ${day} ${monthName} ${year}`;

    // Check if EstimateFormat is tomorrow
    if (
      EstimateFormat ===
      formatDateObject(new Date(new Date().setDate(new Date().getDate() + 1)))
    ) {
      return "Tomorrow";
    } else {
      return EstimateFormat;
    }
  }

  // console.log(formatDate("today")); // Output: Today
  // console.log(formatDate("tomorrow")); // Output: Tomorrow
  // console.log(formatDate("2024-05-24")); // Output: Wednesday, 24 May 2024

  //estimate change tab
  const ChangeTab = (data) => {
    if (
      getOrderMode === "Delivery" &&
      preOrderTimeTable?.Delivery?.asap?.tatTime
    ) {
      localStorage.setItem("orderType", data);
      localStorage.setItem(
        "orderTime",
        preOrderTimeTable?.Delivery?.asap?.time
      );
      localStorage.setItem("preOrder", "0");
      setTabStatus(data);
      setGetOrderType(data);
    }
    if (
      getOrderMode === "Collection" &&
      preOrderTimeTable?.Collection?.asap?.tatTime
    ) {
      localStorage.setItem("orderType", data);
      localStorage.setItem(
        "orderTime",
        preOrderTimeTable?.Collection?.asap?.time
      );
      localStorage.setItem("preOrder", "0");
      setGetOrderType(data);
      setTabStatus(data);
    }
  };

  const EstimateDateFormat = formatDate(exitOrderDatePart);

  const tableOrderCheck = localStorage.getItem("isTableQr");

  return (
    <>
      <div>
        {!tableOrderCheck ? (
          <Card className="estimateCard">
            <Card.Body className="estimateBody">
              <Card.Title className="estimateTitle">
                {getOrderMode === "Delivery"
                  ? "Delivery estimate"
                  : "Pickup estimate"}{" "}
                {""} :
                {getorderType === "ASAP" ? (
                  getOrderMode === "Delivery" ? (
                    <>
                      <span
                        style={{
                          fontFamily: "Geist-Regular",
                          fontSize: "14px",
                          alignSelf: "center",
                        }}
                      >
                        {" "}
                        {preOrderTimeTable &&
                        preOrderTimeTable?.Delivery?.asap?.tatTime
                          ? ""
                          : "Currently not avaialble"}
                      </span>
                      <span
                        style={{
                          fontFamily: "Geist-Regular",
                          fontSize: "14px",
                          alignSelf: "center",
                        }}
                      >
                        {" "}
                        {preOrderTimeTable &&
                        preOrderTimeTable?.Delivery?.asap?.tatTime
                          ? `${preOrderTimeTable?.Delivery?.asap?.tatTime} mins`
                          : ""}
                      </span>
                      {}
                      <br />
                    </>
                  ) : (
                    <>
                      <span
                        style={{
                          fontFamily: "Geist-Regular",
                          fontSize: "14px",
                          alignSelf: "center",
                        }}
                      >
                        {" "}
                        {preOrderTimeTable &&
                        preOrderTimeTable?.Collection?.asap?.tatTime
                          ? ""
                          : "Currently not avaialble"}
                      </span>
                      <span
                        style={{
                          fontFamily: "Geist-Regular",
                          fontSize: "14px",
                          alignSelf: "center",
                        }}
                      >
                        {" "}
                        {preOrderTimeTable &&
                        preOrderTimeTable?.Collection?.asap?.time
                          ? `${preOrderTimeTable?.Collection?.asap?.tatTime} mins`
                          : ""}
                      </span>
                      <br />
                    </>
                  )
                ) : getOrderMode === "Delivery" ? (
                  <>
                    <span
                      style={{
                        fontFamily: "Geist-Regular",
                        fontSize: "14px",
                        alignSelf: "center",
                      }}
                    >
                      {`${
                        exitOrderDatePart
                          ? exitOrderDatePart == formattedDateE
                            ? preOrderTimeTable?.Delivery?.today
                              ? "Today at"
                              : "Select Date"
                            : exitOrderDatePart == formatToday
                            ? preOrderTimeTable?.Delivery?.today
                              ? "Today at"
                              : "Select time"
                            : EstimateDateFormat.replace(/\s\d{4}$/, "")
                          : selectEstimateTime
                      } ${
                        exitOrderTimePart ? exitOrderTimePart : selectedTime
                      }`}
                    </span>
                  </>
                ) : (
                  <>
                    <span
                      style={{
                        fontFamily: "Geist-Regular",
                        fontSize: "14px",
                        alignSelf: "center",
                      }}
                    >
                      {`${
                        exitOrderDatePart
                          ? exitOrderDatePart == formattedDateE
                            ? preOrderTimeTable?.Collection?.today
                              ? "Today at"
                              : "Select Date"
                            : exitOrderDatePart == formatToday
                            ? preOrderTimeTable?.Collection?.today
                              ? "Today at"
                              : "Select time"
                            : EstimateDateFormat.replace(/\s\d{4}$/, "")
                          : selectEstimateTime
                      } ${
                        exitOrderTimePart ? exitOrderTimePart : selectedTime
                      }`}
                    </span>
                  </>
                )}
              </Card.Title>
              <Row>
                <Col xxl={6} xs={6} md={6}>
                  <div
                    className={`estimate-detail ${
                      getorderType === "ASAP" ? "active" : ""
                    } `}
                    onClick={() => {
                      ChangeTab("ASAP");
                    }}
                  >
                    <div className="estimateimgpara">
                      {/* <img
                       
                        src={clockcommon} alt="clockwhite"
                      /> */}
                      <FaRegClock />

                      <p className="estimate-text-postcode">
                        {getOrderMode === "Delivery" ? "ASAP" : "ASAP"}
                      </p>
                    </div>
                    <div className="estimate-text">
                      <p className="estimate-text-sub">
                        {getOrderMode === "Delivery" ? (
                          <>
                            <span>
                              {" "}
                              {preOrderTimeTable &&
                              preOrderTimeTable?.Delivery?.asap?.tatTime
                                ? ""
                                : "Currently not avaialble"}
                            </span>
                            {preOrderTimeTable &&
                            preOrderTimeTable?.Delivery?.asap?.tatTime
                              ? `${preOrderTimeTable?.Delivery?.asap?.tatTime} mins`
                              : ""}
                            {}
                            <br />
                          </>
                        ) : (
                          <>
                            <span>
                              {" "}
                              {preOrderTimeTable &&
                              preOrderTimeTable?.Collection?.asap?.tatTime
                                ? ""
                                : "Currently not avaialble"}
                            </span>
                            {preOrderTimeTable &&
                            preOrderTimeTable?.Collection?.asap?.time
                              ? ` ${preOrderTimeTable?.Collection?.asap?.tatTime} mins`
                              : ""}
                            <br />
                          </>
                        )}
                      </p>
                    </div>

                    {/* <div className="estimate-action-btn"></div> */}
                  </div>
                </Col>
                {/* <div className="border-style"></div> */}
                <Col xxl={6} xs={6} md={6}>
                  <div
                    className={`estimate-detail ${
                      getorderType === "ASAP" ? "" : "active"
                    } `}
                    onClick={handleEstimate}
                  >
                    <div className="estimateimgpara">
                      {/* <img
                        
                        src={timecommon}
                        alt="timeicon" /> */}
                      <FiCalendar />

                      <p className="estimate-text-postcode">Schedule</p>
                    </div>

                    <div className="estimate-text" onClick={handleEstimate}>
                      {/* <p className="estimate-text-sub">{exitOrderDatePart ? exitOrderDatePart == formattedDate ? "Today" : exitOrderDatePart == formatToday ? "Today" : EstimateDateFormat :  selectEstimateTime} {exitOrderTimePart ? exitOrderTimePart : selectedTime}</p> */}
                      {/* <p className="estimate-text-sub">{exitOrderTimePart ? exitOrderTimePart : selectedTime}</p> */}
                      {selectimeStatus ? (
                        <p className="estimate-text-sub">Select time</p>
                      ) : (
                        <>
                          {getOrderMode === "Delivery" ? (
                            <p className="estimate-text-sub">
                              {exitOrderDatePart
                                ? exitOrderDatePart == formattedDateE
                                  ? preOrderTimeTable?.Delivery?.today
                                    ? "Today"
                                    : "Select Date"
                                  : exitOrderDatePart == formatToday
                                  ? preOrderTimeTable?.Delivery?.today
                                    ? "Today"
                                    : "Select time"
                                  : EstimateDateFormat.replace(/\s\d{4}$/, "")
                                : selectEstimateTime}{" "}
                              {exitOrderTimePart
                                ? exitOrderTimePart
                                : selectedTime}
                            </p>
                          ) : (
                            <p className="estimate-text-sub">
                              {exitOrderDatePart
                                ? exitOrderDatePart == formattedDateE
                                  ? preOrderTimeTable?.Collection?.today
                                    ? "Today"
                                    : "Select Date"
                                  : exitOrderDatePart == formatToday
                                  ? preOrderTimeTable?.Collection?.today
                                    ? "Today"
                                    : "Select time"
                                  : EstimateDateFormat.replace(/\s\d{4}$/, "")
                                : selectEstimateTime}{" "}
                              {exitOrderTimePart
                                ? exitOrderTimePart
                                : selectedTime}
                            </p>
                          )}
                        </>
                      )}
                    </div>

                    {/* <div className="estimate-action-btn"></div> */}
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        ) : null}
      </div>

      <div>
        {getorderType === "ASAP" ? (
          <></>
        ) : (
          <>
            <div className="d-block d-sm-none schedule-notice">
              {orderModetype === "Delivery" ? (
                <p className="title">This is a schedule delivery</p>
              ) : (
                <p className="title">This is a schedule collection</p>
              )}
              {orderModetype === "Delivery" ? (
                <p className="subtitle">
                  Your order will be prepared closer to your delivery time
                </p>
              ) : (
                <p className="subtitle">
                  Your order will be prepared closer to your collection time
                </p>
              )}
            </div>
          </>
        )}
      </div>
      {!AddressPopupshow && estimateShow && !tableOrderCheck && (
        <EstimateModal
          estimateShow={estimateShow}
          setEstimateShow={setEstimateShow}
          selectedTime={selectedTime}
          setSelectedTime={setSelectedTime}
          selectEstimateTime={selectEstimateTime}
          setSelectEstimateTime={setSelectEstimateTime}
          exitOrderDatePart={exitOrderDatePart}
          exitOrderTimePart={exitOrderTimePart}
          setGetOrderType={setGetOrderType}
        />
      )}
    </>
  );
};
//estimate MOdal
const EstimateModal = ({
  estimateShow,
  setEstimateShow,
  selectedTime,
  setSelectedTime,
  selectEstimateTime,
  setSelectEstimateTime,
  setGetOrderType,
}) => {
  const { getOrderMode } = OrderFlow();
  const { preOrderTimeTable, setTabStatus, setSelectimeStatus } =
    useContext(CheckoutContext);
  const [isLoadingTimes, setIsLoadingTimes] = useState(true);

  const handleEstimateClose = () => {
    setEstimateShow(false);
  };
  //states
  const [estimateError, setEstimateError] = useState(false);
  const isDeliveryTodayEmptyOrNoPreorder =
    preOrderTimeTable?.Delivery?.today === "" ||
    preOrderTimeTable?.Delivery?.today == "No Pre-order" ||
    preOrderTimeTable?.Delivery?.today == "closed";
  const deliveryTimesToday = !isDeliveryTodayEmptyOrNoPreorder
    ? preOrderTimeTable?.Delivery?.today
    : "";
  const isCollectionTodayEmptyOrNoPreorder =
    preOrderTimeTable?.Collection?.today === "" ||
    preOrderTimeTable?.Collection?.today == "No Pre-order" ||
    preOrderTimeTable?.Collection?.today == "closed";
  const collectionTimesToday = !isCollectionTodayEmptyOrNoPreorder
    ? preOrderTimeTable?.Collection?.today
    : "";
  console.log('collectionTimesToday == ""', preOrderTimeTable);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoadingTimes(false);
    }, 1000); // 5 seconds

    return () => clearTimeout(timer); // Cleanup
  }, []);

  useEffect(() => {
    console.log(selectEstimateTime);
  }, [selectEstimateTime]);

  const handleScheduleChange = () => {
    const scduleType = selectEstimateTime == "today" ? "Today" : "Later";
    console.log(scduleType);
    setGetOrderType(scduleType);
    setSelectimeStatus(false);
    console.log(selectEstimateTime, selectedTime);
    localStorage.setItem("orderType", scduleType);
    setTabStatus(scduleType);
    const dateZone = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };

    let formatToday = new Date()
      ?.toLocaleString("en-GB", dateZone)
      .replace(",", "");

    const dateString = formatToday?.replaceAll("/", "-");
    const parts = dateString?.split("-"); // Split the string by '-'
    let formattedDate = `${parts[2]}-${parts[1]}-${parts[0]} ${selectedTime}`;

    function midNightTimeCheck() {
      // Define the current date and time
      let userSelectDateStr = `${selectEstimateTime} ${selectedTime}`;
      let currentDate =
        selectEstimateTime == "today"
          ? new Date(formattedDate)
          : new Date(userSelectDateStr);
      let formatDateSplit =
        selectEstimateTime == "today"
          ? formattedDate?.split(" ")[0]
          : selectEstimateTime;

      // Define the start and end of the time range on June 5, 2024
      // const startRange = new Date(`${formatDateSplit} 00:00:00 GMT+0530`);
      // const endRange = new Date(`${formatDateSplit} 07:55:00 GMT+0530`);
      const startRange = new Date(`${formatDateSplit} T00:00:00+01:00`);
      const endRange = new Date(`${formatDateSplit} T07:55:00+01:00`);

      // Function to format date as 'YYYY-MM-DD HH:mm:ss'
      function formatDate(date) {
        let year = date.getFullYear();
        let month = String(date.getMonth() + 1).padStart(2, "0");
        let day = String(date.getDate()).padStart(2, "0");
        let hours = String(date.getHours()).padStart(2, "0");
        let minutes = String(date.getMinutes()).padStart(2, "0");
        let seconds = String(date.getSeconds()).padStart(2, "0");
        return `${year}-${month}-${day} ${hours}:${minutes}`;
      }

      // Check if the current date falls within the specified range
      if (currentDate >= startRange && currentDate <= endRange) {
        // Set the date to tomorrow at the same time
        const tomorrow = new Date(currentDate);
        tomorrow.setDate(tomorrow.getDate());
        // tomorrow.setDate(tomorrow.getDate() + 1);
        console.log(
          "Current date and time fall within the range. Setting date to tomorrow: " +
            formatDate(tomorrow)
        );
        const midNightTime = formatDate(tomorrow);
        return midNightTime;
      }
    }

    if (selectedTime) {
      if (selectEstimateTime == "today") {
        //current Date
        let midNightFormat = midNightTimeCheck();
        if (midNightFormat > formattedDate) {
          localStorage.setItem("orderTime", midNightFormat);
          localStorage.setItem("preOrder", midNightFormat);
          setEstimateShow(false);
          localStorage.setItem("orderType", "Today");
          setGetOrderType("Today");
        } else {
          localStorage.setItem("orderTime", formattedDate);
          localStorage.setItem("preOrder", formattedDate);
          setEstimateShow(false);
          setGetOrderType("Today");
        }
      } else {
        // let midNightFormat = midNightTimeCheck();
        // alert(midNightFormat)
        // if (midNightFormat) {
        //   localStorage.setItem(
        //     "orderTime",
        //     midNightFormat
        //   );
        //   localStorage.setItem(
        //     "preOrder",
        //     midNightFormat
        //   );
        //   setEstimateShow(false);
        //   setGetOrderType("Later");
        // }
        // else {
        // }
        localStorage.setItem(
          "orderTime",
          `${selectEstimateTime} ${selectedTime}`
        );
        localStorage.setItem(
          "preOrder",
          `${selectEstimateTime} ${selectedTime}`
        );
        setEstimateShow(false);
        setGetOrderType("Later");
      }
    } else {
      setEstimateError(true);
    }
  };
  const handleEstimateErrorClose = () => {
    setEstimateError(false);
  };
  function formatDate(dateString) {
    // Helper function to get a formatted date string from a Date object
    function formatDateObject(dateObj) {
      const year = dateObj.getFullYear();
      const month = dateObj.getMonth();
      const day = dateObj.getDate();

      // Array of month names (abbreviated)
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      // Array of weekday names (abbreviated)
      const weekdayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

      // Convert month number to month name and weekday number to weekday name
      const monthName = monthNames[month];
      const weekdayName = weekdayNames[dateObj.getDay()];

      // Return formatted date
      return `${weekdayName} ${monthName} ${day}`;
    }

    // Get today's date without time (for comparison)
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Helper function to compare dates
    function compareDates(date1, date2) {
      return date1.toDateString() === date2.toDateString();
    }

    // Parse the input date string
    const inputDate = new Date(dateString);

    // Compare with today and tomorrow
    if (compareDates(inputDate, today)) {
      return "Today";
    } else if (
      compareDates(inputDate, new Date(today.getTime() + 24 * 60 * 60 * 1000))
    ) {
      return "Tomorrow";
    } else {
      // Format as "weekday month year"
      return formatDateObject(inputDate);
    }
  }
  // old one
  // function formatDate(dateString) {
  //   // Helper function to get a formatted date string from a Date object
  //   function formatDateObject(dateObj) {
  //     const year = dateObj.getFullYear();
  //     const month = dateObj.getMonth();
  //     const day = dateObj.getDate();

  //     // Array of month names
  //     const monthNames = [
  //       "January",
  //       "February",
  //       "March",
  //       "April",
  //       "May",
  //       "June",
  //       "July",
  //       "August",
  //       "September",
  //       "October",
  //       "November",
  //       "December",
  //     ];

  //     // Convert month number to month name
  //     const monthName = monthNames[month];

  //     // Return formatted date
  //     return `${day} ${monthName} ${year}`;
  //   }

  //   // Handle special cases "today" and "tomorrow"
  //   if (dateString.toLowerCase() === "today") {
  //     const today = new Date();
  //     return formatDateObject(today);
  //   } else if (dateString.toLowerCase() === "tomorrow") {
  //     const tomorrow = new Date();
  //     tomorrow.setDate(tomorrow.getDate() + 1);
  //     return formatDateObject(tomorrow);
  //   }

  //   // Split the date string into components
  //   const dateParts = dateString.split("-");

  //   // Extract year, month, and day
  //   const year = dateParts[0];
  //   const month = dateParts[1];
  //   const day = dateParts[2];

  //   // Array of month names
  //   const monthNames = [
  //     "January",
  //     "February",
  //     "March",
  //     "April",
  //     "May",
  //     "June",
  //     "July",
  //     "August",
  //     "September",
  //     "October",
  //     "November",
  //     "December",
  //   ];

  //   // Convert month number to month name
  //   const monthName = monthNames[parseInt(month) - 1];

  //   // Create the estimate format
  //   const EstimateFormat = `${day} ${monthName} ${year}`;

  //   // Check if EstimateFormat is tomorrow
  //   if (
  //     EstimateFormat ===
  //     formatDateObject(new Date(new Date().setDate(new Date().getDate() + 1)))
  //   ) {
  //     return "Tomorrow";
  //   } else {
  //     return EstimateFormat;
  //   }
  // }
  //tomorrow today day day name format
  //  function formatDate(dateString) {
  //   // Helper function to get a formatted date string from a Date object
  //   function formatDateObject(dateObj) {
  //       const year = dateObj.getFullYear();
  //       const month = dateObj.getMonth();
  //       const day = dateObj.getDate();

  //       // Array of month names
  //       const monthNames = ["January", "February", "March", "April", "May", "June",
  //           "July", "August", "September", "October", "November", "December"];

  //       // Array of day names
  //       const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  //       // Convert month number to month name and get day of the week
  //       const monthName = monthNames[month];
  //       const dayOfWeek = dayNames[dateObj.getDay()];

  //       // Return formatted date with day of the week
  //       return `${dayOfWeek}, ${day} ${monthName} ${year}`;
  //   }

  //   // Handle special cases "today" and "tomorrow"
  //   if (dateString.toLowerCase() === "today") {
  //       const today = new Date();
  //       return formatDateObject(today);
  //   } else if (dateString.toLowerCase() === "tomorrow") {
  //       const tomorrow = new Date();
  //       tomorrow.setDate(tomorrow.getDate() + 1);
  //       return formatDateObject(tomorrow);
  //   }

  //   // Split the date string into components
  //   const dateParts = dateString.split('-');

  //   // Extract year, month, and day
  //   const year = dateParts[0];
  //   const month = dateParts[1];
  //   const day = dateParts[2];

  //   // Array of month names
  //   const monthNames = ["January", "February", "March", "April", "May", "June",
  //       "July", "August", "September", "October", "November", "December"];

  //   // Array of day names
  //   const dayNames = ["Sun", "Mon", "Tue", "Wedn", "Thu", "Fri", "Sat"];

  //   // Convert month number to month name and get day of the week
  //   const monthName = monthNames[parseInt(month) - 1];
  //   const dayOfWeek = dayNames[new Date(year, month - 1, day).getDay()];

  //   // Create the estimate format
  //   const EstimateFormat = `${dayOfWeek}, ${day} ${monthName} ${year}`;

  //   // Check if EstimateFormat is tomorrow
  //   if (EstimateFormat === formatDateObject(new Date(new Date().setDate(new Date().getDate() + 1)))) {
  //       return "Tomorrow";
  //   } else {
  //       return EstimateFormat;
  //   }
  //  }

  // console.log(formatDate("today")); // Output: Today
  // console.log(formatDate("tomorrow")); // Output: Tomorrow
  // console.log(formatDate("2024-05-24")); // Output: Wednesday, 24 May 2024

  return (
    <>
      <Modal
        size="md"
        show={estimateShow}
        onHide={handleEstimateClose}
        className="estimateModalcheckout"
      >
        <Modal.Header
          className="estimateHeadercheckout"
          data-fus="fus-test-closebtn"
        >
          <Modal.Title
            id="example-modal-sizes-title-md estimateTitle"
            className="estimateTitle"
          >
            {getOrderMode == "Delivery"
              ? " Schedule your delivery "
              : " Schedule your collection "}
          </Modal.Title>
          {/* <span className="close-btn" onClick={handleEstimateClose}>
              <MdOutlineCancel />
            </span> */}
          <img
            src={closeiconnew}
            alt="closeicon"
            className="closeiconnew"
            onClick={handleEstimateClose}
          />
        </Modal.Header>
        <Modal.Body>
          <Swiper
            // navigation={{
            //   nextEl: '.swiper-button-next',
            //   prevEl: '.swiper-button-prev',
            // }}
            modules={[Pagination, Navigation]}
            className="mySwiper1"
            slidesPerView={6}
            spaceBetween={5}
            breakpoints={{
              0: {
                slidesPerView: 3,
              },
              400: {
                slidesPerView: 3,
              },
              639: {
                slidesPerView: 3,
              },
              865: {
                slidesPerView: 3,
              },
              1000: {
                slidesPerView: 3,
              },
              1500: {
                slidesPerView: 3,
              },
              1700: {
                slidesPerView: 3,
              },
            }}
            style={{
              boxShadow:
                "rgba(0, 0, 0, 0.1) 0px 0px 8px, rgba(0, 0, 0, 0.04) 0px 4px 4px",
              borderRadius: "15px",
            }}
          >
            {/* <div className="swiper-button-prev">
              <FaArrowLeft />
            </div>
            <div className="swiper-button-next">
              <FaArrowRight />
            </div> */}
            <SwiperSlide>
              {getOrderMode === "Delivery" ? (
                <Card
                  className={`estimateTimeCard ${
                    selectEstimateTime == "today" && deliveryTimesToday
                      ? "cardactive"
                      : ""
                  }`}
                  onClick={() => {
                    {
                      deliveryTimesToday && setSelectEstimateTime("today");
                      setSelectedTime(null);
                    }
                  }}
                  disabled={deliveryTimesToday ? false : true}
                  style={{
                    marginBottom: deliveryTimesToday ? "" : "0px",
                    textAlign: "center",
                  }}
                >
                  <Card.Body>
                    <Card.Title
                      onClick={() => {
                        {
                          deliveryTimesToday && setSelectEstimateTime("today");
                          setSelectedTime(null);
                        }
                      }}
                      style={{
                        marginBottom: deliveryTimesToday ? "" : "0px",
                        textAlign: "center",
                        cursor: "pointer",
                      }}
                    >
                      {" "}
                      <h6>
                        {" "}
                        {getOrderMode === "Delivery" ? "Today" : "Today"}
                      </h6>
                    </Card.Title>
                    {deliveryTimesToday == "" && (
                      <Card.Text
                        style={{
                          color: deliveryTimesToday ? "#000" : "#FF0000",
                          backgroundColor: deliveryTimesToday ? "" : "#FFF3F3",
                          marginBottom: deliveryTimesToday ? "" : "0px",
                          fontSize: deliveryTimesToday ? "" : "12px",
                          padding: deliveryTimesToday ? "" : "2px 4px",
                          textAlign: "center",
                          width: deliveryTimesToday ? "100%" : "auto",
                          borderRadius: "4px",
                        }}
                      >
                        Closed
                      </Card.Text>
                    )}
                  </Card.Body>
                </Card>
              ) : (
                <Card
                  className={`estimateTimeCard ${
                    selectEstimateTime == "today" && collectionTimesToday
                      ? "cardactive"
                      : ""
                  }`}
                  onClick={() => {
                    {
                      collectionTimesToday && setSelectEstimateTime("today");
                      setSelectedTime(null);
                    }
                  }}
                  style={{
                    marginBottom: collectionTimesToday ? "" : "0px",
                    textAlign: "center",
                  }}
                >
                  <Card.Body>
                    <Card.Title
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        {
                          collectionTimesToday &&
                            setSelectEstimateTime("today");
                          setSelectedTime(null);
                        }
                      }}
                    >
                      {" "}
                      <h6>
                        {" "}
                        {getOrderMode === "Delivery" ? "Today" : "Today"}
                      </h6>
                    </Card.Title>
                    {collectionTimesToday == "" && (
                      <Card.Text
                        style={{
                          color: collectionTimesToday ? "#000" : "#FF0000",
                          backgroundColor: collectionTimesToday
                            ? ""
                            : "#FFF3F3",
                          marginBottom: collectionTimesToday ? "" : "0px",
                          fontSize: collectionTimesToday ? "" : "12px",
                          padding: collectionTimesToday ? "" : "2px 4px",
                        }}
                      >
                        Closed
                      </Card.Text>
                    )}
                  </Card.Body>
                </Card>
              )}
            </SwiperSlide>

            {getOrderMode === "Delivery" ? (
              <>
                {preOrderTimeTable &&
                  preOrderTimeTable?.Delivery &&
                  preOrderTimeTable.Delivery.later &&
                  Object.entries(preOrderTimeTable.Delivery.later).map(
                    ([v, times]) => {
                      const deliveryDate = formatDate(v);
                      const parts = deliveryDate.split(" ");
                      const firstPart = parts[0]; // "Sun"
                      const secondPart = parts.slice(1).join(" "); // "Jul 7"
                      console.log(deliveryDate);
                      return (
                        <SwiperSlide>
                          <Card
                            className={`estimateTimeCard ${
                              selectEstimateTime == v && times
                                ? "cardactive"
                                : ""
                            }`}
                            onClick={() => {
                              {
                                times && setSelectEstimateTime(v);
                                setSelectedTime(null);
                              }
                            }}
                            disabled={times ? false : true}
                          >
                            <Card.Body>
                              <Card.Title></Card.Title>
                              <Card.Text
                                style={{ marginBottom: times ? "" : "0px" }}
                              >
                                {firstPart}
                                {times && secondPart && `(${secondPart})`}
                              </Card.Text>
                              {/* {times &&
                              <p>{secondPart}</p>
                            } */}
                              {times == "" && (
                                <Card.Text
                                  style={{
                                    color: times ? "#000" : "#FF0000",
                                    backgroundColor: times ? "" : "#FFF3F3",
                                    marginBottom: times ? "" : "0px",
                                    fontSize: times ? "" : "12px",
                                    padding: times ? "" : "2px 4px",
                                  }}
                                >
                                  Closed
                                </Card.Text>
                              )}
                            </Card.Body>
                          </Card>
                        </SwiperSlide>
                      );
                    }
                  )}
              </>
            ) : (
              <>
                {preOrderTimeTable &&
                  preOrderTimeTable?.Collection &&
                  preOrderTimeTable.Collection.later &&
                  Object.entries(preOrderTimeTable.Collection.later).map(
                    ([v, times]) => {
                      const collectionDate = formatDate(v);
                      const parts = collectionDate?.split(" ");
                      const firstPart = parts[0]; // "Sun"
                      // console.log("firstPartfirstPart", firstPart);

                      const secondPart = parts?.slice(1)?.join(" "); // "Jul 7"
                      return (
                        <SwiperSlide>
                          <Card
                            className={`estimateTimeCard ${
                              selectEstimateTime == v && times
                                ? "cardactive"
                                : ""
                            }`}
                            onClick={() => {
                              {
                                times && setSelectEstimateTime(v);
                                setSelectedTime(null);
                              }
                            }}
                            disabled={times ? false : true}
                          >
                            <Card.Body>
                              <Card.Title></Card.Title>
                              <Card.Text
                                style={{
                                  marginBottom: times ? "" : "0px",
                                  cursor: "pointer",
                                }}
                              >
                                {" "}
                                {firstPart}
                                {times && secondPart && `(${secondPart})`}
                              </Card.Text>
                              {/* {times &&
                              <p>{secondPart}</p>
                            } */}
                              {times == "" && (
                                <Card.Text
                                  style={{
                                    color: times ? "#000" : "#FF0000",
                                    backgroundColor: times ? "" : "#FFF3F3",
                                    marginBottom: times ? "" : "0px",
                                    fontSize: times ? "" : "12px",
                                    padding: times ? "" : "2px 4px",
                                  }}
                                >
                                  Closed
                                </Card.Text>
                              )}
                            </Card.Body>
                          </Card>
                        </SwiperSlide>
                      );
                    }
                  )}
              </>
            )}
          </Swiper>
          <div
            className="estimateTimetable border-bottom"
            data-fus="fus-test-timedateattribute"
          >
            {isLoadingTimes ? (
              <div className="skeleton-wrapper">
                {[...Array(4)].map((_, i) => (
                  <div className="skeleton-time-slot" key={i}></div>
                ))}
              </div>
            ) : getOrderMode === "Delivery" ? (
              selectEstimateTime == "today" ? (
                <>
                  {preOrderTimeTable &&
                  preOrderTimeTable?.Delivery &&
                  preOrderTimeTable.Delivery.today
                    ? preOrderTimeTable.Delivery.today
                        .split(",")
                        .map((v, i) => {
                          const addMinutes = (timeString, minutesToAdd) => {
                            // Split the time string into hours and minutes
                            const [hours, minutes] = timeString
                              .split(":")
                              .map(Number);

                            // Convert hours and minutes to total minutes
                            let totalMinutes = hours * 60 + minutes;

                            // Add the minutes to total minutes
                            totalMinutes += minutesToAdd;

                            // Calculate new hours and minutes
                            let newHours = Math.floor(totalMinutes / 60) % 24; // Ensure it wraps around correctly
                            let newMinutes = totalMinutes % 60;

                            // Handle negative totalMinutes (if minutesToAdd is negative)
                            if (totalMinutes < 0) {
                              newHours = (newHours + 24) % 24;
                              newMinutes = (newMinutes + 60) % 60;
                            }

                            // Format the new time
                            const formattedHours = String(newHours).padStart(
                              2,
                              "0"
                            );
                            const formattedMinutes = String(
                              newMinutes
                            ).padStart(2, "0");

                            // Return the formatted time string
                            return `${formattedHours}:${formattedMinutes}`;
                          };

                          function formatTime(timeString) {
                            const [hours, minutes] = timeString
                              ?.split(":")
                              ?.map(Number);

                            const hours12 = (hours % 12 || 12)
                              ?.toString()
                              ?.padStart(2, "0");
                            const ampm = hours >= 12 ? "PM" : "AM";

                            return `${hours12}:${minutes
                              ?.toString()
                              ?.padStart(2, "0")} ${ampm}`;
                          }

                          const endTime = addMinutes(v, 5);
                          const startTime = v;
                          const startTimeAmPM = formatTime(startTime);
                          const endTimeAmPm = formatTime(endTime);
                          return (
                            <>
                              <div
                                className="estimateTiming"
                                onClick={() => setSelectedTime(v)}
                              >
                                {/* <IoIosClock /> */}
                                {v && v !== "closed" ? (
                                  <>
                                    {v !== "No Pre-order" ? (
                                      <label onClick={() => setSelectedTime(v)}>
                                        {startTimeAmPM} - {endTimeAmPm}
                                      </label>
                                    ) : (
                                      <label>No Pre-order</label>
                                    )}
                                  </>
                                ) : (
                                  "null"
                                )}

                                {v && v !== "No Pre-order" && v !== "closed" ? (
                                  <>
                                    <input
                                      name="selectaddtype"
                                      type="radio"
                                      label="Home"
                                      id={i}
                                      checked={selectedTime === v}
                                      onChange={() => setSelectedTime(v)}
                                    />
                                  </>
                                ) : null}
                              </div>
                            </>
                          );
                        })
                    : null}
                </>
              ) : (
                <>
                  {preOrderTimeTable &&
                    preOrderTimeTable?.Delivery &&
                    preOrderTimeTable.Delivery.later &&
                    Object.entries(preOrderTimeTable?.Delivery?.later)
                      .filter(
                        ([date1, time1]) =>
                          selectEstimateTime && date1 === selectEstimateTime
                      )
                      .map(([date, times]) => {
                        return (
                          <div key={date}>
                            {times.split(",").length
                              ? times.split(",").map((v, i) => {
                                  const addMinutes = (
                                    timeString,
                                    minutesToAdd
                                  ) => {
                                    // Split the time string into hours and minutes
                                    const [hours, minutes] = timeString
                                      .split(":")
                                      .map(Number);

                                    // Convert hours and minutes to total minutes
                                    let totalMinutes = hours * 60 + minutes;

                                    // Add the minutes to total minutes
                                    totalMinutes += minutesToAdd;

                                    // Calculate new hours and minutes
                                    let newHours =
                                      Math.floor(totalMinutes / 60) % 24; // Ensure it wraps around correctly
                                    let newMinutes = totalMinutes % 60;

                                    // Handle negative totalMinutes (if minutesToAdd is negative)
                                    if (totalMinutes < 0) {
                                      newHours = (newHours + 24) % 24;
                                      newMinutes = (newMinutes + 60) % 60;
                                    }

                                    // Format the new time
                                    const formattedHours = String(
                                      newHours
                                    ).padStart(2, "0");
                                    const formattedMinutes = String(
                                      newMinutes
                                    ).padStart(2, "0");

                                    // Return the formatted time string
                                    return `${formattedHours}:${formattedMinutes}`;
                                  };

                                  function formatTime(timeString) {
                                    const [hours, minutes] = timeString
                                      ?.split(":")
                                      ?.map(Number);

                                    const hours12 = (hours % 12 || 12)
                                      ?.toString()
                                      ?.padStart(2, "0");
                                    const ampm = hours >= 12 ? "PM" : "AM";

                                    return `${hours12}:${minutes
                                      ?.toString()
                                      ?.padStart(2, "0")} ${ampm}`;
                                  }

                                  const endTime = addMinutes(v, 5);
                                  const startTime = v;
                                  const startTimeAmPM = formatTime(startTime);
                                  const endTimeAmPm = formatTime(endTime);
                                  return (
                                    <>
                                      <div
                                        className="estimateTiming"
                                        onClick={() => setSelectedTime(v)}
                                      >
                                        {/* <IoIosClock /> */}
                                        {v ? (
                                          <>
                                            {v !== "No Pre-order later" ? (
                                              <label
                                                onClick={() =>
                                                  setSelectedTime(v)
                                                }
                                              >
                                                {startTimeAmPM} - {endTimeAmPm}
                                              </label>
                                            ) : (
                                              <label>No Pre-order later</label>
                                            )}
                                          </>
                                        ) : (
                                          "null"
                                        )}

                                        {v && v !== "No Pre-order later" && (
                                          <input
                                            name="selectaddtype"
                                            type="radio"
                                            label="Home"
                                            id={i}
                                            checked={selectedTime == v}
                                            onChange={() => setSelectedTime(v)}
                                          />
                                        )}
                                      </div>
                                    </>
                                  );
                                })
                              : null}
                          </div>
                        );
                      })}
                </>
              )
            ) : selectEstimateTime == "today" ? (
              <>
                {preOrderTimeTable &&
                preOrderTimeTable?.Collection &&
                preOrderTimeTable.Collection.today
                  ? preOrderTimeTable.Collection.today
                      .split(",")
                      .map((v, i) => {
                        const addMinutes = (timeString, minutesToAdd) => {
                          // Split the time string into hours and minutes
                          const [hours, minutes] = timeString
                            .split(":")
                            .map(Number);

                          // Convert hours and minutes to total minutes
                          let totalMinutes = hours * 60 + minutes;

                          // Add the minutes to total minutes
                          totalMinutes += minutesToAdd;

                          // Calculate new hours and minutes
                          let newHours = Math.floor(totalMinutes / 60) % 24; // Ensure it wraps around correctly
                          let newMinutes = totalMinutes % 60;

                          // Handle negative totalMinutes (if minutesToAdd is negative)
                          if (totalMinutes < 0) {
                            newHours = (newHours + 24) % 24;
                            newMinutes = (newMinutes + 60) % 60;
                          }

                          // Format the new time
                          const formattedHours = String(newHours).padStart(
                            2,
                            "0"
                          );
                          const formattedMinutes = String(newMinutes).padStart(
                            2,
                            "0"
                          );

                          // Return the formatted time string
                          return `${formattedHours}:${formattedMinutes}`;
                        };
                        function formatTime(timeString) {
                          const [hours, minutes] = timeString
                            ?.split(":")
                            ?.map(Number);

                          const hours12 = (hours % 12 || 12)
                            ?.toString()
                            ?.padStart(2, "0");
                          const ampm = hours >= 12 ? "PM" : "AM";

                          return `${hours12}:${minutes
                            ?.toString()
                            ?.padStart(2, "0")} ${ampm}`;
                        }

                        const endTime = addMinutes(v, 5);
                        const startTime = v;
                        const startTimeAmPM = formatTime(startTime);
                        const endTimeAmPm = formatTime(endTime);
                        return (
                          <>
                            <div
                              className="estimateTiming"
                              onClick={() => setSelectedTime(v)}
                            >
                              {/* <IoIosClock /> */}

                              {v && v !== "closed" ? (
                                <>
                                  {v !== "No Pre-order" ? (
                                    <label onClick={() => setSelectedTime(v)}>
                                      {startTimeAmPM} - {endTimeAmPm}
                                    </label>
                                  ) : (
                                    <label>No Pre-order</label>
                                  )}
                                </>
                              ) : (
                                "null"
                              )}

                              {v && v !== "No Pre-order" && v !== "closed" ? (
                                <>
                                  <input
                                    name="selectaddtype"
                                    type="radio"
                                    label="Home1"
                                    id={i}
                                    checked={selectedTime === v}
                                    onChange={() => setSelectedTime(v)}
                                  />
                                </>
                              ) : null}
                            </div>
                          </>
                        );
                      })
                  : null}
              </>
            ) : (
              <>
                {preOrderTimeTable &&
                  preOrderTimeTable?.Collection &&
                  preOrderTimeTable.Collection.later &&
                  Object.entries(preOrderTimeTable?.Collection?.later)
                    .filter(
                      ([date1, time1]) =>
                        selectEstimateTime && date1 == selectEstimateTime
                    )
                    .map(([date, times]) => {
                      return (
                        <div key={date}>
                          {times
                            ? times.split(",").map((v, i) => {
                                const date1 = date; // Define date1 here
                                const addMinutes = (
                                  timeString,
                                  minutesToAdd
                                ) => {
                                  // Split the time string into hours and minutes
                                  const [hours, minutes] = timeString
                                    .split(":")
                                    .map(Number);

                                  // Convert hours and minutes to total minutes
                                  let totalMinutes = hours * 60 + minutes;

                                  // Add the minutes to total minutes
                                  totalMinutes += minutesToAdd;

                                  // Calculate new hours and minutes
                                  let newHours =
                                    Math.floor(totalMinutes / 60) % 24; // Ensure it wraps around correctly
                                  let newMinutes = totalMinutes % 60;

                                  // Handle negative totalMinutes (if minutesToAdd is negative)
                                  if (totalMinutes < 0) {
                                    newHours = (newHours + 24) % 24;
                                    newMinutes = (newMinutes + 60) % 60;
                                  }

                                  // Format the new time
                                  const formattedHours = String(
                                    newHours
                                  ).padStart(2, "0");
                                  const formattedMinutes = String(
                                    newMinutes
                                  ).padStart(2, "0");

                                  // Return the formatted time string
                                  return `${formattedHours}:${formattedMinutes}`;
                                };

                                function formatTime(timeString) {
                                  const [hours, minutes] = timeString
                                    ?.split(":")
                                    ?.map(Number);

                                  const hours12 = (hours % 12 || 12)
                                    ?.toString()
                                    ?.padStart(2, "0");
                                  const ampm = hours >= 12 ? "PM" : "AM";

                                  return `${hours12}:${minutes
                                    ?.toString()
                                    ?.padStart(2, "0")} ${ampm}`;
                                }

                                const endTime = addMinutes(v, 5);
                                const startTime = v;
                                const startTimeAmPM = formatTime(startTime);
                                const endTimeAmPm = formatTime(endTime);

                                return (
                                  <div
                                    key={i}
                                    className="estimateTiming"
                                    onClick={() => setSelectedTime(v)}
                                  >
                                    {/* <IoIosClock /> */}
                                    {v ? (
                                      <>
                                        {v !== "No Pre-order later" ? (
                                          <label
                                            onClick={() => setSelectedTime(v)}
                                          >
                                            {startTimeAmPM} - {endTimeAmPm}
                                          </label>
                                        ) : (
                                          <label>No Pre-order later</label>
                                        )}
                                      </>
                                    ) : (
                                      "null"
                                    )}
                                    {v && v !== "No Pre-order later" && (
                                      <input
                                        name="selectaddtype"
                                        type="radio"
                                        label="Home"
                                        id={i}
                                        data-attr={date}
                                        checked={
                                          date == selectEstimateTime
                                            ? selectedTime == v
                                            : ""
                                        }
                                        onChange={() => setSelectedTime(v)}
                                      />
                                    )}
                                  </div>
                                );
                              })
                            : null}
                        </div>
                      );
                    })}
              </>
            )}
          </div>
          <div className="scheduleBtncheckout">
            <Button
              variant="secondary"
              className="estimateCancelBtn"
              onClick={handleEstimateClose}
              style={{ background: "#EEEEEE !important" }}
              data-fus="fus-test-cancelbtn"
            >
              Cancel
            </Button>
            <Button
              variant="secondary"
              onClick={handleScheduleChange}
              disabled={selectedTime ? false : true}
              data-fus="fus-test-schedulebtn"
            >
              Schedule
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      {estimateError && (
        <Modal
          show={estimateError}
          onHide={handleEstimateErrorClose}
          className="estimateErrorModal"
        >
          <Modal.Header
            closeButton
            className="estimateErrorHeader"
          ></Modal.Header>
          <Modal.Body>
            <Modal.text className="estimateErrorText">
              Choose new {getOrderMode == "Delivery" ? "Delivery" : "Pickup"}{" "}
              time
            </Modal.text>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};


const VoucherCodeAdd = () => {
  const { theme } = useContext(ThemeContext);
  const { getOrderMode, getOrderTime } = OrderFlow();
  const {
    deliveryCharge,
    bagCharge,
    clientFkCharge,
    setFinalTotal,
    currency_symbol,
  } = CheckoutData();
  const {
    stripepayment,
    stripe,
    elements,
    setPayType,
    paymentSva,
    setPaymentSva,
    paymentMId,
    setPaymentMId,
    setPaymentIntentId,
    setPaymentType,
    setPaySubmit,
    paySubmit,
    clientSecret,
    setClientSecret,
    payPalClientSecret,
    svclientSecret,
    setSvpaySubmit,
    svpaySubmit,
    walletstatus,
    setWalletstatus,
    walletamount,
    setWalletamount,
    setCardErrorMessage,
    cardErrorMessage,
    finalTotalValue,
    selectedValue,
    setSelectedValue,
    paymentOptions,
    cardtype,
    setCardtype,
    setPaypalType,
    paypalType,
    setApplepaytype,
    setGooglepaytype,
    klarnaType,
    setKlarnaType,
    setFooterBtn,
    sectionRef,
    buttonstatus,
    setButtonstatus,
    setPaymentModalShow,
    paymentModalShow,
    gpaydeviceInfo,
    appledeviceInfo,
    setPaySaveCard,
    handlesavecardPayment,
    CARD_OPTIONS1,
    containerStyle,
    setSaveCardError,
    setCardStatus,
    paySpinner,
    cashtype,
    setCashtype,
    setExtraLessAmount,
    extraPayment,
    setExtraPayment,
    setExtraPayStatus,
    setUseWalletBalance,
    setFinalTotalValue,
    clientName,
    clientLogo,
    itemAvailableData,
    useWalletBalance,
    polling,
  } = useContext(CheckoutContext);
  const [voucherValue, setVoucherValue] = useState("");
  const [voucherApplied, setVoucherApplied] = useState(false);
  const [validDiscount, setValidDiscount] = useState(true);
  const [voucherMinimum, setVoucherMinimum] = useState(false);
  const [voucherLogin, setVoucherLogin] = useState(false);
  const [voucherUsed, setVoucherUsed] = useState(false);
  const [voucherLoad, setVoucherLoad] = useState(false);
  const [customer, setCustomer] = useState("");
  const [appliedDiscount, setAppliedDiscount] = useState(0);
  const [cartItemsData, setcartItems] = useState([]);
  const [showModalPromo, setShowModalPromo] = useState(false);
  const [parsedDiscount, setParsedDiscount] = useState("");
  const orderTime = getOrderTime;

  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const loginAddress = localStorage.getItem("loginAddress") || "";
  const guestAddress = localStorage.getItem("guestAddress") || "";
  const path = localStorage.getItem("clientPath");
  const domain = window.location.origin;

  const subTotal = localStorage.getItem("totalPrice");
  const roundedValue = localStorage.getItem("roundOffPrice");
  const driverTipValue = localStorage.getItem("driverTipValue")
    ? localStorage.getItem("driverTipValue")
    : "0";

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (userData !== null && isLoggedIn === "true") {
      setCustomer(userData);
    } else {
      setCustomer("");
    }
  }, [isLoggedIn]);

  const voucherData = useMemo(() => {
    const orderTime = localStorage.getItem("orderTime") || "";
    let dateParts = "";
    let timePart = "";
    let formattedDate = "";
    if (orderTime) {
      let inputDate = orderTime;
      if (inputDate.includes("/")) {
        dateParts = inputDate.split(" ")[0].split("/"); // Split the date into parts
        timePart = inputDate.split(" ")[1]; // Get the time part
        // Create a Date object with the parts
        const dateObject = new Date(
          `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}T${timePart}`
        );
        // Format the date in the desired format
        const year = dateObject.getFullYear();
        const month = String(dateObject.getMonth() + 1).padStart(2, "0");
        const day = String(dateObject.getDate()).padStart(2, "0");
        const hour = String(dateObject.getHours()).padStart(2, "0");
        const minute = String(dateObject.getMinutes()).padStart(2, "0");
        formattedDate = `${year}-${month}-${day} ${hour}:${minute}`;
      } else {
        formattedDate = orderTime;
      }
    }
    return {
      customerId: customer.customerId,
      clientPath: path,
      orderTime: formattedDate,
      voucherCode: voucherValue || "",
    };
  }, [path, orderTime, customer, voucherValue]);

  const discountJSON = localStorage.getItem("discount");
  const SummaryOrderType = getOrderMode === "Collection" ? 1 : 0;

  useEffect(() => {
    const discount = discountJSON ? JSON.parse(discountJSON) : "";
    setParsedDiscount(discount);
    let finalTotalValue =
      parseFloat(subTotal) +
      parseFloat(deliveryCharge) +
      parseFloat(bagCharge) +
      parseFloat(clientFkCharge) +
      parseFloat(driverTipValue);

    if (
      parsedDiscount !== "" &&
      (parsedDiscount?.orderType === SummaryOrderType ||
        parsedDiscount?.orderType === "2")
    ) {
      if (discount?.appliedDiscount) {
        finalTotalValue -= parseFloat(discount.appliedDiscount);
      }
    }

    if (discount?.source == "voucherDiscount") {
      setVoucherValue(discount?.discount || "");
    }
    if (discount?.source == "SubscriptionCoupon") {
      setVoucherValue(discount?.discount || "");
      setVoucherApplied(true);
    }
    setAppliedDiscount(discount?.appliedDiscount || 0);
    localStorage.setItem("finalTotal", finalTotalValue.toFixed(2));
    setFinalTotal(finalTotalValue.toFixed(2));
    setFinalTotalValue(
      (parseFloat(finalTotalValue) + parseFloat(roundedValue)).toFixed(2)
    );
    localStorage.setItem(
      "finalTotalValue",
      (parseFloat(finalTotalValue) + parseFloat(roundedValue)).toFixed(2)
    );
  }, [
    subTotal,
    parsedDiscount,
    deliveryCharge,
    bagCharge,
    clientFkCharge,
    driverTipValue,
    roundedValue,
    discountJSON,
    useWalletBalance,
    polling,
  ]);

  useEffect(() => {
    let localStorageData =
      localStorage.getItem("cart") &&
      localStorage.getItem("cart") !== "undefined"
        ? JSON.parse(localStorage.getItem("cart"))
        : [];

    setcartItems(localStorageData);
  }, [localStorage.getItem("cart")]);

  const handleKeyChange = () => {
    setVoucherUsed(false);
    setVoucherLogin(false);
    setVoucherMinimum(false);
    setValidDiscount(true);
    setVoucherApplied(false);
  };

  const checkVoucher = () => {
    if (voucherValue == "") {
      setValidDiscount(false);
    }
    //Subscription Coupon Code Apply
    const SubscriptionCouponCode1 = localStorage.getItem("SubcripeCoupon");

    // Check if the value exists and is not the string "undefined"
    const SubscriptionCouponCode =
      SubscriptionCouponCode1 !== null &&
      SubscriptionCouponCode1 !== "undefined"
        ? JSON.parse(SubscriptionCouponCode1)
        : "";

    setVoucherLoad(true);
    if (
      SubscriptionCouponCode != "" &&
      typeof SubscriptionCouponCode !== "undefined"
    ) {
      console.log(voucherData);
      if (voucherValue === SubscriptionCouponCode.code) {
        const isCouponApplied = applySubcriptionCouponCode(
          SubscriptionCouponCode,
          getOrderMode
        );

        if (isCouponApplied) {
          setValidDiscount(true);
          setVoucherApplied(true);
          setVoucherLoad(false);
          // setCelebrate(true);
          // setTimeout(() => setCelebrate(false), 6000);
        }
      } else {
        setValidDiscount(false);
        setVoucherLoad(false);
      }
    } else {
      checkVoucherCode(voucherData)
        .then((response) => {
          if (!response.status) {
            if (response.message == "voucher code was already Used") {
              setVoucherUsed(true);
              setValidDiscount(false);
            } else if (response.message == "Invalid code") {
              setValidDiscount(false);
            } else if (response.message == "voucher not available") {
              setValidDiscount(false);
            } else if (response.message == "CustomerId is required") {
              setVoucherLogin(true);
              setValidDiscount(false);
            }
            setVoucherApplied(false);
            setVoucherLoad(false);
            console.log("vocuherRespose");
            console.log(response.message);
            return;
          }
          const storedCart = localStorage.getItem("cart");
          const localStorageCart = JSON.parse(storedCart) || [];
          const filteredItems = localStorageCart.filter(
            (cart) => cart.itemAllowCoupon === 1
          );
          const totalValue = filteredItems.reduce(
            (sum, item) => sum + parseFloat(item.price),
            0
          );
          // const totalValue = localStorage.getItem("totalPrice");
          if (
            parseFloat(totalValue) >= parseFloat(response.message.minAmount)
          ) {
            const voucher = {
              code: response.message.code,
              discount: response.message.discount,
              description: response.message.description,
              discountType: response.message.type,
              minOrder: response.message.minAmount,
            };
            localStorage.setItem("AppliedVoucherCode", response.message.code);
            applyVoucher(voucher, getOrderMode);
            setValidDiscount(true);
            setVoucherApplied(true);
            setVoucherLoad(false);
          } else {
            setVoucherMinimum(true);
            setVoucherLoad(false);
            setValidDiscount(false);
          }
        })
        .catch((error) => {
          setVoucherLoad(false);
          console.log(error);
        });
    }
  };

  const Appliedvouchercode = localStorage.getItem("AppliedVoucherCode");

  const handleOpenModal = () => setShowModalPromo(true);
  const handleCloseModal = () => setShowModalPromo(false);
  return (
    <>
      <div className="d-none d-sm-block">
        <div className="voucher-code-container" onClick={handleOpenModal}>
          <div className="voucher-code-left">
            {/* <img
                    src={Voucherimg} // example icon
                    alt="voucher"
                    className="voucher-icon"
                  /> */}
            <span className="voucher-label">
              Add voucher code <br />
              <span
                style={{
                  fontFamily: "Geist-Regular",
                  fontSize: "15px",
                  color: "#008D2D",
                }}
              >
                {voucherApplied ? <>voucher code applied</> : <></>}
              </span>
            </span>
          </div>
          <RiArrowRightSLine className="voucher-arrow" />
        </div>
      </div>
      {showModalPromo && (
        <div className="custom-modal-overlay">
          <div className="custom-modal-content">
            <h2 className="voucher-modal-title">
              Voucher{" "}
              <img
                src={closeiconnew}
                alt="closeicon"
                className="closeiconnew"
                onClick={handleCloseModal}
              />
            </h2>
            <div className="voucher-modal-bodycontent">
              <form>
                <p className="voucher-modal-subtitle">Add your voucher</p>
                <Form.Control
                  type="text"
                  value={voucherValue}
                  onChange={(e) => setVoucherValue(e.target.value)}
                  onKeyDown={handleKeyChange}
                  isInvalid={!validDiscount}
                  data-fus="fus-test-vouchercodeinput"
                  placeholder="Voucher code"
                  className="voucher-input"
                />

                <button
                  className="voucher-apply-btn"
                  type="button"
                  onClick={checkVoucher}
                >
                  {voucherLoad ? (
                    <Spinner animation="border" size="sm" variant="primary" />
                  ) : voucherApplied ? (
                    <>Applied {localStorage.getItem("AppliedVoucherCode")}</>
                  ) : (
                    "Apply"
                  )}
                </button>
              </form>
              {voucherUsed && (
                <p className="error-code" style={{ color: "red" }}>
                  Sorry Voucher already redeemed
                </p>
              )}
              {voucherLogin && (
                <p className="error-code" style={{ color: "red" }}>
                  Please log in to redeem this voucher
                </p>
              )}
              {voucherMinimum && (
                <p className="error-code" style={{ color: "red" }}>
                  Need to added more item
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

//payment method
const PaymentMethod = () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const { theme } = useContext(ThemeContext);
  const { getOrderMode, getOrderTime } = OrderFlow();
  const {
    deliveryCharge,
    bagCharge,
    clientFkCharge,
    setFinalTotal,
    currency_symbol,
  } = CheckoutData();
  const {
    stripepayment,
    stripe,
    elements,
    setPayType,
    paymentSva,
    setPaymentSva,
    paymentMId,
    setPaymentMId,
    setPaymentIntentId,
    setPaymentType,
    setPaySubmit,
    paySubmit,
    clientSecret,
    setClientSecret,
    payPalClientSecret,
    svclientSecret,
    setSvpaySubmit,
    svpaySubmit,
    walletstatus,
    setWalletstatus,
    walletamount,
    setWalletamount,
    setCardErrorMessage,
    cardErrorMessage,
    finalTotalValue,
    selectedValue,
    setSelectedValue,
    paymentOptions,
    cardtype,
    setCardtype,
    setPaypalType,
    paypalType,
    setApplepaytype,
    setGooglepaytype,
    klarnaType,
    setKlarnaType,
    setFooterBtn,
    sectionRef,
    buttonstatus,
    setButtonstatus,
    setPaymentModalShow,
    paymentModalShow,
    gpaydeviceInfo,
    appledeviceInfo,
    setPaySaveCard,
    handlesavecardPayment,
    CARD_OPTIONS1,
    containerStyle,
    setSaveCardError,
    setCardStatus,
    paySpinner,
    cashtype,
    setCashtype,
    setExtraLessAmount,
    extraPayment,
    setExtraPayment,
    setExtraPayStatus,
    setUseWalletBalance,
    setFinalTotalValue,
    clientName,
    clientLogo,
    itemAvailableData,
    useWalletBalance,
    polling,
  } = useContext(CheckoutContext);
  const [activeKey, setActiveKey] = useState("add-card"); // Add state to store CCV
  const [savecardPay, setSavecardPay] = useState(0); // Add state to store CCV
  const [showModalPromo, setShowModalPromo] = useState(false);
  const [voucherValue, setVoucherValue] = useState("");
  const [voucherApplied, setVoucherApplied] = useState(false);
  const [validDiscount, setValidDiscount] = useState(true);
  const [voucherMinimum, setVoucherMinimum] = useState(false);
  const [voucherLogin, setVoucherLogin] = useState(false);
  const [voucherUsed, setVoucherUsed] = useState(false);
  const [voucherLoad, setVoucherLoad] = useState(false);
  const [customer, setCustomer] = useState("");
  const [parsedDiscount, setParsedDiscount] = useState("");
  const [cartItemsData, setcartItems] = useState([]);
  const orderTime = getOrderTime;
  const [appliedDiscount, setAppliedDiscount] = useState(0);
  const [cardBrand, setCardBrand] = useState("");
  const [showCVVInfo, setShowCVVInfo] = useState(false);
  const [showSecureModal, setShowSecureModal] = useState(false);
  const [showSavedCardSection, setShowSavedCardSection] = useState(true);

  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const loginAddress = localStorage.getItem("loginAddress") || "";
  const guestAddress = localStorage.getItem("guestAddress") || "";
  const path = localStorage.getItem("clientPath");
  const domain = window.location.origin;
  const guestusered = localStorage.getItem("guestAddress");

  const subTotal = localStorage.getItem("totalPrice");
  const roundedValue = localStorage.getItem("roundOffPrice");
  const driverTipValue = localStorage.getItem("driverTipValue")
    ? localStorage.getItem("driverTipValue")
    : "0";
  // stripe style
  const getCardBrandIcon = (brand) => {
    switch (brand) {
      case "visa":
        return faCcVisa;
      case "mastercard":
        return faCcMastercard;
      case "amex":
        return faCcAmex;
      case "discover":
        return faCcDiscover;
      case "diners":
        return faCcDinersClub;
      case "jcb":
        return faCcJcb;
      default:
        return null;
    }
  };
  const CARD_OPTIONS = {
    iconStyle: "solid",
    style: {
      base: {
        iconColor: "#c4f0ff",
        color: theme === "dark" ? "#fff" : "#000",
        fontWeight: 300,
        border: "1px solid #ddd", // Add border style here
        fontFamily: "Source Code Pro, monospace",
        fontSmoothing: "antialiased",
        ":-webkit-autofill": {
          color: `${theme === "dark" ? "#fff" : "#000"}`, // Conditional color
          backgroundColor: `${theme === "dark" ? "#02111f" : "#fff"}`, // Conditional color
        },
        "::placeholder": { color: "#aab7c4" },
        backgroundColor: theme === "dark" ? "#02111f" : "#fff", // // Background color for the card input area
        padding: "10px", // Adjust padding as needed
        fontSize: "16px", // Padding for the card input area
      },
      invalid: {
        iconColor: "#ffc7ee",
        color: theme === "dark" ? "red" : "#000",
        backgroundColor: theme === "dark" ? "#02111f" : "#fff", //Background color for invalid input
        padding: "10px", // Padding for the invalid input area
      },
    },
  };

  // stripe style
  // Function to update the JSON data with the new paymentMethodId

  // Function to handle the change event
  const handleChange = async (event) => {
    const setpt = event?.target?.value;
    // Define a lookup table for payment types
    const paymentTypeMap = {
      cashimg: 0,
      cardimg: 1,
      "apple-pay": 7,
      "google-pay": 8,
      wallet: 9,
      klarna: 10,
      paypal: 14,
      savedcard: 12,
    };

    // Use the lookup table to set the payment type, defaulting to 1 if not found
    const paymentType = paymentTypeMap[setpt];
    console.log(paymentType);

    setPaymentType(paymentType);
    console.log(event.target.value);
    setSelectedValue(event.target.value);
    console.log(selectedValue);
    // handlePaymentSelection(paymentType, setpt);
    if (paymentType === 9) {
      setUseWalletBalance(true);
    } else {
      setUseWalletBalance(false);
    }
  };

  const handlePaymentSelection = async (paymentType, selectedValue) => {
    setPaymentType(paymentType);
    console.log(paymentType);
    setSelectedValue(selectedValue);
    setPaymentModalShow(false);
    if (paymentType === 9) {
      setUseWalletBalance(true);
    } else {
      setUseWalletBalance(false);
    }
  };

  const dispatch = useDispatch();
  const [selectedCard, setSelectedCard] = useState(null);
  const [cardaccordion, setcardAccordion] = useState(null);
  const [primary, setPrimary] = useState(true);
  const [fullscreen, setFullscreen] = useState("sm-down");
  const [showchildpopup, setshowchildpopup] = useState(false);
  const [showSavedCardPopUp, setShowSavedCardPopUp] = useState(false);
  const cardSelector = useSelector(
    (state) => state.placeorderStatusReducer?.placecard
  );

  useEffect(() => {
    setcardAccordion(cardSelector);
  }, [cardSelector]);
  // console.log(cardaccordion);

  const handlecardChange = (e) => {
    setSelectedCard(e.target.value);
    setPrimary(false);
    dispatch(postPlaceOrderStatus(true));
  };

  const handleSaveCardCheckboxClick = () => {
    setPaymentSva(paymentSva == 0 ? 1 : 0);
  };

  // console.log(paymentSva);
  const orderModeCheck = localStorage.getItem("orderMode");
  const isLoggedInChecked = localStorage.getItem("isLoggedIn");
  useEffect(() => {
    // Check if stripepayment is available before updating state
    let width = window.innerWidth;
    if (stripepayment) {
      const paymentStatus = stripepayment.message.paymentStatus;
      if (isLoggedIn === "true") {
        if (orderModeCheck === "Delivery") {
          setCashtype(paymentStatus.cash && 1);
          setPaypalType(paymentStatus.paypalStatus && 1);
          setCardtype(paymentStatus.card && 1);
          setApplepaytype(paymentStatus.applePay && 1);
          setGooglepaytype(paymentStatus.googlePay && 1);
          setKlarnaType(paymentStatus.klarna && 1);
          if (width > 1199) {
            if (paymentStatus.card && 1) {
              setSelectedValue("cardimg");
              setPaymentType(1);
            } else {
              if (paymentStatus.cash && 1) {
                setSelectedValue("cashimg");
                setPaymentType(0);
              }
            }
          }
        } else {
          setCashtype(paymentStatus.coll_cash && 1);
          setPaypalType(paymentStatus.paypalStatus && 1);
          setCardtype(paymentStatus.coll_card && 1);
          setApplepaytype(paymentStatus.coll_applePay && 1);
          setGooglepaytype(paymentStatus.coll_googlePay && 1);
          setKlarnaType(paymentStatus.klarna && 1);
          if (width > 1199) {
            if (paymentStatus.coll_card && 1) {
              setSelectedValue("cardimg");
              setPaymentType(1);
            } else {
              if (paymentStatus.coll_cash && 1) {
                setSelectedValue("cashimg");
                setPaymentType(0);
              }
            }
          }
        }
      } else {
        setCashtype(paymentStatus.guest_cash && 1);
        setPaypalType(paymentStatus.paypalStatus && 1);
        setCardtype(paymentStatus.coll_card && 1);
        setApplepaytype(paymentStatus.coll_applePay && 1);
        setGooglepaytype(paymentStatus.coll_googlePay && 1);
        setKlarnaType(paymentStatus.klarna && 1);
        if (width > 1199) {
          if (paymentStatus.coll_card && 1) {
            setSelectedValue("cardimg");
            setPaymentType(1);
          } else {
            if (paymentStatus.guest_cash && 1) {
              setSelectedValue("cashimg");
              setPaymentType(0);
            }
          }
        }
      }
    }
  }, [stripepayment, orderModeCheck, isLoggedInChecked]);

  useEffect(() => {
    if (stripepayment && !isNaN(finalTotalValue) && finalTotalValue > 0) {
      const oamount = finalTotalValue;
      const walletamount = stripepayment?.message?.wallet;

      if (walletamount !== undefined) {
        setWalletamount(walletamount);
        setWalletstatus(
          parseFloat(walletamount) >= parseFloat(oamount) ? 1 : 0
        );
      }
      const walletAmount = parseFloat(walletamount); // Assuming walletamount = "138.96"
      const oAmount = parseFloat(oamount);
      const isButtonEnabled = walletAmount <= oAmount;
      if (isButtonEnabled) {
        const oAmount1 = parseFloat(oamount) || 0;
        const walletAmount1 = parseFloat(walletamount) || 0;
        const setExtraLess = oAmount1 - walletAmount1;
        setExtraPayStatus(1);
        setExtraLessAmount(setExtraLess);
        console.log(setExtraLess);
        setExtraPayment(true);
        console.log("hii--1");
      } else {
        setExtraPayment(false);
        setExtraPayStatus(0);
        // setExtraLessAmount(null);
        console.log("hii--2");
      }
    }
  }, [stripepayment, finalTotalValue]);

  // console.log(svpaySubmit);

  // console.log(svclientSecret);
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (userData !== null && isLoggedIn === "true") {
      setCustomer(userData);
    } else {
      setCustomer("");
    }
  }, [isLoggedIn]);

  const voucherData = useMemo(() => {
    const orderTime = localStorage.getItem("orderTime") || "";
    let dateParts = "";
    let timePart = "";
    let formattedDate = "";
    if (orderTime) {
      let inputDate = orderTime;
      if (inputDate.includes("/")) {
        dateParts = inputDate.split(" ")[0].split("/"); // Split the date into parts
        timePart = inputDate.split(" ")[1]; // Get the time part
        // Create a Date object with the parts
        const dateObject = new Date(
          `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}T${timePart}`
        );
        // Format the date in the desired format
        const year = dateObject.getFullYear();
        const month = String(dateObject.getMonth() + 1).padStart(2, "0");
        const day = String(dateObject.getDate()).padStart(2, "0");
        const hour = String(dateObject.getHours()).padStart(2, "0");
        const minute = String(dateObject.getMinutes()).padStart(2, "0");
        formattedDate = `${year}-${month}-${day} ${hour}:${minute}`;
      } else {
        formattedDate = orderTime;
      }
    }
    return {
      customerId: customer.customerId,
      clientPath: path,
      orderTime: formattedDate,
      voucherCode: voucherValue || "",
    };
  }, [path, orderTime, customer, voucherValue]);

  useEffect(() => {
    // save card client secret id confirm payment
    if (svpaySubmit == 2) {
      // After set save card secret id i have changed svpaysubmit == 2
      const confirmPayment = async () => {
        const cardCvcElement = elements.getElement(CardCvcElement);

        try {
          const result = await stripe.confirmCardPayment(svclientSecret, {
            payment_method: paymentMId,
            payment_method_options: {
              card: {
                cvc: cardCvcElement,
              },
            },
          });

          if (result.error) {
            // Handle the error (e.g., display an error message)
            setSaveCardError(result.error.message);
            console.error(result.error.message);
          } else {
            // Payment was successful
            setSvpaySubmit(3);
            setPayType("paymentIntentId");
            setPaymentIntentId(result.paymentIntent.id);
            console.log("Payment confirmed:", result.paymentIntent);
          }
        } catch (error) {
          // Handle any unexpected errors
          console.error("Error confirming payment:", error);
        }
      };

      // Call the function to confirm payment
      confirmPayment();
    }

    // common confirm payment code
    if (paySubmit == 2) {
      // After set save card secret id i have changed svpaysubmit == 2
      const cardconfirmPayment = async () => {
        // console.log(clientSecret);
        // console.log(paymentMId);

        try {
          const result = await stripe
            .confirmCardPayment(clientSecret)
            .then(function (result) {
              if (result.error) {
                setButtonstatus(false);
                setClientSecret(0);
                setPayType("paymentMethodId");
                setPaymentIntentId("");
                setPaymentMId("");
                dispatch(clearPlaceOrder());
                // console.log(result);
                // Handle the error (e.g., display an error message)
                // console.error(result.error.message);
              } else {
                setPaySubmit(3);
                setPayType("paymentIntentId");
                console.log("Payment confirmed:", result);
              }
            });
        } catch (error) {
          console.log(error);
          // Handle any unexpected errors
          // console.error("Error confirming payment:", error);
        }
      };

      // Call the function to confirm payment
      cardconfirmPayment();
    }
    if (paySubmit === 14 && payPalClientSecret) {
      const checkLoginAddress = localStorage.getItem("loginAddress") || "";
      const checkGuestAddress = localStorage.getItem("guestAddress") || "";
      const path = localStorage.getItem("clientPath");
      const domain = window.location.origin;

      const confirmPayPalPayment = async () => {
        let addressFromUser = null;
        if (isLoggedIn === "true") {
          addressFromUser = checkLoginAddress;
        } else {
          addressFromUser = checkGuestAddress;
        }
        const detailsFromUser = JSON.parse(addressFromUser);
        const currencyName = localStorage.getItem("currencyName");
        let countryCode;

        // Define currency based on country
        switch (currencyName) {
          case "USD":
            countryCode = "US"; // United States Dollar
            break;
          case "INR":
            countryCode = "IN"; // Indian Rupee
            break;
          case "GBP":
            countryCode = "GB"; // British Pound Sterling
            break;
          case "EUR":
            countryCode = "FR"; // Euro
            break;
          default:
            countryCode = "US"; // Default to USD
        }

        try {
          const { error } = await stripe.confirmPayPalPayment(
            payPalClientSecret,
            {
              payment_method: {
                billing_details: {
                  email: detailsFromUser?.email,
                  address: {
                    country: countryCode,
                  },
                },
              },
              return_url: `${domain}/${encodeURIComponent(path)}/checkout`,
            }
          );

          if (error) {
            console.error(error.message);
            setPaySubmit(0);
            setPayType("");
          } else {
            setPaySubmit(3);
            setPayType("paymentIntentId");
            console.log("PayPal Payment confirmed:");
          }
        } catch (error) {
          console.error("Error confirming PayPal payment:", error);
        }
      };

      confirmPayPalPayment();
    }
  }, [
    svpaySubmit,
    svclientSecret,
    paymentMId,
    elements,
    stripe,
    paySubmit,
    payPalClientSecret,
  ]);

  useEffect(() => {
    // common klarna payment code
    if (paySubmit === 10 && clientSecret !== 0) {
      const klarnaPaymentConfirm = async () => {
        let addressData = null;
        if (isLoggedIn === "true") {
          addressData = loginAddress;
        } else {
          addressData = guestAddress;
        }
        const address = JSON.parse(addressData);

        const currencyName = localStorage.getItem("currencyName");
        let countryCode;

        // Define currency based on country
        switch (currencyName) {
          case "USD":
            countryCode = "US"; // United States Dollar
            break;
          case "INR":
            countryCode = "IN"; // Indian Rupee
            break;
          case "GBP":
            countryCode = "GB"; // British Pound Sterling
            break;
          case "EUR":
            countryCode = "FR"; // Euro
            break;
          default:
            countryCode = "US"; // Default to USD
        }

        try {
          await stripe.confirmKlarnaPayment(clientSecret, {
            payment_method: {
              billing_details: {
                email: address?.email,
                address: {
                  country: countryCode,
                },
              },
            },
            return_url: `${domain}/${path}/checkout`,
          });
        } catch (error) {
          console.log("Error confirming Klarna payment:", error);
          // Handle errors
        }
      };
      klarnaPaymentConfirm();
    }
  }, [
    svpaySubmit,
    svclientSecret,
    paymentMId,
    elements,
    stripe,
    paySubmit,
    clientSecret,
  ]);
  const discountJSON = localStorage.getItem("discount");
  const SummaryOrderType = getOrderMode === "Collection" ? 1 : 0;

  useEffect(() => {
    const discount = discountJSON ? JSON.parse(discountJSON) : "";
    setParsedDiscount(discount);
    let finalTotalValue =
      parseFloat(subTotal) +
      parseFloat(deliveryCharge) +
      parseFloat(bagCharge) +
      parseFloat(clientFkCharge) +
      parseFloat(driverTipValue);

    if (
      parsedDiscount !== "" &&
      (parsedDiscount?.orderType === SummaryOrderType ||
        parsedDiscount?.orderType === "2")
    ) {
      if (discount?.appliedDiscount) {
        finalTotalValue -= parseFloat(discount.appliedDiscount);
      }
    }

    if (discount?.source == "voucherDiscount") {
      setVoucherValue(discount?.discount || "");
    }
    if (discount?.source == "SubscriptionCoupon") {
      setVoucherValue(discount?.discount || "");
      setVoucherApplied(true);
    }
    setAppliedDiscount(discount?.appliedDiscount || 0);
    localStorage.setItem("finalTotal", finalTotalValue.toFixed(2));
    setFinalTotal(finalTotalValue.toFixed(2));
    setFinalTotalValue(
      (parseFloat(finalTotalValue) + parseFloat(roundedValue)).toFixed(2)
    );
    localStorage.setItem(
      "finalTotalValue",
      (parseFloat(finalTotalValue) + parseFloat(roundedValue)).toFixed(2)
    );
  }, [
    subTotal,
    parsedDiscount,
    deliveryCharge,
    bagCharge,
    clientFkCharge,
    driverTipValue,
    roundedValue,
    discountJSON,
    useWalletBalance,
    polling,
  ]);

  useEffect(() => {
    let localStorageData =
      localStorage.getItem("cart") &&
      localStorage.getItem("cart") !== "undefined"
        ? JSON.parse(localStorage.getItem("cart"))
        : [];

    setcartItems(localStorageData);
  }, [localStorage.getItem("cart")]);

  if (!stripepayment) {
    return <div>Loading...</div>;
  }

  const SavedCards = stripepayment?.message?.card?.cardDetail;

  if (SavedCards) {
    setPaySaveCard(SavedCards);
  }

  // Assign to a separate variable
  // if (SavedCards) {
  //   console.log("SavedCards =>", SavedCards);
  // }

  const handleToggle = (eventKey) => {
    setActiveKey(eventKey === activeKey ? null : eventKey);
    setSavecardPay(activeKey == "add-card" ? 1 : 0);
  };
  const handleCardChange = (e) => {
    setCardStatus(true);
    setCardErrorMessage(null);
    setFooterBtn(false);
    dispatch(postPlaceOrderStatus(false));
  };

  function handleShow() {
    setPaymentModalShow(true);
  }

  function handlechildshow() {
    setPaymentType(1);
    setSelectedValue("cardimg1");
    setshowchildpopup(true);
    // setPaymentModalShow(false);
  }

  const handleClose = () => setPaymentModalShow(false);

  // function JsonDisplay({ data }) {
  //   // Format the JSON data with indentation for readability
  //   const formattedData = JSON.stringify(data, null, 2);

  //   return (
  //     <div>
  //       <h4>Formatted JSON Data</h4>
  //       <pre>{formattedData}</pre>
  //     </div>
  //   );
  // }

  if (paySpinner) {
    <Loader />;
  }

  // const handleApply = () => {
  //   console.log("Applied voucher:", voucherCode);
  //   setShowModalPromo(false);
  // };

  const checkVoucher = () => {
    if (voucherValue == "") {
      setValidDiscount(false);
    }
    //Subscription Coupon Code Apply
    const SubscriptionCouponCode1 = localStorage.getItem("SubcripeCoupon");

    // Check if the value exists and is not the string "undefined"
    const SubscriptionCouponCode =
      SubscriptionCouponCode1 !== null &&
      SubscriptionCouponCode1 !== "undefined"
        ? JSON.parse(SubscriptionCouponCode1)
        : "";

    setVoucherLoad(true);
    if (
      SubscriptionCouponCode != "" &&
      typeof SubscriptionCouponCode !== "undefined"
    ) {
      console.log(voucherData);
      if (voucherValue === SubscriptionCouponCode.code) {
        const isCouponApplied = applySubcriptionCouponCode(
          SubscriptionCouponCode,
          getOrderMode
        );

        if (isCouponApplied) {
          setValidDiscount(true);
          setVoucherApplied(true);
          setVoucherLoad(false);
          // setCelebrate(true);
          // setTimeout(() => setCelebrate(false), 6000);
        }
      } else {
        setValidDiscount(false);
        setVoucherLoad(false);
      }
    } else {
      checkVoucherCode(voucherData)
        .then((response) => {
          if (!response.status) {
            if (response.message == "voucher code was already Used") {
              setVoucherUsed(true);
              setValidDiscount(false);
            } else if (response.message == "Invalid code") {
              setValidDiscount(false);
            } else if (response.message == "voucher not available") {
              setValidDiscount(false);
            } else if (response.message == "CustomerId is required") {
              setVoucherLogin(true);
              setValidDiscount(false);
            }
            setVoucherApplied(false);
            setVoucherLoad(false);
            console.log("vocuherRespose");
            console.log(response.message);
            return;
          }
          const storedCart = localStorage.getItem("cart");
          const localStorageCart = JSON.parse(storedCart) || [];
          const filteredItems = localStorageCart.filter(
            (cart) => cart.itemAllowCoupon === 1
          );
          const totalValue = filteredItems.reduce(
            (sum, item) => sum + parseFloat(item.price),
            0
          );
          // const totalValue = localStorage.getItem("totalPrice");
          if (
            parseFloat(totalValue) >= parseFloat(response.message.minAmount)
          ) {
            const voucher = {
              code: response.message.code,
              discount: response.message.discount,
              description: response.message.description,
              discountType: response.message.type,
              minOrder: response.message.minAmount,
            };
            applyVoucher(voucher, getOrderMode);
            setValidDiscount(true);
            setVoucherApplied(true);
            setVoucherLoad(false);
          } else {
            setVoucherMinimum(true);
            setVoucherLoad(false);
            setValidDiscount(false);
          }
        })
        .catch((error) => {
          setVoucherLoad(false);
          console.log(error);
        });
    }
  };

  const handleOpenModal = () => setShowModalPromo(true);
  const handleCloseModal = () => setShowModalPromo(false);
  const handleKeyChange = () => {
    setVoucherUsed(false);
    setVoucherLogin(false);
    setVoucherMinimum(false);
    setValidDiscount(true);
    setVoucherApplied(false);
  };

  const hanldechildclosenew = () => {
    setshowchildpopup(false);
    setPaymentModalShow(false);
    setSelectedValue("cardimg1"); // Reset selectedValue so modal condition becomes false
    // setCardType(null);      // Optional: Reset cardtype if needed
  };

  const handleSavedPopupShow = () => {
    setShowSavedCardSection(false);
    setShowSavedCardPopUp(true);
  };
  const handleSavedPopupClose = () => {
    setShowSavedCardSection(true);
    setShowSavedCardPopUp(false);
    setshowchildpopup(false);
    setPaymentModalShow(false);
    setSelectedValue("cardimg1");
  };

  const handleCVVInfo = () => {
    setShowCVVInfo(true);
  };
  const handleCVVclose = () => {
    setShowCVVInfo(false);
  };

  const handleSecureInfo = () => {
    setShowSecureModal(true);
  };
  const handleSecureClose = () => {
    setShowSecureModal(false);
  };

  const mobileSaveCard = (
    <>
      {Array.isArray(SavedCards) &&
        SavedCards?.length > 0 &&
        SavedCards?.map((savedCard, index) => {
          const cardNumber = savedCard.card ?? "";
          const isSelected = selectedCard === cardNumber;
          const isPrimary = savedCard.primary === "1" && primary;

          return (
            <div
              key={index}
              style={{
                marginBottom: "16px",
                // border: "1px solid #eee",
                borderRadius: "12px",
                padding: "5px",
                backgroundColor: "#fff",
              }}
            >
              <label
                htmlFor={`savedcard-${index}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  gap: "12px",
                }}
              >
                <img
                  src={savedCard.brand || "/default.png"}
                  alt="card-logo"
                  style={{
                    width: "65px",
                    height: "65px",
                    objectFit: "contain",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "6px",
                    padding: "4px",
                  }}
                  onError={(e) => (e.target.src = "/default.png")}
                />
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: "22px" }}>
                    **** **** ***** {cardNumber.slice(-4)}
                  </div>
                  <small style={{ color: "#555", fontSize: "16px" }}>
                    Expires on {savedCard.expMonth}/
                    {String(savedCard.expYear).slice(-2)}
                  </small>
                </div>
                <input
                  id={`savedcard-${index}`}
                  type="radio"
                  name="savedcard"
                  value={cardNumber}
                  checked={isSelected}
                  onChange={handlecardChange}
                  className="custom-radio"
                />
              </label>

              {(isSelected || isPrimary) && (
                <div
                  style={{
                    marginTop: "16px",
                    display: "flex",
                    gap: "10px",
                    flexWrap: "wrap",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      flex: 1,
                      minWidth: "100px",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      padding: "10px",
                    }}
                  >
                    <CardCvcElement
                      options={{
                        iconStyle: "solid",
                        style: {
                          base: {
                            iconColor: "#c4f0ff",
                            color: "#000",
                            fontWeight: 300,
                            fontSize: "16px",
                            "::placeholder": {
                              color: "#aab7c4",
                            },
                          },
                          invalid: {
                            iconColor: "#ffc7ee",
                            color: "red",
                          },
                        },
                      }}
                    />
                  </div>

                  <button
                    onClick={() =>
                      handlesavecardPayment(savedCard.paymentMethodId)
                    }
                    disabled={buttonstatus}
                    style={{
                      backgroundColor: "#000",
                      color: "#fff",
                      padding: "10px 16px",
                      borderRadius: "8px",
                      border: "none",
                      fontWeight: 600,
                      minWidth: "120px",
                    }}
                  >
                    {buttonstatus ? (
                      <Spinner animation="border" size="md" variant="light" />
                    ) : (
                      "Pay" // or use your actual total
                    )}
                  </button>
                </div>
              )}
            </div>
          );
        })}
    </>
  );

  return (
    <>
      {/* <div>
          <p>JsonFormate</p>
          <JsonDisplay data={placeOrderApiJson} />
        </div> */}
      {/* mobile payment ui */}
      <div>
        <Card className="paymentCard">
          <Card.Body className="paymentCardBody">
            {/* <div>
              <div className="voucher-code-container" onClick={handleOpenModal}>
                <div className="voucher-code-left">
                 
                  <span className="voucher-label">Add Voucher code</span>
                </div>
                <RiArrowRightSLine className="voucher-arrow" />
              </div>

            </div>
            <div className="borderbottomdiv"></div>
            {showModalPromo && (
              <div className="custom-modal-overlay">
                <div className="custom-modal-content">
                  <form>
                    <h2 className="voucher-modal-title">Voucher <img src={closeiconnew} alt="closeicon" className="closeiconnew" onClick={handleCloseModal} /></h2>
                    <p className="voucher-modal-subtitle">Add your voucher</p>
                    <Form.Control
                      type="text"
                      value={voucherValue}
                      onChange={(e) => setVoucherValue(e.target.value)}
                      onKeyDown={handleKeyChange}
                      isInvalid={!validDiscount}
                      data-fus="fus-test-vouchercodeinput"
                      placeholder="voucher Code"
                      className="voucher-input"
                    />

                    <button className="voucher-apply-btn" type="button" onClick={checkVoucher}>
                      {voucherLoad ? (
                        <Spinner animation="border" size="sm" variant="primary" />
                      ) : voucherApplied ? (
                        "Applied"
                      ) : (
                        "Apply"
                      )}
                    </button>
                  </form>
                  {voucherUsed && (
                    <p className="error-code" style={{ color: "red" }}>
                      Sorry Voucher already redeemed
                    </p>
                  )}
                  {voucherLogin && (
                    <p className="error-code" style={{ color: "red" }}>
                      Please log in to redeem this voucher
                    </p>
                  )}
                  {voucherMinimum && (
                    <p className="error-code" style={{ color: "red" }}>
                      Need to added more item
                    </p>
                  )}
                </div>
              </div>
            )} */}

            <Card.Title className="paymentCardTitle">
              Payment options{" "}
              <div className="secure-badge" onClick={handleSecureInfo}>
                <img src={lockimgkey} className="lock-icon" />
                100% Secure
              </div>
            </Card.Title>
            {/* <div className="payment-detail">
              <img
                  src={theme === "dark" ? MdPayment : MdPayment}
                  alt="Order Mode"
                />
              <MdPayment />
              <div className="payment-text">
              <p className="payment-text-postcode">Add Payment Method</p>
              </div>
              <div className="payment-action-btn">
                <button className="payment-action-btn" onClick={() => handleShow()}>
                              Edit
                            </button>
              </div>
            </div> */}

            {/* <div className="borderbottomdiv"></div> */}

            {/* <div className="payment-detail">
                            <FaUser />
                            <div className="payment-text">
    <p className="payment-text-postcode">Add Promo Code</p>
                            </div>
                            
                            <div className="payment-action-btn">
  <button className="payment-action-btn">
    Add
  </button>
                            </div>
                          </div> */}

            <div className="payment-tab d-none d-md-block">
              <form className="tabs-div">
                {paymentOptions?.map(
                  ({ value, icon, darkicon, status, type, device, para }) => {
                    const guestusered = localStorage.getItem("guestAddress");

                    // Skip wallet if guest
                    if (guestusered && value === "wallet") return null;

                    // Proper return
                    return (
                      <>
                        {status == 1 ? (
                          <>
                            {device == 1 ? (
                              <label
                                className={`${
                                  type === 1 && type !== 3
                                    ? "mobileview"
                                    : "desktopviews"
                                } ${
                                  selectedValue === value
                                    ? "newactivestyle"
                                    : ""
                                }`}
                                key={value}
                              >
                                <img
                                  className={value}
                                  src={theme === "dark" ? darkicon : icon}
                                  alt="darkicon"
                                />

                                <input
                                  type="radio"
                                  value={value}
                                  name="payment"
                                  checked={selectedValue === value}
                                  onChange={handleChange}
                                />
                                <p>{para}</p>
                              </label>
                            ) : null}
                          </>
                        ) : null}
                      </>
                    );
                  }
                )}
              </form>

              {selectedValue === "cardimg" ? (
                <>
                  <div className="selected-tab">
                    <div className="card-tab">
                      <div className="header">
                        <h5 style={{ marginTop: "20px", marginBottom: "5px" }}>
                          {" "}
                          <img
                            src={creditcarddebitcart}
                            alt="crediticon"
                            className="creditdebitcard"
                          />{" "}
                          Credit or Debit card
                        </h5>
                      </div>
                      {/* New Accordion Start */}
                      <Accordion
                        className="selected-tab-accord"
                        activeKey={activeKey}
                        onSelect={handleToggle}
                        style={{ border: "none !important" }}
                      >
                        <Accordion.Item
                          eventKey="add-card"
                          className="border-0 mt-3"
                          // style={{ border: "none" }}
                        >
                          <Accordion.Header>
                            {/* <span>
                              {activeKey === "add-card" ? (
                                <BiMinus />
                              ) : (
                                <BiPlus />
                              )}
                            </span> */}
                            <span className="fw-bold">Add Card</span>
                          </Accordion.Header>
                          <Accordion.Body>
                            <form className="add-card-form">
                              <Row>
                                <Col xxl={12} xl={12}>
                                  <Form.Label>Card number</Form.Label>
                                  <div
                                    style={{
                                      height: "40px",
                                      marginBottom: "35px",
                                      position: "relative",
                                    }}
                                  >
                                    <CardNumberElement
                                      options={CARD_OPTIONS}
                                      className="custom-card-element"
                                      onChange={(e) => {
                                        handleCardChange(e);
                                        setCardBrand(e.brand);
                                      }}
                                    />

                                    {getCardBrandIcon(cardBrand) && (
                                      <FontAwesomeIcon
                                        icon={getCardBrandIcon(cardBrand)}
                                        style={{
                                          position: "absolute",
                                          right: "15px",
                                          top: "55%",
                                          transform: "translateY(-50%)",
                                          fontSize: "45px",
                                          color: "#DEDEDE",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      />
                                    )}
                                  </div>
                                </Col>
                                <Col
                                  xxl={6}
                                  sm={6}
                                  xs={6}
                                  xl={6}
                                  style={{ marginBottom: "20px" }}
                                >
                                  <Form.Label>Expires on</Form.Label>

                                  <CardExpiryElement
                                    options={CARD_OPTIONS}
                                    onChange={handleCardChange}
                                  />
                                </Col>

                                <Col
                                  xxl={6}
                                  sm={6}
                                  xs={6}
                                  xl={6}
                                  style={{ marginBottom: "20px" }}
                                >
                                  <Form.Label>CVV</Form.Label>
                                  {savecardPay == 0 && (
                                    <>
                                      <div style={{ position: "relative" }}>
                                        <CardCvcElement
                                          options={CARD_OPTIONS}
                                          onChange={handleCardChange}
                                        />
                                        <div
                                          title="What is CVV?"
                                          style={{
                                            position: "absolute",
                                            top: "50%", // vertically center
                                            right: "15px", // distance from right edge
                                            transform: "translateY(-50%)", // align vertical center correctly
                                            height: "22px",
                                            width: "22px",
                                            backgroundColor: "#f5f5f5",
                                            border: "1px solid #ccc",
                                            borderRadius: "50%",
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                            color: "#000",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                            zIndex: 2,
                                          }}
                                          onClick={handleCVVInfo} // Optional: for a modal or tooltip
                                        >
                                          ?
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </Col>
                                <span
                                  className="card-error"
                                  style={{
                                    color: "red",
                                    margin: cardErrorMessage
                                      ? "10px 0 10px 0"
                                      : "",
                                    textAlign: cardErrorMessage ? "center" : "",
                                  }}
                                >
                                  {cardErrorMessage}{" "}
                                </span>

                                <Modal
                                  show={showCVVInfo}
                                  // fullscreen={fullscreen}
                                  centered
                                  onHide={() => setShowCVVInfo(false)}
                                  id="checkoutcustomModal"
                                  className={
                                    theme === "dark" ? "dark-popup" : null
                                  }
                                  dialogClassName="bottom-modal"
                                  fade
                                >
                                  <div
                                    style={{
                                      borderRadius: "12px",
                                      padding: "20px",
                                    }}
                                  >
                                    <div className="d-flex justify-content-between align-items-center">
                                      <h5 className="whatcvvtext">
                                        What is CVV?
                                      </h5>
                                      <img
                                        src={closeiconnew}
                                        alt="closeicon"
                                        className="closeiconnew"
                                        onClick={handleCVVclose}
                                      />
                                    </div>

                                    <div className="text-center my-3">
                                      <img
                                        src={Cvvbgimage}
                                        alt="CVV example"
                                        style={{
                                          width: "100%",
                                          maxWidth: "360px",
                                          height: "100%",
                                        }}
                                      />
                                    </div>

                                    <p className="cvvdescription">
                                      The CVV number is the last three digits on
                                      the back of your card
                                    </p>
                                  </div>
                                </Modal>

                                {isLoggedIn !== "false" ? (
                                  <>
                                    <Col xxl={12}>
                                      <Form.Check
                                        label=" Securely save this card future order"
                                        name="form-check"
                                        type="checkbox"
                                        id="form-check"
                                        // className="form-check"
                                        onClick={() =>
                                          handleSaveCardCheckboxClick()
                                        }
                                        // style={{ marginTop: "15px" }}
                                      />
                                    </Col>
                                  </>
                                ) : null}
                              </Row>
                            </form>
                          </Accordion.Body>
                        </Accordion.Item>
                        {userData && isLoggedIn === "true" ? (
                          <>
                            {!cardaccordion &&
                            isLoggedIn !== "false" &&
                            SavedCards ? (
                              <Accordion.Item
                                eventKey="saved-card"
                                className="border-0 mt-3"
                                // style={{ border: "none" }}
                              >
                                <Accordion.Header>
                                  {/* <span>
                                    {activeKey === "saved-card" ? (
                                      <BiMinus />
                                    ) : (
                                      <BiPlus />
                                    )}
                                  </span> */}

                                  <span className="fw-bold">Saved Cards</span>
                                </Accordion.Header>
                                <Accordion.Body>
                                  <div className="saved-cards">
                                    <div className="save-card-form">
                                      {SavedCards ? (
                                        <>
                                          {SavedCards.map(
                                            (savedCard, index) => (
                                              <label key={index}>
                                                <div className="main-data">
                                                  <span
                                                    className={` tick
                                                ${
                                                  selectedCard ===
                                                    savedCard.card && "active"
                                                }
                                                `}
                                                  >
                                                    {selectedCard ===
                                                    savedCard.card ? (
                                                      <>
                                                        <MdDone />
                                                      </>
                                                    ) : savedCard.primary ===
                                                        "1" && primary ? (
                                                      <>
                                                        <MdDone />
                                                      </>
                                                    ) : (
                                                      <></>
                                                    )}
                                                  </span>
                                                  <img
                                                    src={savedCard.brand}
                                                    alt=""
                                                  />
                                                  <div className="card-data">
                                                    <p>{savedCard.card}</p>
                                                    <span>
                                                      Expires on{" "}
                                                      {savedCard.expMonth}/
                                                      {savedCard.expYear % 100}
                                                    </span>
                                                  </div>
                                                  <input
                                                    type="radio"
                                                    value={savedCard.card}
                                                    name="savedcard"
                                                    checked={
                                                      selectedCard ===
                                                      savedCard.card
                                                    }
                                                    onChange={handlecardChange}
                                                  />
                                                </div>
                                                <br />
                                                <div className="main-datanewsave">
                                                  {selectedCard ===
                                                  savedCard.card ? (
                                                    <>
                                                      <div className="cvv-btn">
                                                        {savecardPay == 1 && (
                                                          <CardCvcElement
                                                            options={
                                                              CARD_OPTIONS
                                                            }
                                                          />
                                                        )}

                                                        <button
                                                          disabled={
                                                            buttonstatus
                                                              ? true
                                                              : false
                                                          }
                                                          onClick={() =>
                                                            handlesavecardPayment(
                                                              savedCard.paymentMethodId
                                                            )
                                                          }
                                                        >
                                                          {buttonstatus ? (
                                                            <Spinner
                                                              animation="border"
                                                              size="sm"
                                                              variant="success"
                                                            />
                                                          ) : (
                                                            "Pay"
                                                          )}
                                                        </button>
                                                      </div>
                                                    </>
                                                  ) : savedCard.primary ===
                                                      "1" && primary ? (
                                                    <>
                                                      <div className="cvv-btn">
                                                        {savecardPay == 1 && (
                                                          <CardCvcElement
                                                            options={
                                                              CARD_OPTIONS
                                                            }
                                                          />
                                                        )}

                                                        <button
                                                          disabled={
                                                            buttonstatus
                                                              ? true
                                                              : false
                                                          }
                                                          onClick={() =>
                                                            handlesavecardPayment(
                                                              savedCard.paymentMethodId
                                                            )
                                                          }
                                                        >
                                                          {buttonstatus ? (
                                                            <Spinner
                                                              animation="border"
                                                              size="sm"
                                                              variant="success"
                                                            />
                                                          ) : (
                                                            "Pay"
                                                          )}
                                                        </button>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )}
                                                </div>
                                              </label>
                                            )
                                          )}
                                        </>
                                      ) : null}
                                    </div>
                                  </div>
                                </Accordion.Body>
                              </Accordion.Item>
                            ) : (
                              <></>
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                      </Accordion>
                      {/* New Accordion End */}
                    </div>
                  </div>
                </>
              ) : selectedValue === "paypal" ? (
                <>
                  <div className="selected-tab"></div>
                </>
              ) : selectedValue === "google-pay" ? (
                <div className="selected-tab"></div>
              ) : selectedValue === "apple-pay" ? (
                <div className="selected-tab"></div>
              ) : guestusered !== "" && selectedValue === "wallet" ? (
                isLoggedIn === "true" ? (
                  <div className="selected-tab">
                    <div className="wallet-tab">
                      {walletstatus == 1 ? (
                        <>
                          <img
                            src={theme === "dark" ? CardIconDark : CardIcon}
                            alt="darkicon"
                          />

                          <h4>{walletamount}</h4>
                          <p>Available Balance</p>
                        </>
                      ) : (
                        <>
                          <img
                            src={theme === "dark" ? CardIconDark : CardIcon}
                            alt="cardicon"
                          />

                          <h4>{walletamount}</h4>
                          <p>Not placed Available Balance</p>
                        </>
                      )}
                    </div>
                  </div>
                ) : null
              ) : selectedValue === "cashimg" && cashtype ? (
                <></>
              ) : // <div className="selected-tab"></div>
              null}

              <div
                className="fus-payment-btnpayment"
                style={{ marginBottom: "15px" }}
              >
                <OrderButton
                  walletamount={walletamount}
                  finalTotalValue={finalTotalValue}
                />
              </div>
            </div>

            {/* mobile payment ui */}
            <div className="payment-tab d-block d-sm-none" ref={sectionRef}>
              <div className="header-content">
                <div className="order-data">
                  {/* <img
                src={theme === "dark" ? WalletIconwhite : WalletIcon}
                alt="Order Mode"
              /> */}
                  <p>Try More ways to pay</p>
                </div>
                <div className="order-datap">
                  <p>We support Fusion pay,Klarna, Paypal and 2+ more</p>
                </div>
              </div>
              <div className="checkoutimgs">
                <div className="checkoutimgschild">
                  <img
                    src={
                      appledeviceInfo === 1
                        ? theme === "dark"
                          ? applepaydark
                          : applepays
                        : Gpay
                    }
                    alt="appleinfoicon"
                  />
                  {cashtype && <img src={CardImgWhite} alt="cartwhite" />}
                  <img src={CardImgWhite} alt="cartwhiteicon" />
                  {/* <img src={appledeviceInfo === 1 ? applepays : (theme === "dark" ? applepaydark : Gpay)} alt="" /> */}
                  {klarnaType && <img src={klarnapay} alt="klarnapay" />}
                  {paypalType && <img src={Paypallogo} alt="paypallogo" />}
                  <img src={threeplus} alt="" />
                </div>
                <div>
                  <IoIosArrowForward onClick={() => handleShow()} />
                </div>
              </div>
              <div>
                {/* modal popup payment  */}
                <Modal
                  show={paymentModalShow}
                  fullscreen={fullscreen}
                  onHide={() => setPaymentModalShow(false)}
                  id="checkoutcustomModal"
                  className={
                    localStorage.getItem("isApp") == "true"
                      ? `app-side ${theme === "dark" ? "dark-popup" : null}`
                      : theme === "dark"
                      ? "dark-popup"
                      : null
                  }
                  dialogClassName="bottom-modal"
                >
                  {" "}
                  <IoCloseSharp className="closeicon" onClick={handleClose} />
                  <Modal.Header>
                    <Modal.Title className="checkoutpaymentmodaltext">
                      {/* <img
                        src={theme === "dark" ? BackWhiteIcon : BackIcon}
                        style={{ height: "20px", marginRight: "10px" }}
                        onClick={handleClose}
                      /> */}
                      How would you like to pay ?
                      {/* <img src={closeiconnew} alt="closeicon" className="closeiconnew" onClick={handleClose} /> */}
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="payment-options">
                      <ul className="list-group">
                        {cardtype && (
                          <li
                            className={`list-group-item ${
                              selectedValue == "cardimg1" ? "active" : ""
                            }`}
                            onClick={handlechildshow}
                          >
                            <div className="checkoutpayUI">
                              <div className="checkoutpayUIchild">
                                <div className="checkoutpaynewdiv">
                                  <img
                                    src={
                                      theme === "dark"
                                        ? CreditdebitCardImg
                                        : CreditdebitCardImg
                                    }
                                    alt=""
                                    onClick={handlechildshow}
                                  />
                                  <h5 onClick={handlechildshow}>Card</h5>
                                </div>
                                <label>
                                  <input
                                    type="radio"
                                    id="payment"
                                    checked={
                                      selectedValue == "cardimg1" ? true : false
                                    }
                                    onChange={handlechildshow}
                                  />
                                </label>
                              </div>
                            </div>
                            {/* {showchildpopup &&
                              selectedValue == "cardimg1" &&
                              cardtype && (
                                <div className="d-flex align-items-center justify-content-center flex-column vh-75 checkOutMobile">
                                  <Form className="form-label mb-3">
                                    <Row>
                                      <Col
                                        xxl={6}
                                        xl={6}
                                        style={{ padding: "10px" }}
                                      >
                                        <Form.Label className="checkOutMobileLabel">
                                          Card Number
                                        </Form.Label>
                                        <div
                                          style={containerStyle}
                                          className="checkOutMobileElement"
                                        >
                                          <CardNumberElement
                                            options={CARD_OPTIONS1}
                                            className="custom-card-element"
                                            style={{ height: "300px" }}
                                            onChange={handleCardChange}
                                          />
                                        </div>
                                      </Col>
                                      <Col xxl={3} sm={6} xs={6} xl={3}>
                                        <Form.Label className="checkOutMobileLabel">
                                          Validity
                                        </Form.Label>
                                        <div
                                          style={containerStyle}
                                          className="checkOutMobileElement"
                                        >
                                          <CardExpiryElement
                                            options={CARD_OPTIONS1}
                                            onChange={handleCardChange}
                                          />
                                        </div>
                                      </Col>
                                      <Col xxl={3} sm={6} xs={6} xl={3}>
                                        <Form.Label className="checkOutMobileLabel">
                                          CVV
                                        </Form.Label>
                                        {savecardPay == 0 && (
                                          <div
                                            style={containerStyle}
                                            className="checkOutMobileElement"
                                          >
                                            <CardCvcElement
                                              options={CARD_OPTIONS1}
                                              onChange={handleCardChange}
                                            />
                                          </div>
                                        )}
                                      </Col>
                                      <Form.Label
                                        style={{
                                          color: "red",
                                        }}
                                      >
                                        {cardErrorMessage}
                                      </Form.Label>
                                      {isLoggedIn !== "false" ? (
                                        <>
                                          <div className="p-2">
                                            <Col xxl={12}>
                                              <Form.Check
                                                label=" Securely save this card future order"
                                                name="form-check"
                                                type="checkbox"
                                                id="form-check"
                                                className="checkOutMobile-form-check-label"
                                                onClick={() =>
                                                  handleSaveCardCheckboxClick()
                                                }
                                              />
                                            </Col>
                                          </div>
                                        </>
                                      ) : null}
                                    </Row>
                                  </Form>
                                  <OrderButton walletamount={walletamount} finalTotalValue={finalTotalValue} />
                                </div>
                              )}
                            {
                              <div className="creditcardparent">
                                {userData && isLoggedIn === "true" ? (
                                  <>
                                    {SavedCards &&
                                      selectedValue == "cardimg1" ? (
                                      <>
                                        <h5></h5>

                                        {SavedCards.map((savedCard, index) => (
                                          <div key={index}>
                                            {savedCard.primary === "1" ? (
                                              <div className="creditcard">
                                                <div className="creditcardui">
                                                  <input
                                                    name="gender"
                                                    type="radio"
                                                    value={"savedcard"}
                                                    onChange={() =>
                                                      handlePaymentSelection(
                                                        12,
                                                        "savedcard"
                                                      )
                                                    }
                                                  />
                                                  <img
                                                    src={savedCard.brand}
                                                    alt="savedcard"
                                                    style={{ height: "40px" }}
                                                  />
                                                  <div className="creditcarduichild">
                                                    <p>{savedCard.card}</p>
                                                  </div>
                                                </div>

                                                <div></div>
                                              </div>
                                            ) : null}
                                          </div>
                                        ))}
                                      </>
                                    ) : null}
                                  </>
                                ) : null}
                              </div>
                            } */}
                          </li>
                        )}
                        <Modal
                          show={
                            showchildpopup &&
                            selectedValue === "cardimg1" &&
                            cardtype
                          }
                          onHide={() => setshowchildpopup(false)}
                          fullscreen
                          className={
                            localStorage.getItem("isApp") == "true"
                              ? "app-side"
                              : ""
                          }
                          centered
                        >
                          <Modal.Header
                            className={
                              localStorage.getItem("isApp") == "true"
                                ? "app-side arrowheadermodal"
                                : "arrowheadermodal"
                            }
                          >
                            <Modal.Title>
                              <MdOutlineArrowBackIos
                                className="arrowclose"
                                style={{ color: "#fff" }}
                                onClick={hanldechildclosenew}
                              />{" "}
                              <span className="ms-2">Payment</span>
                            </Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            {Array.isArray(SavedCards) &&
                              SavedCards.length > 0 && (
                                <div
                                  className="saved-cards-box"
                                  onClick={handleSavedPopupShow}
                                >
                                  <div className="saved-cards-left">
                                    <FiCreditCard className="card-icon" />
                                    <span className="saved-cards-text">
                                      Saved cards
                                    </span>
                                  </div>
                                  <RiArrowRightSLine className="voucher-arrow" />
                                </div>
                              )}
                            <div className="line-containercheck">
                              <div className="linecheck"></div>
                              <div className="textcheck">Add Card</div>
                              <div className="linecheck"></div>
                            </div>

                            {showSavedCardSection && (
                              <div className="d-flex align-items-center justify-content-center flex-column vh-75 checkOutMobilecard">
                                <Form className="form-label mb-3">
                                  <Row>
                                    <Col
                                      xxl={6}
                                      xl={6}
                                      style={{ padding: "10px" }}
                                    >
                                      <Form.Label className="checkOutMobileLabel">
                                        Card number
                                      </Form.Label>
                                      <div
                                        style={{
                                          padding: "15px 15px 15px 15px",
                                          borderRadius: "10px",
                                          border: "1px solid #EDEDED",
                                          position: "relative",
                                        }}
                                        className="checkOutMobileElement"
                                      >
                                        <CardNumberElement
                                          options={CARD_OPTIONS}
                                          className="custom-card-element"
                                          onChange={(e) => {
                                            handleCardChange(e);
                                            setCardBrand(e.brand);
                                          }}
                                          style={{ height: "300px" }}
                                        />

                                        {getCardBrandIcon(cardBrand) && (
                                          <FontAwesomeIcon
                                            icon={getCardBrandIcon(cardBrand)}
                                            style={{
                                              position: "absolute",
                                              right: "15px",
                                              top: "50%",
                                              transform: "translateY(-50%)",
                                              fontSize: "45px",
                                              color: "#DEDEDE",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                            }}
                                          />
                                        )}
                                      </div>
                                    </Col>
                                    <Col xxl={3} sm={6} xs={6} xl={3}>
                                      <Form.Label className="checkOutMobileLabel">
                                        Validity
                                      </Form.Label>
                                      <div
                                        style={{
                                          padding: "15px 15px 15px 15px",
                                          borderRadius: "10px",
                                          border: "1px solid #EDEDED",
                                        }}
                                        className="checkOutMobileElement"
                                      >
                                        <CardExpiryElement
                                          options={CARD_OPTIONS1}
                                          onChange={handleCardChange}
                                        />
                                      </div>
                                    </Col>
                                    <Col xxl={3} sm={6} xs={6} xl={3}>
                                      <Form.Label className="checkOutMobileLabel">
                                        CVV
                                      </Form.Label>

                                      <div
                                        style={{
                                          padding: "15px 15px 15px 15px",
                                          borderRadius: "10px",
                                          border: "1px solid #EDEDED",
                                          position: "relative",
                                        }}
                                        className="checkOutMobileElement"
                                      >
                                        <CardCvcElement
                                          options={CARD_OPTIONS1}
                                          onChange={handleCardChange}
                                        />
                                        <div
                                          title="What is CVV?"
                                          onClick={handleCVVInfo}
                                          style={{
                                            position: "absolute",
                                            top: "50%", // vertically center
                                            right: "15px", // distance from right edge
                                            transform: "translateY(-50%)", // align vertical center correctly
                                            height: "22px",
                                            width: "22px",
                                            backgroundColor: "#f5f5f5",
                                            border: "1px solid #ccc",
                                            borderRadius: "50%",
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                            color: "#000",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                            zIndex: 2,
                                          }}
                                        >
                                          ?
                                        </div>
                                      </div>
                                    </Col>

                                    <Form.Label
                                      style={{
                                        color: "red",
                                      }}
                                    >
                                      {cardErrorMessage}
                                    </Form.Label>
                                    {isLoggedIn !== "false" ? (
                                      <>
                                        <div className="p-2">
                                          <Col xxl={12}>
                                            <Form.Check
                                              label=" Securely save this card future order"
                                              name="form-check"
                                              type="checkbox"
                                              id="form-check"
                                              className="form-check"
                                              onClick={() =>
                                                handleSaveCardCheckboxClick()
                                              }
                                            />
                                          </Col>
                                        </div>
                                      </>
                                    ) : null}
                                  </Row>
                                </Form>
                                <OrderButton
                                  walletamount={walletamount}
                                  finalTotalValue={finalTotalValue}
                                />
                              </div>
                            )}
                          </Modal.Body>
                        </Modal>

                        <Modal
                          show={showSavedCardPopUp}
                          onHide={() => setshowchildpopup(false)}
                          fullscreen
                          className={
                            Array.isArray(SavedCards) &&
                            SavedCards.length > 0 &&
                            localStorage.getItem("isApp") == "true"
                              ? "app-side"
                              : ""
                          }
                          centered
                        >
                          <Modal.Header
                            className={
                              localStorage.getItem("isApp") == "true"
                                ? "app-side arrowheadermodal"
                                : "arrowheadermodal"
                            }
                          >
                            <Modal.Title>
                              <MdOutlineArrowBackIos
                                className="arrowclose"
                                style={{ color: "#fff" }}
                                onClick={handleSavedPopupClose}
                              />{" "}
                              <span className="ms-2">Payment</span>
                            </Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <h4
                              style={{ marginBottom: "20px", marginTop: "5px" }}
                            >
                              Saved Card
                            </h4>

                            <div className="save-card-form">
                              {!showSavedCardSection && mobileSaveCard}
                            </div>

                            {/* <div className="d-flex align-items-center justify-content-center flex-column vh-75 checkOutMobilecard">
                              <Form className="form-label mb-3">
                                <Row>
                                  <Col
                                    xxl={6}
                                    xl={6}
                                    style={{ padding: "10px" }}
                                  >
                                    <Form.Label className="checkOutMobileLabel">
                                      Card Number
                                    </Form.Label>
                                    <div
                                      style={{ padding: "15px 15px 15px 15px", borderRadius: "10px", border: "1px solid #EDEDED", position: "relative", }}
                                      className="checkOutMobileElement"
                                    >
                                      <CardNumberElement
                                        options={CARD_OPTIONS}
                                        className="custom-card-element"
                                        onChange={(e) => {
                                          handleCardChange(e);
                                          setCardBrand(e.brand);
                                        }}
                                        style={{ height: "300px" }}
                                      />

                                      {getCardBrandIcon(cardBrand) && (
                                        <FontAwesomeIcon
                                          icon={getCardBrandIcon(cardBrand)}
                                          style={{
                                            position: "absolute",
                                            right: "15px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            fontSize: "45px",
                                            color: "#DEDEDE",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                        />
                                      )}
                                    </div>
                                  </Col>
                                  <Col xxl={3} sm={6} xs={6} xl={3}>
                                    <Form.Label className="checkOutMobileLabel">
                                      Validity
                                    </Form.Label>
                                    <div
                                      style={{ padding: "15px 15px 15px 15px", borderRadius: "10px", border: "1px solid #EDEDED" }}
                                      className="checkOutMobileElement"
                                    >
                                      <CardExpiryElement
                                        options={CARD_OPTIONS1}
                                        onChange={handleCardChange}
                                      />

                                    </div>
                                  </Col>
                                  <Col xxl={3} sm={6} xs={6} xl={3}>
                                    <Form.Label className="checkOutMobileLabel" >
                                      CVV
                                    </Form.Label>

                                    <div
                                      style={{ padding: "15px 15px 15px 15px", borderRadius: "10px", border: "1px solid #EDEDED", position: "relative", }}
                                      className="checkOutMobileElement"
                                    >
                                      <CardCvcElement
                                        options={CARD_OPTIONS1}
                                        onChange={handleCardChange}
                                      />
                                      <div
                                        title="What is CVV?"
                                        onClick={handleCVVInfo}
                                        style={{
                                          position: "absolute",
                                          top: "50%",           // vertically center
                                          right: "15px",        // distance from right edge
                                          transform: "translateY(-50%)", // align vertical center correctly
                                          height: "22px",
                                          width: "22px",
                                          backgroundColor: "#f5f5f5",
                                          border: "1px solid #ccc",
                                          borderRadius: "50%",
                                          fontSize: "14px",
                                          fontWeight: "bold",
                                          color: "#000",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          cursor: "pointer",
                                          zIndex: 2,
                                        }}
                                      >
                                        ?
                                      </div>
                                    </div>

                                  </Col>



                                  <Form.Label
                                    style={{
                                      color: "red",
                                    }}
                                  >
                                    {cardErrorMessage}
                                  </Form.Label>
                                  {isLoggedIn !== "false" ? (
                                    <>
                                      <div className="p-2">
                                        <Col xxl={12}>
                                          <Form.Check
                                            label=" Securely save this card future order"
                                            name="form-check"
                                            type="checkbox"
                                            id="form-check"
                                            className="checkOutMobile-form-check-label"
                                            onClick={() =>
                                              handleSaveCardCheckboxClick()
                                            }
                                          />
                                        </Col>
                                      </div>
                                    </>
                                  ) : null}
                                </Row>
                              </Form>
                              <OrderButton walletamount={walletamount} finalTotalValue={finalTotalValue} />
                            </div> */}
                          </Modal.Body>
                        </Modal>

                        <Modal
                          show={showCVVInfo}
                          // fullscreen={fullscreen}
                          onHide={() => setShowCVVInfo(false)}
                          id="checkoutcustomModal"
                          className={theme === "dark" ? "dark-popup" : null}
                          fade
                          // dialogClassName="bottom-modal"
                        >
                          <div
                            style={{ borderRadius: "12px", padding: "20px" }}
                          >
                            <div className="d-flex justify-content-between align-items-center">
                              <h5 className="whatcvvtext">What is CVV?</h5>
                              <img
                                src={closeiconnew}
                                alt="closeicon"
                                className="closeiconnew"
                                onClick={handleCVVclose}
                              />
                            </div>

                            <div className="text-center my-3">
                              <img
                                src={Cvvbgimage}
                                alt="CVV example"
                                style={{
                                  width: "100%",
                                  maxWidth: "260px",
                                  height: "100%",
                                }}
                              />
                            </div>

                            <p
                              style={{
                                fontSize: "14px",
                                textAlign: "left",
                                marginBottom: "0",
                                fontFamily: "Geist-Regular",
                              }}
                            >
                              The CVV number is the last three digits on the
                              back of your card
                            </p>
                          </div>
                        </Modal>

                        {appledeviceInfo === 1 ? (
                          <li
                            className={`list-group-item ${
                              selectedValue == "apple-pay" ? "active" : ""
                            }`}
                            value={"apple-pay"}
                            onClick={() =>
                              handlePaymentSelection(7, "apple-pay")
                            }
                          >
                            <div className="checkoutpayUI">
                              <div className="checkoutpayUIchild">
                                <div className="checkoutpaynewdiv">
                                  <img
                                    src={
                                      theme === "dark"
                                        ? applepaydark
                                        : applepays
                                    }
                                    alt="applepayicon"
                                  />

                                  <h5>Pay</h5>
                                </div>
                                <label>
                                  <input
                                    type="radio"
                                    id="payment"
                                    checked={
                                      selectedValue == "apple-pay"
                                        ? true
                                        : false
                                    }
                                    onChange={() =>
                                      handlePaymentSelection(7, "apple-pay")
                                    }
                                  />
                                </label>
                              </div>
                            </div>
                          </li>
                        ) : null}
                        {cashtype ? (
                          <li
                            className="list-group-item"
                            value={"cashimg"}
                            onClick={() => handlePaymentSelection(0, "cashimg")}
                          >
                            <div className="checkoutpayUI">
                              <div className="checkoutpayUIchild">
                                <div className="checkoutpaynewdiv">
                                  <img
                                    src={Cashimgicondesktop}
                                    alt="cashimgicon"
                                    style={{ height: "30px" }}
                                  />

                                  <h5>Cash Pay</h5>
                                </div>
                                <label>
                                  <input
                                    type="radio"
                                    id="payment"
                                    checked={
                                      selectedValue == "cashimg" ? true : false
                                    }
                                    onChange={() =>
                                      handlePaymentSelection(0, "cashimg")
                                    }
                                  />
                                </label>
                              </div>
                            </div>
                          </li>
                        ) : null}
                        {gpaydeviceInfo === 1 ? (
                          <li
                            className={`list-group-item ${
                              selectedValue == "google-pay" ? "active" : ""
                            }`}
                            value={"google-pay"}
                            onClick={() =>
                              handlePaymentSelection(8, "google-pay")
                            }
                          >
                            <div className="checkoutpayUI">
                              <div className="checkoutpayUIchild">
                                <div className="checkoutpaynewdiv">
                                  <img
                                    src={Gpay}
                                    alt="google-pay"
                                    className="payment-logo"
                                    onClick={() =>
                                      handlePaymentSelection(8, "google-pay")
                                    }
                                  />
                                  <h5
                                    onClick={() =>
                                      handlePaymentSelection(8, "google-pay")
                                    }
                                  >
                                    Google Pay
                                  </h5>
                                </div>
                                <label>
                                  <input
                                    type="radio"
                                    id="payment"
                                    checked={
                                      selectedValue == "google-pay"
                                        ? true
                                        : false
                                    }
                                    onChange={() =>
                                      handlePaymentSelection(8, "google-pay")
                                    }
                                  />
                                </label>
                              </div>
                            </div>
                          </li>
                        ) : null}
                        {klarnaType && (
                          <li
                            className={`list-group-item ${
                              selectedValue == "klarna" ? "active" : ""
                            }`}
                            value={"klarna"}
                            onClick={() => handlePaymentSelection(10, "klarna")}
                          >
                            <div className="checkoutpayUI">
                              <div className="checkoutpayUIchild">
                                <div className="checkoutpaynewdiv">
                                  <img
                                    src={klarnapay}
                                    alt="klarnapay"
                                    className="payment-logo"
                                    onClick={() =>
                                      handlePaymentSelection(10, "klarna")
                                    }
                                  />
                                  <h5
                                    onClick={() =>
                                      handlePaymentSelection(10, "klarna")
                                    }
                                  >
                                    klarna
                                  </h5>
                                </div>
                                <label>
                                  <input
                                    type="radio"
                                    id="payment"
                                    checked={
                                      selectedValue == "klarna" ? true : false
                                    }
                                    onClick={() =>
                                      handlePaymentSelection(10, "klarna")
                                    }
                                  />
                                </label>
                              </div>
                            </div>
                          </li>
                        )}
                        {paypalType && (
                          <li
                            className={`list-group-item ${
                              selectedValue == "paypal" ? "active" : ""
                            }`}
                            value={"cashimg"}
                            onClick={() => handlePaymentSelection(14, "paypal")}
                          >
                            <div className="checkoutpayUI">
                              <div className="checkoutpayUIchild">
                                <div className="checkoutpaynewdiv">
                                  <img src={PayPal} alt="paypalnew" />
                                  <h5
                                    onClick={() =>
                                      handlePaymentSelection(14, "paypal")
                                    }
                                  >
                                    Paypal
                                  </h5>
                                </div>
                                <label>
                                  <input
                                    type="radio"
                                    id="payment"
                                    checked={
                                      selectedValue == "paypal" ? true : false
                                    }
                                    onClick={() =>
                                      handlePaymentSelection(14, "paypal")
                                    }
                                  />
                                </label>
                              </div>
                            </div>
                          </li>
                        )}
                        {!extraPayment && (
                          <>
                            <li
                              className={`list-group-item ${
                                selectedValue == "wallet" ? "active" : ""
                              }`}
                              value={"wallet"}
                              onClick={() => {
                                handlePaymentSelection(9, "wallet");
                              }}
                            >
                              <div className="checkoutpayUI">
                                <div className="checkoutpayUIchild">
                                  <div className="checkoutpaynewdiv">
                                    <img
                                      src={
                                        theme === "dark"
                                          ? CardIconDark
                                          : CardIcon
                                      }
                                      alt="cardicondark"
                                    />
                                    <h5
                                      className="mobile-wallet-disabled"
                                      style={{ fontSize: "16px" }}
                                    >
                                      Wallet
                                    </h5>
                                  </div>
                                  <label>
                                    <input
                                      type="radio"
                                      id="payment"
                                      checked={
                                        selectedValue == "wallet" ? true : false
                                      }
                                      onChange={() => {
                                        handlePaymentSelection(9, "wallet");
                                      }}
                                    />
                                  </label>
                                </div>
                              </div>
                            </li>
                          </>
                        )}
                      </ul>
                    </div>
                  </Modal.Body>
                </Modal>

                {/* <Modal
                    show={showchildpopup}
                    fullscreen={fullscreen}
                    onHide={() => setPaymentModalShow(false)}
                    id="checkoutcustomModalchild"
                    className={theme === "dark" ? "dark-popup" : null}
                  >
                    {" "}
                    <IoCloseSharp className="closeicon" onClick={handleClosechild} />
                    <Modal.Header>
                      <Modal.Title>Add credit / debit card </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="d-flex align-items-center justify-content-center flex-column vh-75 checkOutMobile">
                        <Form className="form-label mb-3">
                          <Row>
                            <Col xxl={6} xl={6} style={{ padding: "10px" }}>
                              <Form.Label>Card Number</Form.Label>
                              <div style={containerStyle}>
                                <CardNumberElement
                                  options={CARD_OPTIONS1}
                                  className="custom-card-element"
                                  style={{ height: "300px" }}
                                  onChange={handleCardChange}
                                />
                              </div>
                            </Col>
                            <Col xxl={3} sm={6} xs={6} xl={3}>
                              <Form.Label>Expires on</Form.Label>
                              <div style={containerStyle}>
                                <CardExpiryElement
                                  options={CARD_OPTIONS1}
                                  onChange={handleCardChange}
                                />
                              </div>
                            </Col>
                            <Col xxl={3} sm={6} xs={6} xl={3}>
                              <Form.Label>Security Code</Form.Label>
                              {savecardPay == 0 && (
                                <div style={containerStyle}>
                                  <CardCvcElement
                                    options={CARD_OPTIONS1}
                                    onChange={handleCardChange}
                                  />
                                </div>
                              )}
                            </Col>
                            {isLoggedIn !== "false" ? (
                              <>
                                <div className="p-2">
                                  <Col xxl={12}>
                                    <Form.Check
                                      label=" Securely save this card future order"
                                      name="form-check"
                                      type="checkbox"
                                      id="form-check"
                                      onClick={() => handleSaveCardCheckboxClick()}
                                    />
                                  </Col>
                                </div>
                              </>
                            ) : null}
                          </Row>
                        </Form>
                        <OrderButton />
                      </div>
                    </Modal.Body>
                  </Modal> */}
              </div>
            </div>
          </Card.Body>
        </Card>
        <Modal
          show={showSecureModal}
          id="checkoutcustomModal"
          dialogClassName="bottom-modal"
          centered
          className="secure-modal"
        >
          <div className="secure-payment-content">
            <div className="secure-header">
              <h5>100% Safe and Secure payments</h5>
              <img
                src={closeiconnew}
                alt="closeicon"
                className="closeiconnew"
                onClick={handleSecureClose}
              />
            </div>

            <div className="secure-body">
              <img
                src={Secureimgone}
                alt="secure shield"
                className="shield-icon"
              />

              <p>
                We use Stripe for secure payment processing in Stripe is a
                certified PCI DSS Level 1 Service Provider — the highest level
                of certification in the payments industry. All transactions are
                encrypted using industry-standard SSL encryption. Your payment
                information is processed securely and is never stored on our
                servers. For more information, please refer to our Privacy
                Policy.
              </p>

              <div className="secure-badges">
                <img src={Secureimgtwo} alt="PCI DSS" />
                <img src={Secureimgthree} alt="SSL 256 Bit" />
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};
const Vouchermobile = () => {
  const { getOrderMode, getOrderTime } = OrderFlow();
  const {
    deliveryCharge,
    bagCharge,
    clientFkCharge,
    setFinalTotal,
    currency_symbol,
  } = CheckoutData();
  const {
    getorderType,
    stripepayment,
    stripe,
    elements,
    setPayType,
    paymentSva,
    setPaymentSva,
    paymentMId,
    setPaymentMId,
    setPaymentIntentId,
    setPaymentType,
    setPaySubmit,
    paySubmit,
    clientSecret,
    setClientSecret,
    payPalClientSecret,
    svclientSecret,
    setSvpaySubmit,
    svpaySubmit,
    walletstatus,
    setWalletstatus,
    walletamount,
    setWalletamount,
    setCardErrorMessage,
    cardErrorMessage,
    finalTotalValue,
    selectedValue,
    setSelectedValue,
    paymentOptions,
    cardtype,
    setCardtype,
    setPaypalType,
    paypalType,
    setApplepaytype,
    setGooglepaytype,
    klarnaType,
    setKlarnaType,
    setFooterBtn,
    sectionRef,
    buttonstatus,
    setButtonstatus,
    setPaymentModalShow,
    paymentModalShow,
    gpaydeviceInfo,
    appledeviceInfo,
    setPaySaveCard,
    handlesavecardPayment,
    CARD_OPTIONS1,
    containerStyle,
    setSaveCardError,
    setCardStatus,
    paySpinner,
    cashtype,
    setCashtype,
    setExtraLessAmount,
    extraPayment,
    setExtraPayment,
    setExtraPayStatus,
    setUseWalletBalance,
    setFinalTotalValue,
    clientName,
    clientLogo,
    itemAvailableData,
    useWalletBalance,
    polling,
  } = useContext(CheckoutContext);
  const [showModalPromo, setShowModalPromo] = useState(false);
  const [voucherValue, setVoucherValue] = useState("");
  const [voucherApplied, setVoucherApplied] = useState(false);
  const [validDiscount, setValidDiscount] = useState(true);
  const [voucherMinimum, setVoucherMinimum] = useState(false);
  const [voucherLogin, setVoucherLogin] = useState(false);
  const [voucherUsed, setVoucherUsed] = useState(false);
  const [voucherLoad, setVoucherLoad] = useState(false);
  const [customer, setCustomer] = useState("");
  const [parsedDiscount, setParsedDiscount] = useState("");
  const [cartItemsData, setcartItems] = useState([]);
  const orderTime = getOrderTime;
  const [appliedDiscount, setAppliedDiscount] = useState(0);

  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const loginAddress = localStorage.getItem("loginAddress") || "";
  const guestAddress = localStorage.getItem("guestAddress") || "";
  const path = localStorage.getItem("clientPath");
  const domain = window.location.origin;

  const subTotal = localStorage.getItem("totalPrice");
  const roundedValue = localStorage.getItem("roundOffPrice");
  const driverTipValue = localStorage.getItem("driverTipValue")
    ? localStorage.getItem("driverTipValue")
    : "0";

  const discountJSON = localStorage.getItem("discount");
  const SummaryOrderType = getOrderMode === "Collection" ? 1 : 0;

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (userData !== null && isLoggedIn === "true") {
      setCustomer(userData);
    } else {
      setCustomer("");
    }
  }, [isLoggedIn]);

  useEffect(() => {
    const discount = discountJSON ? JSON.parse(discountJSON) : "";
    setParsedDiscount(discount);
    let finalTotalValue =
      parseFloat(subTotal) +
      parseFloat(deliveryCharge) +
      parseFloat(bagCharge) +
      parseFloat(clientFkCharge) +
      parseFloat(driverTipValue);

    if (
      parsedDiscount !== "" &&
      (parsedDiscount?.orderType === SummaryOrderType ||
        parsedDiscount?.orderType === "2")
    ) {
      if (discount?.appliedDiscount) {
        finalTotalValue -= parseFloat(discount.appliedDiscount);
      }
    }

    if (discount?.source == "voucherDiscount") {
      setVoucherValue(discount?.discount || "");
    }
    if (discount?.source == "SubscriptionCoupon") {
      setVoucherValue(discount?.discount || "");
      setVoucherApplied(true);
    }
    setAppliedDiscount(discount?.appliedDiscount || 0);
    localStorage.setItem("finalTotal", finalTotalValue.toFixed(2));
    setFinalTotal(finalTotalValue.toFixed(2));
    setFinalTotalValue(
      (parseFloat(finalTotalValue) + parseFloat(roundedValue)).toFixed(2)
    );
    localStorage.setItem(
      "finalTotalValue",
      (parseFloat(finalTotalValue) + parseFloat(roundedValue)).toFixed(2)
    );
  }, [
    subTotal,
    parsedDiscount,
    deliveryCharge,
    bagCharge,
    clientFkCharge,
    driverTipValue,
    roundedValue,
    discountJSON,
    useWalletBalance,
    polling,
  ]);

  useEffect(() => {
    let localStorageData =
      localStorage.getItem("cart") &&
      localStorage.getItem("cart") !== "undefined"
        ? JSON.parse(localStorage.getItem("cart"))
        : [];

    setcartItems(localStorageData);
  }, [localStorage.getItem("cart")]);

  const voucherData = useMemo(() => {
    const orderTime = localStorage.getItem("orderTime") || "";
    let dateParts = "";
    let timePart = "";
    let formattedDate = "";
    if (orderTime) {
      let inputDate = orderTime;
      if (inputDate.includes("/")) {
        dateParts = inputDate.split(" ")[0].split("/"); // Split the date into parts
        timePart = inputDate.split(" ")[1]; // Get the time part
        // Create a Date object with the parts
        const dateObject = new Date(
          `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}T${timePart}`
        );
        // Format the date in the desired format
        const year = dateObject.getFullYear();
        const month = String(dateObject.getMonth() + 1).padStart(2, "0");
        const day = String(dateObject.getDate()).padStart(2, "0");
        const hour = String(dateObject.getHours()).padStart(2, "0");
        const minute = String(dateObject.getMinutes()).padStart(2, "0");
        formattedDate = `${year}-${month}-${day} ${hour}:${minute}`;
      } else {
        formattedDate = orderTime;
      }
    }
    return {
      customerId: customer.customerId,
      clientPath: path,
      orderTime: formattedDate,
      voucherCode: voucherValue || "",
    };
  }, [path, orderTime, customer, voucherValue]);

  const checkVoucher = () => {
    if (voucherValue == "") {
      setValidDiscount(false);
    }
    const SubscriptionCouponCode1 = localStorage.getItem("SubcripeCoupon");

    const SubscriptionCouponCode =
      SubscriptionCouponCode1 !== null &&
      SubscriptionCouponCode1 !== "undefined"
        ? JSON.parse(SubscriptionCouponCode1)
        : "";

    setVoucherLoad(true);
    if (
      SubscriptionCouponCode != "" &&
      typeof SubscriptionCouponCode !== "undefined"
    ) {
      console.log(voucherData);
      if (voucherValue === SubscriptionCouponCode.code) {
        const isCouponApplied = applySubcriptionCouponCode(
          SubscriptionCouponCode,
          getOrderMode
        );

        if (isCouponApplied) {
          setValidDiscount(true);
          setVoucherApplied(true);
          setVoucherLoad(false);
        }
      } else {
        setValidDiscount(false);
        setVoucherLoad(false);
      }
    } else {
      checkVoucherCode(voucherData)
        .then((response) => {
          if (!response.status) {
            if (response.message == "voucher code was already Used") {
              setVoucherUsed(true);
              setValidDiscount(false);
            } else if (response.message == "Invalid code") {
              setValidDiscount(false);
            } else if (response.message == "voucher not available") {
              setValidDiscount(false);
            } else if (response.message == "CustomerId is required") {
              setVoucherLogin(true);
              setValidDiscount(false);
            }
            setVoucherApplied(false);
            setVoucherLoad(false);
            console.log("vocuherRespose");
            console.log(response.message);
            return;
          }
          const storedCart = localStorage.getItem("cart");
          const localStorageCart = JSON.parse(storedCart) || [];
          const filteredItems = localStorageCart.filter(
            (cart) => cart.itemAllowCoupon === 1
          );
          const totalValue = filteredItems.reduce(
            (sum, item) => sum + parseFloat(item.price),
            0
          );
          if (
            parseFloat(totalValue) >= parseFloat(response.message.minAmount)
          ) {
            const voucher = {
              code: response.message.code,
              discount: response.message.discount,
              description: response.message.description,
              discountType: response.message.type,
              minOrder: response.message.minAmount,
            };
            applyVoucher(voucher, getOrderMode);
            setValidDiscount(true);
            setVoucherApplied(true);
            setVoucherLoad(false);
          } else {
            setVoucherMinimum(true);
            setVoucherLoad(false);
            setValidDiscount(false);
          }
        })
        .catch((error) => {
          setVoucherLoad(false);
          console.log(error);
        });
    }
  };

  const handleOpenModal = () => setShowModalPromo(true);
  const handleCloseModal = () => setShowModalPromo(false);

  const handleKeyChange = () => {
    setVoucherUsed(false);
    setVoucherLogin(false);
    setVoucherMinimum(false);
    setValidDiscount(true);
    setVoucherApplied(false);
  };
  return (
    <>
      <div
        className="d-block d-sm-none  voucher-code-full"
        style={{ marginTop: getorderType === "ASAP" ? "15px" : "0" }}
      >
        <h5 className="vocuher-htag">Vouchers & discounts </h5>
        <div className="voucher-code-container" onClick={handleOpenModal}>
          <div className="voucher-code-left">
            <img
              src={Voucherimg} // example icon
              alt="voucher"
              className="voucher-icon"
            />
            {/* <BiSolidDiscount className="voucher-icon" /> */}
            <span className="voucher-label">Add voucher discounts</span>
          </div>
          {/* <RiArrowRightSLine className="voucher-arrow" /> */}
          <PiPlusCircle className="voucher-arrow" />
          {/* <img src={EditadressPlus} alt="itemplus"  /> */}
        </div>
      </div>

      {showModalPromo && (
        <div className="custom-modal-overlay">
          <div className="custom-modal-content">
            <h2 className="voucher-modal-title">
              Voucher{" "}
              <img
                src={closeiconnew}
                alt="closeicon"
                className="closeiconnew"
                onClick={handleCloseModal}
              />
            </h2>
            <div className="voucher-modal-bodycontent">
              <form>
                <p className="voucher-modal-subtitle">Add your voucher</p>
                <Form.Control
                  type="text"
                  value={voucherValue}
                  onChange={(e) => setVoucherValue(e.target.value)}
                  onKeyDown={handleKeyChange}
                  isInvalid={!validDiscount}
                  data-fus="fus-test-vouchercodeinput"
                  placeholder="Voucher code"
                  className="voucher-input"
                />

                <button
                  className="voucher-apply-btn"
                  type="button"
                  onClick={checkVoucher}
                >
                  {voucherLoad ? (
                    <Spinner animation="border" size="sm" variant="primary" />
                  ) : voucherApplied ? (
                    "Applied"
                  ) : (
                    "Apply"
                  )}
                </button>
              </form>
              {voucherUsed && (
                <p className="error-code" style={{ color: "red" }}>
                  Sorry Voucher already redeemed
                </p>
              )}
              {voucherLogin && (
                <p className="error-code" style={{ color: "red" }}>
                  Please log in to redeem this voucher
                </p>
              )}
              {voucherMinimum && (
                <p className="error-code" style={{ color: "red" }}>
                  Need to added more item
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
//end payment method
function Loader() {
  return (
    <div className="loading">
      <Spinner animation="border" size="lg" variant="success" />
      <p>
        Please Wait while your Payment is being verified. you will be redirected
        automatically.
      </p>
    </div>
  );
}
//tips
const AddTip = () => {
  const TipsList = [
    {
      Label: "0%",
    },
    {
      Label: "5%",
    },
    {
      Label: "10%",
    },
    {
      Label: "15%",
    },
  ];
  const [selectedTip, setSelectedTip] = useState("0%");
  const [customTipAmount, setCustomTipAmount] = useState("");
  const [showCustomTip, setShowCustomTip] = useState(false);
  const { setDriverTip, subTotal } = useContext(CheckoutContext);
  const { theme } = useContext(ThemeContext);

  const setTipValue = (tipValue, setDriverTip) => {
    localStorage.setItem("driverTipValue", tipValue.toFixed(2));
    setDriverTip(tipValue.toFixed(2));
  };

  useEffect(() => {
    if (showCustomTip) {
      const customTipValue = parseFloat(customTipAmount) || 0;
      setTipValue(customTipValue, setDriverTip);
    } else {
      const tipPercentage = parseFloat(selectedTip) || 0;
      const tipValue = subTotal * (tipPercentage / 100) || 0;
      setTipValue(tipValue, setDriverTip);
    }
  }, [selectedTip, showCustomTip, customTipAmount, subTotal, setDriverTip]);

  const handleTipChange = (e) => {
    setSelectedTip(e.target.value);
  };

  const toggleCustomTip = () => {
    setShowCustomTip(!showCustomTip);
  };

  return (
    <>
      <div>
        <Card className="requestCard">
          <Card.Body className="requestBody">
            <Card.Title className="requestTitle">
              Tip your courier ? {""}
              {/* <img src={theme === "dark" ? PrivacyWhite : Privacy} alt="privacy" /> */}
            </Card.Title>
            <Card.Text className="tip-text">
              {" "}
              {/* <img src={theme === "dark" ? OkWhite : OK} alt="whiteokay" />{" "} */}
              <p className="tip-subtext">
                It’s optional but a tip can brighten your courier’s day
              </p>
            </Card.Text>
            <div className="request-detail">
              <form className="tips-form">
                {!showCustomTip ? (
                  <>
                    {TipsList.map((Tips, index) => (
                      <label
                        key={index}
                        className={selectedTip === Tips.Label && "active"}
                      >
                        <span>{Tips.Label}</span>
                        <input
                          type="radio"
                          value={Tips.Label}
                          name="tips"
                          checked={selectedTip === Tips.Label}
                          onChange={handleTipChange}
                        />
                      </label>
                    ))}
                  </>
                ) : (
                  <>
                    <label className="tip-label">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Your Tip"
                        value={customTipAmount}
                        onChange={(e) => setCustomTipAmount(e.target.value)}
                      />
                    </label>
                  </>
                )}
                <label className="label-btn" onClick={toggleCustomTip}>
                  {showCustomTip ? "Cancel" : "Others"}
                </label>
              </form>
            </div>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};
//Donate
const DonateChange = () => {
  const { setRoundedValue, driverTip, finalTotal } =
    useContext(CheckoutContext);

  const checkRoundEnable =
    JSON.parse(localStorage.getItem("checkRoundEnable")) || false;
  const [roundOff, setRoundOff] = useState(checkRoundEnable);
  const [checkFirstTime, setCheckFirstTime] = useState(true);
  const width = window.innerwidth;
  const roundOffTotal = () => {
    const newRoundOff = !roundOff; // Toggle roundOff
    setRoundOff(newRoundOff);
  };

  useEffect(() => {
    const calculateRoundedValue = () => {
      const roundedValue = (Math.ceil(finalTotal) - finalTotal).toFixed(2);
      setRoundedValue(roundedValue);
      localStorage.setItem("roundOffPrice", roundedValue);
      localStorage.setItem("checkRoundEnable", true);
    };

    if (checkFirstTime) {
      calculateRoundedValue();
      setRoundOff(false);
      setCheckFirstTime(false);
    } else if (roundOff) {
      calculateRoundedValue();
    } else {
      localStorage.setItem("roundOffPrice", "0");
      localStorage.setItem("checkRoundEnable", false);
      setRoundedValue("0");
    }
  }, [checkFirstTime, driverTip, roundOff, finalTotal]);

  return (
    <>
      <div>
        <Card className="requestCard">
          <Card.Body className="requestBody">
            <Card.Title className="requestTitle">Donate the change</Card.Title>
            <div className="request-detail">
              <div className="donate-change">
                <div className="content">
                  <Form.Check
                    label=" You’re opted in to round up and donate to fusion kitchen fund. By
              checking this box you agree to the donate the change"
                    name="Donate"
                    type="checkbox"
                    id="Donate"
                    checked={roundOff}
                    onClick={roundOffTotal}
                    data-fus="fus-test-checkoutdonecheckbox"
                  />
                </div>
                {width > 767 ? (
                  <Link to="/myaccount/wallet-tc">Learn more</Link>
                ) : (
                  <Link to="/wallet-tc">Learn more</Link>
                )}
              </div>
            </div>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};
//orderButton
const OrderButton = (params) => {
  const dispatch = useDispatch();
  //status selector
  const placeOrder_status = useSelector(
    (state) => state.placeorderStatusReducer?.placeorder
  );
  const [status, setStatus] = useState(false);
  useEffect(() => {
    setStatus(placeOrder_status);
  }, [placeOrder_status]);

  const {
    stripe,
    elements,
    setPaymentMId,
    preOrderTimeTable,
    setPayType,
    setPaySubmit,
    paymentType,
    paySubmit,
    walletstatus,
    setCardErrorMessage,
    setPaymentSuccessShow,
    setFaildShow,
    buttonstatus,
    setButtonstatus,
    placeorder,
    payType,
    setCardStatus,
    setPaymentIntentId,
    setEstimateShow,
    setMinOrderStatus,
    minOrderStatus,
    setMinOrderMessage,
    extraStatus,
    setExtraStatus,
    setUseWalletBalance,
    extraPayment,
    selectedValue,
    walletamount,
  } = useContext(CheckoutContext);

  const { getOrderMode } = OrderFlow();
  //scroll down card section
  const elementScrollCard = document.querySelector(".add-card-form");
  const orderMinOrder_Check = localStorage.getItem("orderMinOrder")
    ? JSON.parse(localStorage.getItem("orderMinOrder"))
    : "";
  const TotalPriceValue = localStorage.getItem("totalPrice")
    ? localStorage.getItem("totalPrice")
    : 0;
  const deliverRadious = localStorage.getItem("deliverRadiousAmount") || "";
  const [waiting, setWaiting] = useState(true);
  if (getOrderMode == "Delivery") {
    if (orderMinOrder_Check) {
      if (
        parseFloat(TotalPriceValue) <
        parseFloat(orderMinOrder_Check.deliveryMinOrder)
      ) {
        setMinOrderStatus(true);
        let difference = orderMinOrder_Check.deliveryMinOrder - TotalPriceValue;
        let roundedDifference = difference.toFixed(2);
        const minMsg = `Need More £${roundedDifference} for delivery`;
        setMinOrderMessage(minMsg);
      } else if (parseFloat(TotalPriceValue) < parseFloat(deliverRadious)) {
        setMinOrderStatus(true);
        let difference = deliverRadious - TotalPriceValue;
        let roundedDifference = difference.toFixed(2);
        const minMsg = `Need More £${roundedDifference} for delivery`;
        setMinOrderMessage(minMsg);
      } else {
        setMinOrderStatus(false);
      }
    }
  } else {
    if (orderMinOrder_Check) {
      if (
        parseFloat(TotalPriceValue) <
        parseFloat(orderMinOrder_Check.collectionMinOrder)
      ) {
        let difference =
          orderMinOrder_Check.collectionMinOrder - TotalPriceValue;
        let roundedDifference = difference.toFixed(2);
        const minMsg = `Just £${roundedDifference} away from enjoying pickup`;
        setMinOrderMessage(minMsg);
        setMinOrderStatus(true);
      } else {
        setMinOrderStatus(false);
      }
    }
  }
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const loginAddress = localStorage.getItem("loginAddress") || "";
  const guestAddress = localStorage.getItem("guestAddress") || "";
  const { setAddressPopupshow } = useContext(CheckoutContext);

  const parseDateString = (dateTimeString) => {
    if (dateTimeString && dateTimeString != 0) {
      const [date, time] = dateTimeString.split(" ");
      let day, month, year;
      if (date.includes("/")) {
        [day, month, year] = date.split("/");
      } else if (date.includes("-")) {
        [year, month, day] = date.split("-");
      }
      const [hour, minute] = time.split(":");
      return new Date(year, month - 1, day, hour, minute);
    } else {
      return 0;
    }
  };
  // const date3 = parseDateString(localStorage.getItem("preOrder"));
  // console.log('fffffffffff', moment(date3).format("YYYY-MM-DD"));

  const checkOrderTime = () => {
    const preorderTime = localStorage.getItem("preOrder");
    const orderType = localStorage.getItem("orderType");
    const preorder = preorderTime || "";
    const TimeTable =
      getOrderMode === "Delivery"
        ? preOrderTimeTable?.Delivery
        : preOrderTimeTable?.Collection;
    if (preorder && preorder !== "0") {
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const currentTime = new Date().toLocaleString("en", {
        timeZone: userTimezone,
        hour12: false,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
      const [datePart, timePart] = currentTime.split(", ");
      const [month, day, year] = datePart.split("/");
      const [hour, minute] = timePart.split(":");
      const formattedDay = day.padStart(2, "0");
      const formattedMonth = month.padStart(2, "0");
      const formattedHours = parseInt(hour, 10);
      const formattedMinutes = parseInt(minute, 10);
      const formattedTime = `${formattedHours
        .toString()
        .padStart(2, "0")}:${formattedMinutes.toString().padStart(2, "0")}`;
      const changedDate = `${formattedDay}/${formattedMonth}/${year}`;
      const date1 = parseDateString(changedDate + " " + formattedTime);
      const date2 = parseDateString(localStorage.getItem("orderTime"));
      const date3 = parseDateString(localStorage.getItem("preOrder"));
      const todayAvailable =
        TimeTable?.today == "" && orderType == "ASAP" ? true : false;
      const checkTodayOrder =
        orderType == "Today"
          ? moment(date1).format("YYYY-MM-DD") <
              moment(date2).format("YYYY-MM-DD") ||
            moment(date1).format("YYYY-MM-DD") <
              moment(date3).format("YYYY-MM-DD")
          : false;
      const checkTodayOrder2 =
        orderType == "Today" && TimeTable?.today == "" ? true : false;
      const checkAsap =
        orderType == "ASAP" ? date1 < date2 || date1 < date3 : false;
      const checkLaterOrder =
        orderType == "Later"
          ? moment(date1).format("YYYY-MM-DD") >=
              moment(date2).format("YYYY-MM-DD") ||
            moment(date1).format("YYYY-MM-DD") >=
              moment(date3).format("YYYY-MM-DD")
            ? true
            : false
          : false;
      const checkLaterOrder2 =
        (orderType == "Later" &&
          TimeTable?.later[moment(date2).format("YYYY-MM-DD")] == "") ||
        TimeTable?.later[moment(date3).format("YYYY-MM-DD")] == ""
          ? true
          : false;

      if (
        date1 > date2 ||
        date1 > date3 ||
        checkLaterOrder2 ||
        todayAvailable ||
        checkTodayOrder2 ||
        checkAsap ||
        checkTodayOrder ||
        checkLaterOrder
      ) {
        return true;
      }
    }
  };

  //scroll down
  const cardErrScroll = () => {
    if (elementScrollCard) {
      elementScrollCard.scrollIntoView({
        behavior: "smooth", // For smooth scrolling
        block: "start", // Aligns the element at the top of the viewport
      });
    } else {
      console.error('elementScrollCard with class "add-card-form" not found.');
    }
  };

  const PlacewalletOrder = async (event) => {
    event.preventDefault();
    const checkTime = checkOrderTime();
    if (checkTime) {
      setEstimateShow(true);
    } else {
      setButtonstatus(true);
      setWaiting(true);
      setPaySubmit(9);
    }
    localStorage.setItem("payType", "wallet");
  };

  const PlaceCashOrder = async (event) => {
    event.preventDefault();
    const checkTime = checkOrderTime();
    if (checkTime) {
      setEstimateShow(true);
    } else {
      setButtonstatus(true);
      setWaiting(true);
      setPaySubmit(1);
    }
    localStorage.setItem("payType", "cash");
  };
  useEffect(() => {
    if (
      placeorder?.response_code === 400 &&
      !placeorder.status &&
      payType !== "saveCardPaymentIntent"
    ) {
      setPaymentSuccessShow(false);
      setCardErrorMessage(placeorder.message);
      setFaildShow(true);
      setButtonstatus(false);
      setCardStatus(false);
    }
  }, [placeorder]);

  const HandleClick = async (event) => {
    let addressData = null;

    if (isLoggedIn === "true") {
      addressData = loginAddress;
    } else {
      addressData = guestAddress;
    }

    const checkTime = checkOrderTime();
    if (checkTime) {
      setEstimateShow(true);
    } else if (!addressData) {
      setAddressPopupshow(true);
    } else {
      setButtonstatus(true);
      dispatch(PlaceCardStatus(true));
      event.preventDefault();

      if (!stripe || !elements) {
        return;
      }
      const cardNumberElement = elements?.getElement(CardNumberElement);
      const cardExpiryElement = elements?.getElement(CardExpiryElement);
      const cardCvcElement = elements?.getElement(CardCvcElement);
      if (!cardNumberElement || !cardExpiryElement || !cardCvcElement) {
        console.error("Stripe elements are not found");
        setCardErrorMessage("Stripe elements are missing. Please try again.");
        cardErrScroll();
        setCardStatus(false);
        setFaildShow(true);
        setButtonstatus(false);
        return;
      }
      if (!cardNumberElement || !cardExpiryElement || !cardCvcElement) {
        console.error("Stripe elements are not found");
        return;
      }
      if (!cardNumberElement || !cardExpiryElement || !cardCvcElement) {
        console.error("Stripe elements are not found");
        setCardErrorMessage("Stripe elements are missing. Please try again.");
        cardErrScroll();
        setCardStatus(false);
        setFaildShow(true);
        setButtonstatus(false);
        return;
      }
      if (!cardNumberElement || !cardExpiryElement || !cardCvcElement) {
        console.error("Stripe elements are not found");
        return;
      }
      try {
        const { error: stripeError, paymentMethod } =
          await stripe.createPaymentMethod({
            type: "card",
            card: elements?.getElement(CardNumberElement),
          });
        // Save payment status in storage before starting the process
        localStorage.setItem("paymentStatus", "processing");
        try {
          if (stripeError) {
            console.log(stripeError);
            setButtonstatus(false);
            setCardErrorMessage(stripeError.message);
            cardErrScroll();
            setFaildShow(true);
            setButtonstatus(false);
            dispatch(PlaceCardStatus(false));
            setCardStatus(false);
            localStorage.removeItem("paymentStatus");
            return;
          } else {
            dispatch(PlaceCardStatus(false));
            localStorage.setItem("paymentStatus", "processing");
          }

          setPaymentMId(paymentMethod.id);
          setWaiting(true);
          setPayType("paymentMethodId");
          setPaySubmit(1);
          localStorage.setItem("payType", "paymentMethodId");
        } catch (stripeError) {
          setCardErrorMessage(
            placeorder.message ? placeorder.message : stripeError.message
          );
          setCardStatus(false);
          setFaildShow(true);
          setButtonstatus(false); // Set the error message in state
          cardErrScroll();
          localStorage.removeItem("paymentStatus"); // Clear on error
        }
      } catch (error) {
        if (
          error.code === "payment_intent_authentication_failure" ||
          error.code === "rate_limit"
        ) {
          setCardErrorMessage(
            "Your card was declined due to authentication failure or rate limit. Please try again later."
          );
          setButtonstatus(false);
          setCardStatus(false);
          setButtonstatus(false);
          cardErrScroll();
        } else {
          setCardErrorMessage("An error occurred. Please try again.");
          setCardStatus(false);
          setButtonstatus(false);
          cardErrScroll();
        }
        setCardErrorMessage("An error occurred. Please try again");
        setCardStatus(false);
        setButtonstatus(false);
        cardErrScroll();
      }
    }
  };

  const placeKlarnaOrder = async (event) => {
    event.preventDefault();
    const checkTime = checkOrderTime();
    if (checkTime) {
      setEstimateShow(true);
    } else {
      setPayType("klarnaIntent");
      setPaySubmit(10);
      setWaiting(true);
      setButtonstatus(true);
      localStorage.setItem("isPaypalKlarna", 1);
    }
  };
  const PaypalHandleClick = async (event) => {
    event.preventDefault();
    const checkTime = checkOrderTime();
    if (checkTime) {
      setEstimateShow(true);
    } else {
      setPaySubmit(14);
      setButtonstatus(true);
      setWaiting(true);
      localStorage.setItem("isPaypalKlarna", 0);
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const klarnaPaymentIntent = urlParams.get("payment_intent");
    const redirectStatus = urlParams.get("redirect_status");
    console.log("klarnaPaymentIntent");
    console.log(klarnaPaymentIntent);
    const checkPaypalklarna = localStorage.getItem("isPaypalKlarna");
    console.log("checkPaypalklarna");
    console.log(checkPaypalklarna);
    if (redirectStatus === "succeeded") {
      if (checkPaypalklarna === "1") {
        setPaymentIntentId(klarnaPaymentIntent);
        setPayType("klarnaOrderPlaced");
        setPaySubmit(10);
      } else if (checkPaypalklarna === "0") {
        console.log(paySubmit);
        setPaymentIntentId(klarnaPaymentIntent);
        setPayType("PaypalIntent");
        setPaySubmit(14);
        console.log(paySubmit);
      }
    }
  }, []);

  useEffect(() => {
    console.log(minOrderStatus);
  }, [minOrderStatus]);
  const deliverRadious_Amount =
    localStorage.getItem("deliverRadiousAmount") || "";
  useEffect(() => {
    let MinimumAmount;
    if (getOrderMode === "Delivery") {
      const orderMinOrder_Check = localStorage.getItem("orderMinOrder")
        ? JSON.parse(localStorage.getItem("orderMinOrder"))
        : "";
      const TotalPriceValue = localStorage.getItem("totalPrice")
        ? localStorage.getItem("totalPrice")
        : 0;
      if (deliverRadious_Amount && deliverRadious_Amount !== null) {
        const max = Math.max(TotalPriceValue, deliverRadious_Amount);
        MinimumAmount = max;
      } else {
        const max1 = Math.max(
          TotalPriceValue,
          orderMinOrder_Check.deliveryMinOrder
        );
        MinimumAmount = max1;
      }

      if (parseFloat(TotalPriceValue) < parseFloat(MinimumAmount)) {
        setMinOrderStatus(true);
      }
    }
  }, [deliverRadious_Amount, getOrderMode]);
  const handleExtraAmount = (e) => {
    if (e.target.checked) {
      console.log("Checkbox is checked, extra amount applied");
      // setExtraAmountModal(true);
      // setPaymentType(1);
      setUseWalletBalance(true);
      setExtraStatus(true);
      // setWalletstatus(true);
    } else {
      setUseWalletBalance(false);
      setExtraStatus(false);
      // setExtraLessAmount(null);
      console.log("Checkbox is unchecked");
    }
  };


  const width = window.innerWidth;
  return (
    <>
      <PaymentFaild />
      {buttonstatus ? (
        <PaymentProcessingPopup
          setButtonstatus={setButtonstatus}
          show={waiting}
        />
      ) : (
        ""
      )}
      {!status ? (
        <>
          {extraPayment && width > 767 && (
            <>
              <div className="extraAmountDiv">
                {walletamount > 0 && (
                  <>
                    <input
                      type="checkbox"
                      value="extraAmount"
                      onChange={handleExtraAmount}
                      className="checkwallet"
                    />
                    <label
                      className="ml-2"
                      style={{
                        margin: "7px",
                        fontSize: "15px",
                        fontFamily: '"Geist-Regular", sans-serif',
                      }}
                      onChange={handleExtraAmount}
                    >
                      Pay £{walletamount} from wallet{" "}
                    </label>
                  </>
                )}
              </div>
            </>
          )}
          {paymentType == 1 ? (
            <>
              <Button
                variant="secondary"
                onClick={HandleClick}
                disabled={
                  ((buttonstatus || minOrderStatus) && extraStatus) ||
                  buttonstatus ||
                  minOrderStatus
                    ? true
                    : false
                }
                data-fus="fus-test-placeorderbtn"
              >
                {buttonstatus ? (
                  <Spinner animation="border" size="sm" variant="success" />
                ) : (
                  "Place " + getOrderMode + " order"
                )}
              </Button>
            </>
          ) : paymentType == 14 ? (
            <>
              <Button
                variant="secondary"
                onClick={PaypalHandleClick}
                disabled={buttonstatus || minOrderStatus ? true : false}
                data-fus="fus-test-placeorderpaypalbtn"
              >
                {buttonstatus ? (
                  <Spinner animation="border" size="sm" variant="success" />
                ) : (
                  "Place order with paypal"
                )}
              </Button>
            </>
          ) : paymentType == 9 && !extraPayment ? (
            <>
              <Button
                variant="secondary"
                onClick={PlacewalletOrder}
                disabled={walletstatus == 0}
                data-fus="fus-test-placeorderwalletbtn"
              >
                {buttonstatus || minOrderStatus ? (
                  <Spinner animation="border" size="sm" variant="success" />
                ) : (
                  "Place " + getOrderMode + " order"
                )}
              </Button>
            </>
          ) : paymentType == 0 ? (
            <>
              <Button
                variant="secondary"
                onClick={PlaceCashOrder}
                disabled={minOrderStatus ? true : false}
                data-fus="fus-test-placeordercashbtn"
              >
                {buttonstatus ? (
                  <Spinner animation="border" size="sm" variant="success" />
                ) : (
                  "Place " + getOrderMode + " order"
                )}
              </Button>
            </>
          ) : paymentType == 10 ? (
            <>
              <Button
                variant="secondary"
                onClick={placeKlarnaOrder}
                disabled={buttonstatus || minOrderStatus ? true : false}
                data-fus="fus-test-placeorderklarnabtn"
              >
                {buttonstatus ? (
                  <Spinner animation="border" size="sm" variant="success" />
                ) : (
                  "Place  klarna order"
                )}
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="secondary"
                onClick={HandleClick}
                disabled={minOrderStatus ? true : false}
                data-fus="fus-test-placeordertbtn"
              >
                Place {getOrderMode} order
              </Button>
            </>
          )}
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export const checkVoucherCode = async (formData) => {
  try {
    const response = await checkVoucherApi(formData);
    return response.data; // Assuming the response has a 'data' property
  } catch (error) {
    console.log(error);
    throw error;
  }
};

//section-2
const ItemToal = () => {
  //context
  const {
    deliveryCharge,
    bagCharge,
    clientFkCharge,
    setFinalTotal,
    currency_symbol,
  } = CheckoutData();

  const {
    finalTotalValue,
    setFinalTotalValue,
    walletamount,
    clientName,
    clientLogo,
    itemAvailableData,
    useWalletBalance,
    extraPayment,
    polling,
  } = useContext(CheckoutContext);

  const { getOrderMode, getOrderTime } = OrderFlow();
  const [width, setWidth] = useState(window.innerWidth);
  const breakpoint = 767;
  const { path } = useParams();
  const navigate = useNavigate();

  const subTotal = localStorage.getItem("totalPrice");
  const roundedValue = localStorage.getItem("roundOffPrice");
  const driverTipValue = localStorage.getItem("driverTipValue")
    ? localStorage.getItem("driverTipValue")
    : "0";
  // console.log(driverTipValue);

  //states
  const [parsedDiscount, setParsedDiscount] = useState("");
  const [cartItemsData, setcartItems] = useState([]);
  const [voucherValue, setVoucherValue] = useState("");
  const [validDiscount, setValidDiscount] = useState(true);
  const [customer, setCustomer] = useState("");
  const isLoggedIn = localStorage.getItem("isLoggedIn") || "";
  const orderTime = getOrderTime;
  const [voucherUsed, setVoucherUsed] = useState(false);
  const [voucherLogin, setVoucherLogin] = useState(false);
  const [voucherMinimum, setVoucherMinimum] = useState(false);
  const [voucherApplied, setVoucherApplied] = useState(false);
  const [voucherLoad, setVoucherLoad] = useState(false);
  const [appliedDiscount, setAppliedDiscount] = useState(0);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (userData !== null && isLoggedIn === "true") {
      setCustomer(userData);
    } else {
      setCustomer("");
    }
  }, [isLoggedIn]);

  //useEffect
  const discountJSON = localStorage.getItem("discount");
  const SummaryOrderType = getOrderMode === "Collection" ? 1 : 0;
  useEffect(() => {
    const discount = discountJSON ? JSON.parse(discountJSON) : "";
    setParsedDiscount(discount);
    let finalTotalValue =
      parseFloat(subTotal) +
      parseFloat(deliveryCharge) +
      parseFloat(bagCharge) +
      parseFloat(clientFkCharge) +
      parseFloat(driverTipValue);

    if (
      parsedDiscount !== "" &&
      (parsedDiscount?.orderType === SummaryOrderType ||
        parsedDiscount?.orderType === "2")
    ) {
      if (discount?.appliedDiscount) {
        finalTotalValue -= parseFloat(discount.appliedDiscount);
      }
    }

    if (discount?.source == "voucherDiscount") {
      setVoucherValue(discount?.discount || "");
    }
    if (discount?.source == "SubscriptionCoupon") {
      setVoucherValue(discount?.discount || "");
      setVoucherApplied(true);
    }
    setAppliedDiscount(discount?.appliedDiscount || 0);
    localStorage.setItem("finalTotal", finalTotalValue.toFixed(2));
    setFinalTotal(finalTotalValue.toFixed(2));
    setFinalTotalValue(
      (parseFloat(finalTotalValue) + parseFloat(roundedValue)).toFixed(2)
    );
    localStorage.setItem(
      "finalTotalValue",
      (parseFloat(finalTotalValue) + parseFloat(roundedValue)).toFixed(2)
    );
  }, [
    subTotal,
    parsedDiscount,
    deliveryCharge,
    bagCharge,
    clientFkCharge,
    driverTipValue,
    roundedValue,
    discountJSON,
    useWalletBalance,
    polling,
  ]);

  useEffect(() => {
    let localStorageData =
      localStorage.getItem("cart") &&
      localStorage.getItem("cart") !== "undefined"
        ? JSON.parse(localStorage.getItem("cart"))
        : [];

    setcartItems(localStorageData);
  }, [localStorage.getItem("cart")]);
  const handleReAddItem = () => {
    navigate(`/${path}/menu`);
  };

  const handleKeyChange = () => {
    setVoucherUsed(false);
    setVoucherLogin(false);
    setVoucherMinimum(false);
    setValidDiscount(true);
    setVoucherApplied(false);
  };
  const voucherData = useMemo(() => {
    const orderTime = localStorage.getItem("orderTime") || "";
    let dateParts = "";
    let timePart = "";
    let formattedDate = "";
    if (orderTime) {
      let inputDate = orderTime;
      if (inputDate.includes("/")) {
        dateParts = inputDate.split(" ")[0].split("/"); // Split the date into parts
        timePart = inputDate.split(" ")[1]; // Get the time part
        // Create a Date object with the parts
        const dateObject = new Date(
          `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}T${timePart}`
        );
        // Format the date in the desired format
        const year = dateObject.getFullYear();
        const month = String(dateObject.getMonth() + 1).padStart(2, "0");
        const day = String(dateObject.getDate()).padStart(2, "0");
        const hour = String(dateObject.getHours()).padStart(2, "0");
        const minute = String(dateObject.getMinutes()).padStart(2, "0");
        formattedDate = `${year}-${month}-${day} ${hour}:${minute}`;
      } else {
        formattedDate = orderTime;
      }
    }
    return {
      customerId: customer.customerId,
      clientPath: path,
      orderTime: formattedDate,
      voucherCode: voucherValue || "",
    };
  }, [path, orderTime, customer, voucherValue]);
  // const checkVoucher = () => {
  //   if (voucherValue == "") {
  //     setValidDiscount(false);
  //   }
  //   setVoucherLoad(true);
  //   checkVoucherCode(voucherData)
  //     .then((response) => {
  //       if (!response.status) {
  //         if (response.message == "voucher code was already Used") {
  //           setVoucherUsed(true);
  //           setValidDiscount(false);
  //         } else if (response.message == "Invalid code") {
  //           setValidDiscount(false);
  //         } else if (response.message == "voucher not available") {
  //           setValidDiscount(false);
  //         } else if (response.message == "CustomerId is required") {
  //           setVoucherLogin(true);
  //           setValidDiscount(false);
  //         }
  //         setVoucherApplied(false);
  //         setVoucherLoad(false);
  //         console.log("vocuherRespose");
  //         console.log(response.message);
  //         return;
  //       }
  //       const storedCart = localStorage.getItem("cart");
  //       const localStorageCart = JSON.parse(storedCart) || [];
  //       const filteredItems = localStorageCart.filter(
  //         (cart) => cart.itemAllowCoupon === 1
  //       );
  //       const totalValue = filteredItems.reduce(
  //         (sum, item) => sum + parseFloat(item.price),
  //         0
  //       );
  //       // const totalValue = localStorage.getItem("totalPrice");
  //       if (parseFloat(totalValue) >= parseFloat(response.message.minAmount)) {
  //         const voucher = {
  //           code: response.message.code,
  //           discount: response.message.discount,
  //           description: response.message.description,
  //           discountType: response.message.type,
  //           minOrder: response.message.minAmount,
  //         };
  //         applyVoucher(voucher, getOrderMode);
  //         setValidDiscount(true);
  //         setVoucherApplied(true);
  //         setVoucherLoad(false);
  //       } else {
  //         setVoucherMinimum(true);
  //         setVoucherLoad(false);
  //         setValidDiscount(false);
  //       }
  //     })
  //     .catch((error) => {
  //       setVoucherLoad(false);
  //       console.log(error);
  //     });
  // };
  const checkVoucher = () => {
    if (voucherValue == "") {
      setValidDiscount(false);
    }
    //Subscription Coupon Code Apply
    const SubscriptionCouponCode1 = localStorage.getItem("SubcripeCoupon");

    // Check if the value exists and is not the string "undefined"
    const SubscriptionCouponCode =
      SubscriptionCouponCode1 !== null &&
      SubscriptionCouponCode1 !== "undefined"
        ? JSON.parse(SubscriptionCouponCode1)
        : "";

    setVoucherLoad(true);
    if (
      SubscriptionCouponCode != "" &&
      typeof SubscriptionCouponCode !== "undefined"
    ) {
      console.log(voucherData);
      if (voucherValue === SubscriptionCouponCode.code) {
        const isCouponApplied = applySubcriptionCouponCode(
          SubscriptionCouponCode,
          getOrderMode
        );

        if (isCouponApplied) {
          setValidDiscount(true);
          setVoucherApplied(true);
          setVoucherLoad(false);
          // setCelebrate(true);
          // setTimeout(() => setCelebrate(false), 6000);
        }
      } else {
        setValidDiscount(false);
        setVoucherLoad(false);
      }
    } else {
      checkVoucherCode(voucherData)
        .then((response) => {
          if (!response.status) {
            if (response.message == "voucher code was already Used") {
              setVoucherUsed(true);
              setValidDiscount(false);
            } else if (response.message == "Invalid code") {
              setValidDiscount(false);
            } else if (response.message == "voucher not available") {
              setValidDiscount(false);
            } else if (response.message == "CustomerId is required") {
              setVoucherLogin(true);
              setValidDiscount(false);
            }
            setVoucherApplied(false);
            setVoucherLoad(false);
            console.log("vocuherRespose");
            console.log(response.message);
            return;
          }
          const storedCart = localStorage.getItem("cart");
          const localStorageCart = JSON.parse(storedCart) || [];
          const filteredItems = localStorageCart.filter(
            (cart) => cart.itemAllowCoupon === 1
          );
          const totalValue = filteredItems.reduce(
            (sum, item) => sum + parseFloat(item.price),
            0
          );
          // const totalValue = localStorage.getItem("totalPrice");
          if (
            parseFloat(totalValue) >= parseFloat(response.message.minAmount)
          ) {
            const voucher = {
              code: response.message.code,
              discount: response.message.discount,
              description: response.message.description,
              discountType: response.message.type,
              minOrder: response.message.minAmount,
            };
            applyVoucher(voucher, getOrderMode);
            setValidDiscount(true);
            setVoucherApplied(true);
            setVoucherLoad(false);
          } else {
            setVoucherMinimum(true);
            setVoucherLoad(false);
            setValidDiscount(false);
          }
        })
        .catch((error) => {
          setVoucherLoad(false);
          console.log(error);
        });
    }
  };
  const storeClientName = localStorage.getItem("clientName");

  const [showModal, setShowModal] = useState(false);

  const handleShowordersummary = () => setShowModal(true);
  const handleCloseordersummary = () => setShowModal(false);

  const [showModalMobileSummary, setShowModalMobileSummary] = useState(false);
  const handleBillsummaryMobile = () => setShowModalMobileSummary(true);
  const handleCloseBillsummaryMobile = () => setShowModalMobileSummary(false);
  return (
    <>
      {width > breakpoint ? (
        <Card
          className="fus-payment-card"
          style={{ borderColor: "#fff", borderRadius: "15px", padding: "10px" }}
        >
          {/* order summary */}
          {/* <Card.Body className="fusion-cart-summary" >
            <Card.Title className="fus-bill-title fusion-cart-summary d-none"
              style={{
                display: 'flex',
                alignItems: 'center',
              }}>
              <Image
                src={clientLogo ? clientLogo : clientLogo}
                roundedCircle
                className="fus-client-img"
                style={{
                  width: '48px',
                  height: '48px'
                }}
              />{" "}{clientName ? clientName : ""}</Card.Title>
            <div className="fus-payment-btn">
              <OrderButton />
            </div>
          </Card.Body> */}
          <Card.Body>
            <Card.Title className="fus-bill-title fus-order-summary-title">
              <h5
                className="fus-order-summary-title-text"
                style={{ marginTop: "5px" }}
              >
                Order summary
              </h5>
              {/* <div className="fus-order-summary-btn">
              <button
                className="fus-order-summary-sub-btn"
                onClick={handleReAddItem}
                data-fus="fus-test-additembtn"
              >
                + Add Items
              </button>
            </div> */}
            </Card.Title>
            <div className="clientnamemodalopen">
              <h5>{storeClientName}</h5>
              <h5 className="clickheretext" onClick={handleReAddItem}>
                Add more
              </h5>
            </div>
            {/* <Modal show={showModal} onHide={handleCloseordersummary} centered >
              <Modal.Body className="order-summary-modal"
              >
                <h4 className="modal-title">Your items <img src={closeiconnew} alt="closeicon" className="closeiconnew" onClick={handleCloseordersummary} /></h4>
                <p className="restaurant-name">{storeClientName}</p>
                <div className="order-summary-scroll">
                  {
                    cartItemsData && Array.isArray(cartItemsData) &&
                    cartItemsData
                      .filter(itemA => {

                        if (Array.isArray(itemAvailableData)) {

                          return itemAvailableData.some(itemB => itemB.itemId === itemA.itemId);
                        }
                        return true;
                      }).map((ListItem, index) => (
                        <>
                          <div key={index} className="fus-order-summary">
                            <Card.Text className="fus-order-summary-count">
                              {ListItem.count}    x
                            </Card.Text>
                            <Card.Text className="fus-order-summary-text">
                             
                              {ListItem?.itemName?.split("&#")[0]
                                ? ListItem?.itemName?.split("&#")[0]
                                : ListItem.itemName}
                              <br />
                              {getOrderMode === "Collection" ? (
                                ListItem.collection_available && (
                                  <span style={{
                                    fontSize: "10px",
                                    color: "#f00",
                                    backgroundColor: "#fff2f2",
                                    marginLeft: "10px",
                                    fontFamily: "SegoeUI",
                                    padding: "4px 10px"
                                  }}>Collection Not Available</span>
                                )
                              ) : (
                                ListItem.delivery_available && (
                                  <span style={{
                                    fontSize: "10px",
                                    color: "#f00",
                                    backgroundColor: "#fff2f2",
                                    marginLeft: "10px",
                                    fontFamily: "SegoeUI",
                                    padding: "4px 10px"
                                  }}>Delivery Not Available</span>
                                )
                              )}
                            </Card.Text>
                            <Card.Text className="fus-order-summary-price">
                              {currency_symbol}{ListItem.price}
                            </Card.Text>
                          </div>
                        </>
                      ))}
                </div>
                <button onClick={handleCloseordersummary} className="done-button">
                  Done
                </button>
              </Modal.Body>
            </Modal > */}

            <div className="order-summary-scroll">
              {cartItemsData &&
                Array.isArray(cartItemsData) &&
                cartItemsData
                  .filter((itemA) => {
                    if (Array.isArray(itemAvailableData)) {
                      return itemAvailableData.some(
                        (itemB) => itemB.itemId === itemA.itemId
                      );
                    }
                    return true;
                  })
                  .map((ListItem, index) => (
                    <>
                      <div key={index} className="fus-order-summary">
                        <Card.Text className="fus-order-summary-count">
                          {ListItem.count} x
                        </Card.Text>
                        <Card.Text className="fus-order-summary-text">
                          {/* <Image src={ListItem?.itemImage ? ListItem?.itemImage : ""} roundedCircle className="fus-order-summary-image" style={{ width: '30px', height: '30px' }} /> */}
                          {ListItem?.itemName?.split("&#")[0]
                            ? ListItem?.itemName?.split("&#")[0]
                            : ListItem.itemName}
                          <br />
                          {getOrderMode === "Collection"
                            ? ListItem.collection_available && (
                                <span
                                  style={{
                                    fontSize: "10px",
                                    color: "#f00",
                                    backgroundColor: "#fff2f2",
                                    marginLeft: "10px",
                                    fontFamily: "SegoeUI",
                                    padding: "4px 10px",
                                  }}
                                >
                                  Collection Not Available
                                </span>
                              )
                            : ListItem.delivery_available && (
                                <span
                                  style={{
                                    fontSize: "10px",
                                    color: "#f00",
                                    backgroundColor: "#fff2f2",
                                    marginLeft: "10px",
                                    fontFamily: "SegoeUI",
                                    padding: "4px 10px",
                                  }}
                                >
                                  Delivery Not Available
                                </span>
                              )}
                        </Card.Text>
                        <Card.Text className="fus-order-summary-price">
                          {currency_symbol}
                          {ListItem.price}
                        </Card.Text>
                      </div>
                    </>
                  ))}
            </div>
          </Card.Body>
          {/* <Card.Body className="fusion-voucher">
          <Card.Title className="fus-bill-title mt-3">Add Promo Code</Card.Title>
          <Card.Text className="fus-voucher">
            <form className="voucher-form">
              <label className="voucher-label">
                <Form.Control
                  type="text"
                  className="form-control"
                  placeholder="Enter Your Voucher Code"
                  value={voucherValue}
                  onChange={(e) => setVoucherValue(e.target.value)}
                  onKeyDown={handleKeyChange}
                  isInvalid={!validDiscount}
                  data-fus="fus-test-vouchercodeinput"
                />
              </label>
              <label className="apply" onClick={checkVoucher}>
                {voucherLoad ? (
                  <Spinner animation="border" size="sm" variant="primary" />
                ) : voucherApplied ? (
                  "Applied"
                ) : (
                  "Apply"
                )}
              </label>
            </form>
          </Card.Text>
          {voucherUsed && (
            <p className="error-code" style={{ color: "red" }}>
              Sorry Voucher already redeemed
            </p>
          )}
          {voucherLogin && (
            <p className="error-code" style={{ color: "red" }}>
              Please log in to redeem this voucher
            </p>
          )}
          {voucherMinimum && (
            <p className="error-code" style={{ color: "red" }}>
              Need to added more item
            </p>
          )}
        </Card.Body> */}
          <Card.Body>
            {/* <Card.Title className="fus-bill-title">Order Total</Card.Title> */}

            <Card.Text className="fus-bill-text">
              <p>Sub total</p>
              <p>
                {currency_symbol}
                {subTotal}
              </p>
            </Card.Text>

            {/* {clientFkCharge && (
              <Card.Text className="fus-bill-text">
                <p>Service charge</p>
                <p>
                  {currency_symbol}
                  {clientFkCharge}
                </p>
              </Card.Text>
            )} */}

            {getOrderMode === "Delivery" &&
            deliveryCharge != "0.00" &&
            deliveryCharge != "0" ? (
              <>
                <Card.Text className="fus-bill-text">
                  <p>Delivery charge</p>
                  <p>
                    {currency_symbol}
                    {deliveryCharge}
                  </p>
                </Card.Text>
              </>
            ) : null}

            {roundedValue !== "0" && roundedValue !== "0.00" ? (
              <>
                <Card.Text className="fus-bill-text">
                  <p>Round up</p>
                  <p>
                    {currency_symbol}
                    {roundedValue}
                  </p>
                </Card.Text>
              </>
            ) : null}

            {bagCharge && (
              <Card.Text className="fus-bill-text">
                <p>Bag charge</p>
                <p>
                  {currency_symbol}
                  {bagCharge}
                </p>
              </Card.Text>
            )}

            {driverTipValue !== "0" && driverTipValue !== "0.00" && (
              <Card.Text className="fus-bill-text">
                <p>{getOrderMode === "Delivery" ? "Driver tip" : "Donation"}</p>
                <p>
                  {currency_symbol}
                  {driverTipValue}
                </p>
              </Card.Text>
            )}

            {/* {parsedDiscount !== "" && parsedDiscount?.orderType === SummaryOrderType && appliedDiscount !== 0 ? (
            <Card.Text className="fus-bill-text">
              <p>Discount</p>
              <p>-{currency_symbol}{appliedDiscount}</p>
            </Card.Text>
          ) : null} */}
            {parsedDiscount !== "" &&
            (parsedDiscount?.orderType === SummaryOrderType ||
              parsedDiscount?.orderType === "2") &&
            appliedDiscount !== 0 ? (
              <Card.Text className="fus-bill-text">
                <p>Discount</p>
                <p>-£{appliedDiscount}</p>
              </Card.Text>
            ) : null}
            {extraPayment && useWalletBalance && walletamount > 0 ? (
              <Card.Text className="fus-bill-text">
                <p>wallet cash</p>
                <p>-£{walletamount}</p>
              </Card.Text>
            ) : null}

            <Card.Title className="fus-bill-total">
              <h3>Total</h3>
              <h3>
                {currency_symbol}
                {finalTotalValue}
              </h3>
            </Card.Title>
            <p className="byclicktext">
              By clicking on "Order and pay" you agree with the contents of the
              shopping cart, the data you filled out, our{" "}
              <a
                href="/privacy"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#007bff" }}
              >
                privacy statement
              </a>{" "}
              and{" "}
              <a
                href="/terms"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#007bff" }}
              >
                terms of use
              </a>
              .
            </p>

            <div className="fus-payment-btn">
              <OrderButton
                walletamount={walletamount}
                finalTotalValue={finalTotalValue}
              />
            </div>
          </Card.Body>
        </Card>
      ) : (
        <>
          <div class=" d-block d-sm-none bill-container ">
            <div class="bill-info" onClick={handleBillsummaryMobile}>
              <div className="bill-ptagdiv">
                <p class="bill-title">
                  Total Bill
                  {parsedDiscount !== "" &&
                  (parsedDiscount?.orderType === SummaryOrderType ||
                    parsedDiscount?.orderType === "2") &&
                  appliedDiscount !== 0 ? (
                    <span className="original-price">
                      {currency_symbol}{" "}
                      {(
                        Number(appliedDiscount) + Number(finalTotalValue)
                      ).toFixed(1)}
                    </span>
                  ) : null}
                  <span class="final-price">
                    {currency_symbol}
                    {finalTotalValue}
                  </span>
                </p>{" "}
                <RiArrowRightSLine className="arrowiconbill" />
              </div>
              {parsedDiscount !== "" &&
              (parsedDiscount?.orderType === SummaryOrderType ||
                parsedDiscount?.orderType === "2") &&
              appliedDiscount !== 0 ? (
                <div class="savings">
                  <p>
                    You saved{" "}
                    <span style={{ fontWeight: "600" }}>
                      {currency_symbol} {appliedDiscount}
                    </span>{" "}
                  </p>
                </div>
              ) : null}
            </div>

            <Modal
              show={showModalMobileSummary}
              centered={false}
              backdrop="static"
              id="bottom-sheet-modal"
              style={{ height: "auto" }}
            >
              <Modal.Body
                className="order-summary-modalbillsummary"
                style={{ height: "auto " }}
              >
                <div style={{ height: "auto" }}>
                  <h4 className="modal-titletext">
                    Order summary{" "}
                    <img
                      src={closeiconnew}
                      alt="closeicon"
                      className="closeiconnew"
                      onClick={handleCloseBillsummaryMobile}
                    />
                  </h4>
                  <div className="modaldivsummary" style={{ height: "auto" }}>
                    <div className="order-summary-scrollbill">
                      {cartItemsData &&
                        Array.isArray(cartItemsData) &&
                        cartItemsData
                          .filter((itemA) => {
                            // Ensure itemAvailableData is a valid array
                            if (Array.isArray(itemAvailableData)) {
                              return itemAvailableData.some(
                                (itemB) => itemB.itemId === itemA.itemId
                              );
                            }
                            return true; // If itemAvailableData is not an array, retain all items
                          })
                          .map((ListItem, index) => (
                            <>
                              <div
                                key={index}
                                className="fus-order-summarycheck"
                              >
                                <span className="fus-order-checkcount">
                                  {ListItem.count} x
                                </span>
                                <span className="fus-orderchecktext">
                                  {/* <Image src={ListItem?.itemImage ? ListItem?.itemImage : ""} roundedCircle className="fus-order-summary-image" style={{ width: '30px', height: '30px' }} /> */}
                                  {ListItem?.itemName?.split("&#")[0]
                                    ? ListItem?.itemName?.split("&#")[0]
                                    : ListItem.itemName}
                                  <br />
                                  {getOrderMode === "Collection"
                                    ? ListItem.collection_available && (
                                        <span
                                          style={{
                                            fontSize: "10px",
                                            color: "#f00",
                                            backgroundColor: "#fff2f2",
                                            marginLeft: "10px",
                                            fontFamily: "SegoeUI",
                                            padding: "4px 10px",
                                          }}
                                        >
                                          Collection Not Available
                                        </span>
                                      )
                                    : ListItem.delivery_available && (
                                        <span
                                          style={{
                                            fontSize: "10px",
                                            color: "#f00",
                                            backgroundColor: "#fff2f2",
                                            marginLeft: "10px",
                                            fontFamily: "SegoeUI",
                                            padding: "4px 10px",
                                          }}
                                        >
                                          Delivery Not Available
                                        </span>
                                      )}
                                </span>
                                <span className="fus-ordercheckprice">
                                  {currency_symbol}
                                  {ListItem.price}
                                </span>
                              </div>
                            </>
                          ))}
                    </div>
                    <p
                      className="clickheretextmobile"
                      onClick={handleReAddItem}
                    >
                      Add more
                    </p>
                    <div className="borderbottomdiv"></div>

                    <Card.Text className="fus-bill-textmobile">
                      <p>Sub total</p>
                      <p>
                        {currency_symbol}
                        {subTotal}
                      </p>
                    </Card.Text>

                    {/* {clientFkCharge && (
                      <Card.Text className="fus-bill-textmobile">
                        <p>Service charge</p>
                        <p>
                          {currency_symbol}
                          {clientFkCharge}
                        </p>
                      </Card.Text>
                    )} */}

                    {getOrderMode === "Delivery" &&
                    deliveryCharge != "0.00" &&
                    deliveryCharge != "0" ? (
                      <>
                        <Card.Text className="fus-bill-textmobile">
                          <p>Delivery charge</p>
                          <p>
                            {currency_symbol}
                            {deliveryCharge}
                          </p>
                        </Card.Text>
                      </>
                    ) : null}

                    {roundedValue !== "0" && roundedValue !== "0.00" ? (
                      <>
                        <Card.Text className="fus-bill-textmobile">
                          <p>Round up</p>
                          <p>
                            {currency_symbol}
                            {roundedValue}
                          </p>
                        </Card.Text>
                      </>
                    ) : null}

                    {bagCharge && (
                      <Card.Text className="fus-bill-textmobile">
                        <p>Bag charge</p>
                        <p>
                          {currency_symbol}
                          {bagCharge}
                        </p>
                      </Card.Text>
                    )}

                    {driverTipValue !== "0" && driverTipValue !== "0.00" && (
                      <Card.Text className="fus-bill-textmobile">
                        <p>
                          {getOrderMode === "Delivery"
                            ? "Driver tip"
                            : "Donation"}
                        </p>
                        <p>
                          {currency_symbol}
                          {driverTipValue}
                        </p>
                      </Card.Text>
                    )}

                    {/* {parsedDiscount !== "" && parsedDiscount?.orderType === SummaryOrderType && appliedDiscount !== 0 ? (
            <Card.Text className="fus-bill-text">
              <p>Discount</p>
              <p>-{currency_symbol}{appliedDiscount}</p>
            </Card.Text>
          ) : null} */}
                    {parsedDiscount !== "" &&
                    (parsedDiscount?.orderType === SummaryOrderType ||
                      parsedDiscount?.orderType === "2") &&
                    appliedDiscount !== 0 ? (
                      <Card.Text className="fus-bill-textmobile">
                        <p>Discount</p>
                        <p>-£{appliedDiscount}</p>
                      </Card.Text>
                    ) : null}
                    {extraPayment && useWalletBalance && walletamount > 0 ? (
                      <Card.Text className="fus-bill-textmobile">
                        <p>wallet Cash</p>
                        <p>-£{walletamount}</p>
                      </Card.Text>
                    ) : null}

                    <Card.Title className="fus-bill-textmobile">
                      <h3>Total</h3>
                      <h3>
                        {currency_symbol}
                        {finalTotalValue}
                      </h3>
                    </Card.Title>
                    {parsedDiscount !== "" &&
                    (parsedDiscount?.orderType === SummaryOrderType ||
                      parsedDiscount?.orderType === "2") &&
                    appliedDiscount !== 0 ? (
                      <p className="savedpoundsname">
                        You saved{" "}
                        <span style={{ fontWeight: "600" }}>
                          {" "}
                          {currency_symbol} {appliedDiscount}
                        </span>{" "}
                      </p>
                    ) : null}
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </div>
          <p className="ptagmobilelast">
            By clicking on order and pay you agree with the content of the order
            , the data you filled out, our privacy statement and terms of use
          </p>
        </>
      )}
    </>
  );
};
//MOBILE CART
const MobileCart = () => {
  const { getOrderMode } = OrderFlow();
  const dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();
  const {
    deliveryCharge,
    bagCharge,
    clientFkCharge,
    setFinalTotal,
    clientSecret,
  } = CheckoutData();
  const {
    setPaymentMId,
    setPayType,
    setPaySubmit,
    paymentType,
    walletstatus,
    cashtype,
    setCardErrorMessage,
    buttonstatus,
    setButtonstatus,
    finalTotalValue,
    setFinalTotalValue,
    paymentRequest,
    setApplepayGpayBtnStatus,
    setPaymentRequest,
    setGpaySubmit,
    setPaymentType,
    footerBtn,
    setSavecardPay,
    savecardPay,
    setFooterBtn,
    scrollToSection,
    paymentSuccessShow,
    selectedValue,
    setPaymentModalShow,
    paysaveCard,
    handlesavecardPayment,
    CARD_OPTIONS1,
    containerStyle,
    saveCardError,
    setSaveCardError,
    walletamount,
    googlepaytype,
    applepaytype,
    paypalType,
    klarnaType,
    cardtype,
    setEstimateShow,
    minOrderStatus,
    setUseWalletBalance,
    setExtraStatus,
    extraPayment,
    extraPayStatus,
    extraLessAmount,
    useWalletBalance,
    preOrderTimeTable,
  } = useContext(CheckoutContext);
  const { theme } = useContext(ThemeContext);

  const SAVE_OPTIONS1 = {
    style: {
      base: {
        fontSize: "16px",
        color: "#000",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: "red",
      },
    },
  };

  const saveCardStyle = {
    borderRadius: "10px",
    padding: "5px 15px 5px 17px",
    // overflow: 'hidden',

    // // height:'20px',
    border: theme === "dark" ? "1px solid #fff" : "1px solid #ebedf0", // Add border style here
  };

  const [parsedDiscount, setParsedDiscount] = useState("");
  const [discountStatus, setDiscountStatus] = useState("");
  const [paymentLoad, setPaymentLoad] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState("");
  // const [showPopup, setShowPopup] = useState(false);
  const subTotal = localStorage.getItem("totalPrice");
  const roundedValue = localStorage.getItem("roundOffPrice");
  const driverTipValue = localStorage.getItem("driverTipValue")
    ? localStorage.getItem("driverTipValue")
    : "0";

  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const loginAddress = localStorage.getItem("loginAddress") || "";
  const guestAddress = localStorage.getItem("guestAddress") || "";
  const guestusered = localStorage.getItem("guestAddress");
  const { setAddressPopupshow } = useContext(CheckoutContext);
  const navigate = useNavigate();

  // update total payment value
  const handlePayment = async () => {
    try {
      // Use the updated payment request to start the payment flow
      if (paymentRequest) {
        const paymentResult = await paymentRequest.show();
        // Handle payment result as needed
      }
    } catch (error) {
      // Handle errors
    }
  };

  useEffect(() => {
    if (!stripe || !elements) {
      return;
    }
    const finalAmt = localStorage?.getItem("finalTotalValue") || 0;
    const finalAmtCheck = Math?.round(finalAmt * 100);
    const walletFinalAmtCheck =
      extraLessAmount != null && useWalletBalance
        ? Math.round(extraLessAmount * 100)
        : null;
    const currencyName = localStorage.getItem("currencyName");
    let countryCode;

    // Define currency based on country
    switch (currencyName) {
      case "USD":
        countryCode = "US"; // United States Dollar
        break;
      case "INR":
        countryCode = "IN"; // Indian Rupee
        break;
      case "GBP":
        countryCode = "GB"; // British Pound Sterling
        break;
      case "EUR":
        countryCode = "FR"; // Euro
        break;
      default:
        countryCode = "US"; // Default to USD
    }

    if (stripe && finalAmtCheck) {
      try {
        const pr = stripe?.paymentRequest({
          country: countryCode,
          currency: currencyName?.toLowerCase(),
          total: {
            label: "FK",
            amount: walletFinalAmtCheck ? walletFinalAmtCheck : finalAmtCheck,
          },
          requestPayerName: true,
          requestPayerEmail: true,
        });
        // Check the availability of the Payment Request API first.
        // localStorage.setItem("paymentStatus", "processing");
        pr.canMakePayment()
          .then((result) => {
            console.log(result);
            if (result) {
              setPaymentRequest(pr);
              // console.log(pr);
              pr.on("paymentmethod", async (ev) => {
                // console.log(ev.paymentMethod.id);
                setPaymentMId(ev.paymentMethod.id);
                setPayType("applePayGooglePayPaymentMethodId");
                setGpaySubmit(1);
                setPaymentType(8); // payment type 1,8,7,9
                // Confirm the PaymentIntent without handling potential next actions (yet).
                try {
                  const { paymentIntent, error: confirmError } =
                    await stripe.confirmCardPayment(
                      clientSecret,
                      { payment_method: ev.paymentMethod.id },
                      { handleActions: false }
                    );
                  if (confirmError) {
                    // Report to the browser that the payment failed, prompting it to
                    // re-show the payment interface, or show an error message and close
                    // the payment interface.
                    setPaymentStatus("Payment confirmation error");
                    ev.complete("fail");
                    return;
                  }
                  // Report to the browser that the confirmation was successful, prompting
                  // it to close the browser payment method collection interface.

                  // Check if the PaymentIntent requires any actions and, if so, let Stripe.js
                  // handle the flow. If using an API version older than "2019-02-11"
                  // instead check for: `paymentIntent.status === "requires_source_action"`.
                  if (paymentIntent.status === "requires_action") {
                    // Let Stripe.js handle the rest of the payment flow.
                    const { error: actionError } =
                      await stripe.confirmCardPayment(clientSecret);
                    if (actionError) {
                      ev.complete("fail");
                      setPaymentStatus("Payment actionError error");
                      return;
                      // The payment failed -- ask your customer for a new payment method.
                    } else {
                      paymentSuccessShow(true);
                      setPaymentStatus("Payment succeeded");
                      navigate("/orderstatus");
                      ev.complete("success");
                      // The payment has succeeded -- show a success message to your customer.
                    }
                  }
                  if (paymentIntent.status === "succeeded") {
                    paymentSuccessShow(true);
                    setPaymentStatus("Payment succeeded");
                    navigate("/orderstatus");
                    // Payment succeeded without any further actions
                    ev.complete("success");
                  }
                } catch (error) {
                  ev.complete("fail");
                }
              });
              // return () => {
              //   paymentRequest.off("paymentmethod", onPaymentMethod);
              // };
              setApplepayGpayBtnStatus(1);
            } else {
              console.log("Payment cannot be made.");
            }
          })
          .catch((error) => {
            // alert(error);
          });
      } catch (error) {
        console.error("Error checking if payment can be made:", error);
      }
    }
  }, [stripe, elements, finalTotalValue, extraLessAmount, useWalletBalance]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     // Fetch final amount from your API or other source
  //     const finalAmt = localStorage?.getItem("finalTotalValue") || 0;

  //     // Convert amount to cents (Stripe expects amounts in cents)
  //     const finalAmtCheck = Math.round(finalAmt * 100);

  //     if (stripe && elements && finalAmtCheck) {
  //       try {
  //         // Create a Payment Request
  //         const pr = stripe.paymentRequest({
  //           country: 'US',
  //           currency: 'usd',
  //           total: {
  //             label: 'Demo total',
  //             amount: 10,
  //           },
  //           requestPayerName: true,
  //           requestPayerEmail: true,
  //         });
  //         console.log('Payment Request Object:', pr);

  //         // Check if the browser supports the Payment Request API
  //         const result = await pr.canMakePayment();

  //         console.log(result);
  //         if (result) {
  //           setPaymentRequest(pr);

  //           // Listen for the paymentmethod event
  //           pr.on("paymentmethod", async (ev) => {
  //             try {
  //               // Confirm the PaymentIntent without handling potential next actions (yet).
  //               const { paymentIntent, error: confirmError } = await stripe.confirmCardPayment(
  //                 clientSecret,
  //                 { payment_method: ev.paymentMethod.id },
  //                 { handleActions: false }
  //               );

  //               if (confirmError) {
  //                 // Handle payment confirmation error
  //                 console.error("Payment confirmation error:", confirmError);
  //                 ev.complete("fail");
  //               } else if (paymentIntent.status === "requires_action") {
  //                 // Let Stripe.js handle the rest of the payment flow
  //                 const { error: actionError } = await stripe.confirmCardPayment(clientSecret);
  //                 if (actionError) {
  //                   console.error("Payment actionError error:", actionError);
  //                   ev.complete("fail");
  //                 } else {
  //                   // Payment succeeded with additional actions
  //                   console.log("Payment succeeded with additional actions");
  //                   ev.complete("success");
  //                 }
  //               } else if (paymentIntent.status === "succeeded") {
  //                 // Payment succeeded without additional actions
  //                 console.log("Payment succeeded");
  //                 ev.complete("success");
  //               }
  //             } catch (error) {
  //               // Handle other errors
  //               console.error("Error during payment processing:", error);
  //               ev.complete("fail");
  //             }
  //           });

  //           // Set up the Payment Request button or other UI elements
  //           setApplepayGpayBtnStatus(1);
  //         } else {
  //           console.log("Payment cannot be made.");
  //         }
  //       } catch (error) {
  //         // Handle errors during Payment Request setup
  //         console.error("Error setting up Payment Request:", error);
  //       }
  //     }
  //   };

  //   fetchData();
  // }, [finalTotalValue, stripe, elements]);
  useEffect(() => {
    setPaymentLoad(true);
  }, []);
  useEffect(() => {
    let timer;
    if (!paymentRequest) {
      // Show the spinner for a maximum of 3 second
      setPaymentLoad(true);

      // After 1 second, hide the spinner if payment request is still not available
      timer = setTimeout(() => {
        setPaymentLoad(false);
      }, 3000);
    } else {
      // If payment request arrives before 1 second, clear the timer and hide the spinner immediately
      clearTimeout(timer);
      setPaymentLoad(false);
    }

    // Clean up the timer when component unmounts or payment request changes
    return () => {
      clearTimeout(timer);
    };
  }, [paymentRequest]);

  useEffect(() => {
    const discountJSON = localStorage.getItem("discount");
    const discount = discountJSON ? JSON.parse(discountJSON) : "";
    setParsedDiscount(discount);
  }, [discountStatus]);

  useEffect(() => {
    const discountJSON = localStorage.getItem("discount");
    const discount = discountJSON ? JSON.parse(discountJSON) : "";
    const SummaryOrderType = getOrderMode === "Collection" ? 1 : 0;
    let finalTotalValue =
      parseFloat(subTotal) +
      parseFloat(deliveryCharge) +
      parseFloat(bagCharge) +
      parseFloat(clientFkCharge) +
      parseFloat(driverTipValue);

    if (
      discount?.appliedDiscount &&
      (discount?.orderType === SummaryOrderType || discount?.orderType === 2)
    ) {
      finalTotalValue -= parseFloat(discount.appliedDiscount);
    }

    localStorage.setItem("finalTotal", finalTotalValue.toFixed(2));
    setFinalTotal(finalTotalValue.toFixed(2));
    setFinalTotalValue(
      (parseFloat(finalTotalValue) + parseFloat(roundedValue)).toFixed(2)
    );
    localStorage.setItem(
      "finalTotalValue",
      (parseFloat(finalTotalValue) + parseFloat(roundedValue)).toFixed(2)
    );
  }, [
    subTotal,
    parsedDiscount,
    deliveryCharge,
    bagCharge,
    clientFkCharge,
    driverTipValue,
    roundedValue,
  ]);
  // scroll Fixed Top Start
  const [sidebarTop, setSidebarTop] = useState(undefined);
  const [cartItemsData, setcartItems] = useState([]);

  useEffect(() => {
    const updateSidebarTop = () => {
      const chatEl = document.querySelector(".cart-page");
      setSidebarTop(chatEl?.getBoundingClientRect()?.top);
    };

    updateSidebarTop();
    window.addEventListener("resize", updateSidebarTop);
    return () => {
      window.removeEventListener("resize", updateSidebarTop);
    };
  }, []);

  useEffect(() => {
    const isSticky = (e) => {
      const chatEl = document.querySelector(".cart-page");
      const scrollTop = window.scrollY;
      chatEl.classList.toggle("is-sticky", scrollTop >= sidebarTop - 96);
    };

    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  }, [sidebarTop]);
  // scroll Fixed Top End

  useEffect(() => {
    let localStorageData =
      localStorage.getItem("cart") &&
      localStorage.getItem("cart") !== "undefined"
        ? JSON.parse(localStorage.getItem("cart"))
        : [];
    setcartItems(localStorageData);
  }, [localStorage.getItem("cart")]);

  //status selector
  const placeOrder_status = useSelector(
    (state) => state.placeorderStatusReducer.placeorder
  );
  const [status, setStatus] = useState(false);
  useEffect(() => {
    setStatus(placeOrder_status);
  }, [placeOrder_status]);

  const parseDateString = (dateTimeString) => {
    // console.log("dateTimeString");
    // console.log(dateTimeString);
    if (dateTimeString && dateTimeString != 0) {
      const [date, time] = dateTimeString.split(" ");
      let day, month, year;
      if (date.includes("/")) {
        [day, month, year] = date.split("/");
      } else if (date.includes("-")) {
        [year, month, day] = date.split("-");
      }
      const [hour, minute] = time.split(":");
      return new Date(year, month - 1, day, hour, minute);
    } else {
      return 0;
    }
  };
  const checkOrderTime = () => {
    const preorderTime = localStorage.getItem("preOrder");
    const orderType = localStorage.getItem("orderType");
    const TimeTable =
      getOrderMode === "Delivery"
        ? preOrderTimeTable?.Delivery
        : preOrderTimeTable?.Collection;
    const preorder = preorderTime || "";
    if (preorder && preorder !== "0") {
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const currentTime = new Date().toLocaleString("en", {
        timeZone: userTimezone,
        hour12: false,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
      const [datePart, timePart] = currentTime.split(", ");
      const [month, day, year] = datePart.split("/");
      const [hour, minute] = timePart.split(":");
      const formattedDay = day.padStart(2, "0");
      const formattedMonth = month.padStart(2, "0");
      const formattedHours = parseInt(hour, 10);
      const formattedMinutes = parseInt(minute, 10);
      const formattedTime = `${formattedHours
        .toString()
        .padStart(2, "0")}:${formattedMinutes.toString().padStart(2, "0")}`;
      const changedDate = `${formattedDay}/${formattedMonth}/${year}`;
      const date1 = parseDateString(changedDate + " " + formattedTime);
      const date2 = parseDateString(localStorage.getItem("orderTime"));
      const date3 = parseDateString(localStorage.getItem("preOrder"));
      const todayAvailable =
        TimeTable?.today == "" && orderType == "ASAP" ? true : false;
      const checkTodayOrder =
        orderType == "Today"
          ? moment(date1).format("YYYY-MM-DD") <
              moment(date2).format("YYYY-MM-DD") ||
            moment(date1).format("YYYY-MM-DD") <
              moment(date3).format("YYYY-MM-DD")
          : false;
      const checkTodayOrder2 =
        orderType == "Today" && TimeTable?.today == "" ? true : false;
      const checkAsap =
        orderType == "ASAP" ? date1 < date2 || date1 < date3 : false;
      const checkLaterOrder =
        orderType == "Later"
          ? moment(date1).format("YYYY-MM-DD") >=
              moment(date2).format("YYYY-MM-DD") ||
            moment(date1).format("YYYY-MM-DD") >=
              moment(date3).format("YYYY-MM-DD")
            ? true
            : false
          : false;
      const checkLaterOrder2 =
        (orderType == "Later" &&
          TimeTable?.later[moment(date2).format("YYYY-MM-DD")] == "") ||
        TimeTable?.later[moment(date3).format("YYYY-MM-DD")] == ""
          ? true
          : false;

      if (
        date1 > date2 ||
        date1 > date3 ||
        checkLaterOrder2 ||
        todayAvailable ||
        checkTodayOrder2 ||
        checkAsap ||
        checkTodayOrder ||
        checkLaterOrder
      ) {
        return true;
      }
    }
  };

  const PlacewalletOrder = async (event) => {
    event.preventDefault();
    const checkTime = checkOrderTime();
    if (checkTime) {
      setEstimateShow(true);
    } else {
      setButtonstatus(true);
      setPaySubmit(9);
    }
  };

  const PlaceCashOrder = async (event) => {
    event.preventDefault();
    const checkTime = checkOrderTime();
    if (checkTime) {
      setEstimateShow(true);
    } else {
      setButtonstatus(true);
      setPaySubmit(1);
    }
  };

  const PaypalHandleClick = async (event) => {
    event.preventDefault();
    const checkTime = checkOrderTime();
    if (checkTime) {
      setEstimateShow(true);
    } else {
      setPaySubmit(14);
      setButtonstatus(true);
    }
  };

  // const GoBackFunction = () => {
  //   navigate(-1);
  // };
  // ! page width
  const [width, setWidth] = useState(window.innerWidth);
  // const breakpoint = 767;
  useEffect(() => {
    const handleResizeWindow = () => setWidth(window.innerWidth);
    // subscribe to window resize event "onComponentDidMount"
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      // unsubscribe "onComponentDestroy"
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, []);
  // ! page width

  const HandleClick = async () => {
    let addressData = null;

    if (isLoggedIn === "true") {
      addressData = loginAddress;
    } else {
      addressData = guestAddress;
    }
    const checkTime = checkOrderTime();
    if (checkTime) {
      setEstimateShow(true);
    } else if (!addressData) {
      setAddressPopupshow(true);
    } else {
      setButtonstatus(true);
      dispatch(PlaceCardStatus(true));

      if (!stripe || !elements) {
        return;
      }

      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card: elements.getElement(
          CardExpiryElement,
          CardNumberElement,
          CardCvcElement
        ),
      });

      if (error) {
        scrollToSection();
        setFooterBtn(true);
        console.log(error);
        setCardErrorMessage(error.message);
        dispatch(PlaceCardStatus(false));
        setButtonstatus(false);

        return;
      } else {
        setButtonstatus(true);
        dispatch(PlaceCardStatus(true));

        if (!stripe || !elements) {
          return;
        }

        const { error, paymentMethod } = await stripe.createPaymentMethod({
          type: "card",
          card: elements.getElement(
            CardExpiryElement,
            CardNumberElement,
            CardCvcElement
          ),
        });

        if (error) {
          scrollToSection();
          setFooterBtn(true);
          console.log(error);
          setCardErrorMessage(error.message);
          dispatch(PlaceCardStatus(false));
          setButtonstatus(false);

          return;
        } else {
        }

        setPaymentMId(paymentMethod.id);
        setPayType("paymentMethodId");
        setPaySubmit(1);
      }
    }
  };

  const placeKlarnaOrder = async (event) => {
    event.preventDefault();
    const checkTime = checkOrderTime();
    if (checkTime) {
      setEstimateShow(true);
    } else {
      setPayType("klarnaIntent");
      setPaySubmit(10);
      setButtonstatus(true);
    }
  };

  // const buttonStyles = {
  //   paymentRequestButton: {
  //     height: "200px",
  //     /* Other styles */
  //   },
  // };

  // add style google & apply pay button
  const options = {
    paymentRequest,
    style: {
      paymentRequestButton: {
        type: "default",
        // One of 'default', 'book', 'buy', or 'donate'
        // Defaults to 'default'
        theme: "dark",
        // One of 'dark', 'light', or 'light-outline'
        // Defaults to 'dark'
        height: "40px",
        borderRadius: "10px",
        margin: "25px",
        // Defaults to '40px'. The width is always '100%'.
      },
    },
  };

  const setHeight = document.querySelector(".order-place")?.offsetHeight;

  // const handlePopup = () => {
  //   setShowPopup(true);
  // };

  // const handleClosePopup = () => {
  //   setShowPopup(false);
  // };
  const handleClickToShow = () => {
    setPaymentModalShow(true);
  };
  const handleCVCchange = (event) => {
    if (event.complete) {
      setSavecardPay(1); // Hide CVC after complete entry
    }
    setSaveCardError(null);
    setButtonstatus(false);
  };
  const checkTime = checkOrderTime();
  const checkPreorderTime = async (event) => {
    setEstimateShow(true);
    return;
  };

  const handleExtraAmount = (e) => {
    if (e.target.checked) {
      console.log("Checkbox is checked, extra amount applied");
      // setExtraAmountModal(true);
      // setPaymentType(1);
      setUseWalletBalance(true);
      setExtraStatus(true);
      // setWalletstatus(true);
    } else {
      setUseWalletBalance(false);
      setExtraStatus(false);
      // setExtraLessAmount(null);
      console.log("Checkbox is unchecked");
    }
  };

  return (
    <>
      <div className="cart-page" name="cart-canva-btn-heading">
        <div className="order-duplicate" style={{ height: setHeight }}></div>

        {/* {width > 767 && <FKPlus />} */}

        <div className="order-place pb-4">
          {width <= 767 && !status ? (
            <>
              {/* <div className="total-price mb-2">
                  <span>Total</span>
                  <span>{currency_symbol}{finalTotalValue}</span>
                </div> */}
              {extraPayment && (
                <>
                  <div
                    className={walletamount > 0 ? "extraAmountDiv" : ""}
                    style={{ marginLeft: "15px", marginTop: "5px" }}
                  >
                    {walletamount > 0 && (
                      <>
                        <input
                          type="checkbox"
                          value="extraAmount"
                          onChange={handleExtraAmount}
                          className="checkwallet"
                        />
                        <label
                          className="ml-2"
                          style={{
                            margin: "7px",
                            fontSize: "15px",
                            fontFamily: '"Geist-Regular", sans-serif',
                          }}
                          onChange={handleExtraAmount}
                        >
                          Pay £{walletamount} from wallet{" "}
                        </label>
                      </>
                    )}
                  </div>
                </>
              )}
              <div className="total-price">
                {selectedValue === "google-pay" && googlepaytype ? (
                  <div className="selected-tab d-flex justify-content-center align-items-center gap-2">
                    <div
                      className="new-fus"
                      style={{
                        border: "1px solid #9ee86f",
                        padding: "10px",
                        borderRadius: "10px",
                      }}
                    >
                      <img
                        src={Gpay}
                        alt="gpayicon"
                        style={{ height: "35px" }}
                      />
                    </div>
                    <div>
                      <span style={{ fontWeight: "500", color: "#00000" }}>
                        Pay using{" "}
                      </span>
                      <p className="paytype">pay</p>
                    </div>
                  </div>
                ) : selectedValue === "apple-pay" && applepaytype ? (
                  <div className="selected-tab d-flex justify-content-center align-items-center gap-2">
                    <div
                      className="new-fus"
                      style={{
                        border: "1px solid #9ee86f",
                        padding: "10px",
                        borderRadius: "10px",
                      }}
                    >
                      <img
                        src={theme === "dark" ? applepaydark : applepays}
                        style={{ height: "35px" }}
                        alt="applepayicon"
                      />
                    </div>
                    <div>
                      <span style={{ fontWeight: "500", color: "#00000" }}>
                        Pay using{" "}
                      </span>
                      <p className="paytype">pay</p>
                    </div>
                  </div>
                ) : selectedValue === "paypal" && paypalType ? (
                  <div className="selected-tab d-flex justify-content-center align-items-center gap-2">
                    <div
                      className="new-fus"
                      style={{
                        border: "1px solid #9ee86f",
                        padding: "10px",
                        borderRadius: "10px",
                      }}
                    >
                      <img src={Paypallogo} alt="paypallogo" />
                    </div>
                    <div>
                      <span style={{ fontWeight: "500", color: "#00000" }}>
                        Pay using{" "}
                      </span>
                      <p className="paytype">PayPal</p>
                    </div>
                  </div>
                ) : selectedValue === "klarna" && klarnaType ? (
                  <div className="selected-tab d-flex justify-content-center align-items-center gap-2">
                    <div
                      className="new-fus"
                      style={{
                        border: "1px solid #9ee86f",
                        padding: "10px",
                        borderRadius: "10px",
                      }}
                    >
                      <img
                        src={klarnapay}
                        alt="klarnapay"
                        style={{ height: "30px" }}
                      />
                    </div>
                    <div>
                      <span style={{ fontWeight: "500", color: "#00000" }}>
                        Pay using{" "}
                      </span>
                      <p className="paytype">Klarna</p>
                    </div>
                  </div>
                ) : selectedValue === "cardimg1" && cardtype ? (
                  <>
                    <div className="selected-tab d-flex justify-content-center align-items-center gap-2">
                      <div
                        className="new-fus"
                        style={{
                          border: "1px solid #9ee86f",
                          padding: "10px",
                          borderRadius: "10px",
                        }}
                      >
                        <img
                          src={CreditdebitCardImg}
                          alt="cardimage"
                          style={{ height: "35px" }}
                        />
                      </div>
                      <div>
                        <span style={{ fontWeight: "500", color: "#00000" }}>
                          Pay using{" "}
                        </span>
                        <p className="paytype">Card</p>
                      </div>
                    </div>
                  </>
                ) : selectedValue === "cashimg" && cashtype ? (
                  <>
                    <div className="selected-tab d-flex justify-content-center align-items-center gap-2">
                      <div
                        className="new-fus"
                        style={{
                          border: "1px solid #9ee86f",
                          padding: "10px",
                          borderRadius: "10px",
                        }}
                      >
                        <img
                          src={Cashimgicondesktop}
                          alt="cashimage"
                          style={{ height: "30px" }}
                        />
                      </div>
                      <div>
                        <span style={{ fontWeight: "500", color: "#00000" }}>
                          Pay using{" "}
                        </span>
                        <p className="paytype">Cash</p>
                      </div>
                    </div>
                  </>
                ) : selectedValue === "savedcard" && cardtype ? (
                  <>
                    {paysaveCard ? (
                      <>
                        {paysaveCard?.map((savedCard, index) => (
                          <>
                            {savedCard?.primary === "1" ? (
                              <div key={index} style={{ width: "100%" }}>
                                <div className="selected-tab  gap-2">
                                  <div>
                                    <div className="elementDiv d-flex">
                                      <div className="creditcardui   gap-2">
                                        <img
                                          src={savedCard?.brand}
                                          alt="savedcard"
                                          style={{ height: "40px" }}
                                        />
                                      </div>

                                      <div
                                        className="creditcarduichild"
                                        style={{
                                          width: "50%",
                                          marginLeft: "15px",
                                        }}
                                      >
                                        <p style={{ margin: "0px" }}>
                                          {savedCard?.card}
                                        </p>
                                        <div className="mt-3">
                                          <div style={containerStyle}>
                                            {savecardPay === 0 && (
                                              <CardCvcElement
                                                options={CARD_OPTIONS1}
                                                onChange={handleCVCchange}
                                              />
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    {saveCardError ? (
                                      <>
                                        <span style={{ color: "red" }}>
                                          {saveCardError}
                                        </span>
                                      </>
                                    ) : (
                                      BsNutFill
                                    )}
                                  </div>
                                </div>
                                <button
                                  className="col-sm-12"
                                  disabled={
                                    buttonstatus || minOrderStatus
                                      ? true
                                      : false
                                  }
                                  onClick={() =>
                                    handlesavecardPayment(
                                      savedCard.paymentMethodId
                                    )
                                  }
                                >
                                  {buttonstatus && !saveCardError ? (
                                    <Spinner
                                      animation="border"
                                      size="sm"
                                      variant="success"
                                    />
                                  ) : (
                                    "Pay"
                                  )}
                                </button>
                              </div>
                            ) : null}
                          </>
                        ))}
                      </>
                    ) : null}
                  </>
                ) : selectedValue === "cashimg" && cashtype ? (
                  <p onClick={handleClickToShow} className="change">
                    Select Payment method
                  </p>
                ) : guestusered !== "" && selectedValue === "wallet" ? (
                  isLoggedIn === "true" ? (
                    <div className="selected-tab d-flex justify-content-center align-items-center gap-2">
                      <div
                        className="new-fus"
                        style={{
                          border: "1px solid #9ee86f",
                          padding: "10px",
                          borderRadius: "10px",
                        }}
                      >
                        <img
                          src={theme === "dark" ? CardIconDark : CardIcon}
                          alt="cardicon"
                          style={{ height: "30px" }}
                        />
                      </div>
                      <div>
                        <span style={{ fontWeight: "500", color: "#00000" }}>
                          Pay using{" "}
                        </span>
                        <p className="paytype">Wallet</p>
                      </div>
                    </div>
                  ) : null
                ) : (
                  <></>
                )}

                {selectedValue && selectedValue ? (
                  <>
                    <div style={{ textAlign: "center" }}>
                      {/* <span style={{ color: "rgb(58 87 102)" }}>
                          {currency_symbol}{finalTotalValue}
                        </span> */}
                      <div className="total-pricechild d-block d-sm-none">
                        <p onClick={handleClickToShow}> Change</p>
                      </div>
                    </div>
                  </>
                ) : null}
              </div>

              {paymentType == 1 &&
              selectedValue !== "savedcard" &&
              selectedValue !== "wallet" &&
              cardtype ? (
                <>
                  <div className="total-pricechild">
                    {/* <p onClick={handleClickToShow}>Change</p> */}
                  </div>
                  <button
                    disabled={
                      footerBtn
                        ? true
                        : buttonstatus || minOrderStatus
                        ? true
                        : false
                    }
                    onClick={HandleClick}
                  >
                    {buttonstatus ? (
                      <Spinner animation="border" size="sm" variant="success" />
                    ) : (
                      "Place " + getOrderMode + " order"
                    )}
                  </button>
                </>
              ) : paymentType == 14 && paypalType ? (
                <>
                  <div className="total-pricechild">
                    {/* <p onClick={handleClickToShow}>Change</p> */}
                  </div>
                  <div style={{ display: "flex" }}>
                    {/* <ToPay /> */}
                    <button
                      onClick={PaypalHandleClick}
                      disabled={buttonstatus || minOrderStatus ? true : false}
                    >
                      {buttonstatus ? (
                        <Spinner
                          animation="border"
                          size="sm"
                          variant="success"
                        />
                      ) : (
                        "Place  order with paypal"
                      )}
                    </button>
                  </div>
                </>
              ) : paymentType == 9 && cardtype && extraPayStatus ? (
                <>
                  <p className="mt-2" style={{ paddingLeft: "30px" }}>
                    {walletstatus == 1 ? (
                      <>Available Balance: {walletamount}</>
                    ) : (
                      <>Insufficient Balance in Your Wallet:{walletamount}</>
                    )}
                  </p>
                  <div className="total-pricechild">
                    {/* <p onClick={handleClickToShow}>Change</p> */}
                  </div>
                  <div style={{ display: "flex" }}>
                    {/* <ToPay /> */}
                    <button
                      onClick={PlacewalletOrder}
                      disabled={walletstatus == 0}
                    >
                      {buttonstatus ? (
                        <Spinner
                          animation="border"
                          size="sm"
                          variant="success"
                        />
                      ) : (
                        "Place " + getOrderMode + " order"
                      )}
                    </button>
                  </div>
                </>
              ) : paymentType == 10 && klarnaType ? (
                <>
                  <div className="payment-btn">
                    <div style={{ display: "flex" }}>
                      {/* <ToPay /> */}
                      <button
                        onClick={placeKlarnaOrder}
                        disabled={minOrderStatus ? true : false}
                      >
                        {buttonstatus ? (
                          <Spinner
                            animation="border"
                            size="sm"
                            variant="success"
                          />
                        ) : (
                          "Place  order with klarna"
                        )}
                      </button>
                    </div>
                  </div>
                </>
              ) : (paymentType == 8 && googlepaytype) ||
                (paymentType == 7 && applepaytype) ? (
                <>
                  <div className="payment-btn" style={{ display: "flex" }}>
                    {/* <div style={{ display: 'flex !important' }}>
                      <ToPay />
                    </div> */}
                    <div style={{ width: "100%", marginTop: "20px" }}>
                      {paymentRequest ? (
                        <>
                          {checkTime ? (
                            <>
                              <button onClick={checkPreorderTime}>
                                Proceed
                              </button>
                            </>
                          ) : (
                            !minOrderStatus && (
                              <PaymentRequestButtonElement
                                options={options}
                                onClick={handlePayment}
                              />
                            )
                          )}
                        </>
                      ) : (
                        <>
                          {paymentLoad ? (
                            <>
                              <div
                                className="spinner-container"
                                style={{ alignItems: "center" }}
                              >
                                <Spinner
                                  animation="border"
                                  size="sm"
                                  variant="success"
                                />
                              </div>
                            </>
                          ) : (
                            <>
                              {paymentType === 8 ? (
                                <>
                                  <p>
                                    Sorry, Google Pay is not available on your
                                    device
                                  </p>
                                </>
                              ) : paymentType === 7 ? (
                                <>
                                  <p>
                                    Sorry, Apple Pay is not available on your
                                    device
                                  </p>
                                </>
                              ) : (
                                <>
                                  <p>Something Went Wrong</p>
                                </>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </>
              ) : paymentType == 9 && cardtype ? (
                <>
                  <div style={{ display: "flex" }}>
                    {/* <ToPay /> */}
                    <button
                      className="order-btn"
                      onClick={PlacewalletOrder}
                      disabled={walletstatus == 0}
                    >
                      {buttonstatus ? (
                        <Spinner
                          animation="border"
                          size="sm"
                          variant="success"
                        />
                      ) : (
                        "Place " + getOrderMode + " order"
                      )}
                    </button>
                  </div>
                </>
              ) : paymentType == 0 && cashtype ? (
                <>
                  <div className="total-pricechild mt-2">
                    {/* <p onClick={handleClickToShow}>Change</p> */}
                  </div>
                  {/* disabled={cashtype == 0} */}
                  <div style={{ display: "flex" }}>
                    {/* <ToPay /> */}
                    <button
                      onClick={PlaceCashOrder}
                      disabled={minOrderStatus ? true : false}
                    >
                      {buttonstatus ? (
                        <Spinner
                          animation="border"
                          size="sm"
                          variant="success"
                        />
                      ) : (
                        "Place " + getOrderMode + " order"
                      )}
                    </button>
                  </div>
                </>
              ) : (
                <>
                  {/* <div className="total-pricechild d-block d-sm-none">
                      <p onClick={handleClickToShow}> Change</p>
                    </div>
                    <button onClick={HandleClick}>
                      Place your {getOrderMode} order
                    </button> */}
                </>
              )}
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};

const MobilePayMentDropdown = () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const { theme } = useContext(ThemeContext);
  const { getOrderMode, getOrderTime } = OrderFlow();
  const {
    deliveryCharge,
    bagCharge,
    clientFkCharge,
    setFinalTotal,
    currency_symbol,
  } = CheckoutData();
  const {
    stripepayment,
    stripe,
    elements,
    setPayType,
    paymentSva,
    setPaymentSva,
    paymentMId,
    setPaymentMId,
    setPaymentIntentId,
    setPaymentType,
    setPaySubmit,
    paySubmit,
    clientSecret,
    setClientSecret,
    payPalClientSecret,
    svclientSecret,
    setSvpaySubmit,
    svpaySubmit,
    walletstatus,
    setWalletstatus,
    walletamount,
    setWalletamount,
    setCardErrorMessage,
    cardErrorMessage,
    finalTotalValue,
    selectedValue,
    setSelectedValue,
    paymentOptions,
    cardtype,
    setCardtype,
    setPaypalType,
    paypalType,
    applepaytype,
    setApplepaytype,
    googlepaytype,
    setGooglepaytype,
    klarnaType,
    setKlarnaType,
    setFooterBtn,
    sectionRef,
    buttonstatus,
    setButtonstatus,
    setPaymentModalShow,
    paymentModalShow,
    gpaydeviceInfo,
    appledeviceInfo,
    setPaySaveCard,
    handlesavecardPayment,
    CARD_OPTIONS1,
    containerStyle,
    setSaveCardError,
    setCardStatus,
    paySpinner,
    cashtype,
    setCashtype,
    setExtraLessAmount,
    extraPayment,
    setExtraPayment,
    setExtraPayStatus,
    setUseWalletBalance,
    setFinalTotalValue,
    clientName,
    clientLogo,
    itemAvailableData,
    useWalletBalance,
    polling,
  } = useContext(CheckoutContext);
  const webcamRef = useRef(null);
  const [activeKey, setActiveKey] = useState("add-card"); // Add state to store CCV
  const [savecardPay, setSavecardPay] = useState(0); // Add state to store CCV
  const [showModalPromo, setShowModalPromo] = useState(false);
  const [voucherValue, setVoucherValue] = useState("");
  const [voucherApplied, setVoucherApplied] = useState(false);
  const [validDiscount, setValidDiscount] = useState(true);
  const [voucherMinimum, setVoucherMinimum] = useState(false);
  const [voucherLogin, setVoucherLogin] = useState(false);
  const [voucherUsed, setVoucherUsed] = useState(false);
  const [voucherLoad, setVoucherLoad] = useState(false);
  const [customer, setCustomer] = useState("");
  const [parsedDiscount, setParsedDiscount] = useState("");
  const [cartItemsData, setcartItems] = useState([]);
  const orderTime = getOrderTime;
  const [appliedDiscount, setAppliedDiscount] = useState(0);
  const [cardBrand, setCardBrand] = useState("");
  const [loadingScan, setLoadingScan] = useState(false);
  const [showWebcam, setShowWebcam] = useState(false);
  const [showSecureModal, setShowSecureModal] = useState(false);
  const [showCVVInfo, setShowCVVInfo] = useState(false);
  const [cardInfo, setCardInfo] = useState({
    number: "",
    expiry: "",
  });
  const [showSavedCardSection, setShowSavedCardSection] = useState(true);
  const [showSavedCardPopUp, setShowSavedCardPopUp] = useState(false);

  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const loginAddress = localStorage.getItem("loginAddress") || "";
  const guestAddress = localStorage.getItem("guestAddress") || "";
  const path = localStorage.getItem("clientPath");
  const domain = window.location.origin;

  const subTotal = localStorage.getItem("totalPrice");
  const roundedValue = localStorage.getItem("roundOffPrice");
  const driverTipValue = localStorage.getItem("driverTipValue")
    ? localStorage.getItem("driverTipValue")
    : "0";
  // stripe style
  const guestusered = localStorage.getItem("guestAddress");

  const getCardBrandIcon = (brand) => {
    switch (brand) {
      case "visa":
        return faCcVisa;
      case "mastercard":
        return faCcMastercard;
      case "amex":
        return faCcAmex;
      case "discover":
        return faCcDiscover;
      case "diners":
        return faCcDinersClub;
      case "jcb":
        return faCcJcb;
      default:
        return null;
    }
  };

  const CARD_OPTIONS = {
    iconStyle: "solid",
    style: {
      base: {
        iconColor: "#c4f0ff",
        color: theme === "dark" ? "#fff" : "#000",
        fontWeight: 300,
        border: "1px solid #ddd", // Add border style here
        fontFamily: "Source Code Pro, monospace",
        fontSmoothing: "antialiased",
        ":-webkit-autofill": {
          color: `${theme === "dark" ? "#fff" : "#000"}`, // Conditional color
          backgroundColor: `${theme === "dark" ? "#02111f" : "#fff"}`, // Conditional color
        },
        "::placeholder": { color: "#aab7c4" },
        backgroundColor: theme === "dark" ? "#02111f" : "#fff", // // Background color for the card input area
        padding: "10px", // Adjust padding as needed
        fontSize: "16px", // Padding for the card input area
      },
      invalid: {
        iconColor: "#ffc7ee",
        color: theme === "dark" ? "red" : "#000",
        backgroundColor: theme === "dark" ? "#02111f" : "#fff", //Background color for invalid input
        padding: "10px", // Padding for the invalid input area
      },
    },
  };

  // stripe style
  // Function to update the JSON data with the new paymentMethodId

  // Function to handle the change event
  const handleChange = async (event) => {
    const setpt = event?.target?.value;
    // Define a lookup table for payment types
    const paymentTypeMap = {
      cashimg: 0,
      cardimg: 1,
      "apple-pay": 7,
      "google-pay": 8,
      wallet: 9,
      klarna: 10,
      paypal: 14,
      savedcard: 12,
    };

    // Use the lookup table to set the payment type, defaulting to 1 if not found
    const paymentType = paymentTypeMap[setpt];
    console.log(paymentType);

    setPaymentType(paymentType);
    console.log(event.target.value);
    setSelectedValue(event.target.value);
    console.log(selectedValue);
    // handlePaymentSelection(paymentType, setpt);
    if (paymentType === 9) {
      setUseWalletBalance(true);
    } else {
      setUseWalletBalance(false);
    }
  };

  const handlePaymentSelection = async (paymentType, selectedValue) => {
    setPaymentType(paymentType);
    console.log(paymentType);
    setSelectedValue(selectedValue);
    setPaymentModalShow(false);
    if (paymentType === 9) {
      setUseWalletBalance(true);
    } else {
      setUseWalletBalance(false);
    }
  };

  const dispatch = useDispatch();
  const [selectedCard, setSelectedCard] = useState(null);
  const [cardaccordion, setcardAccordion] = useState(null);
  const [primary, setPrimary] = useState(true);
  const [fullscreen, setFullscreen] = useState("sm-down");
  const [showchildpopup, setshowchildpopup] = useState(false);
  const cardSelector = useSelector(
    (state) => state.placeorderStatusReducer?.placecard
  );

  useEffect(() => {
    setcardAccordion(cardSelector);
  }, [cardSelector]);
  // console.log(cardaccordion);

  const handlecardChange = (e) => {
    setSelectedCard(e.target.value);
    setPrimary(false);
    dispatch(postPlaceOrderStatus(true));
  };

  const handleSaveCardCheckboxClick = () => {
    setPaymentSva(paymentSva == 0 ? 1 : 0);
  };

  // console.log(paymentSva);
  const orderModeCheck = localStorage.getItem("orderMode");
  const isLoggedInChecked = localStorage.getItem("isLoggedIn");
  useEffect(() => {
    // Check if stripepayment is available before updating state
    let width = window.innerWidth;
    if (stripepayment) {
      const paymentStatus = stripepayment.message.paymentStatus;
      if (isLoggedIn === "true") {
        if (orderModeCheck === "Delivery") {
          setCashtype(paymentStatus.cash && 1);
          setPaypalType(paymentStatus.paypalStatus && 1);
          setCardtype(paymentStatus.card && 1);
          setApplepaytype(paymentStatus.applePay && 1);
          setGooglepaytype(paymentStatus.googlePay && 1);
          setKlarnaType(paymentStatus.klarna && 1);
          if (width > 1199) {
            if (paymentStatus.card && 1) {
              setSelectedValue("cardimg");
              setPaymentType(1);
            } else {
              if (paymentStatus.cash && 1) {
                setSelectedValue("cashimg");
                setPaymentType(0);
              }
            }
          }
        } else {
          setCashtype(paymentStatus.coll_cash && 1);
          setPaypalType(paymentStatus.paypalStatus && 1);
          setCardtype(paymentStatus.coll_card && 1);
          setApplepaytype(paymentStatus.coll_applePay && 1);
          setGooglepaytype(paymentStatus.coll_googlePay && 1);
          setKlarnaType(paymentStatus.klarna && 1);
          if (width > 1199) {
            if (paymentStatus.coll_card && 1) {
              setSelectedValue("cardimg");
              setPaymentType(1);
            } else {
              if (paymentStatus.coll_cash && 1) {
                setSelectedValue("cashimg");
                setPaymentType(0);
              }
            }
          }
        }
      } else {
        setCashtype(paymentStatus.guest_cash && 1);
        setPaypalType(paymentStatus.paypalStatus && 1);
        setCardtype(paymentStatus.coll_card && 1);
        setApplepaytype(paymentStatus.coll_applePay && 1);
        setGooglepaytype(paymentStatus.coll_googlePay && 1);
        setKlarnaType(paymentStatus.klarna && 1);
        if (width > 1199) {
          if (paymentStatus.coll_card && 1) {
            setSelectedValue("cardimg");
            setPaymentType(1);
          } else {
            if (paymentStatus.guest_cash && 1) {
              setSelectedValue("cashimg");
              setPaymentType(0);
            }
          }
        }
      }
    }
  }, [stripepayment, orderModeCheck, isLoggedInChecked]);

  useEffect(() => {
    if (stripepayment && !isNaN(finalTotalValue) && finalTotalValue > 0) {
      const oamount = finalTotalValue;
      const walletamount = stripepayment?.message?.wallet;

      if (walletamount !== undefined) {
        setWalletamount(walletamount);
        setWalletstatus(
          parseFloat(walletamount) >= parseFloat(oamount) ? 1 : 0
        );
      }
      const walletAmount = parseFloat(walletamount); // Assuming walletamount = "138.96"
      const oAmount = parseFloat(oamount);
      const isButtonEnabled = walletAmount <= oAmount;
      if (isButtonEnabled) {
        const oAmount1 = parseFloat(oamount) || 0;
        const walletAmount1 = parseFloat(walletamount) || 0;
        const setExtraLess = oAmount1 - walletAmount1;
        setExtraPayStatus(1);
        setExtraLessAmount(setExtraLess);
        console.log(setExtraLess);
        setExtraPayment(true);
        console.log("hii--1");
      } else {
        setExtraPayment(false);
        setExtraPayStatus(0);
        // setExtraLessAmount(null);
        console.log("hii--2");
      }
    }
  }, [stripepayment, finalTotalValue]);

  // console.log(svpaySubmit);

  // console.log(svclientSecret);
  const voucherData = useMemo(() => {
    const orderTime = localStorage.getItem("orderTime") || "";
    let dateParts = "";
    let timePart = "";
    let formattedDate = "";
    if (orderTime) {
      let inputDate = orderTime;
      if (inputDate.includes("/")) {
        dateParts = inputDate.split(" ")[0].split("/"); // Split the date into parts
        timePart = inputDate.split(" ")[1]; // Get the time part
        // Create a Date object with the parts
        const dateObject = new Date(
          `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}T${timePart}`
        );
        // Format the date in the desired format
        const year = dateObject.getFullYear();
        const month = String(dateObject.getMonth() + 1).padStart(2, "0");
        const day = String(dateObject.getDate()).padStart(2, "0");
        const hour = String(dateObject.getHours()).padStart(2, "0");
        const minute = String(dateObject.getMinutes()).padStart(2, "0");
        formattedDate = `${year}-${month}-${day} ${hour}:${minute}`;
      } else {
        formattedDate = orderTime;
      }
    }
    return {
      customerId: customer.customerId,
      clientPath: path,
      orderTime: formattedDate,
      voucherCode: voucherValue || "",
    };
  }, [path, orderTime, customer, voucherValue]);

  useEffect(() => {
    // save card client secret id confirm payment
    if (svpaySubmit == 2) {
      // After set save card secret id i have changed svpaysubmit == 2
      const confirmPayment = async () => {
        const cardCvcElement = elements.getElement(CardCvcElement);

        try {
          const result = await stripe.confirmCardPayment(svclientSecret, {
            payment_method: paymentMId,
            payment_method_options: {
              card: {
                cvc: cardCvcElement,
              },
            },
          });

          if (result.error) {
            // Handle the error (e.g., display an error message)
            setSaveCardError(result.error.message);
            console.error(result.error.message);
          } else {
            // Payment was successful
            setSvpaySubmit(3);
            setPayType("paymentIntentId");
            setPaymentIntentId(result.paymentIntent.id);
            console.log("Payment confirmed:", result.paymentIntent);
          }
        } catch (error) {
          // Handle any unexpected errors
          console.error("Error confirming payment:", error);
        }
      };

      // Call the function to confirm payment
      confirmPayment();
    }

    // common confirm payment code
    if (paySubmit == 2) {
      // After set save card secret id i have changed svpaysubmit == 2
      const cardconfirmPayment = async () => {
        // console.log(clientSecret);
        // console.log(paymentMId);

        try {
          const result = await stripe
            .confirmCardPayment(clientSecret)
            .then(function (result) {
              if (result.error) {
                setButtonstatus(false);
                setClientSecret(0);
                setPayType("paymentMethodId");
                setPaymentIntentId("");
                setPaymentMId("");
                dispatch(clearPlaceOrder());
                // console.log(result);
                // Handle the error (e.g., display an error message)
                // console.error(result.error.message);
              } else {
                setPaySubmit(3);
                setPayType("paymentIntentId");
                console.log("Payment confirmed:", result);
              }
            });
        } catch (error) {
          console.log(error);
          // Handle any unexpected errors
          // console.error("Error confirming payment:", error);
        }
      };

      // Call the function to confirm payment
      cardconfirmPayment();
    }
    if (paySubmit === 14 && payPalClientSecret) {
      const checkLoginAddress = localStorage.getItem("loginAddress") || "";
      const checkGuestAddress = localStorage.getItem("guestAddress") || "";
      const path = localStorage.getItem("clientPath");
      const domain = window.location.origin;

      const confirmPayPalPayment = async () => {
        let addressFromUser = null;
        if (isLoggedIn === "true") {
          addressFromUser = checkLoginAddress;
        } else {
          addressFromUser = checkGuestAddress;
        }
        const detailsFromUser = JSON.parse(addressFromUser);
        const currencyName = localStorage.getItem("currencyName");
        let countryCode;

        // Define currency based on country
        switch (currencyName) {
          case "USD":
            countryCode = "US"; // United States Dollar
            break;
          case "INR":
            countryCode = "IN"; // Indian Rupee
            break;
          case "GBP":
            countryCode = "GB"; // British Pound Sterling
            break;
          case "EUR":
            countryCode = "FR"; // Euro
            break;
          default:
            countryCode = "US"; // Default to USD
        }

        try {
          const { error } = await stripe.confirmPayPalPayment(
            payPalClientSecret,
            {
              payment_method: {
                billing_details: {
                  email: detailsFromUser?.email,
                  address: {
                    country: countryCode,
                  },
                },
              },
              return_url: `${domain}/${encodeURIComponent(path)}/checkout`,
            }
          );

          if (error) {
            console.error(error.message);
            setPaySubmit(0);
            setPayType("");
          } else {
            setPaySubmit(3);
            setPayType("paymentIntentId");
            console.log("PayPal Payment confirmed:");
          }
        } catch (error) {
          console.error("Error confirming PayPal payment:", error);
        }
      };

      confirmPayPalPayment();
    }
  }, [
    svpaySubmit,
    svclientSecret,
    paymentMId,
    elements,
    stripe,
    paySubmit,
    payPalClientSecret,
  ]);

  useEffect(() => {
    // common klarna payment code
    if (paySubmit === 10 && clientSecret !== 0) {
      const klarnaPaymentConfirm = async () => {
        let addressData = null;
        if (isLoggedIn === "true") {
          addressData = loginAddress;
        } else {
          addressData = guestAddress;
        }
        const address = JSON.parse(addressData);

        const currencyName = localStorage.getItem("currencyName");
        let countryCode;

        // Define currency based on country
        switch (currencyName) {
          case "USD":
            countryCode = "US"; // United States Dollar
            break;
          case "INR":
            countryCode = "IN"; // Indian Rupee
            break;
          case "GBP":
            countryCode = "GB"; // British Pound Sterling
            break;
          case "EUR":
            countryCode = "FR"; // Euro
            break;
          default:
            countryCode = "US"; // Default to USD
        }

        try {
          await stripe.confirmKlarnaPayment(clientSecret, {
            payment_method: {
              billing_details: {
                email: address?.email,
                address: {
                  country: countryCode,
                },
              },
            },
            return_url: `${domain}/${path}/checkout`,
          });
        } catch (error) {
          console.log("Error confirming Klarna payment:", error);
          // Handle errors
        }
      };
      klarnaPaymentConfirm();
    }
  }, [
    svpaySubmit,
    svclientSecret,
    paymentMId,
    elements,
    stripe,
    paySubmit,
    clientSecret,
  ]);
  const discountJSON = localStorage.getItem("discount");
  const SummaryOrderType = getOrderMode === "Collection" ? 1 : 0;

  useEffect(() => {
    const discount = discountJSON ? JSON.parse(discountJSON) : "";
    setParsedDiscount(discount);
    let finalTotalValue =
      parseFloat(subTotal) +
      parseFloat(deliveryCharge) +
      parseFloat(bagCharge) +
      parseFloat(clientFkCharge) +
      parseFloat(driverTipValue);

    if (
      parsedDiscount !== "" &&
      (parsedDiscount?.orderType === SummaryOrderType ||
        parsedDiscount?.orderType === "2")
    ) {
      if (discount?.appliedDiscount) {
        finalTotalValue -= parseFloat(discount.appliedDiscount);
      }
    }

    if (discount?.source == "voucherDiscount") {
      setVoucherValue(discount?.discount || "");
    }
    if (discount?.source == "SubscriptionCoupon") {
      setVoucherValue(discount?.discount || "");
      setVoucherApplied(true);
    }
    setAppliedDiscount(discount?.appliedDiscount || 0);
    localStorage.setItem("finalTotal", finalTotalValue.toFixed(2));
    setFinalTotal(finalTotalValue.toFixed(2));
    setFinalTotalValue(
      (parseFloat(finalTotalValue) + parseFloat(roundedValue)).toFixed(2)
    );
    localStorage.setItem(
      "finalTotalValue",
      (parseFloat(finalTotalValue) + parseFloat(roundedValue)).toFixed(2)
    );
  }, [
    subTotal,
    parsedDiscount,
    deliveryCharge,
    bagCharge,
    clientFkCharge,
    driverTipValue,
    roundedValue,
    discountJSON,
    useWalletBalance,
    polling,
  ]);

  useEffect(() => {
    let localStorageData =
      localStorage.getItem("cart") &&
      localStorage.getItem("cart") !== "undefined"
        ? JSON.parse(localStorage.getItem("cart"))
        : [];

    setcartItems(localStorageData);
  }, [localStorage.getItem("cart")]);

  if (!stripepayment) {
    return <div>Loading...</div>;
  }

  const SavedCards = stripepayment?.message?.card?.cardDetail;

  if (SavedCards) {
    setPaySaveCard(SavedCards);
  }

  // Assign to a separate variable
  // if (SavedCards) {
  //   console.log("SavedCards =>", SavedCards);
  // }

  const handleToggle = (eventKey) => {
    setActiveKey(eventKey === activeKey ? null : eventKey);
    setSavecardPay(activeKey == "add-card" ? 1 : 0);
  };
  const handleCardChange = (e) => {
    setCardStatus(true);
    setCardErrorMessage(null);
    setFooterBtn(false);
    dispatch(postPlaceOrderStatus(false));
  };

  function handleShow() {
    setPaymentModalShow(true);
  }

  function handlechildshow() {
    setPaymentType(1);
    setSelectedValue("cardimg1");
    setshowchildpopup(true);
    // setCardtype(true);
    setPaymentModalShow(false);
  }
  // const hanldechildclosenew = () => {
  //   setshowchildpopup(false);
  //   setPaymentModalShow(false);
  //   setSelectedValue("");   // Reset selectedValue so modal condition becomes false
  //   // setCardType(null);      // Optional: Reset cardtype if needed
  // };

  const hanldechildclosenew = () => {
    setshowchildpopup(false);
    setSelectedValue("cardimg1");
    // setCardtype(null);
    setPaymentModalShow(false);
  };

  const handleClose = () => setPaymentModalShow(false);

  // function JsonDisplay({ data }) {
  //   // Format the JSON data with indentation for readability
  //   const formattedData = JSON.stringify(data, null, 2);

  //   return (
  //     <div>
  //       <h4>Formatted JSON Data</h4>
  //       <pre>{formattedData}</pre>
  //     </div>
  //   );
  // }

  if (paySpinner) {
    <Loader />;
  }

  const handleOpenModal = () => setShowModalPromo(true);
  const handleCloseModal = () => setShowModalPromo(false);
  // const handleApply = () => {
  //   console.log("Applied voucher:", voucherCode);
  //   setShowModalPromo(false);
  // };

  const handleKeyChange = () => {
    setVoucherUsed(false);
    setVoucherLogin(false);
    setVoucherMinimum(false);
    setValidDiscount(true);
    setVoucherApplied(false);
  };

  const checkVoucher = () => {
    if (voucherValue == "") {
      setValidDiscount(false);
    }
    //Subscription Coupon Code Apply
    const SubscriptionCouponCode1 = localStorage.getItem("SubcripeCoupon");

    // Check if the value exists and is not the string "undefined"
    const SubscriptionCouponCode =
      SubscriptionCouponCode1 !== null &&
      SubscriptionCouponCode1 !== "undefined"
        ? JSON.parse(SubscriptionCouponCode1)
        : "";

    setVoucherLoad(true);
    if (
      SubscriptionCouponCode != "" &&
      typeof SubscriptionCouponCode !== "undefined"
    ) {
      console.log(voucherData);
      if (voucherValue === SubscriptionCouponCode.code) {
        const isCouponApplied = applySubcriptionCouponCode(
          SubscriptionCouponCode,
          getOrderMode
        );

        if (isCouponApplied) {
          setValidDiscount(true);
          setVoucherApplied(true);
          setVoucherLoad(false);
          // setCelebrate(true);
          // setTimeout(() => setCelebrate(false), 6000);
        }
      } else {
        setValidDiscount(false);
        setVoucherLoad(false);
      }
    } else {
      checkVoucherCode(voucherData)
        .then((response) => {
          if (!response.status) {
            if (response.message == "voucher code was already Used") {
              setVoucherUsed(true);
              setValidDiscount(false);
            } else if (response.message == "Invalid code") {
              setValidDiscount(false);
            } else if (response.message == "voucher not available") {
              setValidDiscount(false);
            } else if (response.message == "CustomerId is required") {
              setVoucherLogin(true);
              setValidDiscount(false);
            }
            setVoucherApplied(false);
            setVoucherLoad(false);
            // console.log("vocuherRespose");
            // console.log(response.message);
            return;
          }
          const storedCart = localStorage.getItem("cart");
          const localStorageCart = JSON.parse(storedCart) || [];
          const filteredItems = localStorageCart.filter(
            (cart) => cart.itemAllowCoupon === 1
          );
          const totalValue = filteredItems.reduce(
            (sum, item) => sum + parseFloat(item.price),
            0
          );
          // const totalValue = localStorage.getItem("totalPrice");
          if (
            parseFloat(totalValue) >= parseFloat(response.message.minAmount)
          ) {
            const voucher = {
              code: response.message.code,
              discount: response.message.discount,
              description: response.message.description,
              discountType: response.message.type,
              minOrder: response.message.minAmount,
            };
            applyVoucher(voucher, getOrderMode);
            setValidDiscount(true);
            setVoucherApplied(true);
            setVoucherLoad(false);
          } else {
            setVoucherMinimum(true);
            setVoucherLoad(false);
            setValidDiscount(false);
          }
        })
        .catch((error) => {
          setVoucherLoad(false);
          console.log(error);
        });
    }
  };

  // const startScanProcess = () => {
  //   setShowWebcam(true);
  //   setTimeout(() => {
  //     captureAndScan();
  //   }, 1000000); // Auto-capture after 2.5 seconds
  // };

  // const captureAndScan = async () => {
  //   if (!webcamRef.current) return;

  //   const screenshot = webcamRef.current.getScreenshot();

  //   if (!screenshot) {
  //     alert("Failed to capture image.");
  //     return;
  //   }

  //   setLoadingScan(true);

  //   try {
  //     const { data } = await Tesseract.recognize(screenshot, "eng", {
  //       logger: (m) => console.log(m),
  //     });

  //     console.log("Detected Text:", data.text);

  //     const cleanedText = data.text.replace(/[^0-9\/]/g, "");
  //     console.log("Cleaned OCR Text:", cleanedText);

  //     const cardNumberMatch = cleanedText.match(/\d{13,19}/);
  //     const expiryMatch = cleanedText.match(/(0[1-9]|1[0-2])\/?(\d{2}|\d{4})/);

  //     setCardInfo({
  //       number: cardNumberMatch ? cardNumberMatch[0] : "Not detected",
  //       expiry: expiryMatch ? expiryMatch[0] : "Not detected",
  //     });
  //   } catch (error) {
  //     console.error("OCR Error:", error);
  //     alert("Failed to scan card details.");
  //   } finally {
  //     setLoadingScan(false);
  //   }
  // };

  const handleSecureInfo = () => {
    setShowSecureModal(true);
  };
  const handleSecureClose = () => {
    setShowSecureModal(false);
  };

  const handleCVVInfo = () => {
    setShowCVVInfo(true);
  };
  const handleCVVclose = () => {
    setShowCVVInfo(false);
  };

  const handleSavedPopupShow = () => {
    setShowSavedCardSection(false);
    setShowSavedCardPopUp(true);
  };

  const handleSavedPopupClose = () => {
    setShowSavedCardSection(true);
    setShowSavedCardPopUp(false);
    setshowchildpopup(false);
    setPaymentModalShow(false);
    setSelectedValue("cardimg1");
  };
  const handleSavedCardCloseNew = () => {
    setShowSavedCardPopUp(false);
  };

  const mobileSaveCard = (
    <>
      {Array.isArray(SavedCards) &&
        SavedCards?.length > 0 &&
        SavedCards?.map((savedCard, index) => {
          const cardNumber = savedCard.card ?? "";
          const isSelected = selectedCard === cardNumber;
          const isPrimary = savedCard.primary === "1" && primary;

          return (
            <div
              key={index}
              style={{
                marginBottom: "16px",
                // border: "1px solid #eee",
                borderRadius: "12px",
                padding: "5px",
                backgroundColor: "#fff",
              }}
            >
              <label
                htmlFor={`savedcard-${index}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  gap: "12px",
                }}
              >
                <img
                  src={savedCard.brand || "/default.png"}
                  alt="card-logo"
                  style={{
                    width: "65px",
                    height: "65px",
                    objectFit: "contain",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "6px",
                    padding: "4px",
                  }}
                  onError={(e) => (e.target.src = "/default.png")}
                />
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: "22px" }}>
                    **** **** ***** {cardNumber.slice(-4)}
                  </div>
                  <small style={{ color: "#555", fontSize: "16px" }}>
                    Expires on {savedCard.expMonth}/
                    {String(savedCard.expYear).slice(-2)}
                  </small>
                </div>
                <input
                  id={`savedcard-${index}`}
                  type="radio"
                  name="savedcard"
                  value={cardNumber}
                  checked={isSelected}
                  onChange={handlecardChange}
                  className="custom-radio"
                />
              </label>

              {(isSelected || isPrimary) && (
                <div
                  style={{
                    marginTop: "16px",
                    display: "flex",
                    gap: "10px",
                    flexWrap: "wrap",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      flex: 1,
                      minWidth: "100px",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      padding: "10px",
                    }}
                  >
                    <CardCvcElement
                      options={{
                        iconStyle: "solid",
                        style: {
                          base: {
                            iconColor: "#c4f0ff",
                            color: "#000",
                            fontWeight: 300,
                            fontSize: "16px",
                            "::placeholder": {
                              color: "#aab7c4",
                            },
                          },
                          invalid: {
                            iconColor: "#ffc7ee",
                            color: "red",
                          },
                        },
                      }}
                    />
                  </div>

                  <button
                    onClick={() =>
                      handlesavecardPayment(savedCard.paymentMethodId)
                    }
                    disabled={buttonstatus}
                    style={{
                      backgroundColor: "#000",
                      color: "#fff",
                      padding: "10px 16px",
                      borderRadius: "8px",
                      border: "none",
                      fontWeight: 600,
                      minWidth: "120px",
                    }}
                  >
                    {buttonstatus ? (
                      <Spinner animation="border" size="md" variant="light" />
                    ) : (
                      "Pay" // or use your actual total
                    )}
                  </button>
                </div>
              )}
            </div>
          );
        })}
    </>
  );

  return (
    <>
      <div className="d-block d-sm-none mobilepaymentall">
        <h5 className="paymentliketag">
          How would you like to pay?{" "}
          <div className="secure-badgepayment" onClick={handleSecureInfo}>
            <img src={lockimgkey} className="lock-icon" />
            100% Secure
          </div>
        </h5>

        <Accordion style={{ padding: "5px" }}>
          <Accordion.Item eventKey="saved-card" style={{ border: "none" }}>
            <Accordion.Header className="p-0 border-0 shadow-none bg-transparent payment-header">
              <div className="total-price-mobile">
                {selectedValue === "google-pay" && googlepaytype ? (
                  <div className="selected-tab d-flex justify-content-center align-items-center gap-3">
                    <div className="new-fus">
                      <img
                        src={Gpay}
                        alt="gpayicon"
                        style={{ height: "35px" }}
                      />
                    </div>
                    <div className="paytypemobile">
                      <p> Google pay</p>
                    </div>
                  </div>
                ) : selectedValue === "apple-pay" && applepaytype ? (
                  <div className="selected-tab d-flex justify-content-center align-items-center gap-3">
                    <div className="new-fus">
                      <img
                        src={theme === "dark" ? applepaydark : applepays}
                        style={{ height: "35px" }}
                        alt="applepayicon"
                      />
                    </div>
                    <div className="paytypemobile">
                      <p>Apple pay</p>
                    </div>
                  </div>
                ) : selectedValue === "paypal" && paypalType ? (
                  <div className="selected-tab d-flex justify-content-center align-items-center gap-3">
                    <div className="new-fus">
                      <img src={Paypallogo} alt="paypallogo" />
                    </div>
                    <div className="paytypemobile">
                      <p>PayPal</p>
                    </div>
                  </div>
                ) : selectedValue === "klarna" && klarnaType ? (
                  <div className="selected-tab d-flex justify-content-center align-items-center gap-3">
                    <div className="new-fus">
                      <img
                        src={klarnapay}
                        alt="klarnapay"
                        style={{ height: "30px" }}
                      />
                    </div>
                    <div className="paytypemobile">
                      <p>Klarna</p>
                    </div>
                  </div>
                ) : selectedValue === "cardimg1" && cardtype ? (
                  <>
                    <div className="selected-tab d-flex justify-content-center align-items-center gap-3">
                      <div className="new-fus">
                        <img
                          src={CreditdebitCardImg}
                          alt="cardimage"
                          style={{ height: "35px" }}
                        />
                      </div>
                      <div className="paytypemobile">
                        <p>Card</p>
                      </div>
                    </div>
                  </>
                ) : selectedValue === "cashimg" && cashtype ? (
                  <>
                    <div className="selected-tab d-flex justify-content-center align-items-center gap-3">
                      <div className="new-fus">
                        <img
                          src={Cashimgicondesktop}
                          alt="cashimage"
                          style={{ height: "30px" }}
                        />
                      </div>
                      <div className="paytypemobile">
                        <p>Cash Pay</p>
                      </div>
                    </div>
                  </>
                ) : selectedValue === "cashimg" && cashtype ? (
                  <p className="change">Select Payment method</p>
                ) : guestusered !== "" && selectedValue === "wallet" ? (
                  isLoggedIn === "true" ? (
                    <div className="selected-tab d-flex justify-content-center align-items-center gap-3">
                      <div className="new-fus">
                        <img
                          src={theme === "dark" ? CardIconDark : CardIcon}
                          alt="cardicon"
                          style={{ height: "30px" }}
                        />
                      </div>
                      <div className="paytypemobile">
                        <p>Wallet</p>
                      </div>
                    </div>
                  ) : null
                ) : (
                  <></>
                )}
                {selectedValue && selectedValue ? (
                  <>
                    <div style={{ textAlign: "center" }}>
                      {/* <span style={{ color: "rgb(58 87 102)" }}>
                          {currency_symbol}{finalTotalValue}
                        </span> */}
                      {/* <div className="total-pricechild d-block d-sm-none">
                        <p > Change</p>
                      </div> */}
                    </div>
                  </>
                ) : null}
              </div>
            </Accordion.Header>

            <Accordion.Body>
              <div className="payment-options">
                <ul className="list-group">
                  {cardtype && (
                    <li
                      className={`list-group-item ${
                        selectedValue == "cardimg1" ? "active" : ""
                      }`}
                      onClick={handlechildshow}
                    >
                      <div className="checkoutpayUI">
                        <div className="checkoutpayUIchildMobilepayment">
                          <div className="checkoutfirstmobile">
                            <img
                              src={
                                theme === "dark"
                                  ? CreditdebitCardImg
                                  : CreditdebitCardImg
                              }
                              alt=""
                              className="paymenticonall"
                              onClick={handlechildshow}
                            />
                            <h5
                              className="paymenthtagname"
                              onClick={handlechildshow}
                            >
                              Card
                            </h5>
                          </div>
                          <label>
                            <input
                              type="radio"
                              id="payment"
                              checked={
                                selectedValue == "cardimg1" ? true : false
                              }
                              onChange={handlechildshow}
                            />
                          </label>
                        </div>

                        {/* <div>
                                {" "}
                                <span onClick={handlechildshow}>
                                  <IoIosArrowForward />
                                </span>
                              </div> */}
                      </div>

                      {/* {showchildpopup &&
                        selectedValue == "cardimg1" &&
                        cardtype && (
                          <div className="d-flex align-items-center justify-content-center flex-column vh-75 checkOutMobile">
                            <Form className="form-label mb-3">
                              <Row>
                                <Col
                                  xxl={6}
                                  xl={6}
                                  style={{ padding: "10px" }}
                                >
                                  <Form.Label className="checkOutMobileLabel">
                                    Card Number
                                  </Form.Label>
                                  <div
                                    style={containerStyle}
                                    className="checkOutMobileElement"
                                  >
                                    <CardNumberElement
                                      options={CARD_OPTIONS1}
                                      className="custom-card-element"
                                      style={{ height: "300px" }}
                                      onChange={handleCardChange}
                                    />
                                  </div>
                                </Col>
                                <Col xxl={3} sm={6} xs={6} xl={3}>
                                  <Form.Label className="checkOutMobileLabel">
                                    Validity
                                  </Form.Label>
                                  <div
                                    style={containerStyle}
                                    className="checkOutMobileElement"
                                  >
                                    <CardExpiryElement
                                      options={CARD_OPTIONS1}
                                      onChange={handleCardChange}
                                    />
                                  </div>
                                </Col>
                                <Col xxl={3} sm={6} xs={6} xl={3}>
                                  <Form.Label className="checkOutMobileLabel">
                                    CVV
                                  </Form.Label>
                                  {savecardPay == 0 && (
                                    <div
                                      style={containerStyle}
                                      className="checkOutMobileElement"
                                    >
                                      <CardCvcElement
                                        options={CARD_OPTIONS1}
                                        onChange={handleCardChange}
                                      />
                                    </div>
                                  )}
                                </Col>
                                <Form.Label
                                  style={{
                                    color: "red",
                                  }}
                                >
                                  {cardErrorMessage}
                                </Form.Label>
                                {isLoggedIn !== "false" ? (
                                  <>
                                    <div className="p-2">
                                      <Col xxl={12}>
                                        <Form.Check
                                          label=" Securely save this card future order"
                                          name="form-check"
                                          type="checkbox"
                                          id="form-check"
                                          className="checkOutMobile-form-check-label"
                                          onClick={() =>
                                            handleSaveCardCheckboxClick()
                                          }
                                        />
                                      </Col>
                                    </div>
                                  </>
                                ) : null}
                              </Row>
                            </Form>
                            <OrderButton walletamount={walletamount} finalTotalValue={finalTotalValue} />
                          </div>
                        )}
                      {
                        <div className="creditcardparent">
                          {userData && isLoggedIn === "true" ? (
                            <>
                              {SavedCards &&
                                selectedValue == "cardimg1" ? (
                                <>
                                  <h5></h5>

                                  {SavedCards.map((savedCard, index) => (
                                    <div key={index}>
                                      {savedCard.primary === "1" ? (
                                        <div className="creditcard">
                                          <div className="creditcardui">
                                            <input
                                              name="gender"
                                              type="radio"
                                              value={"savedcard"}
                                              onChange={() =>
                                                handlePaymentSelection(
                                                  12,
                                                  "savedcard"
                                                )
                                              }
                                            />
                                            <img
                                              src={savedCard.brand}
                                              alt="savedcard"
                                              style={{ height: "40px" }}
                                            />
                                            <div className="creditcarduichild">
                                              <p>{savedCard.card}</p>
                                            </div>
                                          </div>

                                          <div></div>
                                        </div>
                                      ) : null}
                                    </div>
                                  ))}
                                </>
                              ) : null}
                            </>
                          ) : null}
                        </div>
                      } */}
                      {/* <span className="badge badge-primary badge-pill">
                              <i className="fas fa-chevron-right"></i>{" "} */}
                      {/* Right arrow icon */}
                      {/* </span> */}
                    </li>
                  )}

                  {appledeviceInfo === 1 ? (
                    <li
                      className={`list-group-item ${
                        selectedValue == "apple-pay" ? "active" : ""
                      }`}
                      value={"apple-pay"}
                      onClick={() => handlePaymentSelection(7, "apple-pay")}
                    >
                      <div className="checkoutpayUI">
                        <div className="checkoutpayUIchildMobilepayment">
                          <div className="checkoutfirstmobile">
                            <img
                              src={theme === "dark" ? applepaydark : applepays}
                              alt="applepayicon"
                              className="paymenticonall"
                            />
                            {/* <img
                              src={applepays}
                              alt="GPay"
                              className="payment-logo"
                            /> */}
                            <h5 className="paymenthtagname">Apple Pay</h5>
                          </div>
                          <label>
                            <input
                              type="radio"
                              id="payment"
                              checked={
                                selectedValue == "apple-pay" ? true : false
                              }
                              onChange={() =>
                                handlePaymentSelection(7, "apple-pay")
                              }
                            />
                          </label>
                        </div>

                        {/* <div>
                                  {" "}
                                  <span>
                                    <IoIosArrowForward />
                                  </span>
                                </div> */}
                      </div>
                      {/* <span className="badge badge-primary badge-pill">
                                <i className="fas fa-chevron-right"></i>{" "} */}
                      {/* Right arrow icon */}
                      {/* </span> */}
                    </li>
                  ) : null}
                  {/*  */}
                  {cashtype ? (
                    <li
                      className="list-group-item"
                      value={"cashimg"}
                      onClick={() => handlePaymentSelection(0, "cashimg")}
                    >
                      <div className="checkoutpayUI">
                        <div className="checkoutpayUIchildMobilepayment">
                          <div className="checkoutfirstmobile">
                            <img
                              src={Cashimgicondesktop}
                              alt="cashimgicon"
                              className="paymenticonall"
                            />

                            {/* <img
                              src={applepays}
                              alt="GPay"
                              className="payment-logo"
                            /> */}
                            <h5 className="paymenthtagname">Cash Pay</h5>
                          </div>
                          <label>
                            <input
                              type="radio"
                              id="payment"
                              checked={
                                selectedValue == "cashimg" ? true : false
                              }
                              onChange={() =>
                                handlePaymentSelection(0, "cashimg")
                              }
                            />
                          </label>
                        </div>

                        {/* <div>
                            {" "}
                            <span>
                              <IoIosArrowForward />
                            </span>
                          </div> */}
                      </div>
                      {/* <span className="badge badge-primary badge-pill">
                          <i className="fas fa-chevron-right"></i>{" "} */}
                      {/* Right arrow icon */}
                      {/* </span> */}
                    </li>
                  ) : null}
                  {gpaydeviceInfo === 1 ? (
                    <li
                      className={`list-group-item ${
                        selectedValue == "google-pay" ? "active" : ""
                      }`}
                      value={"google-pay"}
                      onClick={() => handlePaymentSelection(8, "google-pay")}
                    >
                      <div className="checkoutpayUI">
                        <div className="checkoutpayUIchildMobilepayment">
                          <div className="checkoutfirstmobile">
                            <img
                              src={Gpay}
                              alt="google-pay"
                              className="paymenticonall"
                              onClick={() =>
                                handlePaymentSelection(8, "google-pay")
                              }
                            />
                            <h5
                              className="paymenthtagname"
                              onClick={() =>
                                handlePaymentSelection(8, "google-pay")
                              }
                            >
                              Google Pay
                            </h5>
                          </div>
                          <label>
                            <input
                              type="radio"
                              id="payment"
                              checked={
                                selectedValue == "google-pay" ? true : false
                              }
                              onChange={() =>
                                handlePaymentSelection(8, "google-pay")
                              }
                            />
                          </label>
                        </div>

                        {/* <div>
                                  {" "}
                                  <span>
                                    <IoIosArrowForward />
                                  </span>
                                </div> */}
                      </div>
                      {/* <span className="badge badge-primary badge-pill">
                                <i className="fas fa-chevron-right"></i>{" "} */}
                      {/* Right arrow icon */}
                      {/* </span> */}
                    </li>
                  ) : null}
                  {klarnaType && (
                    <li
                      className={`list-group-item ${
                        selectedValue == "klarna" ? "active" : ""
                      }`}
                      value={"klarna"}
                      onClick={() => handlePaymentSelection(10, "klarna")}
                    >
                      <div className="checkoutpayUI">
                        <div className="checkoutpayUIchildMobilepayment">
                          <div className="checkoutfirstmobile">
                            <img
                              src={klarnapay}
                              alt="klarnapay"
                              className="paymenticonall"
                              onClick={() =>
                                handlePaymentSelection(10, "klarna")
                              }
                            />
                            <h5
                              className="paymenthtagname"
                              onClick={() =>
                                handlePaymentSelection(10, "klarna")
                              }
                            >
                              klarna
                            </h5>
                          </div>
                          <label>
                            <input
                              type="radio"
                              id="payment"
                              checked={selectedValue == "klarna" ? true : false}
                              onClick={() =>
                                handlePaymentSelection(10, "klarna")
                              }
                            />
                          </label>
                        </div>
                        {/* <div>
                                  {" "}
                                  <span>
                                    <IoIosArrowForward />
                                  </span>
                                </div> */}
                      </div>
                      {/* <span className="badge badge-primary badge-pill">
                                <i className="fas fa-chevron-right"></i>{" "}
                              </span> */}
                    </li>
                  )}
                  {paypalType && (
                    <li
                      className={`list-group-item ${
                        selectedValue == "paypal" ? "active" : ""
                      }`}
                      value={"cashimg"}
                      onClick={() => handlePaymentSelection(14, "paypal")}
                    >
                      <div className="checkoutpayUI">
                        <div className="checkoutpayUIchildMobilepayment">
                          <div className="checkoutfirstmobile">
                            <img
                              src={PayPal}
                              alt="paypalnew"
                              className="paymenticonall"
                            />
                            <h5
                              className="paymenthtagname"
                              onClick={() =>
                                handlePaymentSelection(14, "paypal")
                              }
                            >
                              Paypal
                            </h5>
                          </div>
                          <label>
                            <input
                              type="radio"
                              id="payment"
                              checked={selectedValue == "paypal" ? true : false}
                              onClick={() =>
                                handlePaymentSelection(14, "paypal")
                              }
                            />
                          </label>
                        </div>

                        {/* <div>
                                  {" "}
                                  <span>
                                    <IoIosArrowForward />
                                  </span>
                                </div> */}
                      </div>
                      {/* <span className="badge badge-primary badge-pill">
                                <i className="fas fa-chevron-right"></i>{" "} */}
                      {/* Right arrow icon */}
                      {/* </span> */}
                    </li>
                  )}
                  {!extraPayment && (
                    <>
                      <li
                        className={`list-group-item ${
                          selectedValue == "wallet" ? "active" : ""
                        }`}
                        value={"wallet"}
                        onClick={() => {
                          handlePaymentSelection(9, "wallet");
                        }}
                      >
                        <div className="checkoutpayUI">
                          <div className="checkoutpayUIchildMobilepayment">
                            <div className="checkoutfirstmobile">
                              <img
                                src={theme === "dark" ? CardIconDark : CardIcon}
                                alt="cardicondark"
                                className="paymenticonall"
                              />
                              <h5
                                className="mobile-wallet-disabled"
                                style={{ fontSize: "16px" }}
                              >
                                Wallet
                              </h5>
                            </div>
                            <label>
                              <input
                                type="radio"
                                id="payment"
                                checked={
                                  selectedValue == "wallet" ? true : false
                                }
                                onChange={() => {
                                  handlePaymentSelection(9, "wallet");
                                }}
                              />
                            </label>
                          </div>
                        </div>
                      </li>
                    </>
                  )}
                </ul>

                <Modal
                  show={
                    showchildpopup && selectedValue === "cardimg1" && cardtype
                  }
                  onHide={() => setshowchildpopup(false)}
                  fullscreen
                  className={
                    localStorage.getItem("isApp") == "true" ? "app-side" : ""
                  }
                  centered
                >
                  <Modal.Header
                    className={
                      localStorage.getItem("isApp") == "true"
                        ? "app-side arrowheadermodal"
                        : "arrowheadermodal"
                    }
                  >
                    <Modal.Title>
                      <MdOutlineArrowBackIos
                        className="arrowclose"
                        style={{ color: "#fff" }}
                        onClick={hanldechildclosenew}
                      />{" "}
                      <span className="ms-2">Payment</span>
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {Array.isArray(SavedCards) && SavedCards.length > 0 && (
                      <div
                        className="saved-cards-box"
                        onClick={handleSavedPopupShow}
                      >
                        <div className="saved-cards-left">
                          <FiCreditCard className="card-icon" />
                          <span className="saved-cards-text">Saved cards</span>
                        </div>
                        <RiArrowRightSLine className="voucher-arrow" />
                      </div>
                    )}
                    <div className="line-containercheck">
                      <div className="linecheck"></div>
                      <div className="textcheck">Add Card</div>
                      <div className="linecheck"></div>
                    </div>

                    {showSavedCardSection && (
                      <div className="d-flex align-items-center justify-content-center flex-column vh-75 checkOutMobilecard">
                        <Form className="form-label mb-3">
                          <Row>
                            <Col xxl={6} xl={6} style={{ padding: "10px" }}>
                              <Form.Label className="checkOutMobileLabel">
                                Card number
                              </Form.Label>
                              <div
                                style={{
                                  padding: "15px 15px 15px 15px",
                                  borderRadius: "10px",
                                  border: "1px solid #EDEDED",
                                  position: "relative",
                                }}
                                className="checkOutMobileElement"
                              >
                                <CardNumberElement
                                  options={CARD_OPTIONS}
                                  className="custom-card-element"
                                  onChange={(e) => {
                                    handleCardChange(e);
                                    setCardBrand(e.brand);
                                  }}
                                  style={{ height: "300px" }}
                                />

                                {getCardBrandIcon(cardBrand) && (
                                  <FontAwesomeIcon
                                    icon={getCardBrandIcon(cardBrand)}
                                    style={{
                                      position: "absolute",
                                      right: "15px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      fontSize: "45px",
                                      color: "#DEDEDE",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  />
                                )}
                              </div>
                            </Col>
                            <Col xxl={3} sm={6} xs={6} xl={3}>
                              <Form.Label className="checkOutMobileLabel">
                                Validity
                              </Form.Label>
                              <div
                                style={{
                                  padding: "15px 15px 15px 15px",
                                  borderRadius: "10px",
                                  border: "1px solid #EDEDED",
                                }}
                                className="checkOutMobileElement"
                              >
                                <CardExpiryElement
                                  options={CARD_OPTIONS1}
                                  onChange={handleCardChange}
                                />
                              </div>
                            </Col>
                            <Col xxl={3} sm={6} xs={6} xl={3}>
                              <Form.Label className="checkOutMobileLabel">
                                CVV
                              </Form.Label>

                              <div
                                style={{
                                  padding: "15px 15px 15px 15px",
                                  borderRadius: "10px",
                                  border: "1px solid #EDEDED",
                                  position: "relative",
                                }}
                                className="checkOutMobileElement"
                              >
                                <CardCvcElement
                                  options={CARD_OPTIONS1}
                                  onChange={handleCardChange}
                                />
                                <div
                                  title="What is CVV?"
                                  onClick={handleCVVInfo}
                                  style={{
                                    position: "absolute",
                                    top: "50%", // vertically center
                                    right: "15px", // distance from right edge
                                    transform: "translateY(-50%)", // align vertical center correctly
                                    height: "22px",
                                    width: "22px",
                                    backgroundColor: "#f5f5f5",
                                    border: "1px solid #ccc",
                                    borderRadius: "50%",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    color: "#000",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    zIndex: 2,
                                  }}
                                >
                                  ?
                                </div>
                              </div>
                            </Col>

                            <Modal
                              show={showCVVInfo}
                              // fullscreen={fullscreen}
                              centered
                              onHide={() => setShowCVVInfo(false)}
                              id="checkoutcustomModal"
                              className={theme === "dark" ? "dark-popup" : null}
                              dialogClassName="bottom-modal"
                              fade
                            >
                              <div
                                style={{
                                  borderRadius: "12px",
                                  padding: "20px",
                                }}
                              >
                                <div className="d-flex justify-content-between align-items-center">
                                  <h5 className="whatcvvtext">What is CVV?</h5>
                                  <img
                                    src={closeiconnew}
                                    alt="closeicon"
                                    className="closeiconnew"
                                    onClick={handleCVVclose}
                                  />
                                </div>

                                <div className="text-center my-3">
                                  <img
                                    src={Cvvbgimage}
                                    alt="CVV example"
                                    style={{
                                      width: "100%",
                                      maxWidth: "360px",
                                      height: "100%",
                                    }}
                                  />
                                </div>

                                <p>
                                  The CVV number is the last three digits on the
                                  back of your card
                                </p>
                              </div>
                            </Modal>

                            <Form.Label
                              style={{
                                color: "red",
                              }}
                            >
                              {cardErrorMessage}
                            </Form.Label>
                            {isLoggedIn !== "false" ? (
                              <>
                                <div className="p-2">
                                  <Col xxl={12}>
                                    <Form.Check
                                      label=" Securely save this card future order"
                                      name="form-check"
                                      type="checkbox"
                                      id="form-check"
                                      className="form-check"
                                      onClick={() =>
                                        handleSaveCardCheckboxClick()
                                      }
                                    />
                                  </Col>
                                </div>
                              </>
                            ) : null}
                          </Row>
                        </Form>
                        <OrderButton
                          walletamount={walletamount}
                          finalTotalValue={finalTotalValue}
                        />
                      </div>
                    )}
                  </Modal.Body>
                </Modal>

                <Modal
                  show={showSavedCardPopUp}
                  onHide={() => setshowchildpopup(false)}
                  fullscreen
                  className={
                    Array.isArray(SavedCards) &&
                    SavedCards.length > 0 &&
                    localStorage.getItem("isApp") == "true"
                      ? "app-side"
                      : ""
                  }
                  centered
                >
                  <Modal.Header
                    className={
                      localStorage.getItem("isApp") == "true"
                        ? "app-side arrowheadermodal"
                        : "arrowheadermodal"
                    }
                  >
                    <Modal.Title>
                      <MdOutlineArrowBackIos
                        className="arrowclose"
                        style={{ color: "#fff" }}
                        onClick={handleSavedCardCloseNew}
                      />{" "}
                      <span className="ms-2">Payment</span>
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <h4 style={{ marginBottom: "20px", marginTop: "5px" }}>
                      Saved Card
                    </h4>

                    <div className="save-card-form">
                      {!showSavedCardSection && mobileSaveCard}
                    </div>

                    {/* <div className="d-flex align-items-center justify-content-center flex-column vh-75 checkOutMobilecard">
                              <Form className="form-label mb-3">
                                <Row>
                                  <Col
                                    xxl={6}
                                    xl={6}
                                    style={{ padding: "10px" }}
                                  >
                                    <Form.Label className="checkOutMobileLabel">
                                      Card Number
                                    </Form.Label>
                                    <div
                                      style={{ padding: "15px 15px 15px 15px", borderRadius: "10px", border: "1px solid #EDEDED", position: "relative", }}
                                      className="checkOutMobileElement"
                                    >
                                      <CardNumberElement
                                        options={CARD_OPTIONS}
                                        className="custom-card-element"
                                        onChange={(e) => {
                                          handleCardChange(e);
                                          setCardBrand(e.brand);
                                        }}
                                        style={{ height: "300px" }}
                                      />

                                      {getCardBrandIcon(cardBrand) && (
                                        <FontAwesomeIcon
                                          icon={getCardBrandIcon(cardBrand)}
                                          style={{
                                            position: "absolute",
                                            right: "15px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            fontSize: "45px",
                                            color: "#DEDEDE",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                        />
                                      )}
                                    </div>
                                  </Col>
                                  <Col xxl={3} sm={6} xs={6} xl={3}>
                                    <Form.Label className="checkOutMobileLabel">
                                      Validity
                                    </Form.Label>
                                    <div
                                      style={{ padding: "15px 15px 15px 15px", borderRadius: "10px", border: "1px solid #EDEDED" }}
                                      className="checkOutMobileElement"
                                    >
                                      <CardExpiryElement
                                        options={CARD_OPTIONS1}
                                        onChange={handleCardChange}
                                      />

                                    </div>
                                  </Col>
                                  <Col xxl={3} sm={6} xs={6} xl={3}>
                                    <Form.Label className="checkOutMobileLabel" >
                                      CVV
                                    </Form.Label>

                                    <div
                                      style={{ padding: "15px 15px 15px 15px", borderRadius: "10px", border: "1px solid #EDEDED", position: "relative", }}
                                      className="checkOutMobileElement"
                                    >
                                      <CardCvcElement
                                        options={CARD_OPTIONS1}
                                        onChange={handleCardChange}
                                      />
                                      <div
                                        title="What is CVV?"
                                        onClick={handleCVVInfo}
                                        style={{
                                          position: "absolute",
                                          top: "50%",           // vertically center
                                          right: "15px",        // distance from right edge
                                          transform: "translateY(-50%)", // align vertical center correctly
                                          height: "22px",
                                          width: "22px",
                                          backgroundColor: "#f5f5f5",
                                          border: "1px solid #ccc",
                                          borderRadius: "50%",
                                          fontSize: "14px",
                                          fontWeight: "bold",
                                          color: "#000",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          cursor: "pointer",
                                          zIndex: 2,
                                        }}
                                      >
                                        ?
                                      </div>
                                    </div>

                                  </Col>



                                  <Form.Label
                                    style={{
                                      color: "red",
                                    }}
                                  >
                                    {cardErrorMessage}
                                  </Form.Label>
                                  {isLoggedIn !== "false" ? (
                                    <>
                                      <div className="p-2">
                                        <Col xxl={12}>
                                          <Form.Check
                                            label=" Securely save this card future order"
                                            name="form-check"
                                            type="checkbox"
                                            id="form-check"
                                            className="checkOutMobile-form-check-label"
                                            onClick={() =>
                                              handleSaveCardCheckboxClick()
                                            }
                                          />
                                        </Col>
                                      </div>
                                    </>
                                  ) : null}
                                </Row>
                              </Form>
                              <OrderButton walletamount={walletamount} finalTotalValue={finalTotalValue} />
                            </div> */}
                  </Modal.Body>
                </Modal>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        <Modal
          show={showSecureModal}
          id="checkoutcustomModal"
          dialogClassName="bottom-modal"
          centered
          className="secure-modal"
        >
          <div className="secure-payment-content">
            <div className="secure-header">
              <h5>100% Safe and Secure payments</h5>
              <img
                src={closeiconnew}
                alt="closeicon"
                className="closeiconnew"
                onClick={handleSecureClose}
              />
            </div>

            <div className="secure-body">
              <img
                src={Secureimgone}
                alt="secure shield"
                className="shield-icon"
              />

              <p>
                We use Stripe for secure payment processing in Stripe is a
                certified PCI DSS Level 1 Service Provider — the highest level
                of certification in the payments industry. All transactions are
                encrypted using industry-standard SSL encryption. Your payment
                information is processed securely and is never stored on our
                servers. For more information, please refer to our Privacy
                Policy.
              </p>

              <div className="secure-badges">
                <img src={Secureimgtwo} alt="PCI DSS" />
                <img src={Secureimgthree} alt="SSL 256 Bit" />
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

//client name header
const ClientNameHeader = () => {
  const [clientName, setClientName] = useState("");

  useEffect(() => {
    // Retrieve data from localStorage for the key 'clientName'
    const storedClientName = localStorage.getItem("clientName");

    if (storedClientName) {
      setClientName(storedClientName);
    }
  }, []);
  // ! Scroll Header Start
  const [ScrollHeaer, setScrollHeaer] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 150) {
        setScrollHeaer(true);
      } else {
        setScrollHeaer(false);
      }
    });
  }, []);
  // ! Scroll Header End
  const navigate = useNavigate();
  const GoBackFunction = () => {
    navigate(-1);
  };
  return (
    <section
      className={`scroll-header ${ScrollHeaer && "scroll-header-visible"}`}
    >
      <Container>
        <Row>
          <Col md={12}>
            <div className="scroll-header-content d-none">
              <button className="back" onClick={GoBackFunction}>
                <MdOutlineArrowBackIos />
              </button>
              <h3 className="resta-name ms-2">
                {/* {clientName.length > 16
                    ? clientName.slice(0, 16) + "..."
                    : clientName} */}
                Checkout
              </h3>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

const PaymentProcessingPopup = ({ setButtonstatus }) => {
  const { itemAvailableData } = useContext(CheckoutContext);
  const { getOrderMode } = OrderFlow();
  const [showPopup, setShowPopup] = useState(true);
  const [cartItemsData, setcartItems] = useState([]);
  const [timeLeft, setTimeLeft] = useState(25); // Countdown from 45s
  const orderModeChecked = localStorage.getItem("orderMode");
  const orderpostcodechecked = localStorage.getItem("orderPostcode");
  const clientpathcheckout = localStorage.getItem("clientPath");
  const orderType = localStorage.getItem("orderType");
  const storeClientNamecheck = localStorage.getItem("clientName");
  const cartqtyName = localStorage.getItem("cartQty");
  const preorderTime = localStorage.getItem("preOrder");
  const TatTime = localStorage.getItem("tatTime");
  const [width, setWidth] = useState(window.innerWidth);
  const breakpoint = 767;

  useEffect(() => {
    let localStorageData =
      localStorage.getItem("cart") &&
      localStorage.getItem("cart") !== "undefined"
        ? JSON.parse(localStorage.getItem("cart"))
        : [];

    setcartItems(localStorageData);
  }, [localStorage.getItem("cart")]);

  useEffect(() => {
    // Countdown timer
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timer);
          setShowPopup(false);
          setButtonstatus(false);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer); // Cleanup timer
  }, []);

  const orderDetail = JSON.parse(localStorage.getItem("orderDetail"));
  const paymentType = orderDetail?.paymentType;

  let paymentText = "";

  if (paymentType === 0) {
    paymentText = "Cash";
  } else if (paymentType === 1) {
    paymentText = "Card";
  } else if (paymentType === 8) {
    paymentText = "Google Pay";
  } else if (paymentType === 7) {
    paymentText = "Apple Pay";
  } else if (paymentType === 9) {
    paymentText = "Wallet";
  } else if (paymentType === 10) {
    paymentText = "Klarna";
  } else if (paymentType === 14) {
    paymentText = "Paypal";
  } else if (paymentType === 12) {
    paymentText = "Saved Card";
  } else {
    paymentText = "Unknown";
  }

  return (
    <>
      {width > breakpoint ? (
        <Modal
          show={showPopup}
          centered
          backdrop="static"
          className="ck-payment-processing-desktop"
        >
          <Modal.Body className="ck-paymt-process-body-desktop">
            <div className="modal-contentcheckout-desktop">
              {/* Header */}
              <div className="modal-header">
                <p>Placing {orderModeChecked} order...</p>
                <img
                  src={closeiconnew}
                  alt="closeicon"
                  className="closeiconnew"
                  onClick={() => setShowPopup(false)}
                />
              </div>

              {/* Location */}
              <div className="location">
                <div className="locationnewdiv">
                  <span className="location-icon">
                    <GrLocation />
                  </span>
                  <div className="location-text">
                    {orderModeChecked === "Collection" ? (
                      <>
                        <p className="postcode">{clientpathcheckout}</p>
                      </>
                    ) : (
                      <>
                        <p className="postcode">{orderpostcodechecked}</p>
                        <span className="location-note">Meet me my door</span>
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className="borderbottomdiv"></div>

              {/* Time Section */}
              {orderType === "ASAP" ? (
                <div className="location">
                  <div className="locationnewdiv">
                    <span className="location-icon">
                      <TfiTimer />
                    </span>
                    <p className="postcodeAsap">ASAP : {TatTime}</p>
                  </div>
                </div>
              ) : (
                <div className="location">
                  <div className="locationnewdiv">
                    <span className="location-icon">
                      <TfiTimer />
                    </span>
                    <div className="location-text">
                      <p className="postcode">Scheduled Order</p>
                      <span className="location-note">{preorderTime}</span>
                    </div>
                  </div>
                </div>
              )}

              <div className="borderbottomdiv"></div>

              {/* Item List */}
              <div className="items">
                <p className="restaurant-title">
                  {storeClientNamecheck} <span>{cartqtyName} Item(s)</span>
                </p>
                <div className="order-summary-scroll">
                  {cartItemsData
                    ?.filter((itemA) =>
                      itemAvailableData?.some(
                        (itemB) => itemB.itemId === itemA.itemId
                      )
                    )
                    .map((ListItem, index) => (
                      <div key={index} className="fus-order-summarycheck">
                        <span className="fus-order-checkcount">
                          {ListItem.count} x
                        </span>
                        <span className="fus-orderchecktext">
                          {ListItem.itemName?.split("&#")[0] ||
                            ListItem.itemName}
                          {getOrderMode === "Collection" &&
                            ListItem.collection_available && (
                              <span className="unavailable-badge">
                                Collection Not Available
                              </span>
                            )}
                          {getOrderMode !== "Collection" &&
                            ListItem.delivery_available && (
                              <span className="unavailable-badge">
                                Delivery Not Available
                              </span>
                            )}
                        </span>
                      </div>
                    ))}
                </div>
              </div>

              {/* Payment */}
              <div className="payment">
                <p className="ptagpayment">Paying in {paymentText}</p>
              </div>

              {/* Buttons */}
              <div className="button-containerdesk">
                <button
                  className="confirm-btn"
                  style={{ position: "relative", overflow: "hidden" }}
                >
                  {/* Progress Bar Background */}
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      height: "100%",
                      width: "100%",
                      backgroundColor: "#E0E0E0",
                      animation: "progressBar 3s linear infinite",
                      border: "#E0E0E0",
                      zIndex: 1,
                    }}
                  ></div>

                  {/* Button Text */}
                  <span style={{ position: "relative", zIndex: 2 }}>
                    Looks good {timeLeft} s
                  </span>
                </button>
                {/* <button className="back-btn" onClick={() => setShowPopup(false)}>Go back</button> */}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      ) : (
        <Modal
          show={showPopup}
          centered
          backdrop="static"
          fullscreen
          className="ck-payment-processingcheckout"
        >
          <img
            src={popupimgpayment}
            alt="imgicon"
            className="iconpopuppayment"
          />
          <Modal.Body className=" ck-paymt-process-body">
            <div className="modal-contentcheckout">
              {/* Header */}
              <div className="modal-header">
                <p>Placing {orderModeChecked} order...</p>
                {/* <img src={closeiconnew} alt="closeicon" className="closeiconnew" onClick={() => setShowPopup(false)} /> */}
              </div>

              {/* Location */}
              <div className="location">
                <div className="locationnewdiv">
                  <span className="location-icon">
                    <GrLocation />
                  </span>
                  <div className="location-text">
                    {orderModeChecked === "Collection" ? (
                      <>
                        <p className="postcode">{clientpathcheckout}</p>
                      </>
                    ) : (
                      <>
                        <p className="postcode">{orderpostcodechecked}</p>
                        <span className="location-note">Meet me my door</span>
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className="borderbottomdiv"></div>

              {/* Time Section */}
              {orderType === "ASAP" ? (
                <div className="location">
                  <div className="locationnewdiv">
                    <span className="location-icon">
                      <TfiTimer />
                    </span>
                    <p className="postcodeAsap">ASAP : {TatTime}</p>
                  </div>
                </div>
              ) : (
                <div className="location">
                  <div className="locationnewdiv">
                    <span className="location-icon">
                      <TfiTimer />
                    </span>
                    <div className="location-text">
                      <p className="postcode">Scheduled Order</p>
                      <span className="location-note">{preorderTime}</span>
                    </div>
                  </div>
                </div>
              )}

              <div className="borderbottomdiv"></div>

              {/* Item List */}
              <div className="items">
                <p className="restaurant-title">
                  {storeClientNamecheck} <span>{cartqtyName} Item(s)</span>
                </p>
                <div className="order-summary-scroll">
                  {cartItemsData
                    ?.filter((itemA) =>
                      itemAvailableData?.some(
                        (itemB) => itemB.itemId === itemA.itemId
                      )
                    )
                    .map((ListItem, index) => (
                      <div key={index} className="fus-order-summarycheck">
                        <span className="fus-order-checkcount">
                          {ListItem.count} x
                        </span>
                        <span className="fus-orderchecktext">
                          {ListItem.itemName?.split("&#")[0] ||
                            ListItem.itemName}
                          {getOrderMode === "Collection" &&
                            ListItem.collection_available && (
                              <span className="unavailable-badge">
                                Collection Not Available
                              </span>
                            )}
                          {getOrderMode !== "Collection" &&
                            ListItem.delivery_available && (
                              <span className="unavailable-badge">
                                Delivery Not Available
                              </span>
                            )}
                        </span>
                      </div>
                    ))}
                </div>
              </div>

              {/* Payment */}
              <div className="payment">
                <p className="ptagpayment">Paying in {paymentText}</p>
              </div>

              {/* Buttons */}
              <div className="button-container">
                <button
                  className="confirm-btn"
                  style={{ position: "relative", overflow: "hidden" }}
                >
                  {/* Progress Bar Background */}
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      height: "100%",
                      width: "100%",
                      backgroundColor: "#E0E0E0",
                      animation: "progressBar 3s linear infinite",
                      border: "#E0E0E0",
                      zIndex: 1,
                    }}
                  ></div>

                  {/* Button Text */}
                  <span style={{ position: "relative", zIndex: 2 }}>
                    Looks good {timeLeft} s
                  </span>
                </button>
                {/* <button className="back-btn" onClick={() => setShowPopup(false)}>Go back</button>`` */}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};
